/* This file is generated, do not modify manually */
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  DateTime: { input: string; output: string };
  GraphQLJSON: {
    input: { [key: string]: string | number | boolean };
    output: { [key: string]: string | number | boolean };
  };
  IANATimezone: { input: string; output: string };
  Timezone: { input: string; output: string };
  /** The `Upload` scalar type represents a file upload. */
  Upload: { input: File; output: File };
};

export type AccidentCost = {
  __typename: 'AccidentCost';
  accidentCostValue: Scalars['Float']['output'];
  transportMode: Scalars['String']['output'];
};

export enum Action {
  DISABLE = 'DISABLE',
  ENABLE = 'ENABLE',
}

export type ActionMetadata = FlagCreatedMetadata | FlagUpdatedMetadata;

export type ActualTimeOverrides = {
  __typename: 'ActualTimeOverrides';
  actualTimeOfArrival: Maybe<DateTimeWithTimezone>;
  actualTimeOfArrivalSource: Maybe<Scalars['String']['output']>;
};

export type AddCredentialsToUserInput = {
  type: CredentialType;
  userId: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type AddItemsFilterInput = {
  bulkInvitationSetIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  companyNameOrIdentifier?: InputMaybe<Scalars['String']['input']>;
  invitationStatus?: InputMaybe<Array<InvitationOverviewStatus>>;
  invitedAt?: InputMaybe<Scalars['DateTime']['input']>;
  isInvalid?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<Array<CarrierNetworkStatus>>;
  tourStatusConsent?: InputMaybe<Array<CarrierNetworkConsentStatus>>;
};

export type AddItemsToBulkInvitationSetInput = {
  entityIds?: InputMaybe<Array<Scalars['String']['input']>>;
  filter: AddItemsFilterInput;
  selectType: BulkInvitationSendSelectType;
  sort?: InputMaybe<CarrierNetworkSortOrderInput>;
  targetBulkInvitationSetId: Scalars['String']['input'];
};

export type AddItemsToBulkInvitationSetResult = {
  __typename: 'AddItemsToBulkInvitationSetResult';
  hadDuplicates: Scalars['Boolean']['output'];
  success: Scalars['Boolean']['output'];
};

export type AddOrUpdateConsentInput = {
  fromCompanyId: Scalars['String']['input'];
  toCompanyId: Scalars['String']['input'];
  tourStatusConsent?: InputMaybe<AddOrUpdateConsentState>;
};

export enum AddOrUpdateConsentState {
  ACCEPTED = 'ACCEPTED',
  DECLINED = 'DECLINED',
}

export type AddUserToCompanyInput = {
  companyId: Scalars['String']['input'];
  email: Scalars['String']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<UserRoleInCompany>;
};

export type AddVehiclesToCompanyVehicleGroupInput = {
  companyId: Scalars['String']['input'];
  companyVehicleGroupId: Scalars['String']['input'];
  vehicleIds: Array<Scalars['String']['input']>;
};

export type Address = {
  __typename: 'Address';
  city: Maybe<Scalars['String']['output']>;
  country: Maybe<Scalars['String']['output']>;
  full_address: Maybe<Scalars['String']['output']>;
  shortAreaCode: Maybe<Scalars['String']['output']>;
  state: Maybe<Scalars['String']['output']>;
  stopAddressId: Maybe<Scalars['String']['output']>;
  street_address: Maybe<Scalars['String']['output']>;
  zipcode: Maybe<Scalars['String']['output']>;
};

export type AllocationReference = {
  __typename: 'AllocationReference';
  allocationId: Scalars['String']['output'];
  status: AllocationReferenceStatus;
};

export enum AllocationReferenceStatus {
  ACTIVE = 'ACTIVE',
  PAST = 'PAST',
  UPCOMING = 'UPCOMING',
}

export type AllowedCompanyInviteSignup = {
  __typename: 'AllowedCompanyInviteSignup';
  platformId: Maybe<Scalars['String']['output']>;
  type: SignupType;
};

export enum AnalyzeStatus {
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
  IN_PROGRESS = 'IN_PROGRESS',
  NEW = 'NEW',
}

export type ApiEndpointUsageLog = {
  __typename: 'ApiEndpointUsageLog';
  apiHealthStatus: ApiHealth;
  apiImplementedAt: Maybe<Scalars['DateTime']['output']>;
  companyId: Scalars['String']['output'];
  companyName: Maybe<Scalars['String']['output']>;
  counters: Array<EndpointUsageCounterByDate>;
  endpointId: Scalars['String']['output'];
  endpointName: Scalars['String']['output'];
  firstCallAt: Scalars['DateTime']['output'];
  implementationStatus: ImplementationStatus;
  integrationIdentifier: Scalars['String']['output'];
  lastCallAt: Scalars['DateTime']['output'];
  transporeonCompanyId: Maybe<Scalars['String']['output']>;
  webhookSubscription: Maybe<CompanyWebhookSubscription>;
};

export type ApiEndpointUsageLogConnection = {
  __typename: 'ApiEndpointUsageLogConnection';
  edges: Maybe<Array<Maybe<ApiEndpointUsageLogEdge>>>;
  pageInfo: PageInfo;
};

export type ApiEndpointUsageLogEdge = {
  __typename: 'ApiEndpointUsageLogEdge';
  cursor: Maybe<Scalars['String']['output']>;
  node: Maybe<ApiEndpointUsageLog>;
};

export type ApiEndpointUsageLogsEndpoint = {
  __typename: 'ApiEndpointUsageLogsEndpoint';
  endpointId: Scalars['String']['output'];
  endpointName: Scalars['String']['output'];
};

export enum ApiHealth {
  ALL_CALLS_FAILED = 'ALL_CALLS_FAILED',
  CONCERNING = 'CONCERNING',
  HEALTHY = 'HEALTHY',
  HIGH_ERROR_RATE = 'HIGH_ERROR_RATE',
}

export type ApiMetricsEntry = {
  __typename: 'ApiMetricsEntry';
  endpointId: Maybe<Scalars['String']['output']>;
  errorMessage: Maybe<Scalars['String']['output']>;
  requestPayload: Maybe<Scalars['String']['output']>;
  requestUrl: Maybe<Scalars['String']['output']>;
  statusCode: Maybe<Scalars['String']['output']>;
  timestamp: Maybe<Scalars['DateTime']['output']>;
};

export type ApiMetricsEntryConnection = {
  __typename: 'ApiMetricsEntryConnection';
  edges: Maybe<Array<Maybe<ApiMetricsEntryEdge>>>;
  pageInfo: PageInfo;
};

export type ApiMetricsEntryEdge = {
  __typename: 'ApiMetricsEntryEdge';
  cursor: Maybe<Scalars['String']['output']>;
  node: Maybe<ApiMetricsEntry>;
};

export type ApplicationDeepLink = {
  __typename: 'ApplicationDeepLink';
  applicationName: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export enum ArcToggleStatus {
  AVAILABLE = 'AVAILABLE',
  NOT_CONFIGURED = 'NOT_CONFIGURED',
  NOT_LINKED = 'NOT_LINKED',
}

export type ArchiveCarrierNetworkItemsInput = {
  entityIds?: InputMaybe<Array<Scalars['String']['input']>>;
  filter?: InputMaybe<CarrierNetworkFilterInput>;
  selectType: BulkInvitationSendSelectType;
  sort?: InputMaybe<CarrierNetworkSortOrderInput>;
};

export type ArchiveCarrierNetworkItemsResult = {
  __typename: 'ArchiveCarrierNetworkItemsResult';
  affectedCount: Scalars['Int']['output'];
  affectedGroupIds: Array<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type ArchiveVehiclesInput = {
  companyId: Scalars['String']['input'];
  selection: VehicleSelectionInput;
};

export type ArchiveVehiclesResult = {
  __typename: 'ArchiveVehiclesResult';
  affectedCount: Scalars['Int']['output'];
  success: Scalars['Boolean']['output'];
};

export type AssignOceanCarrierInput = {
  billOfLading?: InputMaybe<Scalars['String']['input']>;
  bookingNumber?: InputMaybe<Scalars['String']['input']>;
  carrierCode?: InputMaybe<Scalars['String']['input']>;
  carrierName?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['String']['input'];
  containerNumber?: InputMaybe<Scalars['String']['input']>;
  tourId?: InputMaybe<Scalars['String']['input']>;
  transportNumber?: InputMaybe<Scalars['String']['input']>;
};

export type AssignOceanContainerInput = {
  billOfLading?: InputMaybe<Scalars['String']['input']>;
  bookingNumber?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['String']['input'];
  containerNumber: Scalars['String']['input'];
  tourId?: InputMaybe<Scalars['String']['input']>;
  transportNumber?: InputMaybe<Scalars['String']['input']>;
};

export type AssignUserToTourInput = {
  assignedToUserId?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['String']['input'];
  tourId: Scalars['String']['input'];
};

export enum BackofficeRole {
  admin = 'admin',
  readonly = 'readonly',
}

export type BatchUploadFileResult = {
  __typename: 'BatchUploadFileResult';
  error: Maybe<Scalars['String']['output']>;
  errorCode: Maybe<Scalars['String']['output']>;
  expiresAt: Maybe<Scalars['String']['output']>;
  fileName: Scalars['String']['output'];
  storageFileId: Maybe<Scalars['String']['output']>;
  uploadId: Maybe<Scalars['String']['output']>;
  uploadUrl: Maybe<Scalars['String']['output']>;
};

export type BigQueryMessageEntry = {
  __typename: 'BigQueryMessageEntry';
  message: Scalars['String']['output'];
  message_type: Scalars['String']['output'];
  produced_at: Scalars['DateTime']['output'];
};

export type BoundingBoxInput = {
  bottomRight: PositionInput;
  topLeft: PositionInput;
};

export type Bounds = {
  __typename: 'Bounds';
  ne: PointLocation;
  sw: PointLocation;
};

export type BreakCenterPosition = {
  __typename: 'BreakCenterPosition';
  lat: Scalars['Float']['output'];
  lng: Scalars['Float']['output'];
};

export type BulkAssignUserToToursInput = {
  assignedToUserId: Scalars['String']['input'];
  filter: BulkTourUserAssignmentFilterInput;
  selectType: BulkTourUserAssignmentSelectType;
  tourIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type BulkDeleteUserAssignmentFromToursInput = {
  filter: BulkTourUserAssignmentFilterInput;
  selectType: BulkTourUserAssignmentSelectType;
  tourIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type BulkInvitationIdentifierValue = {
  __typename: 'BulkInvitationIdentifierValue';
  isDuplicateInExistingValue: Scalars['Boolean']['output'];
  isDuplicateInSameSet: Scalars['Boolean']['output'];
  value: Scalars['String']['output'];
};

export type BulkInvitationMetadata = {
  __typename: 'BulkInvitationMetadata';
  fileName: Maybe<Scalars['String']['output']>;
  fileSize: Maybe<Scalars['String']['output']>;
};

export type BulkInvitationRecipient = {
  __typename: 'BulkInvitationRecipient';
  email: Scalars['String']['output'];
  locale: Maybe<Scalars['String']['output']>;
};

export enum BulkInvitationSendSelectType {
  EXCLUDE = 'EXCLUDE',
  INCLUDE = 'INCLUDE',
}

export type BulkInvitationSet = {
  __typename: 'BulkInvitationSet';
  bulkInvitationSetId: Scalars['String']['output'];
  companyId: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdByUserId: Scalars['String']['output'];
  items: CountedBulkInvitationSetItemConnection;
  metadata: BulkInvitationMetadata;
  setName: Maybe<Scalars['String']['output']>;
  statistics: BulkInvitationSetStatistics;
  updatedAt: Scalars['DateTime']['output'];
  updatedByUserId: Scalars['String']['output'];
};

export type BulkInvitationSetItemsArgs = {
  filter?: InputMaybe<BulkInvitationSetItemsFilterInput>;
  sort?: InputMaybe<BulkInvitationSetItemsSortOrderInput>;
};

export type BulkInvitationSetStatisticsArgs = {
  filter?: InputMaybe<BulkInvitationSetStatisticsFilterInput>;
};

export type BulkInvitationSetConnection = {
  __typename: 'BulkInvitationSetConnection';
  edges: Maybe<Array<Maybe<BulkInvitationSetEdge>>>;
  pageInfo: PageInfo;
};

export type BulkInvitationSetEdge = {
  __typename: 'BulkInvitationSetEdge';
  cursor: Maybe<Scalars['String']['output']>;
  node: Maybe<BulkInvitationSet>;
};

export type BulkInvitationSetItem = {
  __typename: 'BulkInvitationSetItem';
  bulkInvitationSetId: Scalars['String']['output'];
  bulkInvitationSetItemId: Scalars['String']['output'];
  companyInvitationId: Maybe<Scalars['String']['output']>;
  /** @deprecated Use companyReferenceName instead */
  companyName: Maybe<Scalars['String']['output']>;
  companyReferenceName: Maybe<Scalars['String']['output']>;
  consentStatus: Maybe<ConsentStatus>;
  createdAt: Scalars['DateTime']['output'];
  createdByUserId: Scalars['String']['output'];
  identifierValues: Array<BulkInvitationIdentifierValue>;
  invitedCompanyId: Maybe<Scalars['String']['output']>;
  isDataValid: Scalars['Boolean']['output'];
  recipients: Array<BulkInvitationRecipient>;
  relationCompanyName: Maybe<Scalars['String']['output']>;
  status: BulkInvitationSetItemStatus;
  updatedAt: Scalars['DateTime']['output'];
  updatedByUserId: Scalars['String']['output'];
};

export type BulkInvitationSetItemConnection = {
  __typename: 'BulkInvitationSetItemConnection';
  edges: Maybe<Array<Maybe<BulkInvitationSetItemEdge>>>;
  pageInfo: PageInfo;
};

export type BulkInvitationSetItemEdge = {
  __typename: 'BulkInvitationSetItemEdge';
  cursor: Maybe<Scalars['String']['output']>;
  node: Maybe<BulkInvitationSetItem>;
};

export enum BulkInvitationSetItemStatus {
  INVITED = 'INVITED',
  INVITE_WITHDRAWN = 'INVITE_WITHDRAWN',
  IN_NETWORK = 'IN_NETWORK',
  NOT_INVITED = 'NOT_INVITED',
}

export type BulkInvitationSetItemToDelete = {
  bulkInvitationSetId: Scalars['String']['input'];
  bulkInvitationSetItemId: Scalars['String']['input'];
};

export type BulkInvitationSetItemsFilterInput = {
  companyName?: InputMaybe<Scalars['String']['input']>;
  isInvalid?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<BulkInvitationSetItemStatus>;
};

export type BulkInvitationSetItemsSortOrderInput = {
  direction: SortDirection;
  key: BulkInvitationSetsSortKey;
};

export type BulkInvitationSetStatistics = {
  __typename: 'BulkInvitationSetStatistics';
  itemCountByStatus: Array<ItemCountByStatus>;
};

export type BulkInvitationSetStatisticsFilterInput = {
  isDataValid?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum BulkInvitationSetsSortKey {
  COMPANY_NAME = 'COMPANY_NAME',
  STATUS = 'STATUS',
}

export type BulkTourUserAssignmentFilterInput = {
  airWayBillNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
  assignedToUserIds?: InputMaybe<Array<Scalars['String']['input']>>;
  billOfLadingNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
  bookingNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
  boundingBox?: InputMaybe<BoundingBoxInput>;
  carrierCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  carrierIds?: InputMaybe<Array<Scalars['String']['input']>>;
  carrierNames?: InputMaybe<Array<Scalars['String']['input']>>;
  consigneeContactNames?: InputMaybe<Array<Scalars['String']['input']>>;
  consigneeLocationNames?: InputMaybe<Array<Scalars['String']['input']>>;
  containerNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
  customFields?: InputMaybe<Array<TourCustomFieldSearch>>;
  customerContactNames?: InputMaybe<Array<Scalars['String']['input']>>;
  customerIds?: InputMaybe<Array<Scalars['String']['input']>>;
  customerLocationNames?: InputMaybe<Array<Scalars['String']['input']>>;
  demurrage?: InputMaybe<OceanDemurrageFilter>;
  filterV2?: InputMaybe<Scalars['GraphQLJSON']['input']>;
  flightNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
  hasDocuments?: InputMaybe<Scalars['Boolean']['input']>;
  impactDays?: InputMaybe<ImpactDaysFilter>;
  incoterm?: InputMaybe<Array<IncotermTerm>>;
  locations?: InputMaybe<Array<TransportLocation>>;
  mainCarrierIds?: InputMaybe<Array<Scalars['String']['input']>>;
  orderNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
  shipmentType?: InputMaybe<Array<ShipmentTypeFilter>>;
  shipperContactNames?: InputMaybe<Array<Scalars['String']['input']>>;
  shipperLocationNames?: InputMaybe<Array<Scalars['String']['input']>>;
  siteIds?: InputMaybe<Array<Scalars['String']['input']>>;
  status?: InputMaybe<TourStatusFilter>;
  statuses?: InputMaybe<Array<TourStatusFilter>>;
  transportAlerts?: InputMaybe<TransportAlertsFilterInput>;
  transportGroupIds?: InputMaybe<Array<Scalars['String']['input']>>;
  transportMode?: InputMaybe<Array<TourFilteringTransportMode>>;
  tripsSearch?: InputMaybe<TripsTextSearch>;
  vesselName?: InputMaybe<VesselNameFilterInput>;
  voyageIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type BulkTourUserAssignmentResult = {
  __typename: 'BulkTourUserAssignmentResult';
  affectedCount: Scalars['Int']['output'];
  failedCount: Scalars['Int']['output'];
  success: Scalars['Boolean']['output'];
};

export enum BulkTourUserAssignmentSelectType {
  EXCLUDE = 'EXCLUDE',
  INCLUDE = 'INCLUDE',
}

export enum BulkVehicleAlternativeIdentifiersErrorType {
  ALREADY_EXISTS = 'ALREADY_EXISTS',
  INVALID_REQUEST = 'INVALID_REQUEST',
  LIMIT_EXCEEDED = 'LIMIT_EXCEEDED',
  NOT_ALLOWED_TO_CHANGE = 'NOT_ALLOWED_TO_CHANGE',
  TIMED_OUT = 'TIMED_OUT',
  UNKNOWN_ERROR = 'UNKNOWN_ERROR',
}

export type BulkVehicleAlternativeIdentifiersItemResult = {
  __typename: 'BulkVehicleAlternativeIdentifiersItemResult';
  conflicts: Array<VehicleAlternativeIdentifierConflict>;
  errorType: Maybe<BulkVehicleAlternativeIdentifiersErrorType>;
  success: Scalars['Boolean']['output'];
  vehicleId: Scalars['String']['output'];
};

export type CalculationError = {
  __typename: 'CalculationError';
  code: EmissionsCalculationErrorCode;
  type: EmissionsCalculationErrorType;
};

export type CancelTransportAnalysisInput = {
  analyzeId: Scalars['String']['input'];
  companyId: Scalars['String']['input'];
};

export type Cargo = {
  __typename: 'Cargo';
  containerEmptyWeight: Scalars['Float']['output'];
  tonsPerFeu: Scalars['Float']['output'];
  tonsPerTeu: Scalars['Float']['output'];
  unit: Scalars['String']['output'];
  volumeWeight: Scalars['String']['output'];
  weight: Scalars['Float']['output'];
};

export type CarriageModeParameter = {
  __typename: 'CarriageModeParameter';
  aircraftType: Maybe<Scalars['String']['output']>;
  driveClass: Maybe<Scalars['String']['output']>;
  emissionClass: Maybe<Scalars['String']['output']>;
  emptyRunFactor: Maybe<Scalars['Int']['output']>;
  ferryRouting: Maybe<Scalars['String']['output']>;
  fuelType: Maybe<Scalars['String']['output']>;
  inlandShipType: Maybe<Scalars['String']['output']>;
  loadFactor: Maybe<Scalars['Float']['output']>;
  lorryClass: Maybe<Scalars['String']['output']>;
  mode: Scalars['String']['output'];
  seaShipType: Maybe<Scalars['String']['output']>;
};

export type CarriageParameters = {
  __typename: 'CarriageParameters';
  bioFuelShare: Scalars['Float']['output'];
  carriageModeParameters: Array<CarriageModeParameter>;
};

export enum CarrierConnectionRelationshipType {
  CARRIER = 'CARRIER',
  SUBCARRIER = 'SUBCARRIER',
}

export enum CarrierNetworkConsentStatus {
  ACCEPTED = 'ACCEPTED',
  DECLINED = 'DECLINED',
  PENDING = 'PENDING',
  REQUESTED = 'REQUESTED',
}

export type CarrierNetworkFilterInput = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  bulkInvitationSetIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  companyNameOrIdentifier?: InputMaybe<Scalars['String']['input']>;
  invitationStatus?: InputMaybe<Array<InvitationOverviewStatus>>;
  invitedAt?: InputMaybe<Scalars['DateTime']['input']>;
  isInvalid?: InputMaybe<Scalars['Boolean']['input']>;
  previouslyOnboarded?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<Array<CarrierNetworkStatus>>;
  tourStatusConsent?: InputMaybe<Array<CarrierNetworkConsentStatus>>;
};

export type CarrierNetworkItem = {
  __typename: 'CarrierNetworkItem';
  allocated: Maybe<Scalars['Float']['output']>;
  archivedAt: Maybe<Scalars['DateTime']['output']>;
  bulkInvitationSetId: Maybe<Scalars['String']['output']>;
  bulkInvitationSetItemId: Maybe<Scalars['String']['output']>;
  companyId: Maybe<Scalars['String']['output']>;
  companyIdentifiers: Array<CompanyIdentifier>;
  companyInvitationId: Maybe<Scalars['String']['output']>;
  companyName: Maybe<Scalars['String']['output']>;
  companyReferenceName: Maybe<Scalars['String']['output']>;
  consentStatus: Maybe<CarrierNetworkConsentStatus>;
  entityId: Scalars['String']['output'];
  isArchived: Scalars['Boolean']['output'];
  isDataValid: Maybe<Scalars['Boolean']['output']>;
  isInUngroupedBulkSet: Scalars['Boolean']['output'];
  isWithdrawn: Maybe<Scalars['Boolean']['output']>;
  otherBulkInvitationSetIds: Array<Scalars['String']['output']>;
  recipients: Maybe<Array<BulkInvitationRecipient>>;
  relationIdentifiers: Array<RelationIdentifierWithValidation>;
  status: Maybe<CarrierNetworkStatus>;
  statusContext: Maybe<CarrierNetworkStatusContext>;
  tracked: Maybe<Scalars['Float']['output']>;
  transports: Maybe<Scalars['Int']['output']>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
};

export type CarrierNetworkItemConnection = {
  __typename: 'CarrierNetworkItemConnection';
  edges: Maybe<Array<Maybe<CarrierNetworkItemEdge>>>;
  pageInfo: PageInfo;
};

export type CarrierNetworkItemEdge = {
  __typename: 'CarrierNetworkItemEdge';
  cursor: Maybe<Scalars['String']['output']>;
  node: Maybe<CarrierNetworkItem>;
};

export enum CarrierNetworkSortKey {
  ALLOCATED = 'ALLOCATED',
  COMPANY_NAME = 'COMPANY_NAME',
  COMPANY_REFERENCE_NAME = 'COMPANY_REFERENCE_NAME',
  CONSENT_STATUS = 'CONSENT_STATUS',
  LANGUAGE = 'LANGUAGE',
  STATUS = 'STATUS',
  TRACKED = 'TRACKED',
  TRANSPORTS = 'TRANSPORTS',
  UPDATED_AT = 'UPDATED_AT',
}

export type CarrierNetworkSortOrderInput = {
  direction: SortDirection;
  key: CarrierNetworkSortKey;
};

export enum CarrierNetworkStatus {
  INVITED = 'INVITED',
  NOT_INVITED = 'NOT_INVITED',
  NO_VISIBILITY_SOURCE = 'NO_VISIBILITY_SOURCE',
  ONBOARDED = 'ONBOARDED',
  REGISTERED = 'REGISTERED',
}

export type CarrierNetworkStatusContext = {
  __typename: 'CarrierNetworkStatusContext';
  previousStatus: CarrierNetworkStatus;
  transitionedAt: Scalars['DateTime']['output'];
  type: CarrierNetworkStatusContextType;
};

export enum CarrierNetworkStatusContextType {
  STATUS_REVERTED = 'STATUS_REVERTED',
}

export type CarrierOption = {
  __typename: 'CarrierOption';
  company_id: Scalars['String']['output'];
  company_name: Maybe<Scalars['String']['output']>;
};

export type CarrierOptionConnection = {
  __typename: 'CarrierOptionConnection';
  edges: Maybe<Array<Maybe<CarrierOptionEdge>>>;
  pageInfo: PageInfo;
};

export type CarrierOptionEdge = {
  __typename: 'CarrierOptionEdge';
  cursor: Maybe<Scalars['String']['output']>;
  node: Maybe<CarrierOption>;
};

export type CarrierReport = {
  __typename: 'CarrierReport';
  allocatedToursCount: Scalars['Int']['output'];
  carrier: Maybe<CompanyProfile>;
  toursCount: Scalars['Int']['output'];
  visibilityIndex: Maybe<Scalars['Float']['output']>;
};

export type CarrierReportConnection = {
  __typename: 'CarrierReportConnection';
  edges: Maybe<Array<Maybe<CarrierReportEdge>>>;
  pageInfo: PageInfo;
};

export type CarrierReportEdge = {
  __typename: 'CarrierReportEdge';
  cursor: Maybe<Scalars['String']['output']>;
  node: Maybe<CarrierReport>;
};

export type ChangeUserMetadataInCompanyInput = {
  companyId: Scalars['String']['input'];
  metadata?: InputMaybe<UserMetadataInCompanyInput>;
  userId: Scalars['String']['input'];
};

export type ChangeUserRoleInCompanyInput = {
  companyId: Scalars['String']['input'];
  role: UserRoleInCompany;
  userId: Scalars['String']['input'];
};

export type CircleGeofence = {
  __typename: 'CircleGeofence';
  origin: PointLocation;
  radius_meters: Scalars['Int']['output'];
};

export type CircleGeofenceInput = {
  origin: PointLocationInput;
  radius_meters: Scalars['Int']['input'];
};

export type CombinedEvent = StopEvent | TourEvent;

export type Company = {
  __typename: 'Company';
  address: Maybe<CompanyAddress>;
  agreement: Maybe<CompanyAgreement>;
  airToursCount: Scalars['Int']['output'];
  apiEndpointUsageLogs: Array<ApiEndpointUsageLog>;
  apiMetricsMessages: ApiMetricsEntryConnection;
  arePlacesEnabled: Maybe<Scalars['Boolean']['output']>;
  assets: CompanyAssets;
  bookingLocations: CountedCompanyBookingLocation;
  bulkInvitationSet: Maybe<BulkInvitationSet>;
  bulkInvitationSetItem: Maybe<BulkInvitationSetItem>;
  bulkInvitationSets: Array<BulkInvitationSet>;
  canChangeTourStatusConsent: Scalars['Boolean']['output'];
  carrierNetwork: Maybe<CountedCarrierNetworkConnection>;
  carrierToursCount: Scalars['Int']['output'];
  carriersConnection: CountedCarrierConnection;
  cityIdentifiersConnection: CountedCompanyStopCitiesConnection;
  companyAnalyticsFiltersConnection: CountedCompanyAnalyticsFilterConnection;
  companyIdentifiers: Array<CompanyIdentifier>;
  companyInvitation: Maybe<CompanyInvite>;
  companySignupStatusRollbackProjectedAt: Maybe<Scalars['DateTime']['output']>;
  companyTourFiltersConnection: CountedCompanyTourFilterConnection;
  companyTransportGroupsConnection: CountedCompanyTransportGroupConnection;
  companyTransportNetworkFiltersConnection: CountedCompanyTransportNetworkFilterConnection;
  companyVehicleGroup: Maybe<CompanyVehicleGroup>;
  companyVehicleGroups: Maybe<Array<Maybe<CompanyVehicleGroup>>>;
  companyWebhookSubscription: Maybe<CompanyWebhookSubscriptionInfo>;
  companyWebhookSubscriptions: Maybe<Array<Maybe<CompanyWebhookSubscriptionListItem>>>;
  company_id: Scalars['String']['output'];
  company_name: Maybe<Scalars['String']['output']>;
  configuration: Maybe<CompanyConfiguration>;
  connectedCustomFields: Array<ConnectedCustomField>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  customExceptionTypes: Array<Scalars['String']['output']>;
  customField: Maybe<ConnectedCustomField>;
  customersConnection: CountedCustomerConnection;
  dashboard: Maybe<Dashboard>;
  dashboardsConnection: CountedDashboardsConnection;
  dataNetworkVisibilityReport: Maybe<DataNetworkVisibilityReport>;
  defaultVehicleDwellTimeThresholdMinutes: Maybe<Scalars['Int']['output']>;
  featureFlag: Scalars['Boolean']['output'];
  featureFlagAuditLogConnection: FeatureFlagAuditLogConnection;
  feature_flags: Maybe<Scalars['GraphQLJSON']['output']>;
  fieldDataSources: Maybe<CompanyFieldDataSources>;
  filterBasedTransportNotification: Maybe<FilterBasedTransportNotification>;
  filterBasedTransportNotifications: Array<FilterBasedTransportNotification>;
  filterBasedTransportNotificationsCreators: Array<NotificationUserProfile>;
  fms_integrated_at: Maybe<Scalars['DateTime']['output']>;
  /**
   * Utility for internal processes that allows checking whether a feature flag
   * is defined for a company, i.e distinguish between false and a flag that is
   * not defined at all
   */
  hasFeatureFlag: Scalars['Boolean']['output'];
  hasHadAnyDeliveryExceptions: Scalars['Boolean']['output'];
  hasHadAnyDocuments: Scalars['Boolean']['output'];
  hasHadAnyExceptions: Scalars['Boolean']['output'];
  hasHadAnyNotes: Scalars['Boolean']['output'];
  hasHadAnyServiceExceptions: Scalars['Boolean']['output'];
  hasHadAnyTemperature: Scalars['Boolean']['output'];
  has_created_transport: Maybe<Scalars['Boolean']['output']>;
  incotermConnection: CountedIncotermConnection;
  invitationHistoryLogs: Array<InvitationHistoryItem>;
  isAllocationDialogVisible: Scalars['Boolean']['output'];
  isPendingSignup: Maybe<Scalars['Boolean']['output']>;
  isPresentOnTransporeonPlatform: Maybe<Scalars['Boolean']['output']>;
  isTrimbleVisibilityCustomer: Scalars['Boolean']['output'];
  isVehicleHistoryUiEnabled: Scalars['Boolean']['output'];
  isVisibilityReportingVisible: Scalars['Boolean']['output'];
  is_carrier: Maybe<Scalars['Boolean']['output']>;
  is_paying_customer: Maybe<Scalars['Boolean']['output']>;
  is_pilot: Maybe<Scalars['Boolean']['output']>;
  is_shipper: Maybe<Scalars['Boolean']['output']>;
  is_test: Maybe<Scalars['Boolean']['output']>;
  latestBulkInvitationSet: Maybe<BulkInvitationSet>;
  latestBulkInvitationSetId: Maybe<Scalars['String']['output']>;
  lightdashEmbeddings: LightdashEmbeddings;
  mainCarriersConnection: CountedMainCarrierConnection;
  /**
   * List maritime intelligence events. Customer-facing visibility is
   * controlled by the `enable_maritime_intelligence` company feature flag
   * in customer-web (consistent with how other ocean features are gated).
   *
   * When `onlyActive` is true (the default), only events with
   * `status = DISRUPTED` are returned - the canonical "incident is happening
   * right now" state. `MONITORING` (pre-disruption surveillance) and
   * `ARCHIVED` (post-disruption) are excluded.
   *
   * `eventId` restricts the list to a single event (still subject to
   * `onlyActive`). Used so a drawer does not fan out to
   * tour-filtering-service for every listed event.
   *
   * An explicit `statuses` list overrides `onlyActive`.
   */
  maritimeIntelligenceEvents: Array<MaritimeIntelligenceEvent>;
  me: Maybe<UserInCompany>;
  networkRelationStatistics: NetworkRelationStatistics;
  networkRelations: Maybe<CountedCompanyRelationConnection>;
  oceanMilestonePerformance: OceanMilestonePerformanceResult;
  oceanPortOptions: Array<OceanPortOption>;
  oceanToursCount: Scalars['Int']['output'];
  onboardingAction: Maybe<OnboardingAction>;
  orderItemCustomFieldIdentifiersConnection: CountedOrderItemCustomFieldConnection;
  orderItemIdentifiersConnection: CountedOrderItemConnection;
  place: Maybe<CompanyPlace>;
  placesConnection: CountedCompanyPlaceConnection;
  platforms: Array<CompanyPlatform>;
  postalCodeIdentifiersConnection: CountedCompanyStopPostalCodesConnection;
  providingVisibilityCompanies: Maybe<CountedProvidingVisibilityCompaniesConnection>;
  providingVisibilityCompany: Maybe<ProvidingVisibilityCompany>;
  receivingVisibilityCompanies: Maybe<CountedReceivingVisibilityCompaniesConnection>;
  receivingVisibilityCompany: Maybe<ReceivingVisibilityCompany>;
  relationIdentifiersConnection: Maybe<CompanyIdentifierConnection>;
  roadToursCount: Scalars['Int']['output'];
  serviceExceptionCodes: Array<Scalars['String']['output']>;
  settings: CompanySettings;
  sharedView: Maybe<SharedView>;
  sharedViewBranding: CompanySharedViewBranding;
  sharedViewDeprecated: Maybe<SharedViewDeprecated>;
  sharedViewsConnection: CountedSharedViewConnection;
  sharedViewsCreatedBy: Array<SharedViewUserProfile>;
  shipperToursCount: Scalars['Int']['output'];
  shippersConnection: CountedShipperConnection;
  signup: Maybe<CompanySignup>;
  signupAction: Maybe<SignupAction>;
  signupCompletedAt: Maybe<Scalars['DateTime']['output']>;
  signupStatusTransitionedAt: Maybe<Scalars['DateTime']['output']>;
  signupVisibilitySources: Maybe<Array<CompanySignupVisibilitySource>>;
  signupVisibilitySourcesViaSubcarriers: Maybe<Array<CompanySignupVisibilitySource>>;
  sitesConnection: CountedSiteConnection;
  stopAddress: Maybe<CompanyStopAddress>;
  stopAddressesConnection: CountedCompanyStopAddressConnection;
  stopCompanyNameIdentifiersConnection: CountedStopCompanyNameConnection;
  stopGateIdentifiersConnection: CountedCompanyStopGateIdentifiersConnection;
  stopStatesIdentifiersConnection: CountedCompanyStopStatesConnection;
  tags: Array<CompanyTag>;
  telematicsIntegration: Maybe<CompanyTelematicsIntegration>;
  telematicsIntegrations: Array<CompanyTelematicsIntegration>;
  tfsSpace: Maybe<TfsSpace>;
  totalVehiclesCount: Scalars['Int']['output'];
  tour: Maybe<Tour>;
  tourReportsByCarrier: CarrierReportConnection;
  tourReportsByShipper: ShipperReportConnection;
  tourVisibilityPerformance: Maybe<TourVisibilityPerformance>;
  tours: CountedTourConnection;
  transporeonId: Maybe<Scalars['String']['output']>;
  tripsIdentifiersConnection: CountedTripsIdentifiersConnection;
  tripsOptionsConnection: CountedTripsOptionConnection;
  tripsTours: CountedTripsTourConnection;
  unifiedOnboardingStatus: Maybe<UnifiedCompanyOnboardingStatus>;
  unifiedOnboardingStuckReason: Maybe<UnifiedCompanyOnboardingStuckReason>;
  unifiedSignupEvents: Maybe<Array<UnifiedCompanySignupEvent>>;
  unifiedSignupStatus: Maybe<UnifiedCompanySignupStatus>;
  user: Maybe<UserInCompanyProfile>;
  userGroupOnPlatform: Maybe<UserGroupOnPlatform>;
  userGroupsOnPlatform: UserGroupOnPlatformConnection;
  users: CountedUserInCompanyProfileConnection;
  vatNumbers: Array<CompanyVatNumber>;
  vehicle: Maybe<Vehicle>;
  vehicleGrantPartner: Maybe<VehicleGrantPartner>;
  vehicleGrantPartners: CountedVehicleGrantPartnerConnection;
  vehicles: Maybe<CompanyVehicles>;
  visibilityPerformanceOverview: Maybe<VisibilityPerformanceOverview>;
  widgetPreview: Maybe<WidgetPreview>;
};

export type CompanyApiMetricsMessagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  endDate: Scalars['DateTime']['input'];
  endpointId: Scalars['String']['input'];
  errorMessage?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<SortDirection>;
  startDate: Scalars['DateTime']['input'];
  statusCode?: InputMaybe<Scalars['String']['input']>;
};

export type CompanyBookingLocationsArgs = {
  search?: InputMaybe<Scalars['String']['input']>;
};

export type CompanyBulkInvitationSetArgs = {
  bulkInvitationSetId: Scalars['String']['input'];
};

export type CompanyBulkInvitationSetItemArgs = {
  bulkInvitationSetId: Scalars['String']['input'];
  bulkInvitationSetItemId: Scalars['String']['input'];
};

export type CompanyCarrierNetworkArgs = {
  filter?: InputMaybe<CarrierNetworkFilterInput>;
  sort?: InputMaybe<CarrierNetworkSortOrderInput>;
  timezone?: InputMaybe<Scalars['IANATimezone']['input']>;
};

export type CompanyCarriersConnectionArgs = {
  companyIds?: InputMaybe<Array<Scalars['String']['input']>>;
  relationshipTypes: Array<CarrierConnectionRelationshipType>;
  textSearch?: InputMaybe<Scalars['String']['input']>;
};

export type CompanyCityIdentifiersConnectionArgs = {
  textSearch?: InputMaybe<Scalars['String']['input']>;
};

export type CompanyCompanyAnalyticsFiltersConnectionArgs = {
  textSearch?: InputMaybe<Scalars['String']['input']>;
};

export type CompanyCompanyInvitationArgs = {
  invitationId: Scalars['String']['input'];
};

export type CompanyCompanyTourFiltersConnectionArgs = {
  filterType?: InputMaybe<FilterType>;
  textSearch?: InputMaybe<Scalars['String']['input']>;
};

export type CompanyCompanyTransportGroupsConnectionArgs = {
  textSearch?: InputMaybe<Scalars['String']['input']>;
  transportGroupIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type CompanyCompanyTransportNetworkFiltersConnectionArgs = {
  textSearch?: InputMaybe<Scalars['String']['input']>;
};

export type CompanyCompanyVehicleGroupArgs = {
  companyVehicleGroupId: Scalars['String']['input'];
};

export type CompanyCompanyWebhookSubscriptionArgs = {
  subscriptionId: Scalars['String']['input'];
};

export type CompanyConnectedCustomFieldsArgs = {
  sort?: InputMaybe<ConnectedCustomFieldNamesSortOrder>;
  transportMode: TourFilteringTransportMode;
};

export type CompanyCustomFieldArgs = {
  fieldName: Scalars['String']['input'];
  transportMode: TourFilteringTransportMode;
};

export type CompanyCustomersConnectionArgs = {
  companyIds?: InputMaybe<Array<Scalars['String']['input']>>;
  textSearch?: InputMaybe<Scalars['String']['input']>;
};

export type CompanyDashboardArgs = {
  dashboardId: Scalars['String']['input'];
};

export type CompanyDashboardsConnectionArgs = {
  queryType?: InputMaybe<DashboardQueryType>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type CompanyDataNetworkVisibilityReportArgs = {
  dataNetworkFilter?: InputMaybe<DataNetworkFilterInput>;
  filter?: InputMaybe<DataNetworkReportFilterInput>;
  filterV2?: InputMaybe<Scalars['GraphQLJSON']['input']>;
  sort?: InputMaybe<DataNetworkReportSortOrderInput>;
  type: DataNetworkReportType;
};

export type CompanyFeatureFlagArgs = {
  flagName: Scalars['String']['input'];
};

export type CompanyFeatureFlagAuditLogConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CompanyFilterBasedTransportNotificationArgs = {
  notificationId: Scalars['String']['input'];
};

export type CompanyFilterBasedTransportNotificationsArgs = {
  filter?: InputMaybe<NotificationFilterInput>;
  sort?: InputMaybe<NotificationSortOrder>;
};

export type CompanyFilterBasedTransportNotificationsCreatorsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type CompanyHasFeatureFlagArgs = {
  flagName: Scalars['String']['input'];
};

export type CompanyIncotermConnectionArgs = {
  transportMode: TourFilteringTransportMode;
};

export type CompanyInvitationHistoryLogsArgs = {
  acceptingCompanyId: Scalars['String']['input'];
};

export type CompanyMainCarriersConnectionArgs = {
  companyIds?: InputMaybe<Array<Scalars['String']['input']>>;
  textSearch?: InputMaybe<Scalars['String']['input']>;
};

export type CompanyMaritimeIntelligenceEventsArgs = {
  eventId?: InputMaybe<Scalars['ID']['input']>;
  onlyActive?: InputMaybe<Scalars['Boolean']['input']>;
  statuses?: InputMaybe<Array<MaritimeEventStatus>>;
};

export type CompanyNetworkRelationsArgs = {
  filter?: InputMaybe<NetworkRelationFilter>;
  sort?: InputMaybe<NetworkRelationsSortOrderInput>;
};

export type CompanyOceanMilestonePerformanceArgs = {
  filter?: InputMaybe<Scalars['GraphQLJSON']['input']>;
};

export type CompanyOceanPortOptionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  textSearch?: InputMaybe<Scalars['String']['input']>;
  transportMode: TripsTransportMode;
  type: OceanPortLocationType;
};

export type CompanyOrderItemCustomFieldIdentifiersConnectionArgs = {
  search?: InputMaybe<OrderItemCustomFieldSearch>;
};

export type CompanyOrderItemIdentifiersConnectionArgs = {
  textSearch?: InputMaybe<Scalars['String']['input']>;
};

export type CompanyPlaceArgs = {
  place_id: Scalars['String']['input'];
};

export type CompanyPlacesConnectionArgs = {
  includeSixfoldGenerated?: InputMaybe<Scalars['Boolean']['input']>;
  placeIds?: InputMaybe<Array<Scalars['String']['input']>>;
  textSearch?: InputMaybe<PlaceTextSearch>;
};

export type CompanyPostalCodeIdentifiersConnectionArgs = {
  textSearch?: InputMaybe<Scalars['String']['input']>;
};

export type CompanyProvidingVisibilityCompaniesArgs = {
  filter: ProvidingVisibilityCompaniesFilterInput;
  sort?: InputMaybe<ProvidingVisibilityCompaniesSortOrderInput>;
};

export type CompanyProvidingVisibilityCompanyArgs = {
  companyId: Scalars['String']['input'];
};

export type CompanyReceivingVisibilityCompaniesArgs = {
  filter: ReceivingVisibilityCompaniesFilterInput;
  sort?: InputMaybe<ReceivingVisibilityCompaniesSortOrderInput>;
};

export type CompanyReceivingVisibilityCompanyArgs = {
  companyId: Scalars['String']['input'];
};

export type CompanyRelationIdentifiersConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  carrierCompanyIds?: InputMaybe<Array<Scalars['String']['input']>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  relationIdentifierIds?: InputMaybe<Array<Scalars['String']['input']>>;
  textSearch?: InputMaybe<Scalars['String']['input']>;
};

export type CompanySharedViewArgs = {
  sharedViewId: Scalars['String']['input'];
};

export type CompanySharedViewDeprecatedArgs = {
  companyTourFilterId: Scalars['String']['input'];
};

export type CompanySharedViewsConnectionArgs = {
  filter?: InputMaybe<SharedViewsFilterInput>;
  sort?: InputMaybe<SharedViewsSortOrder>;
};

export type CompanyShippersConnectionArgs = {
  companyIds?: InputMaybe<Array<Scalars['String']['input']>>;
  textSearch?: InputMaybe<Scalars['String']['input']>;
};

export type CompanySitesConnectionArgs = {
  siteIds?: InputMaybe<Array<Scalars['String']['input']>>;
  textSearch?: InputMaybe<Scalars['String']['input']>;
};

export type CompanyStopAddressArgs = {
  addressId: Scalars['String']['input'];
};

export type CompanyStopAddressesConnectionArgs = {
  textSearch?: InputMaybe<Scalars['String']['input']>;
};

export type CompanyStopCompanyNameIdentifiersConnectionArgs = {
  textSearch?: InputMaybe<Scalars['String']['input']>;
};

export type CompanyStopGateIdentifiersConnectionArgs = {
  gateIds?: InputMaybe<Array<Scalars['String']['input']>>;
  textSearch?: InputMaybe<Scalars['String']['input']>;
};

export type CompanyStopStatesIdentifiersConnectionArgs = {
  textSearch?: InputMaybe<Scalars['String']['input']>;
};

export type CompanyTelematicsIntegrationArgs = {
  telematicsIntegrationId: Scalars['String']['input'];
};

export type CompanyTourArgs = {
  tour_id: Scalars['Int']['input'];
};

export type CompanyTourReportsByCarrierArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CompanyTourReportsByShipperArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CompanyTourVisibilityPerformanceArgs = {
  filter?: InputMaybe<VisibilityPerformanceFilterInput>;
  sort?: InputMaybe<TourVisibilityPerformanceListSortOrderInput>;
  viewMode: ViewMode;
};

export type CompanyToursArgs = {
  allocationStatus?: InputMaybe<TourAllocationStatus>;
  assignedToUserIds?: InputMaybe<Array<Scalars['String']['input']>>;
  carrierIds?: InputMaybe<Array<Scalars['String']['input']>>;
  customFields?: InputMaybe<Array<TourCustomFieldSearch>>;
  customerIds?: InputMaybe<Array<Scalars['String']['input']>>;
  delayStatus?: InputMaybe<TourDelayStatusFilter>;
  delayTime?: InputMaybe<TimeRangeInput>;
  documentTypes?: InputMaybe<Array<DocumentType>>;
  endTimeEnd?: InputMaybe<Scalars['DateTime']['input']>;
  endTimeStart?: InputMaybe<Scalars['DateTime']['input']>;
  endTimeSugarTimezone?: InputMaybe<Scalars['IANATimezone']['input']>;
  exceptionTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  failureReasons?: InputMaybe<Array<TourFailureReasonType>>;
  filterV2?: InputMaybe<Scalars['GraphQLJSON']['input']>;
  hasDocuments?: InputMaybe<Scalars['Boolean']['input']>;
  hasNotes?: InputMaybe<Scalars['Boolean']['input']>;
  hasTemperature?: InputMaybe<Scalars['Boolean']['input']>;
  lastActualLocationsAndMilestones?: InputMaybe<LastActualLocationsAndMilestonesFilterInput>;
  lastSignalTimestamp?: InputMaybe<LastSignalTimestampFilterInput>;
  mainCarrierIds?: InputMaybe<Array<Scalars['String']['input']>>;
  mainVisibilityIssues?: InputMaybe<Array<VisibilityIssueType>>;
  orderItemCustomFields?: InputMaybe<OrderItemCustomFieldInput>;
  orderItemGroups?: InputMaybe<OrderItemGroupsInput>;
  orderItemIsHazardous?: InputMaybe<Scalars['Boolean']['input']>;
  orderItemNames?: InputMaybe<Array<Scalars['String']['input']>>;
  placeIds?: InputMaybe<Array<Scalars['String']['input']>>;
  role: TourCompanyRole;
  serviceExceptionCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  shipmentType?: InputMaybe<Array<ShipmentTypeFilter>>;
  shipperIds?: InputMaybe<Array<Scalars['String']['input']>>;
  siteIds?: InputMaybe<Array<Scalars['String']['input']>>;
  sortOrder?: InputMaybe<TourSortOrder>;
  startTimeEnd?: InputMaybe<Scalars['DateTime']['input']>;
  startTimeStart?: InputMaybe<Scalars['DateTime']['input']>;
  startTimeSugarTimezone?: InputMaybe<Scalars['IANATimezone']['input']>;
  status?: InputMaybe<TourStatusFilter>;
  statuses?: InputMaybe<Array<TourStatusFilter>>;
  stopBookingLocationNames?: InputMaybe<Array<Scalars['String']['input']>>;
  stopCompanyNames?: InputMaybe<Array<Scalars['String']['input']>>;
  stopCountries?: InputMaybe<Array<Scalars['String']['input']>>;
  stopFilters?: InputMaybe<Array<StopFilterInput>>;
  stopStates?: InputMaybe<Array<StopStatesInput>>;
  temperatureEverOutOfRange?: InputMaybe<TemperatureEverOutOfRangeFilterInput>;
  textSearch?: InputMaybe<TourTextSearch>;
  timeSpentAtStop?: InputMaybe<TimeRangeInput>;
  tourIds?: InputMaybe<Array<Scalars['String']['input']>>;
  transportMode?: InputMaybe<Array<TourFilteringTransportMode>>;
  vehicleLicensePlates?: InputMaybe<Array<TourVehicleLicensePlateFilterInput>>;
  vesselName?: InputMaybe<VesselNameFilterInput>;
  voyageIds?: InputMaybe<Array<Scalars['String']['input']>>;
  warnings?: InputMaybe<Array<TourWarningType>>;
  workingStopStatus?: InputMaybe<WorkingStopStatusFilter>;
  workingStopTimeslotBeginEnd?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CompanyTripsIdentifiersConnectionArgs = {
  identifierValues?: InputMaybe<Array<Scalars['String']['input']>>;
  textSearch?: InputMaybe<Scalars['String']['input']>;
  transportMode: TripsTransportMode;
  types: Array<TripsIdentifierType>;
};

export type CompanyTripsOptionsConnectionArgs = {
  subType: Scalars['String']['input'];
  textSearch?: InputMaybe<Scalars['String']['input']>;
  transportMode: TripsTransportMode;
  type?: InputMaybe<Scalars['String']['input']>;
  types?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type CompanyTripsToursArgs = {
  airWayBillNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
  assignedToUserIds?: InputMaybe<Array<Scalars['String']['input']>>;
  billOfLadingNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
  bookingNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
  boundingBox?: InputMaybe<BoundingBoxInput>;
  carrierCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  carrierIds?: InputMaybe<Array<Scalars['String']['input']>>;
  carrierNames?: InputMaybe<Array<Scalars['String']['input']>>;
  consigneeContactNames?: InputMaybe<Array<Scalars['String']['input']>>;
  consigneeLocationNames?: InputMaybe<Array<Scalars['String']['input']>>;
  containerNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
  customFields?: InputMaybe<Array<TourCustomFieldSearch>>;
  customerContactNames?: InputMaybe<Array<Scalars['String']['input']>>;
  customerIds?: InputMaybe<Array<Scalars['String']['input']>>;
  customerLocationNames?: InputMaybe<Array<Scalars['String']['input']>>;
  demurrage?: InputMaybe<OceanDemurrageFilter>;
  filterV2?: InputMaybe<Scalars['GraphQLJSON']['input']>;
  flightNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
  hasDocuments?: InputMaybe<Scalars['Boolean']['input']>;
  impactDays?: InputMaybe<ImpactDaysFilter>;
  incoterm?: InputMaybe<Array<IncotermTerm>>;
  locations?: InputMaybe<Array<TransportLocation>>;
  mainCarrierIds?: InputMaybe<Array<Scalars['String']['input']>>;
  orderNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
  shipmentType?: InputMaybe<Array<ShipmentTypeFilter>>;
  shipperContactNames?: InputMaybe<Array<Scalars['String']['input']>>;
  shipperLocationNames?: InputMaybe<Array<Scalars['String']['input']>>;
  siteIds?: InputMaybe<Array<Scalars['String']['input']>>;
  sortOrder?: InputMaybe<TourSortOrder>;
  status?: InputMaybe<TourStatusFilter>;
  statuses?: InputMaybe<Array<TourStatusFilter>>;
  transportAlerts?: InputMaybe<TransportAlertsFilterInput>;
  transportGroupIds?: InputMaybe<Array<Scalars['String']['input']>>;
  transportMode?: InputMaybe<Array<TourFilteringTransportMode>>;
  tripsSearch?: InputMaybe<TripsTextSearch>;
  vesselName?: InputMaybe<VesselNameFilterInput>;
  voyageIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type CompanyUserArgs = {
  userId: Scalars['String']['input'];
};

export type CompanyUserGroupOnPlatformArgs = {
  groupId: Scalars['String']['input'];
};

export type CompanyUserGroupsOnPlatformArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CompanyUsersArgs = {
  search?: InputMaybe<Scalars['String']['input']>;
  userIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type CompanyVehicleArgs = {
  vehicleId: Scalars['String']['input'];
};

export type CompanyVehicleGrantPartnerArgs = {
  grantDirection: GrantDirection;
  partnerId: Scalars['String']['input'];
};

export type CompanyVehicleGrantPartnersArgs = {
  grantDirection: GrantDirection;
  partnerNameSearch?: InputMaybe<Scalars['String']['input']>;
};

export type CompanyVisibilityPerformanceOverviewArgs = {
  aggregate?: InputMaybe<VisibilityPerformanceOverviewAggregateInput>;
  filter?: InputMaybe<VisibilityPerformanceFilterInput>;
  sort?: InputMaybe<VisibilityPerformanceOverviewSortOrderInput>;
  timezone?: InputMaybe<Scalars['IANATimezone']['input']>;
  viewMode: ViewMode;
};

export type CompanyWidgetPreviewArgs = {
  filters?: InputMaybe<Array<WidgetFilterInput>>;
  filtersV2?: InputMaybe<Array<WidgetFilterInputV2>>;
  operator?: InputMaybe<OperatorType>;
  type: WidgetType;
};

export type CompanyAddress = {
  __typename: 'CompanyAddress';
  city: Scalars['String']['output'];
  country: Scalars['String']['output'];
  postalCode: Scalars['String']['output'];
  street: Scalars['String']['output'];
};

export type CompanyAddressInput = {
  city: Scalars['String']['input'];
  country: Scalars['String']['input'];
  postalCode: Scalars['String']['input'];
  street: Scalars['String']['input'];
};

/**
 * Current effective PUA/DPA agreement state for a company, sourced from the
 * Transporeon platform agreement and company events. Carriers on a Light
 * Registration have no agreement (hasAgreement = false).
 */
export type CompanyAgreement = {
  __typename: 'CompanyAgreement';
  agreementVersion: Maybe<Scalars['Float']['output']>;
  contractualPartner: Maybe<Scalars['String']['output']>;
  hasAgreement: Scalars['Boolean']['output'];
  signedDate: Maybe<Scalars['DateTime']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

/**
 * Effective DPA/PUA agreement status of a company, used to filter the company list.
 * - HAS_DPA: has an agreement on PUA v14 or later (DPA included)
 * - NO_DPA: has an agreement but on a pre-v14 PUA (no DPA)
 * - LIGHT_REGISTRATION: no PUA on record, either an explicit no-agreement state or no agreement data received yet (uses functionality free of charge)
 */
export enum CompanyAgreementStatus {
  HAS_DPA = 'HAS_DPA',
  LIGHT_REGISTRATION = 'LIGHT_REGISTRATION',
  NO_DPA = 'NO_DPA',
}

export type CompanyAnalyticsFilter = {
  __typename: 'CompanyAnalyticsFilter';
  companyAnalyticsFilterId: Scalars['String']['output'];
  filterV2: VisibilityPerformanceFilter;
  name: Scalars['String']['output'];
  visibilityType: CompanyAnalyticsFilterVisibility;
};

export type CompanyAnalyticsFilterConnection = {
  __typename: 'CompanyAnalyticsFilterConnection';
  edges: Maybe<Array<Maybe<CompanyAnalyticsFilterEdge>>>;
  pageInfo: PageInfo;
};

export type CompanyAnalyticsFilterEdge = {
  __typename: 'CompanyAnalyticsFilterEdge';
  cursor: Maybe<Scalars['String']['output']>;
  node: Maybe<CompanyAnalyticsFilter>;
};

export enum CompanyAnalyticsFilterVisibility {
  COMPANY = 'COMPANY',
  PRIVATE = 'PRIVATE',
}

export type CompanyAsset = {
  __typename: 'CompanyAsset';
  url: Scalars['String']['output'];
};

export type CompanyAssets = {
  __typename: 'CompanyAssets';
  consigneeBackground: Maybe<CompanyAsset>;
  consigneeLogo: Maybe<CompanyAsset>;
  sharedViewLogo: Maybe<CompanyAsset>;
};

export type CompanyBookingLocation = {
  __typename: 'CompanyBookingLocation';
  bookingLocationName: Scalars['String']['output'];
};

export type CompanyBookingLocationConnection = {
  __typename: 'CompanyBookingLocationConnection';
  edges: Maybe<Array<Maybe<CompanyBookingLocationEdge>>>;
  pageInfo: PageInfo;
};

export type CompanyBookingLocationEdge = {
  __typename: 'CompanyBookingLocationEdge';
  cursor: Maybe<Scalars['String']['output']>;
  node: Maybe<CompanyBookingLocation>;
};

export type CompanyBulkInvitationRecipient = {
  email: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
};

export type CompanyBulkInviteMetadata = {
  fileName: Scalars['String']['input'];
  fileSize: Scalars['String']['input'];
};

export type CompanyConfiguration = {
  __typename: 'CompanyConfiguration';
  configurations: Configuration;
};

export type CompanyConnection = {
  __typename: 'CompanyConnection';
  edges: Maybe<Array<Maybe<CompanyEdge>>>;
  pageInfo: PageInfo;
};

export type CompanyCountBySignupStatus = {
  __typename: 'CompanyCountBySignupStatus';
  count: Scalars['Int']['output'];
  signupStatus: Maybe<UnifiedCompanyRelationshipSignupStatus>;
};

export type CompanyCustomFieldConfiguration = {
  __typename: 'CompanyCustomFieldConfiguration';
  displayName: Maybe<Scalars['String']['output']>;
  key: Scalars['String']['output'];
  visibility: Maybe<CustomFieldConfigurationVisibility>;
  visibilityAction: Maybe<CustomFieldConfigurationVisibilityAction>;
};

export type CompanyCustomFieldConfigurationInput = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  key: Scalars['String']['input'];
  visibility?: InputMaybe<CustomFieldConfigurationVisibility>;
  visibilityAction?: InputMaybe<CustomFieldConfigurationVisibilityAction>;
};

export type CompanyCustomFieldsConfiguration = {
  __typename: 'CompanyCustomFieldsConfiguration';
  fields: Maybe<Array<CompanyCustomFieldConfiguration>>;
};

export type CompanyCustomFieldsConfigurationInput = {
  fields?: InputMaybe<Array<CompanyCustomFieldConfigurationInput>>;
};

export enum CompanyDataSource {
  EXTERNAL = 'EXTERNAL',
  INTERNAL = 'INTERNAL',
}

export type CompanyEdge = {
  __typename: 'CompanyEdge';
  cursor: Maybe<Scalars['String']['output']>;
  node: Maybe<Company>;
};

export type CompanyFieldDataSources = {
  __typename: 'CompanyFieldDataSources';
  companyName: Maybe<CompanyDataSource>;
  isCarrier: Maybe<CompanyDataSource>;
  isShipper: Maybe<CompanyDataSource>;
  isTest: Maybe<CompanyDataSource>;
};

export type CompanyIdAndVisibilityServices = {
  __typename: 'CompanyIdAndVisibilityServices';
  companyId: Scalars['String']['output'];
  visibilityServices: Maybe<Array<VisibilityService>>;
};

export type CompanyIdentifier = {
  __typename: 'CompanyIdentifier';
  companyId: Scalars['String']['output'];
  companyIdentifierId: Scalars['String']['output'];
  discriminatorCountry: Maybe<Scalars['String']['output']>;
  identifierType: CompanyIdentifierType;
  identifierValue: Scalars['String']['output'];
  source: Scalars['String']['output'];
};

export type CompanyIdentifierConnection = {
  __typename: 'CompanyIdentifierConnection';
  edges: Maybe<Array<Maybe<CompanyIdentifierEdge>>>;
  pageInfo: PageInfo;
};

export type CompanyIdentifierEdge = {
  __typename: 'CompanyIdentifierEdge';
  cursor: Maybe<Scalars['String']['output']>;
  node: Maybe<CompanyIdentifier>;
};

export enum CompanyIdentifierType {
  MC_NUMBER = 'MC_NUMBER',
  MISCELLANEOUS = 'MISCELLANEOUS',
  SCAC = 'SCAC',
  TAX_IDENTIFICATION_NUMBER = 'TAX_IDENTIFICATION_NUMBER',
  TTC_SHARING_AGREEMENT_ID = 'TTC_SHARING_AGREEMENT_ID',
  USDOT_NUMBER = 'USDOT_NUMBER',
  VAT_NUMBER = 'VAT_NUMBER',
}

export type CompanyInvitationRecipient = {
  __typename: 'CompanyInvitationRecipient';
  email: Scalars['String']['output'];
  locale: Scalars['String']['output'];
};

export type CompanyInvite = {
  __typename: 'CompanyInvite';
  acceptedByCompany: Maybe<CompanyProfile>;
  companyInviteId: Scalars['String']['output'];
  companyName: Maybe<Scalars['String']['output']>;
  deadlineAt: Scalars['DateTime']['output'];
  historyLog: Array<InvitationHistoryItem>;
  identifiers: Maybe<Array<CompanyIdentifier>>;
  invitationLink: Maybe<Scalars['String']['output']>;
  inviteMethod: Maybe<CompanyInviteMethod>;
  invitedAt: Scalars['DateTime']['output'];
  invitedByCompany: Maybe<CompanyProfile>;
  invitedByUser: Maybe<UserProfile>;
  invitedCompany: Maybe<CompanyProfile>;
  metadata: CompanyInviteMetadata;
  recipient: CompanyInviteRecipient;
  recipients: Array<CompanyInvitationRecipient>;
  status: CompanyInviteStatus;
  type: CompanyInviteType;
};

export type CompanyInviteMetadata = {
  __typename: 'CompanyInviteMetadata';
  locale: Scalars['String']['output'];
};

export enum CompanyInviteMethod {
  BULK = 'BULK',
  STANDALONE = 'STANDALONE',
}

export type CompanyInviteRecipient = {
  __typename: 'CompanyInviteRecipient';
  email: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export enum CompanyInviteStatus {
  COMPLETED = 'COMPLETED',
  IGNORED = 'IGNORED',
  PENDING = 'PENDING',
  WITHDRAWN = 'WITHDRAWN',
}

export enum CompanyInviteType {
  LINK_AND_EMAIL = 'LINK_AND_EMAIL',
  LINK_ONLY = 'LINK_ONLY',
}

export type CompanyLemLicenses = {
  __typename: 'CompanyLemLicenses';
  arc_license_active: Scalars['Boolean']['output'];
  arc_toggle_status: ArcToggleStatus;
  company_id: Scalars['String']['output'];
  licenses: Array<LemLicense>;
  transporeon_account_id: Maybe<Scalars['Int']['output']>;
  visibility_standard_license: Maybe<LemLicense>;
};

export type CompanyOverview = {
  __typename: 'CompanyOverview';
  assignmentPercentage: Maybe<Scalars['Float']['output']>;
  assignmentPercentageChange: Maybe<Scalars['Float']['output']>;
  companyId: Scalars['String']['output'];
  tourCancelledCount: Scalars['Int']['output'];
  tourCompletedCount: Scalars['Int']['output'];
  tourTotalCount: Scalars['Int']['output'];
  tourUnassignedCount: Scalars['Int']['output'];
  tourUpcomingCount: Scalars['Int']['output'];
  tourWorkingCount: Scalars['Int']['output'];
  visibilityIndex: Maybe<Scalars['Float']['output']>;
  visibilityIndexChange: Maybe<Scalars['Float']['output']>;
};

export type CompanyPlace = {
  __typename: 'CompanyPlace';
  addresses: Array<CompanyPlaceAddress>;
  geofences: Array<PlaceGeofenceWithZone>;
  isSixfoldGenerated: Scalars['Boolean']['output'];
  location: PointLocation;
  name: Scalars['String']['output'];
  place_id: Scalars['String']['output'];
  possibleAddresses: CompanyStopAddressConnection;
  referenceId: Maybe<Scalars['String']['output']>;
  stopAddresses: Array<CompanyStopAddress>;
  tours: CountedPlaceTourConnection;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  updatedByUser: Maybe<UserProfile>;
};

export type CompanyPlacePossibleAddressesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CompanyPlaceToursArgs = {
  arrivalTimeAfter?: InputMaybe<Scalars['DateTime']['input']>;
  arrivalTimeBefore?: InputMaybe<Scalars['DateTime']['input']>;
  status: SiteTourStatusFilter;
};

export type CompanyPlaceAddress = {
  __typename: 'CompanyPlaceAddress';
  addressId: Maybe<Scalars['String']['output']>;
  city: Scalars['String']['output'];
  companyName: Maybe<Scalars['String']['output']>;
  country: Scalars['String']['output'];
  fullAddress: Maybe<Scalars['String']['output']>;
  gate: Maybe<Scalars['String']['output']>;
  gateId: Maybe<Scalars['String']['output']>;
  state: Maybe<Scalars['String']['output']>;
  streetAddress: Scalars['String']['output'];
  zipcode: Scalars['String']['output'];
};

export type CompanyPlaceConnection = {
  __typename: 'CompanyPlaceConnection';
  edges: Maybe<Array<Maybe<CompanyPlaceEdge>>>;
  pageInfo: PageInfo;
};

export type CompanyPlaceEdge = {
  __typename: 'CompanyPlaceEdge';
  cursor: Maybe<Scalars['String']['output']>;
  node: Maybe<CompanyPlace>;
};

export type CompanyPlatform = {
  __typename: 'CompanyPlatform';
  company_id: Scalars['String']['output'];
  company_id_on_platform: Scalars['String']['output'];
  company_platform_id: Scalars['String']['output'];
  created_at: Scalars['DateTime']['output'];
  created_by: Maybe<UserProfile>;
  platformPageUrl: Maybe<Scalars['String']['output']>;
  platform_id: Scalars['String']['output'];
  platform_name: Scalars['String']['output'];
};

export type CompanyPlatformPlatformPageUrlArgs = {
  pageType: CompanyPlatformPageType;
};

export type CompanyPlatformInput = {
  company_id_on_platform: Scalars['String']['input'];
  platform_id: Scalars['String']['input'];
};

export enum CompanyPlatformPageType {
  tpa_dev_company_page = 'tpa_dev_company_page',
  tpa_int_company_page = 'tpa_int_company_page',
  tpa_production_company_page = 'tpa_production_company_page',
  tpa_test_company_page = 'tpa_test_company_page',
}

export type CompanyProfile = {
  __typename: 'CompanyProfile';
  company_id: Scalars['String']['output'];
  company_name: Maybe<Scalars['String']['output']>;
};

export type CompanyProfileConnection = {
  __typename: 'CompanyProfileConnection';
  edges: Maybe<Array<Maybe<CompanyProfileEdge>>>;
  pageInfo: PageInfo;
};

export type CompanyProfileEdge = {
  __typename: 'CompanyProfileEdge';
  cursor: Maybe<Scalars['String']['output']>;
  node: Maybe<CompanyProfile>;
};

export type CompanyRelationship = {
  __typename: 'CompanyRelationship';
  companyRelationshipId: Scalars['String']['output'];
  dataSharingConsent: Maybe<DataSharingConsent>;
  relationIdentifiers: Array<CompanyIdentifier>;
  relationshipType: CompanyRelationshipType;
  sourceCompany: Company;
  targetCompany: Company;
  unifiedOnboardingStatus: Maybe<UnifiedCompanyRelationshipOnboardingStatus>;
  unifiedOnboardingStuckReason: Maybe<UnifiedCompanyOnboardingStuckReason>;
  unifiedSignupEvents: Maybe<Array<UnifiedCompanyRelationshipSignupEvent>>;
  unifiedSignupStatus: Maybe<UnifiedCompanyRelationshipSignupStatus>;
};

export type CompanyRelationshipConnection = {
  __typename: 'CompanyRelationshipConnection';
  edges: Maybe<Array<Maybe<CompanyRelationshipEdge>>>;
  pageInfo: PageInfo;
};

export type CompanyRelationshipEdge = {
  __typename: 'CompanyRelationshipEdge';
  cursor: Maybe<Scalars['String']['output']>;
  node: Maybe<CompanyRelationship>;
};

export enum CompanyRelationshipRole {
  SOURCE = 'SOURCE',
  TARGET = 'TARGET',
}

export enum CompanyRelationshipType {
  CARRIER = 'CARRIER',
  REFERRER = 'REFERRER',
  SUBCARRIER = 'SUBCARRIER',
}

export enum CompanyRole {
  CARRIER = 'CARRIER',
  SHIPPER = 'SHIPPER',
}

export type CompanySettings = {
  __typename: 'CompanySettings';
  allowAllocatingFromGlobalPool: Scalars['Boolean']['output'];
  enableAutoAllocation: Scalars['Boolean']['output'];
  enableAutoAllocationFullVisibility: Scalars['Boolean']['output'];
  enableTourEmissionsCalculation: Scalars['Boolean']['output'];
  shareOwnVehiclesInGlobalPool: Scalars['Boolean']['output'];
  transportContactDetails: Array<CompanyTransportContactDetails>;
};

export type CompanySettingsInput = {
  allowAllocatingFromGlobalPool?: InputMaybe<Scalars['Boolean']['input']>;
  enableAutoAllocation?: InputMaybe<Scalars['Boolean']['input']>;
  enableAutoAllocationFullVisibility?: InputMaybe<Scalars['Boolean']['input']>;
  enableTourEmissionsCalculation?: InputMaybe<Scalars['Boolean']['input']>;
  shareOwnVehiclesInGlobalPool?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CompanySharedViewBranding = {
  __typename: 'CompanySharedViewBranding';
  logo: Maybe<CompanyAsset>;
};

export type CompanySharedViewLogoInput = {
  assetId: Scalars['String']['input'];
};

export type CompanySignup = {
  __typename: 'CompanySignup';
  companySignupId: Scalars['String']['output'];
  contactPerson: Maybe<CompanySignupContactPerson>;
  hasFms: Maybe<Scalars['Boolean']['output']>;
  isSubcontracting: Maybe<Scalars['Boolean']['output']>;
  status: CompanySignupStatus;
  surveyAnswers: Maybe<Array<CompanySignupSurveyAnswer>>;
  surveySubmittedAt: Maybe<Scalars['DateTime']['output']>;
};

export type CompanySignupCompleted = {
  __typename: 'CompanySignupCompleted';
  company: Company;
  companySignupId: Scalars['String']['output'];
  status: CompanySignupStatus;
  user: User;
};

export type CompanySignupContactPerson = {
  __typename: 'CompanySignupContactPerson';
  email: Maybe<Scalars['String']['output']>;
  firstName: Maybe<Scalars['String']['output']>;
  lastName: Maybe<Scalars['String']['output']>;
  phone: Maybe<Scalars['String']['output']>;
};

export enum CompanySignupStatus {
  COMPLETED = 'COMPLETED',
  PENDING = 'PENDING',
}

export type CompanySignupSurveyAnswer = {
  __typename: 'CompanySignupSurveyAnswer';
  fieldName: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type CompanySignupVisibilitySource = {
  __typename: 'CompanySignupVisibilitySource';
  status: CompanySignupVisibilitySourceStatus;
  type: TourVisibilitySourceType;
};

export enum CompanySignupVisibilitySourceStatus {
  ACTIVE = 'ACTIVE',
  DEACTIVATED = 'DEACTIVATED',
  IDENTIFIED = 'IDENTIFIED',
}

export enum CompanySortKey {
  COMPANY_NAME = 'COMPANY_NAME',
}

export type CompanySortOrder = {
  direction: SortDirection;
  key: CompanySortKey;
};

export type CompanyStopAddress = {
  __typename: 'CompanyStopAddress';
  city: Maybe<Scalars['String']['output']>;
  closeByAddresses: CompanyStopAddressConnection;
  companyId: Scalars['String']['output'];
  companyName: Maybe<Scalars['String']['output']>;
  country: Maybe<Scalars['String']['output']>;
  invalidFields: Maybe<Array<CompanyStopAddressField>>;
  location: Maybe<PointLocation>;
  place: Maybe<CompanyPlace>;
  postalCode: Maybe<Scalars['String']['output']>;
  state: Maybe<Scalars['String']['output']>;
  stopAddressId: Scalars['String']['output'];
  streetAddress: Maybe<Scalars['String']['output']>;
};

export type CompanyStopAddressCloseByAddressesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CompanyStopAddressConnection = {
  __typename: 'CompanyStopAddressConnection';
  edges: Maybe<Array<Maybe<CompanyStopAddressEdge>>>;
  pageInfo: PageInfo;
};

export type CompanyStopAddressEdge = {
  __typename: 'CompanyStopAddressEdge';
  cursor: Maybe<Scalars['String']['output']>;
  node: Maybe<CompanyStopAddress>;
};

export enum CompanyStopAddressField {
  CITY = 'CITY',
  COUNTRY = 'COUNTRY',
  POSTAL_CODE = 'POSTAL_CODE',
  STREET_ADDRESS = 'STREET_ADDRESS',
}

export type CompanyStopCities = {
  __typename: 'CompanyStopCities';
  city: Scalars['String']['output'];
  country: Scalars['String']['output'];
};

export type CompanyStopCitiesConnection = {
  __typename: 'CompanyStopCitiesConnection';
  edges: Maybe<Array<Maybe<CompanyStopCitiesEdge>>>;
  pageInfo: PageInfo;
};

export type CompanyStopCitiesEdge = {
  __typename: 'CompanyStopCitiesEdge';
  cursor: Maybe<Scalars['String']['output']>;
  node: Maybe<CompanyStopCities>;
};

export type CompanyStopGateIdentifier = {
  __typename: 'CompanyStopGateIdentifier';
  gate: Maybe<Scalars['String']['output']>;
  gateId: Scalars['String']['output'];
};

export type CompanyStopGateIdentifierConnection = {
  __typename: 'CompanyStopGateIdentifierConnection';
  edges: Maybe<Array<Maybe<CompanyStopGateIdentifierEdge>>>;
  pageInfo: PageInfo;
};

export type CompanyStopGateIdentifierEdge = {
  __typename: 'CompanyStopGateIdentifierEdge';
  cursor: Maybe<Scalars['String']['output']>;
  node: Maybe<CompanyStopGateIdentifier>;
};

export type CompanyStopPostalCodes = {
  __typename: 'CompanyStopPostalCodes';
  country: Scalars['String']['output'];
  postalCode: Scalars['String']['output'];
};

export type CompanyStopPostalCodesConnection = {
  __typename: 'CompanyStopPostalCodesConnection';
  edges: Maybe<Array<Maybe<CompanyStopPostalCodesEdge>>>;
  pageInfo: PageInfo;
};

export type CompanyStopPostalCodesEdge = {
  __typename: 'CompanyStopPostalCodesEdge';
  cursor: Maybe<Scalars['String']['output']>;
  node: Maybe<CompanyStopPostalCodes>;
};

export type CompanyStopStates = {
  __typename: 'CompanyStopStates';
  country: Scalars['String']['output'];
  state: Scalars['String']['output'];
};

export type CompanyStopStatesConnection = {
  __typename: 'CompanyStopStatesConnection';
  edges: Maybe<Array<Maybe<CompanyStopStatesEdge>>>;
  pageInfo: PageInfo;
};

export type CompanyStopStatesEdge = {
  __typename: 'CompanyStopStatesEdge';
  cursor: Maybe<Scalars['String']['output']>;
  node: Maybe<CompanyStopStates>;
};

export type CompanyTag = {
  __typename: 'CompanyTag';
  name: Scalars['String']['output'];
};

export type CompanyTagInput = {
  companyId: Scalars['String']['input'];
  tagName: Scalars['String']['input'];
};

export type CompanyTelematicsIntegration = {
  __typename: 'CompanyTelematicsIntegration';
  companyId: Scalars['String']['output'];
  connectionData: Maybe<Scalars['GraphQLJSON']['output']>;
  createdAt: Scalars['DateTime']['output'];
  diagnosticComment: Maybe<Scalars['String']['output']>;
  diagnosticStatus: Maybe<TelematicsIntegrationDiagnosticStatus>;
  enabled: Scalars['Boolean']['output'];
  exclusiveVehicleCount: Scalars['Int']['output'];
  isAllowedToUpdateCredentials: Scalars['Boolean']['output'];
  lastIntegrationSyncResult: Maybe<IntegrationSyncResult>;
  lastSuccess: Maybe<Scalars['DateTime']['output']>;
  telematicsIntegrationId: Scalars['String']['output'];
  telematicsProvider: TelematicsProvider;
  updatedAt: Scalars['DateTime']['output'];
};

export type CompanyTourFilter = {
  __typename: 'CompanyTourFilter';
  companyTourFilterId: Scalars['String']['output'];
  filter: Maybe<TourFilter>;
  filterV2: Maybe<Scalars['GraphQLJSON']['output']>;
  name: Scalars['String']['output'];
  sharedByUser: Maybe<UserProfile>;
  sharingToken: Maybe<Scalars['String']['output']>;
  tourCount: Scalars['Int']['output'];
  tours: Array<Tour>;
};

export type CompanyTourFilterToursArgs = {
  included_filter_ids?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type CompanyTourFilterConnection = {
  __typename: 'CompanyTourFilterConnection';
  edges: Maybe<Array<Maybe<CompanyTourFilterEdge>>>;
  pageInfo: PageInfo;
};

export type CompanyTourFilterEdge = {
  __typename: 'CompanyTourFilterEdge';
  cursor: Maybe<Scalars['String']['output']>;
  node: Maybe<CompanyTourFilter>;
};

export type CompanyTransportContactDetails = {
  __typename: 'CompanyTransportContactDetails';
  customText: Maybe<Scalars['String']['output']>;
  emails: Array<Maybe<Scalars['String']['output']>>;
  firstName: Maybe<Scalars['String']['output']>;
  lastName: Maybe<Scalars['String']['output']>;
  phones: Array<Maybe<Scalars['String']['output']>>;
};

export type CompanyTransportContactDetailsInput = {
  customText?: InputMaybe<Scalars['String']['input']>;
  emails: Array<InputMaybe<Scalars['String']['input']>>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phones: Array<InputMaybe<Scalars['String']['input']>>;
};

export type CompanyTransportGroup = {
  __typename: 'CompanyTransportGroup';
  companyId: Scalars['String']['output'];
  transportGroupId: Scalars['String']['output'];
};

export type CompanyTransportGroupConnection = {
  __typename: 'CompanyTransportGroupConnection';
  edges: Maybe<Array<Maybe<CompanyTransportGroupEdge>>>;
  pageInfo: PageInfo;
};

export type CompanyTransportGroupEdge = {
  __typename: 'CompanyTransportGroupEdge';
  cursor: Maybe<Scalars['String']['output']>;
  node: Maybe<CompanyTransportGroup>;
};

export type CompanyTransportNetworkFilter = {
  __typename: 'CompanyTransportNetworkFilter';
  companyTransportNetworkFilterId: Scalars['String']['output'];
  dataNetworkFilter: Maybe<DataNetworkFilter>;
  filter: TransportNetworkFilter;
  filterV2: Maybe<Scalars['GraphQLJSON']['output']>;
  name: Scalars['String']['output'];
  visibilityType: CompanyTransportNetworkFilterVisibility;
};

export type CompanyTransportNetworkFilterConnection = {
  __typename: 'CompanyTransportNetworkFilterConnection';
  edges: Maybe<Array<Maybe<CompanyTransportNetworkFilterEdge>>>;
  pageInfo: PageInfo;
};

export type CompanyTransportNetworkFilterEdge = {
  __typename: 'CompanyTransportNetworkFilterEdge';
  cursor: Maybe<Scalars['String']['output']>;
  node: Maybe<CompanyTransportNetworkFilter>;
};

export enum CompanyTransportNetworkFilterVisibility {
  COMPANY = 'COMPANY',
  PRIVATE = 'PRIVATE',
}

export type CompanyTypeInput = {
  is_carrier?: InputMaybe<Scalars['Boolean']['input']>;
  is_paying_customer?: InputMaybe<Scalars['Boolean']['input']>;
  is_pending_signup?: InputMaybe<Scalars['Boolean']['input']>;
  is_pilot?: InputMaybe<Scalars['Boolean']['input']>;
  is_shipper?: InputMaybe<Scalars['Boolean']['input']>;
  is_test?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CompanyVatNumber = {
  __typename: 'CompanyVatNumber';
  vatNumber: Scalars['String']['output'];
};

export type CompanyVatNumberChangeResult = {
  __typename: 'CompanyVatNumberChangeResult';
  success: Scalars['Boolean']['output'];
};

export type CompanyVatNumberInput = {
  discriminatorCountry?: InputMaybe<Scalars['String']['input']>;
  vatNumber: Scalars['String']['input'];
};

export type CompanyVehicleGroup = {
  __typename: 'CompanyVehicleGroup';
  companyVehicleGroupId: Scalars['String']['output'];
  name: Scalars['String']['output'];
  vehiclesConnection: CountedVehicleInGroupConnection;
};

export type CompanyVehicleGroupVehiclesConnectionArgs = {
  licensePlateSearch?: InputMaybe<Scalars['String']['input']>;
  vehicleState?: InputMaybe<VehicleState>;
  vehicleStateFilter?: InputMaybe<VehicleStateFilterInput>;
};

export type CompanyVehicles = {
  __typename: 'CompanyVehicles';
  all: Maybe<CountedVehicleConnection>;
  allocatable: Maybe<CountedVehicleConnection>;
  distinctDedicatedToPartnersVehiclesCount: Scalars['Int']['output'];
  distinctDedicatedToPartnersVehiclesCountByStatus: VehicleCountByStatus;
  grantedByPartners: Maybe<CountedVehicleConnection>;
  grantedToPartners: Maybe<CountedVehicleConnection>;
  summaryCounts: DedicatedVehiclesSummaryCounts;
};

export type CompanyVehiclesAllArgs = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  grantedByPartnersFilter?: InputMaybe<Scalars['Boolean']['input']>;
  hasAllocationsFilter?: InputMaybe<HasAllocationsFilterInput>;
  integrationIds?: InputMaybe<Array<Scalars['String']['input']>>;
  licensePlateOrAlternativeIdentifierSearch?: InputMaybe<Scalars['String']['input']>;
  licensePlateSearch?: InputMaybe<Scalars['String']['input']>;
  ownVehiclesOnly?: InputMaybe<Scalars['Boolean']['input']>;
  partnerNameSearch?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<VehicleFilterSortOrderInput>;
  timeBasedStatusFilter?: InputMaybe<TimeBasedStatus>;
  trackerTypes?: InputMaybe<Array<VehicleTrackerType>>;
  vehicleGroupIds?: InputMaybe<Array<Scalars['String']['input']>>;
  vehicleState?: InputMaybe<VehicleState>;
  vehicleStateFilter?: InputMaybe<VehicleStateFilterInput>;
};

export type CompanyVehiclesAllocatableArgs = {
  hasAllocationsFilter?: InputMaybe<HasAllocationsFilterInput>;
  licensePlateSearch?: InputMaybe<Scalars['String']['input']>;
  mobileTrackerSearch?: InputMaybe<Scalars['String']['input']>;
  partnerNameSearch?: InputMaybe<Scalars['String']['input']>;
  trackerTypes?: InputMaybe<Array<VehicleTrackerType>>;
};

export type CompanyVehiclesGrantedByPartnersArgs = {
  grantedByPartnerIds?: InputMaybe<Array<Scalars['String']['input']>>;
  licensePlateOrAlternativeIdentifierSearch?: InputMaybe<Scalars['String']['input']>;
  licensePlateSearch?: InputMaybe<Scalars['String']['input']>;
  partnerNameSearch?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<VehicleFilterSortOrderInput>;
  timeBasedStatusFilter?: InputMaybe<TimeBasedStatus>;
  trackerTypes?: InputMaybe<Array<VehicleTrackerType>>;
};

export type CompanyVehiclesGrantedToPartnersArgs = {
  grantedToPartnerIds?: InputMaybe<Array<Scalars['String']['input']>>;
  licensePlateOrAlternativeIdentifierSearch?: InputMaybe<Scalars['String']['input']>;
  licensePlateSearch?: InputMaybe<Scalars['String']['input']>;
  partnerNameSearch?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<VehiclePermissionsInput>;
  sort?: InputMaybe<VehicleFilterSortOrderInput>;
  timeBasedStatusFilter?: InputMaybe<TimeBasedStatus>;
  trackerTypes?: InputMaybe<Array<VehicleTrackerType>>;
};

export type CompanyVehiclesSummaryCountsArgs = {
  archived: Scalars['Boolean']['input'];
};

export type CompanyVehiclesFilterInput = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  grantedByPartnersFilter?: InputMaybe<Scalars['Boolean']['input']>;
  hasAllocationsFilter?: InputMaybe<HasAllocationsFilterInput>;
  integrationIds?: InputMaybe<Array<Scalars['String']['input']>>;
  licensePlateOrAlternativeIdentifierSearch?: InputMaybe<Scalars['String']['input']>;
  licensePlateSearch?: InputMaybe<Scalars['String']['input']>;
  ownVehiclesOnly?: InputMaybe<Scalars['Boolean']['input']>;
  partnerNameSearch?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<VehicleFilterSortOrderInput>;
  timeBasedStatusFilter?: InputMaybe<TimeBasedStatus>;
  trackerTypes?: InputMaybe<Array<VehicleTrackerType>>;
  vehicleGroupIds?: InputMaybe<Array<Scalars['String']['input']>>;
  vehicleStateFilter?: InputMaybe<VehicleStateFilterInput>;
};

export type CompanyWebhookSubscription = {
  __typename: 'CompanyWebhookSubscription';
  companyId: Scalars['String']['output'];
  status: CompanyWebhookSubscriptionStatus;
  subscriptionId: Scalars['String']['output'];
};

export type CompanyWebhookSubscriptionInfo = {
  __typename: 'CompanyWebhookSubscriptionInfo';
  brokenReason: Maybe<Scalars['String']['output']>;
  companyId: Scalars['String']['output'];
  contactEmails: Array<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdByUserId: Maybe<Scalars['String']['output']>;
  discriminator: Maybe<Scalars['GraphQLJSON']['output']>;
  expirationDate: Scalars['DateTime']['output'];
  headers: Scalars['GraphQLJSON']['output'];
  lastStatusChange: Scalars['DateTime']['output'];
  payloadContentType: WebhookPayloadContentType;
  status: CompanyWebhookSubscriptionStatus;
  subscriptionId: Scalars['String']['output'];
  subscriptionUpdatedAt: Scalars['DateTime']['output'];
  topics: Array<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  updatedByUserId: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
};

export type CompanyWebhookSubscriptionListItem = {
  __typename: 'CompanyWebhookSubscriptionListItem';
  lastStatusChange: Scalars['DateTime']['output'];
  status: CompanyWebhookSubscriptionStatus;
  subscriptionId: Scalars['String']['output'];
  topics: Array<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  url: Maybe<Scalars['String']['output']>;
};

export enum CompanyWebhookSubscriptionStatus {
  BROKEN = 'BROKEN',
  PAUSED = 'PAUSED',
  WORKING = 'WORKING',
}

export enum ComparisonOperator {
  GTE = 'GTE',
  LTE = 'LTE',
  RANGE = 'RANGE',
}

export enum ComparisonOperatorExtended {
  ANY_TIME_RANGE = 'ANY_TIME_RANGE',
  GTE = 'GTE',
  LTE = 'LTE',
  NOT_AVAILABLE = 'NOT_AVAILABLE',
  RANGE = 'RANGE',
}

export enum ComparisonTerm {
  DELAY_GREATER_THAN = 'DELAY_GREATER_THAN',
  TIME_TO_ARRIVAL_LESS_THAN = 'TIME_TO_ARRIVAL_LESS_THAN',
}

export enum ComparisonUnit {
  DAY = 'DAY',
  HOUR = 'HOUR',
  MINUTE = 'MINUTE',
}

export type Configuration = {
  __typename: 'Configuration';
  customFields: Maybe<CompanyCustomFieldsConfiguration>;
  customerPortal: Maybe<CustomerPortalConfiguration>;
  sharedStopView: Maybe<SharedStopViewConfiguration>;
  sharedTourView: Maybe<SharedTourViewConfiguration>;
};

export type ConfigurationUpdateInput = {
  customFields?: InputMaybe<CompanyCustomFieldsConfigurationInput>;
  customerPortal?: InputMaybe<CustomerPortalConfigurationValueInput>;
  sharedStopView?: InputMaybe<SharedStopViewConfigurationValueInput>;
  sharedTourView?: InputMaybe<SharedTourViewConfigurationValueInput>;
};

export type ConflictingLicensePlate = {
  __typename: 'ConflictingLicensePlate';
  licensePlate: Scalars['String']['output'];
  remoteIds: Maybe<Array<Scalars['String']['output']>>;
};

export type ConflictingRemoteId = {
  __typename: 'ConflictingRemoteId';
  licensePlates: Maybe<Array<Scalars['String']['output']>>;
  remoteId: Scalars['String']['output'];
};

export type ConnectedCustomField = {
  __typename: 'ConnectedCustomField';
  displayName: Maybe<Scalars['String']['output']>;
  fieldName: Scalars['String']['output'];
  valuesConnection: CountedCustomFieldValueConnection;
};

export type ConnectedCustomFieldValuesConnectionArgs = {
  textSearch?: InputMaybe<Scalars['String']['input']>;
};

export enum ConnectedCustomFieldNamesSortKey {
  DISPLAY_NAME_AND_FIELD = 'DISPLAY_NAME_AND_FIELD',
}

export type ConnectedCustomFieldNamesSortOrder = {
  direction: SortDirection;
  key: ConnectedCustomFieldNamesSortKey;
};

export type ConnectionParameter = {
  __typename: 'ConnectionParameter';
  defaultValue: Maybe<Scalars['String']['output']>;
  enumFieldValues: Array<ConnectionParameterEnumValue>;
  fieldDisplayName: Maybe<Scalars['String']['output']>;
  fieldName: Scalars['String']['output'];
  fieldType: ConnectionParameterFieldType;
  isInternal: Scalars['Boolean']['output'];
  isOptional: Scalars['Boolean']['output'];
  isSensitive: Scalars['Boolean']['output'];
};

export type ConnectionParameterEnumValue = {
  __typename: 'ConnectionParameterEnumValue';
  display_name: Maybe<Scalars['String']['output']>;
  is_default: Scalars['Boolean']['output'];
  value: Scalars['String']['output'];
};

export enum ConnectionParameterFieldType {
  BOOLEAN = 'BOOLEAN',
  ENUM = 'ENUM',
  JSON = 'JSON',
  NUMBER = 'NUMBER',
  TEXT = 'TEXT',
  URL = 'URL',
}

export enum ConsentSource {
  AUTO_INHERITED = 'AUTO_INHERITED',
  BACKOFFICE_USER = 'BACKOFFICE_USER',
  INHERITED = 'INHERITED',
  USER = 'USER',
}

export enum ConsentState {
  ACCEPTED = 'ACCEPTED',
  DECLINED = 'DECLINED',
  REQUESTED = 'REQUESTED',
}

export enum ConsentStatus {
  ACCEPTED = 'ACCEPTED',
  DECLINED = 'DECLINED',
  REQUESTED = 'REQUESTED',
}

export type Contact = {
  __typename: 'Contact';
  code: Maybe<Scalars['String']['output']>;
  email: Maybe<Scalars['String']['output']>;
  firstName: Maybe<Scalars['String']['output']>;
  fullName: Maybe<Scalars['String']['output']>;
  interestedInStopType: Maybe<Scalars['String']['output']>;
  lastName: Maybe<Scalars['String']['output']>;
  locale: Maybe<Scalars['String']['output']>;
};

export type CopyDashboardInput = {
  companyId: Scalars['String']['input'];
  dashboardId: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type CountedBulkInvitationSetConnection = {
  __typename: 'CountedBulkInvitationSetConnection';
  bulkInvitationSets: BulkInvitationSetConnection;
  count: Scalars['Int']['output'];
};

export type CountedBulkInvitationSetConnectionBulkInvitationSetsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CountedBulkInvitationSetItemConnection = {
  __typename: 'CountedBulkInvitationSetItemConnection';
  count: Scalars['Int']['output'];
  items: BulkInvitationSetItemConnection;
  statistics: BulkInvitationSetStatistics;
};

export type CountedBulkInvitationSetItemConnectionItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CountedBulkInvitationSetItemConnectionStatisticsArgs = {
  filter?: InputMaybe<BulkInvitationSetStatisticsFilterInput>;
};

export type CountedCarrierConnection = {
  __typename: 'CountedCarrierConnection';
  carriers: CarrierOptionConnection;
  count: Scalars['Int']['output'];
  hasAny: Scalars['Boolean']['output'];
};

export type CountedCarrierConnectionCarriersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sortOrder?: InputMaybe<CompanySortOrder>;
};

export type CountedCarrierNetworkConnection = {
  __typename: 'CountedCarrierNetworkConnection';
  count: Scalars['Int']['output'];
  items: CarrierNetworkItemConnection;
  reportDownloadURI: Scalars['String']['output'];
};

export type CountedCarrierNetworkConnectionItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CountedCompanyAnalyticsFilterConnection = {
  __typename: 'CountedCompanyAnalyticsFilterConnection';
  companyAnalyticsFilters: CompanyAnalyticsFilterConnection;
  count: Scalars['Int']['output'];
};

export type CountedCompanyAnalyticsFilterConnectionCompanyAnalyticsFiltersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CountedCompanyBookingLocation = {
  __typename: 'CountedCompanyBookingLocation';
  bookingLocations: CompanyBookingLocationConnection;
  count: Scalars['Int']['output'];
  hasAny: Scalars['Boolean']['output'];
};

export type CountedCompanyBookingLocationBookingLocationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CountedCompanyPlaceConnection = {
  __typename: 'CountedCompanyPlaceConnection';
  count: Scalars['Int']['output'];
  hasAny: Scalars['Boolean']['output'];
  mapTilesBounds: Maybe<Bounds>;
  mapTilesTemplateURI: Maybe<Scalars['String']['output']>;
  places: CompanyPlaceConnection;
};

export type CountedCompanyPlaceConnectionPlacesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CountedCompanyRelationConnection = {
  __typename: 'CountedCompanyRelationConnection';
  count: Scalars['Int']['output'];
  networkRelations: NetworkRelationConnection;
  reportDownloadURI: Scalars['String']['output'];
};

export type CountedCompanyRelationConnectionNetworkRelationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CountedCompanyStopAddressConnection = {
  __typename: 'CountedCompanyStopAddressConnection';
  addresses: CompanyStopAddressConnection;
  count: Scalars['Int']['output'];
  mapTilesBounds: Maybe<Bounds>;
  mapTilesTemplateURI: Maybe<Scalars['String']['output']>;
};

export type CountedCompanyStopAddressConnectionAddressesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CountedCompanyStopCitiesConnection = {
  __typename: 'CountedCompanyStopCitiesConnection';
  cityIdentifiers: CompanyStopCitiesConnection;
  hasAny: Scalars['Boolean']['output'];
};

export type CountedCompanyStopCitiesConnectionCityIdentifiersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CountedCompanyStopGateIdentifiersConnection = {
  __typename: 'CountedCompanyStopGateIdentifiersConnection';
  hasAny: Scalars['Boolean']['output'];
  stopGateIdentifiers: CompanyStopGateIdentifierConnection;
};

export type CountedCompanyStopGateIdentifiersConnectionStopGateIdentifiersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CountedCompanyStopPostalCodesConnection = {
  __typename: 'CountedCompanyStopPostalCodesConnection';
  hasAny: Scalars['Boolean']['output'];
  postalCodeIdentifiers: CompanyStopPostalCodesConnection;
};

export type CountedCompanyStopPostalCodesConnectionPostalCodeIdentifiersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CountedCompanyStopStatesConnection = {
  __typename: 'CountedCompanyStopStatesConnection';
  hasAny: Scalars['Boolean']['output'];
  stopStatesIdentifiers: CompanyStopStatesConnection;
};

export type CountedCompanyStopStatesConnectionStopStatesIdentifiersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CountedCompanyTourFilterConnection = {
  __typename: 'CountedCompanyTourFilterConnection';
  companyTourFilters: CompanyTourFilterConnection;
  count: Scalars['Int']['output'];
};

export type CountedCompanyTourFilterConnectionCompanyTourFiltersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CountedCompanyTransportGroupConnection = {
  __typename: 'CountedCompanyTransportGroupConnection';
  companyTransportGroups: CompanyTransportGroupConnection;
  hasAny: Scalars['Boolean']['output'];
};

export type CountedCompanyTransportGroupConnectionCompanyTransportGroupsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CountedCompanyTransportNetworkFilterConnection = {
  __typename: 'CountedCompanyTransportNetworkFilterConnection';
  companyTransportNetworkFilters: CompanyTransportNetworkFilterConnection;
  count: Scalars['Int']['output'];
};

export type CountedCompanyTransportNetworkFilterConnectionCompanyTransportNetworkFiltersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CountedCustomFieldValueConnection = {
  __typename: 'CountedCustomFieldValueConnection';
  count: Scalars['Int']['output'];
  values: CustomFieldValueConnection;
};

export type CountedCustomFieldValueConnectionValuesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CountedCustomerConnection = {
  __typename: 'CountedCustomerConnection';
  count: Scalars['Int']['output'];
  customers: CompanyProfileConnection;
  hasAny: Scalars['Boolean']['output'];
};

export type CountedCustomerConnectionCustomersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sortOrder?: InputMaybe<CompanySortOrder>;
};

export type CountedDashboardsConnection = {
  __typename: 'CountedDashboardsConnection';
  count: Scalars['Int']['output'];
  dashboards: DashboardConnection;
};

export type CountedDashboardsConnectionDashboardsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CountedDataNetworkVisibilityReportCompanyConnection = {
  __typename: 'CountedDataNetworkVisibilityReportCompanyConnection';
  companies: DataNetworkVisibilityReportCompanyConnection;
  count: Scalars['Int']['output'];
};

export type CountedDataNetworkVisibilityReportCompanyConnectionCompaniesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CountedIncotermConnection = {
  __typename: 'CountedIncotermConnection';
  hasAny: Scalars['Boolean']['output'];
};

export type CountedMainCarrierConnection = {
  __typename: 'CountedMainCarrierConnection';
  count: Scalars['Int']['output'];
  hasAny: Scalars['Boolean']['output'];
  mainCarriers: CompanyProfileConnection;
};

export type CountedMainCarrierConnectionMainCarriersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sortOrder?: InputMaybe<CompanySortOrder>;
};

export type CountedOrderItemConnection = {
  __typename: 'CountedOrderItemConnection';
  hasAny: Scalars['Boolean']['output'];
  orderItemIdentifiers: OrderItemIdentifierConnection;
};

export type CountedOrderItemConnectionOrderItemIdentifiersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CountedOrderItemCustomFieldConnection = {
  __typename: 'CountedOrderItemCustomFieldConnection';
  hasAny: Scalars['Boolean']['output'];
  orderItemCustomFieldIdentifiers: OrderItemCustomFieldConnection;
};

export type CountedOrderItemCustomFieldConnectionOrderItemCustomFieldIdentifiersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CountedPlaceTourConnection = {
  __typename: 'CountedPlaceTourConnection';
  count: Scalars['Int']['output'];
  tours: TourConnection;
};

export type CountedPlaceTourConnectionToursArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CountedProvidingVisibilityCompaniesConnection = {
  __typename: 'CountedProvidingVisibilityCompaniesConnection';
  companies: ProvidingVisibilityCompanyConnection;
  count: Scalars['Int']['output'];
};

export type CountedProvidingVisibilityCompaniesConnectionCompaniesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CountedReceivingVisibilityCompaniesConnection = {
  __typename: 'CountedReceivingVisibilityCompaniesConnection';
  companies: ReceivingVisibilityCompanyConnection;
  count: Scalars['Int']['output'];
};

export type CountedReceivingVisibilityCompaniesConnectionCompaniesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CountedSharedViewConnection = {
  __typename: 'CountedSharedViewConnection';
  count: Scalars['Int']['output'];
  sharedViews: SharedViewConnection;
};

export type CountedSharedViewConnectionSharedViewsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CountedShipperConnection = {
  __typename: 'CountedShipperConnection';
  count: Scalars['Int']['output'];
  hasAny: Scalars['Boolean']['output'];
  shippers: CompanyProfileConnection;
};

export type CountedShipperConnectionShippersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sortOrder?: InputMaybe<CompanySortOrder>;
};

export type CountedSiteConnection = {
  __typename: 'CountedSiteConnection';
  count: Scalars['Int']['output'];
  hasAny: Scalars['Boolean']['output'];
  sites: SiteConnection;
};

export type CountedSiteConnectionSitesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CountedStopCompanyNameConnection = {
  __typename: 'CountedStopCompanyNameConnection';
  hasAny: Scalars['Boolean']['output'];
  stopCompanyNameIdentifiers: StopCompanyNameConnection;
};

export type CountedStopCompanyNameConnectionStopCompanyNameIdentifiersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CountedTelematicsIntegrationConnection = {
  __typename: 'CountedTelematicsIntegrationConnection';
  count: Scalars['Int']['output'];
  integrations: TelematicsIntegrationConnection;
};

export type CountedTelematicsIntegrationConnectionIntegrationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CountedTelematicsProviderConnection = {
  __typename: 'CountedTelematicsProviderConnection';
  count: Scalars['Int']['output'];
  providers: TelematicsProviderConnection;
};

export type CountedTelematicsProviderConnectionProvidersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CountedTourConnection = {
  __typename: 'CountedTourConnection';
  count: Scalars['Int']['output'];
  mapTilesBounds: Maybe<Bounds>;
  mapTilesTemplateURI: Maybe<Scalars['String']['output']>;
  reportDownloadURI: Maybe<Scalars['String']['output']>;
  tours: TourConnection;
};

export type CountedTourConnectionReportDownloadUriArgs = {
  timezone?: InputMaybe<Scalars['IANATimezone']['input']>;
};

export type CountedTourConnectionToursArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CountedTripsIdentifiersConnection = {
  __typename: 'CountedTripsIdentifiersConnection';
  hasAny: Scalars['Boolean']['output'];
  tourIdentifiers: TripsTourIdentifierConnection;
};

export type CountedTripsIdentifiersConnectionTourIdentifiersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CountedTripsOptionConnection = {
  __typename: 'CountedTripsOptionConnection';
  count: Scalars['Int']['output'];
  options: Maybe<TripsOptionConnection>;
};

export type CountedTripsOptionConnectionOptionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  company_id?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  subType?: InputMaybe<Scalars['String']['input']>;
  textSearch?: InputMaybe<Scalars['String']['input']>;
  transportMode?: InputMaybe<TripsTransportMode>;
  type?: InputMaybe<Scalars['String']['input']>;
  types?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CountedTripsTourConnection = {
  __typename: 'CountedTripsTourConnection';
  boundedCount: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  mapTilesBounds: Maybe<Bounds>;
  mapTilesTemplateURI: Maybe<Scalars['String']['output']>;
  reportDownloadURI: Maybe<Scalars['String']['output']>;
  tours: TourConnection;
  tripsPositionsGeoJSON: Maybe<PositionGeoJsonFeatureCollection>;
};

export type CountedTripsTourConnectionReportDownloadUriArgs = {
  timezone?: InputMaybe<Scalars['IANATimezone']['input']>;
};

export type CountedTripsTourConnectionToursArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CountedUserFilterConnection = {
  __typename: 'CountedUserFilterConnection';
  count: Scalars['Int']['output'];
  userFilters: UserFilterConnection;
};

export type CountedUserFilterConnectionUserFiltersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CountedUserInCompanyProfileConnection = {
  __typename: 'CountedUserInCompanyProfileConnection';
  count: Scalars['Int']['output'];
  hasAny: Scalars['Boolean']['output'];
  totalAdminUsersCount: Scalars['Int']['output'];
  totalRegularUsersCount: Scalars['Int']['output'];
  users: UserInCompanyProfileConnection;
};

export type CountedUserInCompanyProfileConnectionUsersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CountedVehicleConnection = {
  __typename: 'CountedVehicleConnection';
  boundingBox: Maybe<Array<PointLocation>>;
  count: Scalars['Int']['output'];
  mapTilesTemplateURI: Maybe<Scalars['String']['output']>;
  vehicleAltIdImportTemplateURI: Maybe<Scalars['String']['output']>;
  vehicles: VehicleConnection;
  vehiclesReportDownloadURI: Maybe<Scalars['String']['output']>;
};

export type CountedVehicleConnectionMapTilesTemplateUriArgs = {
  dwellTime?: InputMaybe<Scalars['Int']['input']>;
  returnTimeBasedStatus?: InputMaybe<Scalars['Boolean']['input']>;
  returnVehicleState?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CountedVehicleConnectionVehiclesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CountedVehicleGrantPartnerConnection = {
  __typename: 'CountedVehicleGrantPartnerConnection';
  count: Scalars['Int']['output'];
  partners: VehicleGrantPartnerConnection;
};

export type CountedVehicleGrantPartnerConnectionPartnersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CountedVehicleInGroupConnection = {
  __typename: 'CountedVehicleInGroupConnection';
  count: Scalars['Int']['output'];
  vehicles: Maybe<VehicleConnection>;
};

export type CountedVehicleInGroupConnectionVehiclesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CountedWidgetsConnection = {
  __typename: 'CountedWidgetsConnection';
  count: Scalars['Int']['output'];
  widgets: WidgetConnection;
};

export type CountedWidgetsConnectionWidgetsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  timezone?: InputMaybe<Scalars['IANATimezone']['input']>;
};

export type CreateBulkInvitationSetInput = {
  invitations: Array<CreateBulkInvitationSetItemInput>;
  metadata: CompanyBulkInviteMetadata;
  setName?: InputMaybe<Scalars['String']['input']>;
};

export type CreateBulkInvitationSetItemInput = {
  companyName?: InputMaybe<Scalars['String']['input']>;
  identifierValues?: InputMaybe<Array<Scalars['String']['input']>>;
  recipients: Array<CompanyBulkInvitationRecipient>;
};

export type CreateBulkInvitationSetResult = {
  __typename: 'CreateBulkInvitationSetResult';
  bulkInvitationSetId: Scalars['String']['output'];
  createdBulkInvitationSetItemIds: Array<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type CreateCompanyAnalyticsFilterInput = {
  companyId: Scalars['String']['input'];
  filterV2: VisibilityPerformanceFilterInput;
  name: Scalars['String']['input'];
  visibilityType: CompanyAnalyticsFilterVisibility;
};

export type CreateCompanyIdentifierInput = {
  companyId: Scalars['String']['input'];
  discriminatorCountry?: InputMaybe<Scalars['String']['input']>;
  identifierType: CompanyIdentifierType;
  identifierValue: Scalars['String']['input'];
};

export type CreateCompanyIdentifierResult = {
  __typename: 'CreateCompanyIdentifierResult';
  success: Scalars['Boolean']['output'];
};

export type CreateCompanyInput = {
  company_name: Scalars['String']['input'];
  feature_flags?: InputMaybe<Scalars['GraphQLJSON']['input']>;
  is_carrier?: InputMaybe<Scalars['Boolean']['input']>;
  is_paying_customer?: InputMaybe<Scalars['Boolean']['input']>;
  is_pending_signup?: InputMaybe<Scalars['Boolean']['input']>;
  is_pilot?: InputMaybe<Scalars['Boolean']['input']>;
  is_shipper?: InputMaybe<Scalars['Boolean']['input']>;
  is_test?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreateCompanyInvitationEmailInput = {
  externalInvitation: ExternalCompanyInvitationEmailInput;
};

export type CreateCompanyInvitationEmailResult = {
  __typename: 'CreateCompanyInvitationEmailResult';
  companyInviteId: Maybe<Scalars['String']['output']>;
  invalidEmails: Array<Scalars['String']['output']>;
  invalidIdentifiers: Array<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type CreateCompanyInvitationLinkInput = {
  externalInvitation: ExternalCompanyInvitationLinkInput;
};

export type CreateCompanyInvitationLinkResult = {
  __typename: 'CreateCompanyInvitationLinkResult';
  companyInviteId: Maybe<Scalars['String']['output']>;
  invalidIdentifiers: Array<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type CreateCompanyInvitationLinkWithRecipientsInput = {
  externalInvitation: ExternalCompanyInvitationEmailInput;
};

export type CreateCompanyInvitationLinkWithRecipientsResult = {
  __typename: 'CreateCompanyInvitationLinkWithRecipientsResult';
  companyInviteId: Maybe<Scalars['String']['output']>;
  invalidEmails: Array<Scalars['String']['output']>;
  invalidIdentifiers: Array<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type CreateCompanyInvitationsResult = {
  __typename: 'CreateCompanyInvitationsResult';
  invalidEmails: Array<Scalars['String']['output']>;
  invalidIdentifiers: Array<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type CreateCompanyPlaceInput = {
  companyId: Scalars['String']['input'];
  fromTourId?: InputMaybe<Scalars['String']['input']>;
  geodata?: InputMaybe<Array<PlaceGeodataInput>>;
  location: PointLocationInput;
  name: Scalars['String']['input'];
  referenceId?: InputMaybe<Scalars['String']['input']>;
  stopAddressIds: Array<Scalars['String']['input']>;
};

export type CreateCompanyRelationshipInput = {
  relationshipType: CompanyRelationshipType;
  sourceCompanyId: Scalars['String']['input'];
  targetCompanyId: Scalars['String']['input'];
};

export type CreateCompanyTourFilterInput = {
  companyId: Scalars['String']['input'];
  companyRole?: InputMaybe<CompanyRole>;
  filter?: InputMaybe<TourFilterInput>;
  filterType?: InputMaybe<FilterType>;
  filterV2?: InputMaybe<Scalars['GraphQLJSON']['input']>;
  name: Scalars['String']['input'];
};

export type CreateCompanyTransportNetworkFilterInput = {
  companyId: Scalars['String']['input'];
  dataNetworkFilter?: InputMaybe<DataNetworkFilterInput>;
  filter?: InputMaybe<DataNetworkReportFilterInput>;
  filterV2?: InputMaybe<Scalars['GraphQLJSON']['input']>;
  name: Scalars['String']['input'];
  visibilityType?: InputMaybe<CompanyTransportNetworkFilterVisibility>;
};

export type CreateCompanyVehicleGroupInput = {
  companyId: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type CreateContactInquiryInput = {
  businessEmail: Scalars['String']['input'];
  company: Scalars['String']['input'];
  country: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  lastName: Scalars['String']['input'];
  phone: Scalars['String']['input'];
  source?: InputMaybe<VisibilityService>;
};

export type CreateDashboardInput = {
  companyId: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type CreateEmailAccessInput = {
  email: Scalars['String']['input'];
  locale: Scalars['String']['input'];
};

export type CreateExampleDashboardInput = {
  companyId: Scalars['String']['input'];
  translatedName: Scalars['String']['input'];
  translatedWidgets: Array<ExampleWidgetInput>;
};

export type CreateNoteInput = {
  companyId: Scalars['String']['input'];
  deliveryIds?: InputMaybe<Array<Scalars['String']['input']>>;
  noteText: Scalars['String']['input'];
  noteVisibility: NoteVisibility;
  stopId?: InputMaybe<Scalars['String']['input']>;
  tourId: Scalars['String']['input'];
};

export type CreateOrUpdateEmailAccessInput = {
  create?: InputMaybe<CreateEmailAccessInput>;
  update?: InputMaybe<UpdateEmailAccessInput>;
};

export type CreateOrUpdateFilterBasedTransportNotificationInput = {
  companyId: Scalars['String']['input'];
  deliverySettings?: InputMaybe<DeliverySettingsInput>;
  name: Scalars['String']['input'];
  notificationCustomization?: InputMaybe<NotificationCustomizationInput>;
  notificationId?: InputMaybe<Scalars['String']['input']>;
  notificationTrigger?: InputMaybe<NotificationTriggerInput>;
  recipients?: InputMaybe<Array<EmailRecipientInput>>;
  recipientsV2?: InputMaybe<Array<RecipientInput>>;
  status?: InputMaybe<NotificationStatus>;
  transportFilter?: InputMaybe<TourFilterInput>;
  transportFilterV2?: InputMaybe<Scalars['GraphQLJSON']['input']>;
};

export type CreateOrUpdateRelationIdentifiersInput = {
  companyId: Scalars['String']['input'];
  companyInviteId?: InputMaybe<Scalars['String']['input']>;
  identifierValues?: InputMaybe<Array<IdentifierValueInput>>;
  ownerCompanyId: Scalars['String']['input'];
};

export type CreateOrUpdateRelationIdentifiersResult = {
  __typename: 'CreateOrUpdateRelationIdentifiersResult';
  invalidFormatIdentifiers: Array<Scalars['String']['output']>;
  invalidIdentifiers: Array<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type CreateOrUpdateSharingLinkInput = {
  name: Scalars['String']['input'];
  publicLinkId?: InputMaybe<Scalars['String']['input']>;
};

export type CreateOrUpdateTransportNotificationInput = {
  companyId: Scalars['String']['input'];
  notificationId?: InputMaybe<Scalars['String']['input']>;
  notificationTrigger?: InputMaybe<NotificationTriggerInput>;
  recipients?: InputMaybe<Array<EmailRecipientInput>>;
  recipientsV2?: InputMaybe<Array<RecipientInput>>;
  status?: InputMaybe<NotificationStatus>;
  tourId: Scalars['String']['input'];
};

export type CreateOvdTokenInput = {
  carrierIds?: InputMaybe<Array<Scalars['String']['input']>>;
  deliveryCustomFields?: InputMaybe<Array<Scalars['String']['input']>>;
  enableApiEta?: InputMaybe<Scalars['Boolean']['input']>;
  enableCancellationReason?: InputMaybe<Scalars['Boolean']['input']>;
  enableCustomFields?: InputMaybe<Scalars['Boolean']['input']>;
  enableStatus?: InputMaybe<Scalars['Boolean']['input']>;
  label: Scalars['String']['input'];
  platformIds: Array<Scalars['String']['input']>;
  shipperIds?: InputMaybe<Array<Scalars['String']['input']>>;
  tourCustomFields?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type CreatePlatformSupportTicketInput = {
  businessImpact: Scalars['String']['input'];
  companyId: Scalars['String']['input'];
  content: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  sourceUrl: Scalars['String']['input'];
  title: Scalars['String']['input'];
  tourId?: InputMaybe<Scalars['String']['input']>;
};

export type CreateSharedViewInput = {
  agreeToTermsAndConditions: Scalars['Boolean']['input'];
  companyId: Scalars['String']['input'];
  emailAccesses?: InputMaybe<Array<CreateEmailAccessInput>>;
  filterV1?: InputMaybe<TourFilterInput>;
  filterV2?: InputMaybe<Scalars['GraphQLJSON']['input']>;
  isActive: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  sharingLinks: Array<CreateSharingLinkInput>;
};

export type CreateSharingLinkInput = {
  name: Scalars['String']['input'];
};

export type CreateTelematicsIntegrationInput = {
  company_id: Scalars['String']['input'];
  company_integration_id: Scalars['String']['input'];
  connection_data: Scalars['GraphQLJSON']['input'];
  enabled: Scalars['Boolean']['input'];
  telematics_provider_id: Scalars['String']['input'];
};

export type CreateTransportAnalysisInput = {
  companyId: Scalars['String']['input'];
  tourId: Scalars['String']['input'];
};

export type CreateUserFilterInput = {
  companyId: Scalars['String']['input'];
  companyRole?: InputMaybe<CompanyRole>;
  filter?: InputMaybe<TourFilterInput>;
  filterType?: InputMaybe<FilterType>;
  filterV2?: InputMaybe<Scalars['GraphQLJSON']['input']>;
  name: Scalars['String']['input'];
};

export type CreateVehicleGrantsInput = {
  grantedByCompany: Scalars['String']['input'];
  grantedToCompany: Scalars['String']['input'];
};

export type CreateVehicleInput = {
  licensePlate: Scalars['String']['input'];
  remoteId: Scalars['String']['input'];
};

export type CreateVehicleMobileAppTrackerInput = {
  alias: Scalars['String']['input'];
  companyId: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
};

export type CreateVehiclesInput = {
  telematicsIntegrationId: Scalars['String']['input'];
  vehicles: Array<CreateVehicleInput>;
};

export type CreateVisibilityAgentConversationInput = {
  companyId: Scalars['String']['input'];
  currentUrl?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
};

export type CreateVisibilityAgentConversationResult =
  | VisibilityAgentChatResult
  | VisibilityAgentConversationCreated
  | VisibilityAgentValidationError;

export type CreateVisibilitySolutionsTicketInput = {
  companyId: Scalars['String']['input'];
  content: Scalars['String']['input'];
  sourceUrl: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type CreateWebhookSubscriptionInput = {
  companyId: Scalars['String']['input'];
  contactEmails: Array<Scalars['String']['input']>;
  discriminator?: InputMaybe<Scalars['GraphQLJSON']['input']>;
  expirationDate: Scalars['DateTime']['input'];
  headers: Scalars['GraphQLJSON']['input'];
  payloadContentType: WebhookPayloadContentType;
  topics: Array<Scalars['String']['input']>;
  url: Scalars['String']['input'];
};

export type CreateWidgetInput = {
  dashboardId: Scalars['String']['input'];
  filters?: InputMaybe<Array<WidgetFilterInput>>;
  filtersV2?: InputMaybe<Array<WidgetFilterInputV2>>;
  name: Scalars['String']['input'];
  operator?: InputMaybe<OperatorType>;
  type: WidgetType;
};

export enum CredentialType {
  API_KEY = 'API_KEY',
  EXT_SHIPMENT_STATUS_API_KEY = 'EXT_SHIPMENT_STATUS_API_KEY',
}

export type Credentials = {
  __typename: 'Credentials';
  addedAt: Scalars['DateTime']['output'];
  addedByUserId: Scalars['String']['output'];
  type: CredentialType;
  userId: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type CustomField = {
  __typename: 'CustomField';
  fieldName: Scalars['String']['output'];
  values: Array<CustomFieldValue>;
  visibility: Maybe<Scalars['String']['output']>;
};

export enum CustomFieldConfigurationVisibility {
  CREATOR = 'CREATOR',
  EVERYONE = 'EVERYONE',
  FORWARDING_CHAIN = 'FORWARDING_CHAIN',
}

export enum CustomFieldConfigurationVisibilityAction {
  FALLBACK = 'FALLBACK',
}

export type CustomFieldDisplayNameInput = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  key: Scalars['String']['input'];
};

export type CustomFieldInput = {
  fieldName: Scalars['String']['input'];
  values: Array<Scalars['String']['input']>;
};

export type CustomFieldValue = {
  __typename: 'CustomFieldValue';
  value: Scalars['String']['output'];
};

export type CustomFieldValueConnection = {
  __typename: 'CustomFieldValueConnection';
  edges: Maybe<Array<Maybe<CustomFieldValueEdge>>>;
  pageInfo: PageInfo;
};

export type CustomFieldValueEdge = {
  __typename: 'CustomFieldValueEdge';
  cursor: Maybe<Scalars['String']['output']>;
  node: Maybe<CustomFieldValue>;
};

export type CustomerPortalConfiguration = {
  __typename: 'CustomerPortalConfiguration';
  detailViewTransportIdentifiers: Array<TransportIdentifier>;
  primaryTransportIdentifier: TransportIdentifier;
};

export type CustomerPortalConfigurationInput = {
  detailViewTransportIdentifiers: Array<TransportIdentifier>;
  primaryTransportIdentifier: TransportIdentifier;
};

export type CustomerPortalConfigurationValueInput = {
  value?: InputMaybe<CustomerPortalConfigurationInput>;
};

export type Dashboard = {
  __typename: 'Dashboard';
  canUserEdit: Scalars['Boolean']['output'];
  dashboardId: Scalars['String']['output'];
  description: Maybe<Scalars['String']['output']>;
  isExample: Scalars['Boolean']['output'];
  isOwnedByMe: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  owner: UserProfile;
  sharedWithUsers: Maybe<Array<UserProfile>>;
  sharingType: DashboardSharingType;
  widget: Maybe<Widget>;
  widgets: CountedWidgetsConnection;
};

export type DashboardWidgetArgs = {
  timezone?: InputMaybe<Scalars['IANATimezone']['input']>;
  widgetId: Scalars['String']['input'];
};

export type DashboardConnection = {
  __typename: 'DashboardConnection';
  edges: Maybe<Array<Maybe<DashboardEdge>>>;
  pageInfo: PageInfo;
};

export type DashboardEdge = {
  __typename: 'DashboardEdge';
  cursor: Maybe<Scalars['String']['output']>;
  node: Maybe<Dashboard>;
};

export enum DashboardQueryType {
  CREATED_BY_ME = 'CREATED_BY_ME',
  SHARED_WITH_ME = 'SHARED_WITH_ME',
}

export enum DashboardSharingType {
  ONLY_ME = 'ONLY_ME',
  WITH_COMPANY = 'WITH_COMPANY',
  WITH_SPECIFIC_USERS = 'WITH_SPECIFIC_USERS',
}

export type DataNetworkFilter = {
  __typename: 'DataNetworkFilter';
  onboardingStatus: Maybe<Array<UnifiedCompanyRelationshipOnboardingStatus>>;
  relationIdentifierIds: Maybe<Array<Scalars['String']['output']>>;
};

export type DataNetworkFilterInput = {
  onboardingStatus?: InputMaybe<Array<UnifiedCompanyRelationshipOnboardingStatus>>;
  relationIdentifierIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type DataNetworkReportFilterInput = {
  carrierIds?: InputMaybe<Array<Scalars['String']['input']>>;
  customFields?: InputMaybe<Array<TourCustomFieldSearch>>;
  customerIds?: InputMaybe<Array<Scalars['String']['input']>>;
  endTimeEnd?: InputMaybe<Scalars['DateTime']['input']>;
  endTimeStart?: InputMaybe<Scalars['DateTime']['input']>;
  endTimeSugarTimezone?: InputMaybe<Scalars['IANATimezone']['input']>;
  mainVisibilityIssues?: InputMaybe<Array<VisibilityIssueType>>;
  onboardingStatus?: InputMaybe<Array<UnifiedCompanyRelationshipOnboardingStatus>>;
  placeIds?: InputMaybe<Array<Scalars['String']['input']>>;
  relationIdentifierIds?: InputMaybe<Array<Scalars['String']['input']>>;
  shipperIds?: InputMaybe<Array<Scalars['String']['input']>>;
  siteIds?: InputMaybe<Array<Scalars['String']['input']>>;
  startTimeEnd: Scalars['DateTime']['input'];
  startTimeStart: Scalars['DateTime']['input'];
  startTimeSugarTimezone?: InputMaybe<Scalars['IANATimezone']['input']>;
  stopBookingLocationNames?: InputMaybe<Array<Scalars['String']['input']>>;
  stopCountries?: InputMaybe<Array<Scalars['String']['input']>>;
  stopFilters?: InputMaybe<Array<StopFilterInput>>;
  stopStates?: InputMaybe<Array<StopStatesInput>>;
};

export enum DataNetworkReportSortKey {
  ASSIGNMENT_PERCENTAGE = 'ASSIGNMENT_PERCENTAGE',
  ASSIGNMENT_PERCENTAGE_CHANGE = 'ASSIGNMENT_PERCENTAGE_CHANGE',
  CANCELLED_TOURS_COUNT = 'CANCELLED_TOURS_COUNT',
  COMPANY_NAME = 'COMPANY_NAME',
  COMPLETED_TOURS_COUNT = 'COMPLETED_TOURS_COUNT',
  DATE_ADDED = 'DATE_ADDED',
  ONBOARDING_STATUS = 'ONBOARDING_STATUS',
  ONBOARDING_STATUS_TRANSITIONED_AT = 'ONBOARDING_STATUS_TRANSITIONED_AT',
  TOTAL_TOURS_COUNT = 'TOTAL_TOURS_COUNT',
  TOUR_STATUS_CONSENT = 'TOUR_STATUS_CONSENT',
  UNASSIGNED_TOURS_COUNT = 'UNASSIGNED_TOURS_COUNT',
  UPCOMING_TOURS_COUNT = 'UPCOMING_TOURS_COUNT',
  VISIBILITY_INDEX = 'VISIBILITY_INDEX',
  VISIBILITY_INDEX_CHANGE = 'VISIBILITY_INDEX_CHANGE',
  WORKING_TOURS_COUNT = 'WORKING_TOURS_COUNT',
}

export type DataNetworkReportSortOrderInput = {
  direction: SortDirection;
  key: DataNetworkReportSortKey;
};

export enum DataNetworkReportType {
  PROVIDING_VISIBILITY = 'PROVIDING_VISIBILITY',
  RECEIVING_VISIBILITY = 'RECEIVING_VISIBILITY',
}

export type DataNetworkVisibilityReport = {
  __typename: 'DataNetworkVisibilityReport';
  companies: CountedDataNetworkVisibilityReportCompanyConnection;
  companyOverview: CompanyOverview;
  reportDownloadURI: Scalars['String']['output'];
  toursCountByStatus: ToursCountByStatus;
};

export type DataNetworkVisibilityReportToursCountByStatusArgs = {
  status: TourStatusFilter;
};

export type DataNetworkVisibilityReportCompany = {
  __typename: 'DataNetworkVisibilityReportCompany';
  assignmentPercentage: Maybe<Scalars['Float']['output']>;
  assignmentPercentageChange: Maybe<Scalars['Float']['output']>;
  companyId: Scalars['String']['output'];
  companyIsCarrier: Scalars['Boolean']['output'];
  companyIsShipper: Scalars['Boolean']['output'];
  companyName: Maybe<Scalars['String']['output']>;
  latestPendingInvite: Maybe<CompanyInvite>;
  mainVisibilityIssueType: Maybe<VisibilityIssueType>;
  /** @deprecated Use signupStatus instead */
  onboardingStatus: Maybe<UnifiedCompanyRelationshipOnboardingStatus>;
  /** @deprecated Field no longer supported */
  onboardingStuckReason: Maybe<UnifiedCompanyOnboardingStuckReason>;
  platforms: Array<CompanyPlatform>;
  relationIdentifiers: Array<CompanyIdentifier>;
  signupStatus: Maybe<UnifiedCompanyRelationshipSignupStatus>;
  tourCancelledCount: Scalars['Int']['output'];
  tourCompletedCount: Scalars['Int']['output'];
  tourTotalCount: Scalars['Int']['output'];
  tourUnassignedCount: Scalars['Int']['output'];
  tourUpcomingCount: Scalars['Int']['output'];
  tourWorkingCount: Scalars['Int']['output'];
  visibilityIndex: Maybe<Scalars['Float']['output']>;
  visibilityIndexChange: Maybe<Scalars['Float']['output']>;
};

export type DataNetworkVisibilityReportCompanyConnection = {
  __typename: 'DataNetworkVisibilityReportCompanyConnection';
  edges: Maybe<Array<Maybe<DataNetworkVisibilityReportCompanyEdge>>>;
  pageInfo: PageInfo;
};

export type DataNetworkVisibilityReportCompanyEdge = {
  __typename: 'DataNetworkVisibilityReportCompanyEdge';
  cursor: Maybe<Scalars['String']['output']>;
  node: Maybe<DataNetworkVisibilityReportCompany>;
};

export type DataSharingConsent = {
  __typename: 'DataSharingConsent';
  history: Maybe<Array<DataSharingConsentHistory>>;
  tourStatusScope: ConsentState;
};

export type DataSharingConsentHistory = {
  __typename: 'DataSharingConsentHistory';
  consentSource: ConsentSource;
  tourStatusScope: ConsentState;
  updatedAt: Scalars['DateTime']['output'];
  updatedByUser: Maybe<UserProfile>;
};

export type DateTimeRange = {
  __typename: 'DateTimeRange';
  end: Maybe<Scalars['DateTime']['output']>;
  start: Maybe<Scalars['DateTime']['output']>;
  sugarTimezone: Maybe<Scalars['IANATimezone']['output']>;
};

export type DateTimeRangeInput = {
  end?: InputMaybe<Scalars['DateTime']['input']>;
  start?: InputMaybe<Scalars['DateTime']['input']>;
  sugarTimezone?: InputMaybe<Scalars['IANATimezone']['input']>;
};

export type DateTimeWithTimezone = {
  __typename: 'DateTimeWithTimezone';
  dateTime: Scalars['DateTime']['output'];
  timezone: Scalars['Timezone']['output'];
};

export type DebugLog = {
  __typename: 'DebugLog';
  duration: Maybe<Scalars['Float']['output']>;
  logMessage: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type DedicatedVehiclesSummaryCounts = {
  __typename: 'DedicatedVehiclesSummaryCounts';
  active: Scalars['Int']['output'];
  inactive: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum DelayComparisonOperator {
  GTE = 'GTE',
  LTE = 'LTE',
}

export type DelayTimeRange = {
  comparison: DelayComparisonOperator;
  delayUnit: DelayTimerangeUnit;
  startInSeconds?: InputMaybe<Scalars['Int']['input']>;
};

export type DelayTimeRangeOutput = {
  __typename: 'DelayTimeRangeOutput';
  comparison: DelayComparisonOperator;
  delayUnit: DelayTimerangeUnit;
  startInSeconds: Scalars['Int']['output'];
};

export enum DelayTimerangeUnit {
  DAY = 'DAY',
  HOUR = 'HOUR',
}

export type DeleteBulkInvitationSetInput = {
  bulkInvitationSetId: Scalars['String']['input'];
};

export type DeleteBulkInvitationSetResult = {
  __typename: 'DeleteBulkInvitationSetResult';
  success: Scalars['Boolean']['output'];
};

export type DeleteCompanyIdentifierInput = {
  companyIdentifierId: Scalars['String']['input'];
};

export type DeleteCompanyIdentifierResult = {
  __typename: 'DeleteCompanyIdentifierResult';
  success: Scalars['Boolean']['output'];
};

export type DeleteCompanyPlatformInput = {
  platform_id: Scalars['String']['input'];
};

export type DeleteCompanyRelationshipInput = {
  companyRelationshipId: Scalars['String']['input'];
};

export type DeleteCompanyVehicleGroupInput = {
  companyId: Scalars['String']['input'];
  companyVehicleGroupId: Scalars['String']['input'];
};

export type DeleteFilterBasedTransportNotificationInput = {
  notificationId: Scalars['String']['input'];
};

export type DeleteInvitationsInput = {
  bulkInvitationSetItems?: InputMaybe<Array<BulkInvitationSetItemToDelete>>;
  companyInvitations?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type DeleteInvitationsResult = {
  __typename: 'DeleteInvitationsResult';
  deletedCount: Scalars['Int']['output'];
  success: Scalars['Boolean']['output'];
};

export type DeleteNoteInput = {
  companyId: Scalars['String']['input'];
  noteId: Scalars['String']['input'];
};

export type DeleteOvdTokenInput = {
  tokenId: Scalars['String']['input'];
};

export type DeleteSharedViewInput = {
  sharedViewId: Scalars['String']['input'];
};

export type DeleteSharedViewInputDeprecated = {
  companyId: Scalars['String']['input'];
  companyTourFilterId: Scalars['String']['input'];
};

export type DeleteTransportNotificationInput = {
  notificationId: Scalars['String']['input'];
};

export type DeleteVehicleInput = {
  vehicle_id: Scalars['String']['input'];
};

export type DeleteVehicleTrackerInput = {
  trackerId: Scalars['String']['input'];
};

export type DeleteVehiclesInput = {
  companyId: Scalars['String']['input'];
  vehicleIds: Array<Scalars['String']['input']>;
};

export type DeleteVisibilityAgentConversationInput = {
  companyId: Scalars['String']['input'];
  conversationId: Scalars['String']['input'];
};

export type DeleteWebhookSubscriptionInput = {
  companyId: Scalars['String']['input'];
  subscriptionId: Scalars['String']['input'];
};

export type DeleteWidgetInput = {
  dashboardId: Scalars['String']['input'];
  widgetId: Scalars['String']['input'];
};

export type DeliveryException = {
  __typename: 'DeliveryException';
  createdAt: Scalars['DateTime']['output'];
  deliveryIds: Array<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  exceptionFiles: Array<ExceptionFile>;
  exceptionId: Scalars['String']['output'];
  source: ExceptionSource;
  stopId: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
};

export enum DeliveryFrequency {
  BI_WEEKLY = 'BI_WEEKLY',
  EVERY_1_HOUR = 'EVERY_1_HOUR',
  EVERY_4_HOURS = 'EVERY_4_HOURS',
  EVERY_6_HOURS = 'EVERY_6_HOURS',
  EVERY_12_HOURS = 'EVERY_12_HOURS',
  EVERY_24_HOURS = 'EVERY_24_HOURS',
  INSTANTLY = 'INSTANTLY',
  MONTHLY = 'MONTHLY',
  WEEKLY = 'WEEKLY',
}

export type DeliverySettings = {
  __typename: 'DeliverySettings';
  frequency: DeliveryFrequency;
};

export type DeliverySettingsInput = {
  frequency: DeliveryFrequency;
};

export enum DemurrageType {
  PORT_OF_DISCHARGE = 'PORT_OF_DISCHARGE',
  PORT_OF_LOADING = 'PORT_OF_LOADING',
}

export type Document = {
  __typename: 'Document';
  associatedDeliveries: Array<TourDelivery>;
  createdAt: Scalars['DateTime']['output'];
  createdBy: Maybe<DocumentCreator>;
  description: Maybe<Scalars['String']['output']>;
  documentId: Scalars['String']['output'];
  documentType: DocumentType;
  documentUrl: Scalars['String']['output'];
  fileSize: Maybe<Scalars['Int']['output']>;
  internalDownloadUrl: Maybe<Scalars['String']['output']>;
  stopId: Maybe<Scalars['String']['output']>;
  storageFileId: Scalars['String']['output'];
};

export type DocumentCreator = {
  __typename: 'DocumentCreator';
  firstName: Maybe<Scalars['String']['output']>;
  lastName: Maybe<Scalars['String']['output']>;
};

export enum DocumentType {
  BOL = 'BOL',
  Check = 'Check',
  DOTInspection = 'DOTInspection',
  DeliveryTicketReceiptOrder = 'DeliveryTicketReceiptOrder',
  Directions = 'Directions',
  FineTicket = 'FineTicket',
  FreightBill = 'FreightBill',
  FreightDamageDocumentation = 'FreightDamageDocumentation',
  FuelReceipt = 'FuelReceipt',
  Insurance = 'Insurance',
  Invoice = 'Invoice',
  Log = 'Log',
  LumperReceipt = 'LumperReceipt',
  Match = 'Match',
  ODPermit = 'ODPermit',
  Other = 'Other',
  POD = 'POD',
  PackingSlip = 'PackingSlip',
  ProofOfPerformance = 'ProofOfPerformance',
  RateConfirmation = 'RateConfirmation',
  ScaleReceipt = 'ScaleReceipt',
  SignatureCapture = 'SignatureCapture',
  TripSheet = 'TripSheet',
  TruckTrailerDamageDocumentation = 'TruckTrailerDamageDocumentation',
  WeightScaleCertificate = 'WeightScaleCertificate',
}

export type DummyMobileTourAllocationInput = {
  companyId: Scalars['String']['input'];
  tourId: Scalars['String']['input'];
  vehicleTrackerId: Scalars['String']['input'];
};

export enum EtaType {
  EXTERNAL = 'EXTERNAL',
  INTERNAL = 'INTERNAL',
  ML_MODEL = 'ML_MODEL',
  NOT_UPDATED = 'NOT_UPDATED',
  TRIMBLE_INTERNAL = 'TRIMBLE_INTERNAL',
}

export type EmailRecipient = {
  __typename: 'EmailRecipient';
  email: Scalars['String']['output'];
  locale: Scalars['String']['output'];
};

export type EmailRecipientInput = {
  email: Scalars['String']['input'];
  locale: Scalars['String']['input'];
};

export enum EmailType {
  GLOBAL_ALLOCATION_TOUR_FORWARDED = 'GLOBAL_ALLOCATION_TOUR_FORWARDED',
  ONBOARDING_STATUS_ROLLED_BACK = 'ONBOARDING_STATUS_ROLLED_BACK',
  SIGNUP_STATUS_ROLLBACK_WARNING = 'SIGNUP_STATUS_ROLLBACK_WARNING',
  TELEMATICS_INTEGRATION_CREDENTIALS_INVALID = 'TELEMATICS_INTEGRATION_CREDENTIALS_INVALID',
  TOUR_FORWARDED = 'TOUR_FORWARDED',
}

export type EmissionCost = {
  __typename: 'EmissionCost';
  name: Scalars['String']['output'];
  tankToWheel: Scalars['Float']['output'];
  total: Scalars['Float']['output'];
  wellToTank: Scalars['Float']['output'];
};

export enum EmissionsCalculationErrorCode {
  ECOTRANSIT_IATA_CODE_NOT_FOUND = 'ECOTRANSIT_IATA_CODE_NOT_FOUND',
  ECOTRANSIT_INDEX_OUT_OF_BOUNDS = 'ECOTRANSIT_INDEX_OUT_OF_BOUNDS',
  ECOTRANSIT_POSTAL_CODE_AND_COUNTRY_NOT_FOUND = 'ECOTRANSIT_POSTAL_CODE_AND_COUNTRY_NOT_FOUND',
  ECOTRANSIT_ROUTING_ERROR = 'ECOTRANSIT_ROUTING_ERROR',
  ECOTRANSIT_TOO_MANY_LEGS_RETURNED = 'ECOTRANSIT_TOO_MANY_LEGS_RETURNED',
  ECOTRANSIT_UIC_COUNTRY_AND_CODE_NOT_FOUND = 'ECOTRANSIT_UIC_COUNTRY_AND_CODE_NOT_FOUND',
  ECOTRANSIT_UN_LOCODE_NOT_FOUND = 'ECOTRANSIT_UN_LOCODE_NOT_FOUND',
  TOUR_DELIVERIES_MISSING_WEIGHT = 'TOUR_DELIVERIES_MISSING_WEIGHT',
  TOUR_DELIVERIES_NOT_ENOUGH_VALID = 'TOUR_DELIVERIES_NOT_ENOUGH_VALID',
  TOUR_DISTANCE_CALCULATION_FAILED = 'TOUR_DISTANCE_CALCULATION_FAILED',
  TOUR_HISTORY_POLYLINES_TOO_MANY_POINTS = 'TOUR_HISTORY_POLYLINES_TOO_MANY_POINTS',
  TOUR_HISTORY_POLYLINES_ZERO = 'TOUR_HISTORY_POLYLINES_ZERO',
  TOUR_INVALID_MAX_DEPARTURE = 'TOUR_INVALID_MAX_DEPARTURE',
  TOUR_INVALID_MIN_ARRIVAL = 'TOUR_INVALID_MIN_ARRIVAL',
  TOUR_MORE_THAN_ONE_VEHICLE = 'TOUR_MORE_THAN_ONE_VEHICLE',
  TOUR_STATUS_EVENT_TELEMETRY_MISMATCH = 'TOUR_STATUS_EVENT_TELEMETRY_MISMATCH',
  TOUR_STATUS_NOT_COMPLETED = 'TOUR_STATUS_NOT_COMPLETED',
  TOUR_STATUS_POSSIBLE_WRONG_TRUCK = 'TOUR_STATUS_POSSIBLE_WRONG_TRUCK',
  TOUR_STOPS_MISSING_COORDINATES = 'TOUR_STOPS_MISSING_COORDINATES',
  TOUR_STOPS_NOT_ENOUGH_VALID = 'TOUR_STOPS_NOT_ENOUGH_VALID',
  TOUR_STOPS_NOT_ENOUGH_VALID_UNIQUE = 'TOUR_STOPS_NOT_ENOUGH_VALID_UNIQUE',
  TOUR_STOPS_SOME_IGNORED = 'TOUR_STOPS_SOME_IGNORED',
  TOUR_VEHICLE_MISSING = 'TOUR_VEHICLE_MISSING',
  TOUR_WEIGHT_OUT_OF_ALLOWED_RANGE = 'TOUR_WEIGHT_OUT_OF_ALLOWED_RANGE',
}

export enum EmissionsCalculationErrorType {
  DISTANCE = 'DISTANCE',
  FUEL = 'FUEL',
  PLANNED = 'PLANNED',
  PRECALC = 'PRECALC',
  TELEMETRY = 'TELEMETRY',
}

export type EndpointUsageCounterByDate = {
  __typename: 'EndpointUsageCounterByDate';
  logDate: Scalars['DateTime']['output'];
  noOfCalls: Scalars['Int']['output'];
  statusCode: Maybe<Scalars['Int']['output']>;
};

export type EtaComparison = {
  __typename: 'EtaComparison';
  comparisonTerm: ComparisonTerm;
  comparisonUnit: ComparisonUnit;
  comparisonValueInSeconds: Scalars['Int']['output'];
  remainingTimeInSeconds: Maybe<Scalars['Int']['output']>;
  remainingTimeUnit: Maybe<ComparisonUnit>;
  stopId: Maybe<Scalars['String']['output']>;
};

export type EtaComparisonInput = {
  comparisonTerm: ComparisonTerm;
  comparisonUnit: ComparisonUnit;
  comparisonValueInSeconds: Scalars['Int']['input'];
  remainingTimeInSeconds?: InputMaybe<Scalars['Int']['input']>;
  remainingTimeUnit?: InputMaybe<ComparisonUnit>;
  stopId?: InputMaybe<Scalars['String']['input']>;
};

export type ExampleWidgetInput = {
  exampleWidgetType: ExampleWidgetType;
  translatedName: Scalars['String']['input'];
};

export enum ExampleWidgetType {
  DELAYED_TOWARDS_DELIVERY = 'DELAYED_TOWARDS_DELIVERY',
  ON_TIME_TOWARDS_DELIVERY = 'ON_TIME_TOWARDS_DELIVERY',
  ON_TIME_TOWARDS_PICKUP = 'ON_TIME_TOWARDS_PICKUP',
}

export type ExceptionFile = {
  __typename: 'ExceptionFile';
  description: Maybe<Scalars['String']['output']>;
  documentUrl: Scalars['String']['output'];
  platformDocumentId: Scalars['String']['output'];
};

export enum ExceptionSource {
  TTC = 'TTC',
}

export enum ExceptionType {
  AdditionalCarry = 'AdditionalCarry',
  DeliveryIssueCallCustomer = 'DeliveryIssueCallCustomer',
  DeliveryIssueNeedTechnician = 'DeliveryIssueNeedTechnician',
  Elevator = 'Elevator',
  Ferry = 'Ferry',
  JoybirdCallCustomer = 'JoybirdCallCustomer',
  JoybirdNeedTechnician = 'JoybirdNeedTechnician',
  JoybirdRefused = 'JoybirdRefused',
  Misc = 'Misc',
  NoDeliveryCustomerCancelled = 'NoDeliveryCustomerCancelled',
  NoDeliveryMissedDeliveryWindow = 'NoDeliveryMissedDeliveryWindow',
  NoDeliveryNotAtHome = 'NoDeliveryNotAtHome',
  NoDeliveryOther = 'NoDeliveryOther',
  RefusalCustomerPreference = 'RefusalCustomerPreference',
  RefusalDamage = 'RefusalDamage',
  RefusalDamageCover = 'RefusalDamageCover',
  RefusalDamageFrame = 'RefusalDamageFrame',
}

export type ExposeSixfoldGeneratedPlaceInput = {
  companyId: Scalars['String']['input'];
  placeId: Scalars['String']['input'];
};

export enum ExtendedComparisonOperator {
  ANY_TIME_RANGE = 'ANY_TIME_RANGE',
  GTE = 'GTE',
  LTE = 'LTE',
  NOT_AVAILABLE = 'NOT_AVAILABLE',
  RANGE = 'RANGE',
}

export type ExternalCarrier = {
  __typename: 'ExternalCarrier';
  companyID: Maybe<Scalars['String']['output']>;
  companyName: Maybe<Scalars['String']['output']>;
};

export type ExternalCompanyInvitation = {
  companyName: Scalars['String']['input'];
  identifierValues?: InputMaybe<Array<Scalars['String']['input']>>;
  recipients: Array<ExternalCompanyInvitationRecipient>;
};

export type ExternalCompanyInvitationEmailInput = {
  companyName: Scalars['String']['input'];
  identifierValues?: InputMaybe<Array<Scalars['String']['input']>>;
  recipients: Array<ExternalCompanyInvitationRecipient>;
};

export type ExternalCompanyInvitationLinkInput = {
  companyName: Scalars['String']['input'];
  identifierValues?: InputMaybe<Array<Scalars['String']['input']>>;
  locale: Scalars['String']['input'];
};

export type ExternalCompanyInvitationRecipient = {
  email: Scalars['String']['input'];
  locale: Scalars['String']['input'];
};

export type ExternalCosts = {
  __typename: 'ExternalCosts';
  accidentCosts: Array<AccidentCost>;
  currency: Scalars['String']['output'];
  emissionCosts: Array<EmissionCost>;
  noiseCosts: Array<NoiseCost>;
  totalExternalCosts: Scalars['Float']['output'];
};

export enum ExternalEtaSource {
  CARRIER_API = 'CARRIER_API',
  PLATFORM_API = 'PLATFORM_API',
  PLATFORM_RTV_API = 'PLATFORM_RTV_API',
  TTC = 'TTC',
  TTC_MOBILE = 'TTC_MOBILE',
}

export type ExternalEmissions = {
  __typename: 'ExternalEmissions';
  co2TankToWheelTonnes: Maybe<Scalars['Float']['output']>;
  co2WellToTankTonnes: Maybe<Scalars['Float']['output']>;
  co2WellToWheelTonnes: Maybe<Scalars['Float']['output']>;
};

export enum ExternalEventSource {
  CARRIER_API = 'CARRIER_API',
  DRIVE_APP = 'DRIVE_APP',
  FMS = 'FMS',
  PLATFORM_API = 'PLATFORM_API',
  PLATFORM_API_TOUR_EVENTS = 'PLATFORM_API_TOUR_EVENTS',
  PLATFORM_RTV_API = 'PLATFORM_RTV_API',
  TTC = 'TTC',
}

export type ExternalTourDeliveryEvent = {
  __typename: 'ExternalTourDeliveryEvent';
  createdAt: Scalars['DateTime']['output'];
  delivery: Maybe<TourDelivery>;
  deliveryId: Scalars['String']['output'];
  eventId: Scalars['String']['output'];
  eventSource: ExternalEventSource;
  externalEventId: Maybe<Scalars['String']['output']>;
  externalEventQualifier: Scalars['String']['output'];
  externalEventSource: Maybe<Scalars['String']['output']>;
  latitude: Maybe<Scalars['Float']['output']>;
  longitude: Maybe<Scalars['Float']['output']>;
  qualifier: ExternalTourDeliveryEventQualifier;
  sentByCompanyId: Maybe<Scalars['String']['output']>;
  timestamp: Scalars['DateTime']['output'];
};

export enum ExternalTourDeliveryEventQualifier {
  HEADING_TOWARDS_LOADING = 'HEADING_TOWARDS_LOADING',
  HEADING_TOWARDS_UNLOADING = 'HEADING_TOWARDS_UNLOADING',
  LOADING_ARRIVED = 'LOADING_ARRIVED',
  LOADING_COMPLETED = 'LOADING_COMPLETED',
  LOADING_DEPARTED = 'LOADING_DEPARTED',
  LOADING_STARTED = 'LOADING_STARTED',
  OTHER = 'OTHER',
  UNLOADING_ARRIVED = 'UNLOADING_ARRIVED',
  UNLOADING_COMPLETED = 'UNLOADING_COMPLETED',
  UNLOADING_DEPARTED = 'UNLOADING_DEPARTED',
  UNLOADING_STARTED = 'UNLOADING_STARTED',
}

export type ExternalTourEvent = {
  __typename: 'ExternalTourEvent';
  createdAt: Scalars['DateTime']['output'];
  eventId: Scalars['String']['output'];
  eventSource: ExternalEventSource;
  externalEventId: Maybe<Scalars['String']['output']>;
  externalEventQualifier: Scalars['String']['output'];
  externalEventSource: Maybe<Scalars['String']['output']>;
  latitude: Maybe<Scalars['Float']['output']>;
  licensePlateNumber: Maybe<Scalars['String']['output']>;
  locationName: Maybe<Scalars['String']['output']>;
  longitude: Maybe<Scalars['Float']['output']>;
  qualifier: ExternalTourEventQualifier;
  remoteId: Maybe<Scalars['String']['output']>;
  sentByCompanyId: Maybe<Scalars['String']['output']>;
  timestamp: Scalars['DateTime']['output'];
  vehicleType: Maybe<VehicleType>;
};

export enum ExternalTourEventQualifier {
  ARRIVED = 'ARRIVED',
  COMPLETED = 'COMPLETED',
  DEPARTED = 'DEPARTED',
  HEADING_TOWARDS = 'HEADING_TOWARDS',
  LOADED = 'LOADED',
  OTHER = 'OTHER',
  TRACKING_FINISHED = 'TRACKING_FINISHED',
  TRACKING_STARTED = 'TRACKING_STARTED',
  UNLOADED = 'UNLOADED',
}

export type ExternalTourStopEvent = {
  __typename: 'ExternalTourStopEvent';
  createdAt: Scalars['DateTime']['output'];
  eventId: Scalars['String']['output'];
  eventSource: ExternalEventSource;
  externalEventId: Maybe<Scalars['String']['output']>;
  externalEventQualifier: Scalars['String']['output'];
  externalEventSource: Maybe<Scalars['String']['output']>;
  latitude: Maybe<Scalars['Float']['output']>;
  longitude: Maybe<Scalars['Float']['output']>;
  qualifier: ExternalTourStopEventQualifier;
  sentByCompanyId: Maybe<Scalars['String']['output']>;
  stopId: Scalars['String']['output'];
  timestamp: Scalars['DateTime']['output'];
};

export enum ExternalTourStopEventQualifier {
  ARRIVED = 'ARRIVED',
  DEPARTED = 'DEPARTED',
  HEADING_TOWARDS = 'HEADING_TOWARDS',
  LOADING_COMPLETED = 'LOADING_COMPLETED',
  LOADING_STARTED = 'LOADING_STARTED',
  OTHER = 'OTHER',
}

export type FmsVehicleTracker = {
  __typename: 'FMSVehicleTracker';
  createdAt: Maybe<Scalars['DateTime']['output']>;
  remoteId: Scalars['String']['output'];
  telematicsIntegration: Maybe<CompanyTelematicsIntegration>;
  trackerData: Maybe<Scalars['GraphQLJSON']['output']>;
  trackerType: VehicleTrackerType;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  vehicleId: Scalars['String']['output'];
  vehicleTrackerId: Scalars['String']['output'];
};

export type FeatureFlagAuditLog = {
  __typename: 'FeatureFlagAuditLog';
  companyId: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  featureFlagAuditLogId: Scalars['String']['output'];
  featureFlagId: Maybe<Scalars['String']['output']>;
  metadata: Array<Maybe<ActionMetadata>>;
  user: Maybe<UserProfile>;
};

export type FeatureFlagAuditLogConnection = {
  __typename: 'FeatureFlagAuditLogConnection';
  edges: Maybe<Array<Maybe<FeatureFlagAuditLogEdge>>>;
  pageInfo: PageInfo;
};

export type FeatureFlagAuditLogEdge = {
  __typename: 'FeatureFlagAuditLogEdge';
  cursor: Maybe<Scalars['String']['output']>;
  node: Maybe<FeatureFlagAuditLog>;
};

export type FeatureFlagMetadata = {
  __typename: 'FeatureFlagMetadata';
  description: Scalars['String']['output'];
  display_name: Scalars['String']['output'];
  domains: Array<Maybe<Scalars['String']['output']>>;
  feature_flag_id: Scalars['String']['output'];
  usage: Maybe<Scalars['String']['output']>;
};

export type FeatureFlags = {
  __typename: 'FeatureFlags';
  feature_flags: Array<Maybe<Scalars['String']['output']>>;
};

export type FileUploadInput = {
  contentType: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
  fileSize: Scalars['Int']['input'];
};

export type FilterBasedTransportNotification = {
  __typename: 'FilterBasedTransportNotification';
  createdAt: Scalars['DateTime']['output'];
  createdByUserId: Scalars['String']['output'];
  creator: Maybe<NotificationUserProfile>;
  deliverySettings: Maybe<DeliverySettings>;
  name: Scalars['String']['output'];
  notificationCustomization: Maybe<NotificationCustomization>;
  notificationId: Scalars['String']['output'];
  notificationTrigger: Maybe<NotificationTrigger>;
  recipients: Array<EmailRecipient>;
  recipientsV2: Array<Recipient>;
  status: NotificationStatus;
  transportFilter: Maybe<TourFilter>;
  transportFilterV2: Maybe<Scalars['GraphQLJSON']['output']>;
};

export enum FilterRoadStopType {
  loading = 'loading',
  other = 'other',
  unloading = 'unloading',
  waypoint = 'waypoint',
}

export enum FilterType {
  AIR = 'AIR',
  OCEAN = 'OCEAN',
  ROAD = 'ROAD',
}

export type FinalizeTransportUploadInput = {
  companyId: Scalars['String']['input'];
  mode: TransportUploadMode;
  storageFileId: Scalars['String']['input'];
  uploadId: Scalars['String']['input'];
};

export type FinalizeTransportUploadResult = {
  __typename: 'FinalizeTransportUploadResult';
  mode: TransportUploadMode;
  status: TransportUploadStatus;
  transportUploadId: Scalars['ID']['output'];
};

export type FlagCreatedMetadata = {
  __typename: 'FlagCreatedMetadata';
  action: Scalars['String']['output'];
  value: Scalars['Boolean']['output'];
};

export type FlagUpdatedMetadata = {
  __typename: 'FlagUpdatedMetadata';
  action: Scalars['String']['output'];
  newValue: Scalars['Boolean']['output'];
  oldValue: Maybe<Scalars['Boolean']['output']>;
};

export type ForwardTourInput = {
  forwardByCompanyId: Scalars['String']['input'];
  forwardToCompanyId: Scalars['String']['input'];
  tourId: Scalars['String']['input'];
};

export type FromPlatformData = {
  companyIdOnPlatform: Scalars['String']['input'];
  platformId: Scalars['String']['input'];
  userIdOnPlatform: Scalars['String']['input'];
};

export type FuelBasedEmissions = {
  __typename: 'FuelBasedEmissions';
  accumulatedFuelConsumptionLiters: Maybe<Scalars['Float']['output']>;
  co2TankToWheelTonnes: Maybe<Scalars['Float']['output']>;
  co2WellToTankTonnes: Maybe<Scalars['Float']['output']>;
  co2WellToWheelTonnes: Maybe<Scalars['Float']['output']>;
  emissionsIntensityGramPerTonneKms: Maybe<Scalars['Float']['output']>;
  fuelType: Maybe<Scalars['String']['output']>;
  transportActivityTonneKms: Maybe<Scalars['Float']['output']>;
};

export type GeoJsonGeometry = {
  __typename: 'GeoJSONGeometry';
  coordinates: Array<Scalars['Float']['output']>;
  type: Scalars['String']['output'];
};

export type GeoPosition = {
  __typename: 'GeoPosition';
  geocodingDirection: Maybe<Scalars['String']['output']>;
  geocoding_type: Maybe<GeocodingType>;
  lat: Maybe<Scalars['Float']['output']>;
  lng: Maybe<Scalars['Float']['output']>;
  matchLevel: Maybe<GeoPositionMatchLevel>;
  provider: Maybe<Scalars['String']['output']>;
};

export enum GeoPositionMatchLevel {
  CITY = 'CITY',
  COUNTRY = 'COUNTRY',
  EXTPOSTCODE = 'EXTPOSTCODE',
  HOUSE_NUMBER = 'HOUSE_NUMBER',
  STREET = 'STREET',
}

export enum GeocodingType {
  AUTOMATICALLY_GEOCODED = 'AUTOMATICALLY_GEOCODED',
  CARRIER = 'CARRIER',
  MANUAL = 'MANUAL',
  SHIPPER = 'SHIPPER',
}

export type Geofence = GeofenceCircle | GeofencePolygon;

export type GeofenceCircle = {
  __typename: 'GeofenceCircle';
  origin: Position;
  radiusInMeters: Scalars['Float']['output'];
  type: GeofenceType;
};

export type GeofencePolygon = {
  __typename: 'GeofencePolygon';
  points: Array<Position>;
  type: GeofenceType;
};

export enum GeofenceType {
  CIRCLE = 'CIRCLE',
  POLYGON = 'POLYGON',
}

export type GeofenceZone = {
  __typename: 'GeofenceZone';
  geofence: Geofence;
  zone: GeofenceZoneType;
};

export enum GeofenceZoneType {
  ARRIVAL = 'ARRIVAL',
  DEPARTURE = 'DEPARTURE',
}

export enum GrantDirection {
  GRANTED_BY_PARTNERS = 'GRANTED_BY_PARTNERS',
  GRANTED_TO_PARTNERS = 'GRANTED_TO_PARTNERS',
}

export type HandlingUnit = {
  __typename: 'HandlingUnit';
  handlingUnitDescription: Scalars['String']['output'];
  handlingUnitId: Scalars['String']['output'];
  handlingUnitInstruction: Scalars['String']['output'];
  handlingUnitName: Scalars['String']['output'];
  handlingUnitType: HandlingUnitType;
};

export enum HandlingUnitType {
  BALE = 'BALE',
  BOX = 'BOX',
  CASE = 'CASE',
  CONTAINER = 'CONTAINER',
  CRATE = 'CRATE',
  DRUM = 'DRUM',
  OTHER = 'OTHER',
  PALLET = 'PALLET',
  REEL = 'REEL',
}

export type HasAllocationsFilterInput = {
  fromTime: Scalars['DateTime']['input'];
  toTime: Scalars['DateTime']['input'];
};

export enum HasRoleRoles {
  admin = 'admin',
  readonly = 'readonly',
  service = 'service',
}

export type HazmatType = {
  __typename: 'HazmatType';
  category: HazmatTypeCategory;
  class: Scalars['Float']['output'];
  name: Scalars['String']['output'];
};

export enum HazmatTypeCategory {
  CORROSIVE = 'CORROSIVE',
  EXPLOSIVES = 'EXPLOSIVES',
  FLAMMABLE_LIQUIDS = 'FLAMMABLE_LIQUIDS',
  FLAMMABLE_SOLIDS = 'FLAMMABLE_SOLIDS',
  GASES = 'GASES',
  MISCELLANEOUS = 'MISCELLANEOUS',
  OXIDIZING_ORGANIC = 'OXIDIZING_ORGANIC',
  RADIOACTIVE = 'RADIOACTIVE',
  TOXIC_INFECTIOUS = 'TOXIC_INFECTIOUS',
}

export enum HistorySource {
  CARRIER_API = 'CARRIER_API',
  FMS = 'FMS',
  MOBILE = 'MOBILE',
  PLATFORM_API = 'PLATFORM_API',
  PLATFORM_RTV_API = 'PLATFORM_RTV_API',
  TTC = 'TTC',
  TTC_MOBILE = 'TTC_MOBILE',
}

export enum HistoryType {
  TOUR = 'TOUR',
  VEHICLE = 'VEHICLE',
}

export type IdentifierValueInput = {
  identifierId?: InputMaybe<Scalars['String']['input']>;
  identifierValue: Scalars['String']['input'];
};

export enum ImpactDaysComparison {
  GTE = 'GTE',
  LTE = 'LTE',
}

export type ImpactDaysFilter = {
  comparison: ImpactDaysComparison;
  startInSeconds: Scalars['Int']['input'];
};

export type ImpactDaysOutput = {
  __typename: 'ImpactDaysOutput';
  comparison: ImpactDaysComparison;
  startInSeconds: Scalars['Int']['output'];
};

export enum ImplementationStatus {
  IMPLEMENTED = 'IMPLEMENTED',
  INACTIVE_MORE_THAN_30_DAYS = 'INACTIVE_MORE_THAN_30_DAYS',
  UNDER_IMPLEMENTATION = 'UNDER_IMPLEMENTATION',
}

export enum IncotermTerm {
  CFR = 'CFR',
  CIF = 'CIF',
  CIP = 'CIP',
  CPT = 'CPT',
  DAP = 'DAP',
  DDP = 'DDP',
  DPU = 'DPU',
  EXW = 'EXW',
  FAS = 'FAS',
  FCA = 'FCA',
  FOB = 'FOB',
}

export type InitiateBatchUploadInput = {
  files: Array<FileUploadInput>;
  tourId: Scalars['String']['input'];
};

export type InitiateBatchUploadResult = {
  __typename: 'InitiateBatchUploadResult';
  results: Array<BatchUploadFileResult>;
  tourId: Scalars['String']['output'];
};

export type InitiateTransportUploadInput = {
  companyId: Scalars['String']['input'];
  contentType: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
  fileSize: Scalars['Int']['input'];
  mode: TransportUploadMode;
};

export type InitiateTransportUploadResult = {
  __typename: 'InitiateTransportUploadResult';
  expiresAt: Maybe<Scalars['String']['output']>;
  storageFileId: Scalars['String']['output'];
  uploadId: Scalars['String']['output'];
  uploadUrl: Scalars['String']['output'];
};

export type InitiateUploadInput = {
  contentType: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
  fileSize: Scalars['Int']['input'];
  tourId: Scalars['String']['input'];
};

export type InitiateUploadResult = {
  __typename: 'InitiateUploadResult';
  expiresAt: Maybe<Scalars['String']['output']>;
  storageFileId: Scalars['String']['output'];
  uploadId: Scalars['String']['output'];
  uploadUrl: Scalars['String']['output'];
};

export type IntegrationSyncResult = {
  __typename: 'IntegrationSyncResult';
  conflictingLicensePlates: Maybe<Array<ConflictingLicensePlate>>;
  conflictingRemoteIds: Maybe<Array<ConflictingRemoteId>>;
  distinctVehicleNullIslandCount: Maybe<Scalars['Int']['output']>;
  distinctVehicleStatusFutureCount: Maybe<Scalars['Int']['output']>;
  distinctVehicleTemperatureFutureCount: Maybe<Scalars['Int']['output']>;
  endTimeAt: Scalars['DateTime']['output'];
  errorDescription: Maybe<Scalars['String']['output']>;
  errorType: Maybe<IntegrationSyncResultErrorType>;
  integrationType: Maybe<IntegrationSyncResultIntegrationType>;
  latestStatusTimestamp: Maybe<Scalars['DateTime']['output']>;
  latestTemperatureTimestamp: Maybe<Scalars['DateTime']['output']>;
  resultType: Maybe<IntegrationSyncResultResultType>;
  startTimeAt: Scalars['DateTime']['output'];
  statusCount: Maybe<Scalars['Int']['output']>;
  stopEventsCount: Maybe<Scalars['Int']['output']>;
  temperatureCount: Maybe<Scalars['Int']['output']>;
  tourAllocationsCount: Maybe<Scalars['Int']['output']>;
  tourEventsCount: Maybe<Scalars['Int']['output']>;
  tourPositionsCount: Maybe<Scalars['Int']['output']>;
  vehicleAmbiguityCount: Maybe<Scalars['Int']['output']>;
  vehicleCount: Maybe<Scalars['Int']['output']>;
};

export enum IntegrationSyncResultErrorType {
  GLOBAL_TIMEOUT = 'GLOBAL_TIMEOUT',
  RATE_LIMIT = 'RATE_LIMIT',
  UNAUTHORIZED = 'UNAUTHORIZED',
  UNKNOWN = 'UNKNOWN',
}

export enum IntegrationSyncResultIntegrationType {
  CARRIER_INTEGRATION = 'CARRIER_INTEGRATION',
  FMS = 'FMS',
}

export enum IntegrationSyncResultResultType {
  HISTORICAL_RESULT = 'HISTORICAL_RESULT',
  LATEST_RESULT = 'LATEST_RESULT',
}

export type InvitationHistoryItem = {
  __typename: 'InvitationHistoryItem';
  inviteSentByLabel: Maybe<Scalars['String']['output']>;
  performedByEmail: Maybe<Scalars['String']['output']>;
  recipients: Maybe<Array<InvitationHistoryItemRecipient>>;
  time: Scalars['String']['output'];
  type: Maybe<InvitationHistoryLogItemType>;
};

export type InvitationHistoryItemRecipient = {
  __typename: 'InvitationHistoryItemRecipient';
  email: Scalars['String']['output'];
  locale: Scalars['String']['output'];
};

export enum InvitationHistoryLogItemType {
  ACCEPTED = 'ACCEPTED',
  EMAIL_SENT = 'EMAIL_SENT',
  LINK_CREATED = 'LINK_CREATED',
  WITHDRAWN = 'WITHDRAWN',
}

export enum InvitationOverviewStatus {
  INVITED = 'INVITED',
  NOT_INVITED = 'NOT_INVITED',
}

export type ItemCountByStatus = {
  __typename: 'ItemCountByStatus';
  count: Scalars['Int']['output'];
  status: BulkInvitationSetItemStatus;
};

export enum LstfTimeUnit {
  DAY = 'DAY',
  HOUR = 'HOUR',
  MINUTE = 'MINUTE',
  MONTH = 'MONTH',
  WEEK = 'WEEK',
}

export type LastActualLocationsAndMilestonesFilter = {
  __typename: 'LastActualLocationsAndMilestonesFilter';
  milestoneQualifiers: Maybe<Array<MilestoneQualifier>>;
  types: Maybe<Array<LocationType>>;
};

export type LastActualLocationsAndMilestonesFilterInput = {
  milestoneQualifiers?: InputMaybe<Array<MilestoneQualifier>>;
  types?: InputMaybe<Array<LocationType>>;
};

export type LastSignalTimestampFilter = {
  __typename: 'LastSignalTimestampFilter';
  comparison: ComparisonOperatorExtended;
  endInSeconds: Maybe<Scalars['Int']['output']>;
  startInSeconds: Maybe<Scalars['Int']['output']>;
  unit: Maybe<LstfTimeUnit>;
};

export type LastSignalTimestampFilterInput = {
  comparison: ComparisonOperatorExtended;
  endInSeconds?: InputMaybe<Scalars['Int']['input']>;
  startInSeconds?: InputMaybe<Scalars['Int']['input']>;
  unit?: InputMaybe<LstfTimeUnit>;
};

export type LatestVehicleTemperature = {
  __typename: 'LatestVehicleTemperature';
  reeferId: Scalars['String']['output'];
  sensorReadings: Array<VehicleTemperatureSensorReading>;
  timestamp: Scalars['DateTime']['output'];
  visibilitySource: VehicleTemperatureVisibilitySource;
};

export type Leg = {
  __typename: 'Leg';
  carriageParameters: CarriageParameters;
  distanceKM: Maybe<Scalars['Float']['output']>;
  emissions: Array<LegEmission>;
  endLocation: GeoPosition;
  externalCosts: Maybe<ExternalCosts>;
  routePolyline: Maybe<Scalars['String']['output']>;
  startLocation: GeoPosition;
  transportMode: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type LegEmission = {
  __typename: 'LegEmission';
  emissionMode: Scalars['String']['output'];
  tankToWheel: Scalars['Float']['output'];
  total: Scalars['Float']['output'];
  type: Scalars['String']['output'];
  unit: Scalars['String']['output'];
  wellToTank: Scalars['Float']['output'];
};

export type LemLicense = {
  __typename: 'LemLicense';
  created_at: Maybe<Scalars['DateTime']['output']>;
  license_id: Scalars['String']['output'];
  plan_id: Scalars['String']['output'];
  plan_name: Maybe<Scalars['String']['output']>;
  status: LemLicenseStatus;
  status_raw: Scalars['String']['output'];
  updated_at: Maybe<Scalars['DateTime']['output']>;
};

export enum LemLicenseStatus {
  ACTIVE = 'ACTIVE',
  ARCHIVED = 'ARCHIVED',
  CANCELLED = 'CANCELLED',
  EXPIRED = 'EXPIRED',
  INACTIVE = 'INACTIVE',
  PENDING = 'PENDING',
  PENDING_INVITATION = 'PENDING_INVITATION',
  UNKNOWN = 'UNKNOWN',
}

export type LicensePlateLookupInput = {
  companyId: Scalars['String']['input'];
  licensePlates: Array<Scalars['String']['input']>;
};

export type LicensePlateLookupResult = {
  __typename: 'LicensePlateLookupResult';
  licensePlate: Scalars['String']['output'];
  matches: Array<LicensePlateLookupVehicle>;
};

export type LicensePlateLookupResultSet = {
  __typename: 'LicensePlateLookupResultSet';
  result: Array<LicensePlateLookupResult>;
};

export type LicensePlateLookupVehicle = {
  __typename: 'LicensePlateLookupVehicle';
  alternativeIdentifier: Maybe<Scalars['String']['output']>;
  availability: VehicleAvailability;
  createdAt: Scalars['DateTime']['output'];
  lastStatusTimestamp: Maybe<Scalars['DateTime']['output']>;
  licensePlate: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  vehicleId: Scalars['String']['output'];
};

export type LightdashEmbeddings = {
  __typename: 'LightdashEmbeddings';
  allocationSourceAndSuccessUrl: Scalars['String']['output'];
};

export enum LinearUnit {
  FEET = 'FEET',
  INCHES = 'INCHES',
  KILOMETERS = 'KILOMETERS',
  METERS = 'METERS',
  MILES = 'MILES',
}

export enum LoadType {
  BULK = 'BULK',
  COURIER_EXPRESS_PARCEL = 'COURIER_EXPRESS_PARCEL',
  CUSTOMER_PICKUP = 'CUSTOMER_PICKUP',
  FULL_CONTAINER_LOAD = 'FULL_CONTAINER_LOAD',
  FULL_TRUCKLOAD = 'FULL_TRUCKLOAD',
  LESS_THAN_CONTAINER_LOAD = 'LESS_THAN_CONTAINER_LOAD',
  LESS_THAN_TRUCKLOAD = 'LESS_THAN_TRUCKLOAD',
  LESS_THAN_TRUCKLOAD_GROUPAGE = 'LESS_THAN_TRUCKLOAD_GROUPAGE',
}

export type LocationIdentifier = {
  __typename: 'LocationIdentifier';
  type: LocationIdentifierType;
  value: Scalars['String']['output'];
};

export enum LocationIdentifierType {
  UN_LOCODE = 'UN_LOCODE',
}

export type LocationMilestone = {
  delayTime?: InputMaybe<MilestoneDelay>;
  milestoneQualifier: Scalars['String']['input'];
  timelineEvents?: InputMaybe<Array<LocationMilestoneTimelineEvent>>;
};

export type LocationMilestoneOutput = {
  __typename: 'LocationMilestoneOutput';
  delayTime: Maybe<MilestoneDelayOutput>;
  milestoneQualifier: Scalars['String']['output'];
  timelineEvents: Maybe<Array<LocationMilestoneTimelineEventOutput>>;
};

export type LocationMilestoneTimelineEvent = {
  criteria: Scalars['String']['input'];
  timerange?: InputMaybe<TimeRangeSugarDate>;
};

export type LocationMilestoneTimelineEventOutput = {
  __typename: 'LocationMilestoneTimelineEventOutput';
  criteria: Scalars['String']['output'];
  timerange: Maybe<TimeRangeSugarDateOutput>;
};

export enum LocationType {
  COLLECTION = 'COLLECTION',
  DELIVERY = 'DELIVERY',
  DESTINATION = 'DESTINATION',
  EMPTY_CONTAINER_GATE_IN = 'EMPTY_CONTAINER_GATE_IN',
  EMPTY_CONTAINER_GATE_OUT = 'EMPTY_CONTAINER_GATE_OUT',
  EMPTY_POD = 'EMPTY_POD',
  EMPTY_POL = 'EMPTY_POL',
  GATEWAY = 'GATEWAY',
  IN_TRANSIT_DESTINATION = 'IN_TRANSIT_DESTINATION',
  IN_TRANSIT_ORIGIN = 'IN_TRANSIT_ORIGIN',
  LAYOVER = 'LAYOVER',
  LOADING = 'LOADING',
  ORIGIN = 'ORIGIN',
  OTHER = 'OTHER',
  PORT_OF_DISCHARGE = 'PORT_OF_DISCHARGE',
  PORT_OF_LOADING = 'PORT_OF_LOADING',
  TRANSSHIPMENT = 'TRANSSHIPMENT',
  TRANSSHIPMENT_PORT = 'TRANSSHIPMENT_PORT',
  UNLOADING = 'UNLOADING',
}

export type LocationsAndMilestones = {
  __typename: 'LocationsAndMilestones';
  locations: Array<MilestoneLocation>;
  vehicles: Array<VehicleData>;
};

export type LoginSharedView = {
  __typename: 'LoginSharedView';
  name: Scalars['String']['output'];
  owner: Maybe<CompanyProfile>;
  sharedViewId: Scalars['String']['output'];
};

export type LoginUser = {
  __typename: 'LoginUser';
  companies: Array<Company>;
  email: Maybe<Scalars['String']['output']>;
  locale: Maybe<Scalars['String']['output']>;
  user_id: Scalars['String']['output'];
};

export type LogitoneRoadStatusCallback = {
  __typename: 'LogitoneRoadStatusCallback';
  payload: Scalars['String']['output'];
  tourId: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
};

export enum MainMode {
  MODE_AIR = 'MODE_AIR',
  MODE_INLAND_WATER = 'MODE_INLAND_WATER',
  MODE_INTERMODAL = 'MODE_INTERMODAL',
  MODE_RAIL = 'MODE_RAIL',
  MODE_ROAD = 'MODE_ROAD',
  MODE_SEA = 'MODE_SEA',
}

export type MaritimeAffectedPort = {
  __typename: 'MaritimeAffectedPort';
  countryCode: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  unlocode: Scalars['String']['output'];
};

/** Authoritative wire vocab from sixfold-protos/MaritimeIntelligenceEvent; resolver does not normalize. */
export enum MaritimeEventStatus {
  ARCHIVED = 'ARCHIVED',
  DISRUPTED = 'DISRUPTED',
  MONITORING = 'MONITORING',
}

/** All proto values exposed 1:1; resolver does not bucket. */
export enum MaritimeEventType {
  CANAL_DISRUPTION = 'CANAL_DISRUPTION',
  CYBER_ATTACK = 'CYBER_ATTACK',
  GENERAL_DISRUPTION = 'GENERAL_DISRUPTION',
  GEOPOLITICAL = 'GEOPOLITICAL',
  INFRASTRUCTURE = 'INFRASTRUCTURE',
  PIRACY = 'PIRACY',
  PORT_CLOSURE = 'PORT_CLOSURE',
  PORT_CONGESTION = 'PORT_CONGESTION',
  PORT_STRIKE = 'PORT_STRIKE',
  REGULATORY = 'REGULATORY',
  ROUTE_DISRUPTION = 'ROUTE_DISRUPTION',
  SANCTIONS = 'SANCTIONS',
  STRAIT_CLOSURE = 'STRAIT_CLOSURE',
  VESSEL_INCIDENT = 'VESSEL_INCIDENT',
  WEATHER_DELAY = 'WEATHER_DELAY',
}

export type MaritimeIntelligenceEvent = {
  __typename: 'MaritimeIntelligenceEvent';
  /**
   * UN/LOCODEs used to match affected tours. Corridor and chokepoint events
   * (Suez, Hormuz, Red Sea) often have an empty `affectedPorts` list; this
   * field still carries the locodes those events apply to so clients do not
   * treat them as geographically empty.
   */
  affectedLocodes: Array<Scalars['String']['output']>;
  affectedPorts: Array<MaritimeAffectedPort>;
  /** Total number of the viewer's ocean shipments affected by this event, not capped by `first` (but capped at 1000). */
  affectedTourCount: Scalars['Int']['output'];
  /**
   * The requesting company's ocean shipments affected by this event: containers
   * calling at one of the `affectedPorts` whose vessel has not yet arrived there.
   * Resolved by tour-filtering-service and scoped to the viewer that fetched the
   * parent `Company.maritimeIntelligenceEvents` list.
   */
  affectedTours: Array<Tour>;
  /**
   * Ocean shipments report (XLSX) scoped to exactly the `affectedTours` of this event, with an
   * additional Incident sheet. Clients may append the usual report options (`timezone`,
   * `dateFormat`, `excludeColumnGroups`). Null when the event was not fetched through a company.
   */
  affectedToursReportURL: Maybe<Scalars['String']['output']>;
  eventId: Scalars['ID']['output'];
  eventType: MaritimeEventType;
  lastUpdatedAt: Scalars['DateTime']['output'];
  overview: Maybe<Scalars['String']['output']>;
  /** Map marker latitude. Null when upstream has no geolocation; the UI filters those events out client-side. */
  representativeLat: Maybe<Scalars['Float']['output']>;
  /** Map marker longitude. Null when upstream has no geolocation; the UI filters those events out client-side. */
  representativeLng: Maybe<Scalars['Float']['output']>;
  severity: MaritimeSeverity;
  status: MaritimeEventStatus;
  title: Scalars['String']['output'];
};

export type MaritimeIntelligenceEventAffectedToursArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
};

/** Authoritative wire vocab from sixfold-protos/MaritimeIntelligenceEvent; resolver does not normalize. */
export enum MaritimeSeverity {
  CRITICAL = 'CRITICAL',
  HIGH = 'HIGH',
  LOW = 'LOW',
  MEDIUM = 'MEDIUM',
}

export type MilestoneDelay = {
  anyTimerangeCriteria?: InputMaybe<Scalars['Boolean']['input']>;
  criteria: Scalars['String']['input'];
  timerange?: InputMaybe<DelayTimeRange>;
};

export type MilestoneDelayOutput = {
  __typename: 'MilestoneDelayOutput';
  anyTimerangeCriteria: Maybe<Scalars['Boolean']['output']>;
  criteria: Scalars['String']['output'];
  timerange: Maybe<DelayTimeRangeOutput>;
};

export type MilestoneLocation = {
  __typename: 'MilestoneLocation';
  country: Maybe<Scalars['String']['output']>;
  iataCode: Maybe<Scalars['String']['output']>;
  locationCode: Maybe<Scalars['String']['output']>;
  locationTransportMode: Maybe<MilestoneTransportModeType>;
  milestones: Array<MilestoneWithLocation>;
  name: Scalars['String']['output'];
  position: Maybe<Position>;
  type: Maybe<LocationType>;
  voyageId: Maybe<Scalars['String']['output']>;
};

export enum MilestoneQualifier {
  ARRIVAL = 'ARRIVAL',
  ARRIVAL_ON_RAMP = 'ARRIVAL_ON_RAMP',
  ARRIVED = 'ARRIVED',
  BOOKING_CONFIRMED = 'BOOKING_CONFIRMED',
  COLLECTED = 'COLLECTED',
  CONTAINER_DISCHARGED = 'CONTAINER_DISCHARGED',
  CONTAINER_LOADED = 'CONTAINER_LOADED',
  DELIVERED = 'DELIVERED',
  DEPARTED = 'DEPARTED',
  DEPARTURE = 'DEPARTURE',
  DEPARTURE_FROM_RAMP = 'DEPARTURE_FROM_RAMP',
  DOCUMENTS_DELIVERED = 'DOCUMENTS_DELIVERED',
  EMPTY_CONTAINER_GATE_IN = 'EMPTY_CONTAINER_GATE_IN',
  EMPTY_CONTAINER_GATE_OUT = 'EMPTY_CONTAINER_GATE_OUT',
  EMPTY_CONTAINER_PICKUP = 'EMPTY_CONTAINER_PICKUP',
  EMPTY_RETURN = 'EMPTY_RETURN',
  FLIGHT_ARRIVED = 'FLIGHT_ARRIVED',
  FLIGHT_DEPARTED = 'FLIGHT_DEPARTED',
  FULL_CONTAINER_GATE_IN = 'FULL_CONTAINER_GATE_IN',
  FULL_CONTAINER_GATE_OUT = 'FULL_CONTAINER_GATE_OUT',
  GATE_IN = 'GATE_IN',
  GATE_IN_EMPTY = 'GATE_IN_EMPTY',
  GATE_OUT = 'GATE_OUT',
  GATE_OUT_EMPTY = 'GATE_OUT_EMPTY',
  LOADED = 'LOADED',
  LOADED_ON_RAIL = 'LOADED_ON_RAIL',
  LOADED_ON_TRUCK = 'LOADED_ON_TRUCK',
  LOADING = 'LOADING',
  MANIFESTED = 'MANIFESTED',
  OTHER = 'OTHER',
  PICKUP = 'PICKUP',
  RAIL_ARRIVAL = 'RAIL_ARRIVAL',
  RAIL_DEPARTURE = 'RAIL_DEPARTURE',
  RECEIVED_FROM_FLIGHT = 'RECEIVED_FROM_FLIGHT',
  RECEIVED_FROM_SHIPPER = 'RECEIVED_FROM_SHIPPER',
  ROAD_ARRIVAL = 'ROAD_ARRIVAL',
  ROAD_DEPARTURE = 'ROAD_DEPARTURE',
  TRUCK_ARRIVAL = 'TRUCK_ARRIVAL',
  TRUCK_DEPARTURE = 'TRUCK_DEPARTURE',
  UNLOADED = 'UNLOADED',
  UNLOADED_FROM_RAIL = 'UNLOADED_FROM_RAIL',
  UNLOADED_FROM_TRUCK = 'UNLOADED_FROM_TRUCK',
  UNLOADING = 'UNLOADING',
  VESSEL_ARRIVED = 'VESSEL_ARRIVED',
  VESSEL_DEPARTED = 'VESSEL_DEPARTED',
}

export enum MilestoneTransportModeType {
  AIR = 'AIR',
  BARGE = 'BARGE',
  FEEDER = 'FEEDER',
  INLANDWATERWAY = 'INLANDWATERWAY',
  RAIL = 'RAIL',
  ROAD = 'ROAD',
  SEA = 'SEA',
  UNKNOWN = 'UNKNOWN',
}

export type MilestoneWithLocation = {
  __typename: 'MilestoneWithLocation';
  actualTimeOfArrival: Maybe<DateTimeWithTimezone>;
  actualTimeOfArrivalOverrides: Maybe<ActualTimeOverrides>;
  actualTimeOfArrivalSource: Maybe<Scalars['String']['output']>;
  estimatedTimeOfArrival: Maybe<DateTimeWithTimezone>;
  estimatedTimeOfArrivalSource: Maybe<Scalars['String']['output']>;
  location: Maybe<MilestoneLocation>;
  milestone: Scalars['String']['output'];
  packageCount: Maybe<Scalars['String']['output']>;
  qualifier: Maybe<MilestoneQualifier>;
  scheduledTimeOfArrival: Maybe<DateTimeWithTimezone>;
  scheduledTimeOfArrivalSource: Maybe<Scalars['String']['output']>;
  vehicleId: Maybe<Scalars['String']['output']>;
};

export type MissingLicensePlatesResult = {
  __typename: 'MissingLicensePlatesResult';
  missingLicensePlates: Array<Scalars['String']['output']>;
};

export type MobileVehicleTracker = {
  __typename: 'MobileVehicleTracker';
  alias: Maybe<Scalars['String']['output']>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  phoneNumber: Maybe<Scalars['String']['output']>;
  remoteId: Maybe<Scalars['String']['output']>;
  trackerData: Maybe<Scalars['GraphQLJSON']['output']>;
  trackerType: VehicleTrackerType;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  vehicleId: Scalars['String']['output'];
  vehicleTrackerId: Scalars['String']['output'];
};

export type MoveItemsToBulkInvitationSetInput = {
  bulkInvitationSetItemIds?: InputMaybe<Array<Scalars['String']['input']>>;
  moveToUngrouped?: InputMaybe<Scalars['Boolean']['input']>;
  selectType: BulkInvitationSendSelectType;
  sourceBulkInvitationSetId: Scalars['String']['input'];
  targetBulkInvitationSetId?: InputMaybe<Scalars['String']['input']>;
};

export type MoveItemsToBulkInvitationSetResult = {
  __typename: 'MoveItemsToBulkInvitationSetResult';
  hadDuplicates: Scalars['Boolean']['output'];
  success: Scalars['Boolean']['output'];
};

export type Mutation = {
  __typename: 'Mutation';
  abortTour: Maybe<Tour>;
  acceptSharedViewInvitation: Scalars['Boolean']['output'];
  addCompanyTag: Scalars['Boolean']['output'];
  addCredentialsToUser: Maybe<Credentials>;
  addItemsToBulkInvitationSet: AddItemsToBulkInvitationSetResult;
  addOrUpdateDataSharingConsent: Maybe<Scalars['Boolean']['output']>;
  addTourTag: Scalars['Boolean']['output'];
  addUserToCompany: Maybe<UserInCompanyProfile>;
  addVehiclesToCompanyVehicleGroup: Maybe<Scalars['Boolean']['output']>;
  allocateDummyMobileToTour: Maybe<Tour>;
  allocateVehiclesToTour: Maybe<Tour>;
  archiveCarrierNetworkItems: ArchiveCarrierNetworkItemsResult;
  archiveVehicles: ArchiveVehiclesResult;
  assignOceanCarrier: Maybe<OceanCarrierResult>;
  assignOceanContainer: Maybe<OceanContainerResult>;
  assignUserToTour: Maybe<TourAssignment>;
  bulkAssignUserToTours: BulkTourUserAssignmentResult;
  bulkDeleteUserAssignment: BulkTourUserAssignmentResult;
  cancelTransportAnalysis: Maybe<TransportAnalysisResponse>;
  changeTourStopTimeslot: Maybe<Tour>;
  changeTourVehicleAllocations: Array<TourVehicleAllocation>;
  changeUserMetadataInCompany: Maybe<UserInCompanyProfile>;
  changeUserRoleInCompany: Maybe<UserInCompanyProfile>;
  copyDashboard: Maybe<Dashboard>;
  createAllVehicleGrants: Maybe<Scalars['Boolean']['output']>;
  createBulkInvitationSet: CreateBulkInvitationSetResult;
  createCompany: Maybe<Company>;
  createCompanyAnalyticsFilter: Maybe<CompanyAnalyticsFilter>;
  createCompanyIdentifier: Maybe<CreateCompanyIdentifierResult>;
  createCompanyInvitationEmail: Maybe<CreateCompanyInvitationEmailResult>;
  /** @deprecated Use createCompanyInvitationLinkWithRecipients */
  createCompanyInvitationLink: Maybe<CreateCompanyInvitationLinkResult>;
  createCompanyInvitationLinkWithRecipients: Maybe<CreateCompanyInvitationLinkWithRecipientsResult>;
  createCompanyPlace: Maybe<CompanyPlace>;
  createCompanyPlatform: Maybe<CompanyPlatform>;
  createCompanyRelationship: Maybe<CompanyRelationship>;
  createCompanyTourFilter: Maybe<CompanyTourFilter>;
  createCompanyTransportNetworkFilter: Maybe<CompanyTransportNetworkFilter>;
  createCompanyVehicleGroup: Maybe<CompanyVehicleGroup>;
  createContactInquiry: Maybe<Scalars['Boolean']['output']>;
  createDashboard: Maybe<Dashboard>;
  createExampleDashboard: Maybe<Dashboard>;
  createNote: Maybe<Note>;
  createOrUpdateFilterBasedTransportNotification: Scalars['String']['output'];
  createOrUpdateRelationIdentifiers: Maybe<CreateOrUpdateRelationIdentifiersResult>;
  createOrUpdateTransportNotification: Scalars['String']['output'];
  createOvdToken: Maybe<OvdToken>;
  createPlatformSupportTicket: Maybe<Scalars['Boolean']['output']>;
  createSharedView: Maybe<Scalars['Boolean']['output']>;
  createTelematicsIntegration: Maybe<TelematicsIntegration>;
  createTour: Maybe<Tour>;
  createTourStopSharingToken: Maybe<TourStop>;
  createTransportAnalysis: Maybe<TransportAnalysisResponse>;
  createUser: Maybe<User>;
  createUserFilter: Maybe<UserFilter>;
  createVehicleMobileAppTracker: MobileVehicleTracker;
  createVehicles: Scalars['Boolean']['output'];
  createVisibilityAgentConversation: CreateVisibilityAgentConversationResult;
  createVisibilitySolutionsTicket: Maybe<Scalars['Boolean']['output']>;
  createWebhookSubscription: Maybe<CompanyWebhookSubscriptionInfo>;
  createWidget: Maybe<Widget>;
  deleteBulkInvitationSet: DeleteBulkInvitationSetResult;
  deleteCompanyAnalyticsFilter: Maybe<Scalars['Boolean']['output']>;
  deleteCompanyIdentifier: Maybe<DeleteCompanyIdentifierResult>;
  deleteCompanyPlace: Maybe<Scalars['Boolean']['output']>;
  deleteCompanyPlatform: Scalars['Boolean']['output'];
  deleteCompanyRelationship: Maybe<Scalars['Boolean']['output']>;
  deleteCompanyTourFilter: Maybe<Scalars['Boolean']['output']>;
  deleteCompanyTransportNetworkFilter: Maybe<Scalars['Boolean']['output']>;
  deleteCompanyVehicleGroup: Maybe<Scalars['Boolean']['output']>;
  deleteDashboard: Maybe<Scalars['Boolean']['output']>;
  deleteExternalDeliveryEvent: Scalars['Boolean']['output'];
  deleteExternalStopEvent: Scalars['Boolean']['output'];
  deleteExternalTourEvent: Scalars['Boolean']['output'];
  deleteFilterBasedTransportNotification: Scalars['Boolean']['output'];
  deleteInvitations: DeleteInvitationsResult;
  deleteNote: Scalars['Boolean']['output'];
  deleteOvdToken: Maybe<Scalars['Boolean']['output']>;
  deleteSharedView: Maybe<Scalars['Boolean']['output']>;
  deleteSharedViewAccessLoginToken: Scalars['Boolean']['output'];
  deleteSharedViewDeprecated: Maybe<Scalars['Boolean']['output']>;
  deleteSharedViewInvitationLoginToken: Scalars['Boolean']['output'];
  deleteTelematicsIntegration: Scalars['Boolean']['output'];
  deleteTelematicsIntegrationSyncState: Scalars['Boolean']['output'];
  deleteTour: Maybe<Scalars['Boolean']['output']>;
  deleteTourDocument: Scalars['Boolean']['output'];
  deleteTourStopSharingToken: Maybe<TourStop>;
  deleteTransportNotification: Scalars['Boolean']['output'];
  deleteUser: Maybe<Scalars['Boolean']['output']>;
  deleteUserAssignment: Maybe<Scalars['Boolean']['output']>;
  deleteUserLoginToken: Scalars['Boolean']['output'];
  deleteVehicle: Scalars['Boolean']['output'];
  deleteVehicleTracker: Scalars['Boolean']['output'];
  deleteVehicles: Scalars['Boolean']['output'];
  deleteVisibilityAgentConversation: Scalars['Boolean']['output'];
  deleteWebhookSubscription: Maybe<Scalars['Boolean']['output']>;
  deleteWidget: Maybe<Scalars['Boolean']['output']>;
  error: Maybe<Scalars['Boolean']['output']>;
  exposeSixfoldGeneratedPlace: Maybe<CompanyPlace>;
  finalizeTransportUpload: FinalizeTransportUploadResult;
  forwardTour: Maybe<Tour>;
  grantCompanyLemLicense: CompanyLemLicenses;
  initiateBatchDocumentUpload: InitiateBatchUploadResult;
  initiateDocumentUpload: InitiateUploadResult;
  initiateTransportUpload: InitiateTransportUploadResult;
  moveItemsToBulkInvitationSet: MoveItemsToBulkInvitationSetResult;
  ping: Maybe<Scalars['String']['output']>;
  pingUserUiActivity: Scalars['Boolean']['output'];
  provisionTFSSpace: ProvisionCompanyTfsSpaceResult;
  recalculateTour: Maybe<Tour>;
  removeCompanyTag: Scalars['Boolean']['output'];
  removeCredentialsFromUser: Maybe<Scalars['Boolean']['output']>;
  removeTourTag: Scalars['Boolean']['output'];
  removeUserFilter: Maybe<Scalars['Boolean']['output']>;
  removeUserFromCompany: Maybe<Scalars['Boolean']['output']>;
  removeVehiclesFromCompanyVehicleGroup: Maybe<Scalars['Boolean']['output']>;
  resendCompanyInvitation: Maybe<CreateCompanyInvitationsResult>;
  resendSharedViewEmailInvitation: Maybe<ResendSharedViewEmailInvitationResult>;
  restoreCarrierNetworkItems: ArchiveCarrierNetworkItemsResult;
  revealOvdToken: Maybe<OvdToken>;
  revokeAllVehicleGrants: Maybe<Scalars['Boolean']['output']>;
  revokeCompanyLemLicense: CompanyLemLicenses;
  saveCustomerFeedback: Maybe<Scalars['Boolean']['output']>;
  sendBulkInvitationSet: Maybe<SendBulkInvitationSetResult>;
  sendVisibilityAgentMessage: SendVisibilityAgentMessageResult;
  /**
   * Bulk set alternative identifiers for many vehicles.
   * Hard limit: 1000 vehicles per call.
   * Apply sends one company-service bulk message (one transaction, one Kafka job).
   * dryRun may use up to the hard limit. Apply-time races after validation surface as
   * a whole-request error on every ready item, not per-item errorType.
   */
  setBulkVehicleAlternativeIdentifiers: SetBulkVehicleAlternativeIdentifiersResult;
  setCompanyVATNumbers: Maybe<CompanyVatNumberChangeResult>;
  setVehicleAlternativeIdentifiers: SetVehicleAlternativeIdentifiersResult;
  setVehicleGrantVisibility: Maybe<Scalars['Boolean']['output']>;
  signupPageOpened: Maybe<Scalars['Boolean']['output']>;
  signupPlatformCompany: Maybe<CompanySignupCompleted>;
  submitUnsupportedTelematicsProviderDetails: Scalars['Boolean']['output'];
  submitVisibilityAgentFeedback: SubmitVisibilityAgentFeedbackResult;
  testOvdTokenFilter: Maybe<OvdTokenFilterTestResult>;
  trackTokenView: Scalars['Boolean']['output'];
  unarchiveVehicles: ArchiveVehiclesResult;
  unforwardTour: Maybe<Tour>;
  updateBulkInvitationSet: UpdateBulkInvitationSetResult;
  updateCompany: Maybe<Company>;
  updateCompanyAnalyticsFilter: Maybe<CompanyAnalyticsFilter>;
  updateCompanyConfiguration: Maybe<Company>;
  /**
   * Optimized version of updateCompany for flipping a single feature flag
   * useful for internal processes that want to control feature flags
   * If value is null, removes the feature flag (which is nearly always equivalent to setting it to false)
   * Returns true if the flag has been updated or error otherwise
   */
  updateCompanyFeatureFlag: Maybe<Scalars['Boolean']['output']>;
  updateCompanyPlace: Maybe<CompanyPlace>;
  updateCompanyPlatform: Maybe<CompanyPlatform>;
  updateCompanyRelationshipSignupStatus: Maybe<Scalars['Boolean']['output']>;
  updateCompanySettings: Maybe<Company>;
  updateCompanySharedViewBranding: Maybe<Company>;
  updateCompanyTranportContacts: Maybe<Company>;
  updateCompanyTransportContacts: Maybe<Company>;
  updateCompanyVehicleGroup: Maybe<CompanyVehicleGroup>;
  updateCompanyWebhookSubscription: Maybe<Scalars['Boolean']['output']>;
  updateCustomFieldDisplayNames: Maybe<Company>;
  updateDashboard: Maybe<Dashboard>;
  updateFilterBasedTransportNotification: Scalars['String']['output'];
  updateInviteCompanyName: Maybe<Scalars['Boolean']['output']>;
  updateMergedRowRelationIdentifiers: UpdateMergedRowRelationIdentifiersResult;
  updateNote: Maybe<Note>;
  updateOvdToken: Maybe<OvdToken>;
  updateSharedView: Maybe<Scalars['Boolean']['output']>;
  updateTelematicsIntegration: Maybe<TelematicsIntegration>;
  updateTelematicsIntegrationConnectionParameters: Maybe<CompanyTelematicsIntegration>;
  updateTelematicsIntegrationSyncStateNextSyncAt: Scalars['Boolean']['output'];
  updateTelematicsProvider: Maybe<TelematicsProvider>;
  updateTour: Maybe<Tour>;
  updateUnifiedCompanySignupStatus: Maybe<Scalars['Boolean']['output']>;
  updateUser: Maybe<User>;
  updateUserInCompanyConfiguration: Maybe<UserInCompany>;
  updateUserNotificationConfig: Maybe<UpdateUserNotificationConfigResponse>;
  updateViewerProfile: Maybe<User>;
  updateWebhookSubscription: Maybe<CompanyWebhookSubscriptionInfo>;
  updateWidget: Maybe<Widget>;
  uploadSharedViewLogo: UploadSharedViewLogoResult;
  upsertNotificationTemplateMetadata: NotificationTemplateMetadata;
  validateTelematicsIntegration: Maybe<TelematicsValidation>;
  validateTelematicsIntegrationConnectionParametersUpdate: Maybe<TelematicsValidation>;
  withdrawCompanyInvitation: WithdrawCompanyInvitationResult;
};

export type MutationAbortTourArgs = {
  tour_id: Scalars['Int']['input'];
};

export type MutationAcceptSharedViewInvitationArgs = {
  sharedViewId: Scalars['String']['input'];
};

export type MutationAddCompanyTagArgs = {
  input: CompanyTagInput;
};

export type MutationAddCredentialsToUserArgs = {
  input: AddCredentialsToUserInput;
};

export type MutationAddItemsToBulkInvitationSetArgs = {
  companyId: Scalars['String']['input'];
  input: AddItemsToBulkInvitationSetInput;
};

export type MutationAddOrUpdateDataSharingConsentArgs = {
  input: AddOrUpdateConsentInput;
};

export type MutationAddTourTagArgs = {
  tag_name: Scalars['String']['input'];
  tour_id: Scalars['String']['input'];
};

export type MutationAddUserToCompanyArgs = {
  input: AddUserToCompanyInput;
};

export type MutationAddVehiclesToCompanyVehicleGroupArgs = {
  input: AddVehiclesToCompanyVehicleGroupInput;
};

export type MutationAllocateDummyMobileToTourArgs = {
  input: DummyMobileTourAllocationInput;
};

export type MutationAllocateVehiclesToTourArgs = {
  input: TourAllocationInput;
};

export type MutationArchiveCarrierNetworkItemsArgs = {
  companyId: Scalars['String']['input'];
  input: ArchiveCarrierNetworkItemsInput;
};

export type MutationArchiveVehiclesArgs = {
  input: ArchiveVehiclesInput;
};

export type MutationAssignOceanCarrierArgs = {
  input: AssignOceanCarrierInput;
};

export type MutationAssignOceanContainerArgs = {
  input: AssignOceanContainerInput;
};

export type MutationAssignUserToTourArgs = {
  input: AssignUserToTourInput;
};

export type MutationBulkAssignUserToToursArgs = {
  companyId: Scalars['String']['input'];
  input: BulkAssignUserToToursInput;
};

export type MutationBulkDeleteUserAssignmentArgs = {
  companyId: Scalars['String']['input'];
  input: BulkDeleteUserAssignmentFromToursInput;
};

export type MutationCancelTransportAnalysisArgs = {
  input: CancelTransportAnalysisInput;
};

export type MutationChangeTourStopTimeslotArgs = {
  input: TourStopTimeslotInput;
};

export type MutationChangeTourVehicleAllocationsArgs = {
  input: TourVehicleAllocationsInput;
};

export type MutationChangeUserMetadataInCompanyArgs = {
  input: ChangeUserMetadataInCompanyInput;
};

export type MutationChangeUserRoleInCompanyArgs = {
  input: ChangeUserRoleInCompanyInput;
};

export type MutationCopyDashboardArgs = {
  input?: InputMaybe<CopyDashboardInput>;
};

export type MutationCreateAllVehicleGrantsArgs = {
  input: CreateVehicleGrantsInput;
};

export type MutationCreateBulkInvitationSetArgs = {
  companyId: Scalars['String']['input'];
  input: CreateBulkInvitationSetInput;
};

export type MutationCreateCompanyArgs = {
  input?: InputMaybe<CreateCompanyInput>;
};

export type MutationCreateCompanyAnalyticsFilterArgs = {
  input: CreateCompanyAnalyticsFilterInput;
};

export type MutationCreateCompanyIdentifierArgs = {
  input: CreateCompanyIdentifierInput;
};

export type MutationCreateCompanyInvitationEmailArgs = {
  companyId: Scalars['String']['input'];
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  input: CreateCompanyInvitationEmailInput;
};

export type MutationCreateCompanyInvitationLinkArgs = {
  companyId: Scalars['String']['input'];
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  input: CreateCompanyInvitationLinkInput;
};

export type MutationCreateCompanyInvitationLinkWithRecipientsArgs = {
  companyId: Scalars['String']['input'];
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  input: CreateCompanyInvitationLinkWithRecipientsInput;
};

export type MutationCreateCompanyPlaceArgs = {
  input: CreateCompanyPlaceInput;
};

export type MutationCreateCompanyPlatformArgs = {
  company_id: Scalars['String']['input'];
  input?: InputMaybe<CompanyPlatformInput>;
};

export type MutationCreateCompanyRelationshipArgs = {
  input: CreateCompanyRelationshipInput;
};

export type MutationCreateCompanyTourFilterArgs = {
  input: CreateCompanyTourFilterInput;
};

export type MutationCreateCompanyTransportNetworkFilterArgs = {
  input: CreateCompanyTransportNetworkFilterInput;
};

export type MutationCreateCompanyVehicleGroupArgs = {
  input: CreateCompanyVehicleGroupInput;
};

export type MutationCreateContactInquiryArgs = {
  input: CreateContactInquiryInput;
};

export type MutationCreateDashboardArgs = {
  input?: InputMaybe<CreateDashboardInput>;
};

export type MutationCreateExampleDashboardArgs = {
  input?: InputMaybe<CreateExampleDashboardInput>;
};

export type MutationCreateNoteArgs = {
  input: CreateNoteInput;
};

export type MutationCreateOrUpdateFilterBasedTransportNotificationArgs = {
  input: CreateOrUpdateFilterBasedTransportNotificationInput;
};

export type MutationCreateOrUpdateRelationIdentifiersArgs = {
  input: CreateOrUpdateRelationIdentifiersInput;
};

export type MutationCreateOrUpdateTransportNotificationArgs = {
  input: CreateOrUpdateTransportNotificationInput;
};

export type MutationCreateOvdTokenArgs = {
  input: CreateOvdTokenInput;
};

export type MutationCreatePlatformSupportTicketArgs = {
  input: CreatePlatformSupportTicketInput;
};

export type MutationCreateSharedViewArgs = {
  input: CreateSharedViewInput;
};

export type MutationCreateTelematicsIntegrationArgs = {
  input: CreateTelematicsIntegrationInput;
};

export type MutationCreateTourArgs = {
  input: TourCreationInput;
};

export type MutationCreateTourStopSharingTokenArgs = {
  company_id: Scalars['String']['input'];
  stop_id: Scalars['String']['input'];
  tour_id: Scalars['String']['input'];
};

export type MutationCreateTransportAnalysisArgs = {
  input: CreateTransportAnalysisInput;
};

export type MutationCreateUserArgs = {
  auth_service: Scalars['String']['input'];
  input?: InputMaybe<UserAttributesInput>;
};

export type MutationCreateUserFilterArgs = {
  input: CreateUserFilterInput;
};

export type MutationCreateVehicleMobileAppTrackerArgs = {
  input: CreateVehicleMobileAppTrackerInput;
};

export type MutationCreateVehiclesArgs = {
  input: CreateVehiclesInput;
};

export type MutationCreateVisibilityAgentConversationArgs = {
  input: CreateVisibilityAgentConversationInput;
};

export type MutationCreateVisibilitySolutionsTicketArgs = {
  input: CreateVisibilitySolutionsTicketInput;
};

export type MutationCreateWebhookSubscriptionArgs = {
  input: CreateWebhookSubscriptionInput;
};

export type MutationCreateWidgetArgs = {
  input: CreateWidgetInput;
};

export type MutationDeleteBulkInvitationSetArgs = {
  companyId: Scalars['String']['input'];
  input: DeleteBulkInvitationSetInput;
};

export type MutationDeleteCompanyAnalyticsFilterArgs = {
  companyAnalyticsFilterId: Scalars['String']['input'];
};

export type MutationDeleteCompanyIdentifierArgs = {
  input: DeleteCompanyIdentifierInput;
};

export type MutationDeleteCompanyPlaceArgs = {
  placeId: Scalars['String']['input'];
};

export type MutationDeleteCompanyPlatformArgs = {
  company_id: Scalars['String']['input'];
  input?: InputMaybe<DeleteCompanyPlatformInput>;
};

export type MutationDeleteCompanyRelationshipArgs = {
  input: DeleteCompanyRelationshipInput;
};

export type MutationDeleteCompanyTourFilterArgs = {
  companyTourFilterId: Scalars['String']['input'];
};

export type MutationDeleteCompanyTransportNetworkFilterArgs = {
  companyTransportNetworkFilterId: Scalars['String']['input'];
};

export type MutationDeleteCompanyVehicleGroupArgs = {
  input: DeleteCompanyVehicleGroupInput;
};

export type MutationDeleteDashboardArgs = {
  dashboardId: Scalars['String']['input'];
};

export type MutationDeleteExternalDeliveryEventArgs = {
  eventId: Scalars['String']['input'];
};

export type MutationDeleteExternalStopEventArgs = {
  eventId: Scalars['String']['input'];
};

export type MutationDeleteExternalTourEventArgs = {
  eventId: Scalars['String']['input'];
};

export type MutationDeleteFilterBasedTransportNotificationArgs = {
  input: DeleteFilterBasedTransportNotificationInput;
};

export type MutationDeleteInvitationsArgs = {
  companyId: Scalars['String']['input'];
  input: DeleteInvitationsInput;
};

export type MutationDeleteNoteArgs = {
  input: DeleteNoteInput;
};

export type MutationDeleteOvdTokenArgs = {
  input: DeleteOvdTokenInput;
};

export type MutationDeleteSharedViewArgs = {
  input: DeleteSharedViewInput;
};

export type MutationDeleteSharedViewDeprecatedArgs = {
  input: DeleteSharedViewInputDeprecated;
};

export type MutationDeleteTelematicsIntegrationArgs = {
  telematics_integration_id: Scalars['String']['input'];
};

export type MutationDeleteTelematicsIntegrationSyncStateArgs = {
  telematics_integration_id: Scalars['String']['input'];
};

export type MutationDeleteTourArgs = {
  input: TourDeletionInput;
};

export type MutationDeleteTourDocumentArgs = {
  documentId: Scalars['String']['input'];
};

export type MutationDeleteTourStopSharingTokenArgs = {
  company_id: Scalars['String']['input'];
  stop_id: Scalars['String']['input'];
  tour_id: Scalars['String']['input'];
};

export type MutationDeleteTransportNotificationArgs = {
  input: DeleteTransportNotificationInput;
};

export type MutationDeleteUserArgs = {
  userId: Scalars['String']['input'];
};

export type MutationDeleteUserAssignmentArgs = {
  companyId: Scalars['String']['input'];
  tourId: Scalars['String']['input'];
};

export type MutationDeleteVehicleArgs = {
  input: DeleteVehicleInput;
};

export type MutationDeleteVehicleTrackerArgs = {
  input: DeleteVehicleTrackerInput;
};

export type MutationDeleteVehiclesArgs = {
  input: DeleteVehiclesInput;
};

export type MutationDeleteVisibilityAgentConversationArgs = {
  input: DeleteVisibilityAgentConversationInput;
};

export type MutationDeleteWebhookSubscriptionArgs = {
  input: DeleteWebhookSubscriptionInput;
};

export type MutationDeleteWidgetArgs = {
  input: DeleteWidgetInput;
};

export type MutationErrorArgs = {
  message: Scalars['String']['input'];
};

export type MutationExposeSixfoldGeneratedPlaceArgs = {
  input: ExposeSixfoldGeneratedPlaceInput;
};

export type MutationFinalizeTransportUploadArgs = {
  input: FinalizeTransportUploadInput;
};

export type MutationForwardTourArgs = {
  input: ForwardTourInput;
};

export type MutationGrantCompanyLemLicenseArgs = {
  company_id: Scalars['String']['input'];
};

export type MutationInitiateBatchDocumentUploadArgs = {
  input: InitiateBatchUploadInput;
};

export type MutationInitiateDocumentUploadArgs = {
  input: InitiateUploadInput;
};

export type MutationInitiateTransportUploadArgs = {
  input: InitiateTransportUploadInput;
};

export type MutationMoveItemsToBulkInvitationSetArgs = {
  companyId: Scalars['String']['input'];
  input: MoveItemsToBulkInvitationSetInput;
};

export type MutationPingArgs = {
  input: Scalars['String']['input'];
};

export type MutationPingUserUiActivityArgs = {
  companyId?: InputMaybe<Scalars['String']['input']>;
};

export type MutationProvisionTfsSpaceArgs = {
  input: ProvisionCompanyTfsSpaceInput;
};

export type MutationRecalculateTourArgs = {
  tour_id: Scalars['Int']['input'];
};

export type MutationRemoveCompanyTagArgs = {
  input: CompanyTagInput;
};

export type MutationRemoveCredentialsFromUserArgs = {
  input: RemoveCredentialsFromUserInput;
};

export type MutationRemoveTourTagArgs = {
  tag_name: Scalars['String']['input'];
  tour_id: Scalars['String']['input'];
};

export type MutationRemoveUserFilterArgs = {
  userFilterId: Scalars['String']['input'];
};

export type MutationRemoveUserFromCompanyArgs = {
  input: RemoveUserFromCompanyInput;
};

export type MutationRemoveVehiclesFromCompanyVehicleGroupArgs = {
  input: RemoveVehiclesFromCompanyVehicleGroupInput;
};

export type MutationResendCompanyInvitationArgs = {
  companyId: Scalars['String']['input'];
  input?: InputMaybe<ResendCompanyInvitationInput>;
};

export type MutationResendSharedViewEmailInvitationArgs = {
  input: ResendSharedViewEmailInvitationInput;
};

export type MutationRestoreCarrierNetworkItemsArgs = {
  companyId: Scalars['String']['input'];
  input: ArchiveCarrierNetworkItemsInput;
};

export type MutationRevealOvdTokenArgs = {
  captchaToken: Scalars['String']['input'];
  tokenId: Scalars['String']['input'];
};

export type MutationRevokeAllVehicleGrantsArgs = {
  input: RevokeVehicleGrantsInput;
};

export type MutationRevokeCompanyLemLicenseArgs = {
  company_id: Scalars['String']['input'];
};

export type MutationSaveCustomerFeedbackArgs = {
  input: SaveCustomerFeedbackInput;
};

export type MutationSendBulkInvitationSetArgs = {
  companyId: Scalars['String']['input'];
  input?: InputMaybe<SendBulkInvitationSetInput>;
};

export type MutationSendVisibilityAgentMessageArgs = {
  input: SendVisibilityAgentMessageInput;
};

export type MutationSetBulkVehicleAlternativeIdentifiersArgs = {
  dryRun: Scalars['Boolean']['input'];
  input: SetBulkVehicleAlternativeIdentifiersInput;
};

export type MutationSetCompanyVatNumbersArgs = {
  company_id: Scalars['String']['input'];
  input?: InputMaybe<Array<InputMaybe<CompanyVatNumberInput>>>;
  retainMissingCountryCodes: Scalars['Boolean']['input'];
};

export type MutationSetVehicleAlternativeIdentifiersArgs = {
  input: SetVehicleAlternativeIdentifiersInput;
};

export type MutationSetVehicleGrantVisibilityArgs = {
  input: VehicleGrantVisibilityInput;
};

export type MutationSignupPageOpenedArgs = {
  input: SignupPageOpenedInput;
};

export type MutationSignupPlatformCompanyArgs = {
  input?: InputMaybe<SignupPlatformCompanyInput>;
};

export type MutationSubmitUnsupportedTelematicsProviderDetailsArgs = {
  input: SubmitUnsupportedTelematicsProviderDetailsInput;
};

export type MutationSubmitVisibilityAgentFeedbackArgs = {
  input: SubmitVisibilityAgentFeedbackInput;
};

export type MutationTestOvdTokenFilterArgs = {
  input: TestOvdTokenFilterInput;
};

export type MutationUnarchiveVehiclesArgs = {
  input: ArchiveVehiclesInput;
};

export type MutationUnforwardTourArgs = {
  input: UnforwardTourInput;
};

export type MutationUpdateBulkInvitationSetArgs = {
  companyId: Scalars['String']['input'];
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  input: UpdateBulkInvitationSetInput;
};

export type MutationUpdateCompanyArgs = {
  company_id: Scalars['String']['input'];
  input?: InputMaybe<UpdateCompanyInput>;
};

export type MutationUpdateCompanyAnalyticsFilterArgs = {
  input: UpdateCompanyAnalyticsFilterInput;
};

export type MutationUpdateCompanyConfigurationArgs = {
  input: UpdateCompanyConfigurationInput;
};

export type MutationUpdateCompanyFeatureFlagArgs = {
  companyId: Scalars['String']['input'];
  featureFlag: Scalars['String']['input'];
  value?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationUpdateCompanyPlaceArgs = {
  input: UpdateCompanyPlaceInput;
};

export type MutationUpdateCompanyPlatformArgs = {
  company_id: Scalars['String']['input'];
  input: UpdateCompanyPlatformInput;
  platform_id: Scalars['String']['input'];
};

export type MutationUpdateCompanyRelationshipSignupStatusArgs = {
  input: UpdateCompanyRelationshipSignupStatusInput;
};

export type MutationUpdateCompanySettingsArgs = {
  input: UpdateCompanySettingsInput;
};

export type MutationUpdateCompanySharedViewBrandingArgs = {
  companyId: Scalars['String']['input'];
  input: UpdateCompanySharedViewBrandingInput;
};

export type MutationUpdateCompanyTranportContactsArgs = {
  input: UpdateCompanyTransportContactsInput;
};

export type MutationUpdateCompanyTransportContactsArgs = {
  input: UpdateCompanyTransportContactsInput;
};

export type MutationUpdateCompanyVehicleGroupArgs = {
  input: UpdateCompanyVehicleGroupInput;
};

export type MutationUpdateCompanyWebhookSubscriptionArgs = {
  input: UpdateCompanyWebhookSubscriptionInput;
};

export type MutationUpdateCustomFieldDisplayNamesArgs = {
  input: UpdateCustomFieldDisplayNamesInput;
};

export type MutationUpdateDashboardArgs = {
  input?: InputMaybe<UpdateDashboardInput>;
};

export type MutationUpdateFilterBasedTransportNotificationArgs = {
  input: UpdateFilterBasedTransportNotificationInput;
};

export type MutationUpdateInviteCompanyNameArgs = {
  input: UpdateInviteCompanyNameInput;
};

export type MutationUpdateMergedRowRelationIdentifiersArgs = {
  input: UpdateMergedRowRelationIdentifiersInput;
};

export type MutationUpdateNoteArgs = {
  input: UpdateNoteInput;
};

export type MutationUpdateOvdTokenArgs = {
  input: UpdateOvdTokenInput;
};

export type MutationUpdateSharedViewArgs = {
  input: UpdateSharedViewInput;
};

export type MutationUpdateTelematicsIntegrationArgs = {
  input: UpdateTelematicsIntegrationInput;
};

export type MutationUpdateTelematicsIntegrationConnectionParametersArgs = {
  input: UpdateTelematicsIntegrationConnectionParametersInput;
};

export type MutationUpdateTelematicsIntegrationSyncStateNextSyncAtArgs = {
  telematics_integration_id: Scalars['String']['input'];
};

export type MutationUpdateTelematicsProviderArgs = {
  input: UpdateTelematicsProviderInput;
};

export type MutationUpdateTourArgs = {
  input: TourUpdateInput;
};

export type MutationUpdateUnifiedCompanySignupStatusArgs = {
  companyId: Scalars['String']['input'];
  input: UnifiedCompanySignupStatusUpdateInput;
};

export type MutationUpdateUserArgs = {
  input?: InputMaybe<UserAttributesInput>;
  user_id: Scalars['String']['input'];
};

export type MutationUpdateUserInCompanyConfigurationArgs = {
  input: UpdateUserInCompanyConfigurationInput;
};

export type MutationUpdateUserNotificationConfigArgs = {
  input: UpdateUserNotificationConfigInput;
};

export type MutationUpdateViewerProfileArgs = {
  input: UpdateViewerProfileInput;
};

export type MutationUpdateWebhookSubscriptionArgs = {
  input: UpdateWebhookSubscriptionInput;
};

export type MutationUpdateWidgetArgs = {
  input: UpdateWidgetInput;
};

export type MutationUploadSharedViewLogoArgs = {
  companyId: Scalars['String']['input'];
  logo: Scalars['Upload']['input'];
};

export type MutationUpsertNotificationTemplateMetadataArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  template_name: Scalars['String']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
};

export type MutationValidateTelematicsIntegrationArgs = {
  input: ValidateTelematicsIntegrationInput;
};

export type MutationValidateTelematicsIntegrationConnectionParametersUpdateArgs = {
  input: ValidateTelematicsIntegrationConnectionParametersUpdateInput;
};

export type MutationWithdrawCompanyInvitationArgs = {
  companyId: Scalars['String']['input'];
  input: WithdrawCompanyInvitationInput;
};

export enum NetworkInvitationType {
  LINK_AND_EMAIL = 'LINK_AND_EMAIL',
  LINK_ONLY = 'LINK_ONLY',
}

export type NetworkRelation = {
  __typename: 'NetworkRelation';
  companyIdentifiers: Array<CompanyIdentifier>;
  companyName: Scalars['String']['output'];
  companyReferenceName: Maybe<Scalars['String']['output']>;
  entityId: Scalars['String']['output'];
  invitation: Maybe<CompanyInvite>;
  relationCompanyName: Scalars['String']['output'];
  relationId: Scalars['String']['output'];
  relationIdentifiers: Array<CompanyIdentifier>;
  relationType: NetworkRelationType;
  signupStatus: Maybe<UnifiedCompanyRelationshipSignupStatus>;
  tourStatusConsent: NetworkRelationConsentState;
  type: NetworkRelationType;
};

export type NetworkRelationConnection = {
  __typename: 'NetworkRelationConnection';
  edges: Maybe<Array<Maybe<NetworkRelationEdge>>>;
  pageInfo: PageInfo;
};

export enum NetworkRelationConsentState {
  ACCEPTED = 'ACCEPTED',
  DECLINED = 'DECLINED',
  PENDING = 'PENDING',
  REQUESTED = 'REQUESTED',
}

export type NetworkRelationEdge = {
  __typename: 'NetworkRelationEdge';
  cursor: Maybe<Scalars['String']['output']>;
  node: Maybe<NetworkRelation>;
};

export type NetworkRelationFilter = {
  companyName?: InputMaybe<Scalars['String']['input']>;
  signupStatus?: InputMaybe<Array<UnifiedCompanyRelationshipSignupStatus>>;
  tourStatusConsent?: InputMaybe<Array<InputMaybe<NetworkRelationConsentState>>>;
};

export type NetworkRelationStatistics = {
  __typename: 'NetworkRelationStatistics';
  companyCountsBySignupStatus: Array<CompanyCountBySignupStatus>;
  companyCountsBySignupStatusAndDate: Array<CompanyCountBySignupStatus>;
};

export type NetworkRelationStatisticsCompanyCountsBySignupStatusAndDateArgs = {
  date: Scalars['String']['input'];
};

export enum NetworkRelationType {
  EXISTING = 'EXISTING',
  INVITATION = 'INVITATION',
}

export enum NetworkRelationsSortKey {
  COMPANY_NAME = 'COMPANY_NAME',
  COMPANY_NAME_BY_DISTANCE = 'COMPANY_NAME_BY_DISTANCE',
  COMPANY_REFERENCE_NAME = 'COMPANY_REFERENCE_NAME',
  CONSENT_STATUS = 'CONSENT_STATUS',
  RELATION_COMPANY_NAME = 'RELATION_COMPANY_NAME',
  SIGNUP_STATUS = 'SIGNUP_STATUS',
}

export type NetworkRelationsSortOrderInput = {
  direction: SortDirection;
  key: NetworkRelationsSortKey;
};

export type NoiseCost = {
  __typename: 'NoiseCost';
  noiseCostValue: Scalars['Float']['output'];
  transportMode: Scalars['String']['output'];
};

export type Note = {
  __typename: 'Note';
  associatedDeliveries: Array<TourDelivery>;
  createdAt: Scalars['DateTime']['output'];
  createdBy: NoteCreatedBy;
  creatorCompanyId: Maybe<Scalars['String']['output']>;
  creatorCompanyName: Maybe<Scalars['String']['output']>;
  isEditable: Maybe<Scalars['Boolean']['output']>;
  noteId: Scalars['String']['output'];
  noteOrigin: NoteOrigin;
  noteSentToDriver: Scalars['Boolean']['output'];
  noteText: Scalars['String']['output'];
  noteType: NoteType;
  noteVisibility: NoteVisibility;
  stopId: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export enum NoteCreatedBy {
  CARRIER = 'CARRIER',
  DRIVER = 'DRIVER',
  SHIPPER = 'SHIPPER',
}

export enum NoteOrigin {
  DRIVE_APP = 'DRIVE_APP',
  EXTERNAL = 'EXTERNAL',
  PLATFORM_API = 'PLATFORM_API',
  PLATFORM_RTV_API = 'PLATFORM_RTV_API',
  VH_UI = 'VH_UI',
}

export enum NoteType {
  COMMENT = 'COMMENT',
  NOTE = 'NOTE',
}

export enum NoteVisibility {
  PRIVATE = 'PRIVATE',
  PUBLIC = 'PUBLIC',
}

export type NotesFilterOptions = {
  __typename: 'NotesFilterOptions';
  hasAny: Scalars['Boolean']['output'];
};

export type NotificationCustomization = {
  __typename: 'NotificationCustomization';
  stopLevelSubjectLine: Maybe<Scalars['String']['output']>;
  transportLevelSubjectLine: Maybe<Scalars['String']['output']>;
};

export type NotificationCustomizationInput = {
  stopLevelSubjectLine?: InputMaybe<Scalars['String']['input']>;
  transportLevelSubjectLine?: InputMaybe<Scalars['String']['input']>;
};

export type NotificationFilterInput = {
  createdByUserIds?: InputMaybe<Array<Scalars['String']['input']>>;
  status?: InputMaybe<NotificationStatus>;
  textSearch?: InputMaybe<NotificationTextSearch>;
  transportModes?: InputMaybe<Array<TourFilteringTransportMode>>;
};

export enum NotificationSortKey {
  CREATED_AT = 'CREATED_AT',
  NAME = 'NAME',
}

export type NotificationSortOrder = {
  direction: SortDirection;
  key: NotificationSortKey;
};

export enum NotificationStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
}

export type NotificationTemplateMetadata = {
  __typename: 'NotificationTemplateMetadata';
  description: Maybe<Scalars['String']['output']>;
  template_name: Scalars['String']['output'];
  title: Maybe<Scalars['String']['output']>;
  updated_at: Maybe<Scalars['DateTime']['output']>;
};

export type NotificationTextSearch = {
  fields: Array<NotificationTextSearchField>;
  query: Scalars['String']['input'];
};

export enum NotificationTextSearchField {
  NAME = 'NAME',
  RECIPIENT_EMAIL = 'RECIPIENT_EMAIL',
  RECIPIENT_PHONE = 'RECIPIENT_PHONE',
}

export type NotificationTrigger = {
  __typename: 'NotificationTrigger';
  etaComparison: Maybe<Array<EtaComparison>>;
  exceptionTypes: Maybe<Array<Scalars['String']['output']>>;
  failureReasons: Maybe<Array<TourFailureReasonType>>;
  serviceExceptionCodes: Maybe<Array<Scalars['String']['output']>>;
  stopVisited: Maybe<StopVisited>;
  trackingNotStarted: Maybe<TrackingNotStarted>;
  vehicleTemperatureOutOfRange: Maybe<VehicleTemperatureOutOfRange>;
  warnings: Maybe<Array<TourWarningType>>;
};

export type NotificationTriggerInput = {
  etaComparison?: InputMaybe<Array<EtaComparisonInput>>;
  exceptionTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  failureReasons?: InputMaybe<Array<TourFailureReasonType>>;
  serviceExceptionCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  stopVisited?: InputMaybe<StopVisitedInput>;
  trackingNotStarted?: InputMaybe<TrackingNotStartedInput>;
  vehicleTemperatureOutOfRange?: InputMaybe<VehicleTemperatureOutOfRangeInput>;
  warnings?: InputMaybe<Array<TourWarningType>>;
};

export type NotificationUserProfile = {
  __typename: 'NotificationUserProfile';
  email: Maybe<Scalars['String']['output']>;
  firstName: Maybe<Scalars['String']['output']>;
  lastName: Maybe<Scalars['String']['output']>;
  userId: Scalars['String']['output'];
};

export type NullableUpload = {
  upload?: InputMaybe<Scalars['Upload']['input']>;
};

export type NumericFilterInput = {
  max?: InputMaybe<Scalars['Float']['input']>;
  min?: InputMaybe<Scalars['Float']['input']>;
  operator: NumericFilterOperator;
  value?: InputMaybe<Scalars['Float']['input']>;
};

export enum NumericFilterOperator {
  between = 'between',
  eq = 'eq',
  gt = 'gt',
  gte = 'gte',
  lt = 'lt',
  lte = 'lte',
  ne = 'ne',
  notBetween = 'notBetween',
}

export type OceanCarrierResult = {
  __typename: 'OceanCarrierResult';
  carrierCode: Maybe<Scalars['String']['output']>;
  carrierName: Maybe<Scalars['String']['output']>;
  tour_id: Scalars['String']['output'];
};

export type OceanContainerResult = {
  __typename: 'OceanContainerResult';
  containerNumber: Maybe<Scalars['String']['output']>;
  tour_id: Scalars['String']['output'];
};

export type OceanCostDetails = {
  __typename: 'OceanCostDetails';
  calculation: Maybe<Scalars['String']['output']>;
  costPerDay: Maybe<Scalars['Float']['output']>;
  daysBracket: Maybe<Scalars['String']['output']>;
};

export type OceanDemurrage = {
  __typename: 'OceanDemurrage';
  costs: Maybe<Array<OceanDemurrageCost>>;
  currency: Scalars['String']['output'];
  minRemainingFreeDays: Maybe<Scalars['Int']['output']>;
  overallState: Maybe<Scalars['String']['output']>;
  totalCost: Maybe<Scalars['Float']['output']>;
};

export type OceanDemurrageCost = {
  __typename: 'OceanDemurrageCost';
  actualCost: Maybe<Scalars['Float']['output']>;
  comments: Maybe<Scalars['String']['output']>;
  contractReference: Maybe<Scalars['String']['output']>;
  contractType: Maybe<Scalars['String']['output']>;
  costDetails: Array<OceanCostDetails>;
  currency: Scalars['String']['output'];
  endDate: Maybe<Scalars['String']['output']>;
  freeTimeDays: Maybe<Scalars['Int']['output']>;
  freeTimeType: Maybe<Scalars['String']['output']>;
  name: Maybe<Scalars['String']['output']>;
  overdueDays: Maybe<Scalars['Int']['output']>;
  remainingFreeDays: Maybe<Scalars['Int']['output']>;
  runningCost: Maybe<Scalars['Float']['output']>;
  startDate: Maybe<Scalars['String']['output']>;
  state: Maybe<Scalars['String']['output']>;
  timeElapsedDays: Maybe<Scalars['Int']['output']>;
};

export type OceanDemurrageFilter = {
  cost?: InputMaybe<Scalars['Float']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  names?: InputMaybe<Array<Scalars['String']['input']>>;
  remainingFreeDays?: InputMaybe<Scalars['Int']['input']>;
  states?: InputMaybe<Array<Scalars['String']['input']>>;
  types?: InputMaybe<Array<DemurrageType>>;
};

export type OceanDemurrageFilterOutput = {
  __typename: 'OceanDemurrageFilterOutput';
  cost: Maybe<Scalars['Float']['output']>;
  currency: Maybe<Scalars['String']['output']>;
  names: Maybe<Array<Scalars['String']['output']>>;
  remainingFreeDays: Maybe<Scalars['Int']['output']>;
  states: Maybe<Array<Scalars['String']['output']>>;
  types: Maybe<Array<DemurrageType>>;
};

export type OceanLocationTypeCount = {
  __typename: 'OceanLocationTypeCount';
  count: Scalars['Int']['output'];
  locationType: Scalars['String']['output'];
};

export type OceanMilestonePerformanceResult = {
  __typename: 'OceanMilestonePerformanceResult';
  locationTypeCounts: Array<OceanLocationTypeCount>;
  milestones: Array<OceanMilestonePerformanceRow>;
  totalContainers: Scalars['Int']['output'];
};

export type OceanMilestonePerformanceRow = {
  __typename: 'OceanMilestonePerformanceRow';
  count: Scalars['Int']['output'];
  locationType: Scalars['String']['output'];
  milestoneQualifier: Scalars['String']['output'];
};

export enum OceanPortLocationType {
  PORT_OF_DISCHARGE = 'PORT_OF_DISCHARGE',
  PORT_OF_LOADING = 'PORT_OF_LOADING',
}

export type OceanPortOption = {
  __typename: 'OceanPortOption';
  country: Maybe<Scalars['String']['output']>;
  locode: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type OceanTourLookupInput = {
  billOfLading?: InputMaybe<Scalars['String']['input']>;
  bookingNumber?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['String']['input'];
  containerNumber?: InputMaybe<Scalars['String']['input']>;
  transportNumber?: InputMaybe<Scalars['String']['input']>;
};

export type OnboardingAction = {
  __typename: 'OnboardingAction';
  type: OnboardingActionKey;
};

export enum OnboardingActionKey {
  ALLOCATE_TRANSPORTS = 'ALLOCATE_TRANSPORTS',
  CONNECT_VEHICLES = 'CONNECT_VEHICLES',
  INVALID_INTEGRATION = 'INVALID_INTEGRATION',
  ONBOARDING_ROLLBACK_WARNING = 'ONBOARDING_ROLLBACK_WARNING',
  ONBOARDING_ROLLED_BACK = 'ONBOARDING_ROLLED_BACK',
  ONBOARDING_STUCK = 'ONBOARDING_STUCK',
  UPDATE_COMPANY_DETAILS = 'UPDATE_COMPANY_DETAILS',
}

export enum OperatorType {
  DIVISION = 'DIVISION',
}

export type OptionsArgument = {
  subType: Scalars['String']['input'];
  textSearch?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  types?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OrderItem = {
  __typename: 'OrderItem';
  handlingUnits: Maybe<Array<HandlingUnit>>;
  hazmatType: Maybe<Array<HazmatType>>;
  isHazardous: Maybe<Scalars['Boolean']['output']>;
  itemHeight: Maybe<Scalars['Float']['output']>;
  itemLength: Maybe<Scalars['Float']['output']>;
  itemWidth: Maybe<Scalars['Float']['output']>;
  linearUnit: Maybe<LinearUnit>;
  orderItemCustomFields: Maybe<Array<OrderItemCustomField>>;
  orderItemGroups: Maybe<Array<OrderItemGroup>>;
  orderItemId: Scalars['String']['output'];
  orderItemName: Maybe<Scalars['String']['output']>;
  pieceCount: Maybe<Scalars['Int']['output']>;
  pieceDescription: Maybe<Scalars['String']['output']>;
  pieceUnit: Maybe<PieceUnit>;
  volume: Maybe<Scalars['Float']['output']>;
  volumeUnit: Maybe<VolumeUnit>;
  weightAmount: Maybe<Scalars['Float']['output']>;
  weightUnit: Maybe<WeightUnit>;
};

export type OrderItemCustomField = {
  __typename: 'OrderItemCustomField';
  name: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type OrderItemCustomFieldConnection = {
  __typename: 'OrderItemCustomFieldConnection';
  edges: Maybe<Array<Maybe<OrderItemCustomFieldEdge>>>;
  pageInfo: PageInfo;
};

export type OrderItemCustomFieldEdge = {
  __typename: 'OrderItemCustomFieldEdge';
  cursor: Maybe<Scalars['String']['output']>;
  node: Maybe<OrderItemCustomField>;
};

export type OrderItemCustomFieldInput = {
  productBrandValues?: InputMaybe<Array<Scalars['String']['input']>>;
  productLineValues?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OrderItemCustomFieldOutput = {
  __typename: 'OrderItemCustomFieldOutput';
  productBrandValues: Maybe<Array<Scalars['String']['output']>>;
  productLineValues: Maybe<Array<Scalars['String']['output']>>;
};

export type OrderItemCustomFieldSearch = {
  textSearch?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<OrderItemCustomFieldSearchType>;
};

export enum OrderItemCustomFieldSearchType {
  NAME = 'NAME',
  VALUE = 'VALUE',
}

export type OrderItemGroup = {
  __typename: 'OrderItemGroup';
  orderItemGroupDescription: Scalars['String']['output'];
  orderItemGroupId: Scalars['String']['output'];
  orderItemGroupName: Scalars['String']['output'];
};

export type OrderItemGroupOutput = {
  __typename: 'OrderItemGroupOutput';
  orderItemGroupDescriptions: Maybe<Array<Scalars['String']['output']>>;
  orderItemGroupNames: Maybe<Array<Scalars['String']['output']>>;
};

export type OrderItemGroupsInput = {
  orderItemGroupDescriptions?: InputMaybe<Array<Scalars['String']['input']>>;
  orderItemGroupNames?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OrderItemIdentifier = {
  __typename: 'OrderItemIdentifier';
  orderItemId: Scalars['String']['output'];
  orderItemName: Scalars['String']['output'];
};

export type OrderItemIdentifierConnection = {
  __typename: 'OrderItemIdentifierConnection';
  edges: Maybe<Array<Maybe<OrderItemIdentifierEdge>>>;
  pageInfo: PageInfo;
};

export type OrderItemIdentifierEdge = {
  __typename: 'OrderItemIdentifierEdge';
  cursor: Maybe<Scalars['String']['output']>;
  node: Maybe<OrderItemIdentifier>;
};

export type OrderedAggregateByInput = {
  order: Scalars['Int']['input'];
};

export type OvdToken = {
  __typename: 'OvdToken';
  carrierIds: Array<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  deliveryCustomFields: Array<Scalars['String']['output']>;
  enableApiEta: Scalars['Boolean']['output'];
  enableCancellationReason: Scalars['Boolean']['output'];
  enableCustomFields: Scalars['Boolean']['output'];
  enableStatus: Scalars['Boolean']['output'];
  label: Maybe<Scalars['String']['output']>;
  platformIds: Array<Scalars['String']['output']>;
  shipperIds: Array<Scalars['String']['output']>;
  token: Maybe<Scalars['String']['output']>;
  tokenId: Scalars['String']['output'];
  tourCustomFields: Array<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type OvdTokenFilterTestResult = {
  __typename: 'OvdTokenFilterTestResult';
  matchingShipmentCount: Scalars['Int']['output'];
  sampleShipments: Array<OvdTokenShipmentSummary>;
};

export type OvdTokenShipmentSummary = {
  __typename: 'OvdTokenShipmentSummary';
  platformTransportNumber: Maybe<Scalars['String']['output']>;
  shipmentId: Scalars['String']['output'];
  shipperTransportNumber: Maybe<Scalars['String']['output']>;
};

export type PageInfo = {
  __typename: 'PageInfo';
  endCursor: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  startCursor: Maybe<Scalars['String']['output']>;
};

export enum PieceUnit {
  BOX = 'BOX',
  EACH = 'EACH',
  GALLON = 'GALLON',
  LITER = 'LITER',
  OUNCES = 'OUNCES',
  PALLET = 'PALLET',
  UNITS = 'UNITS',
}

export type PlaceGeodataInput = {
  geofences: Array<PlaceGeofenceInput>;
  location: PointLocationInput;
};

export type PlaceGeofence = CircleGeofence | PolygonGeofence;

export type PlaceGeofenceInput = {
  geofence: PlaceGeofenceUnionInput;
  zone: PlaceGeofenceZoneType;
};

export type PlaceGeofenceUnionInput = {
  circle?: InputMaybe<CircleGeofenceInput>;
  polygon?: InputMaybe<PolygonGeofenceInput>;
};

export type PlaceGeofenceWithZone = {
  __typename: 'PlaceGeofenceWithZone';
  geofence: PlaceGeofence;
  zone: PlaceGeofenceZoneType;
};

export enum PlaceGeofenceZoneType {
  ARRIVAL = 'ARRIVAL',
  DEPARTURE = 'DEPARTURE',
}

export type PlaceTextSearch = {
  fields: Array<PlaceTextSearchField>;
  query: Scalars['String']['input'];
};

export enum PlaceTextSearchField {
  ADDRESSES = 'ADDRESSES',
  NAME = 'NAME',
  REFERENCE_ID = 'REFERENCE_ID',
}

export type Platform = {
  __typename: 'Platform';
  platform_branches: Array<Scalars['String']['output']>;
  platform_id: Scalars['String']['output'];
  platform_name: Scalars['String']['output'];
};

export type PlatformCallbackMessage = {
  __typename: 'PlatformCallbackMessage';
  createdAt: Scalars['DateTime']['output'];
  payload: Scalars['GraphQLJSON']['output'];
  platform: Maybe<Platform>;
  subjectId: Scalars['String']['output'];
  subjectType: Scalars['String']['output'];
};

export type PlatformCompanyInvite = {
  __typename: 'PlatformCompanyInvite';
  inviteStatus: Maybe<CompanyInviteStatus>;
  invitedByCompany: CompanyProfile;
  invitedByUser: UserProfile;
  signupReferenceId: Maybe<Scalars['String']['output']>;
  signupUrls: SignupUrls;
};

export type PlatformConnection = {
  __typename: 'PlatformConnection';
  edges: Maybe<Array<Maybe<PlatformEdge>>>;
  pageInfo: PageInfo;
};

export type PlatformEdge = {
  __typename: 'PlatformEdge';
  cursor: Maybe<Scalars['String']['output']>;
  node: Maybe<Platform>;
};

export type PlatformProfile = {
  __typename: 'PlatformProfile';
  platform_id: Scalars['String']['output'];
  platform_name: Scalars['String']['output'];
};

export type PointLocation = {
  __typename: 'PointLocation';
  lat: Scalars['Float']['output'];
  lng: Scalars['Float']['output'];
};

export type PointLocationInput = {
  lat: Scalars['Float']['input'];
  lng: Scalars['Float']['input'];
};

export type PolygonGeofence = {
  __typename: 'PolygonGeofence';
  points: Array<PointLocation>;
};

export type PolygonGeofenceInput = {
  points: Array<PointLocationInput>;
};

export type Polyline = {
  __typename: 'Polyline';
  points: Scalars['String']['output'];
};

export type Position = {
  __typename: 'Position';
  lat: Scalars['Float']['output'];
  lng: Scalars['Float']['output'];
};

export type PositionGeoJsonFeature = {
  __typename: 'PositionGeoJSONFeature';
  geometry: GeoJsonGeometry;
  properties: PositionGeoJsonProperties;
  type: Scalars['String']['output'];
};

export type PositionGeoJsonFeatureCollection = {
  __typename: 'PositionGeoJSONFeatureCollection';
  features: Array<PositionGeoJsonFeature>;
  type: Scalars['String']['output'];
};

export type PositionGeoJsonProperties = {
  __typename: 'PositionGeoJSONProperties';
  delay_status: Maybe<Scalars['String']['output']>;
  position_id: Scalars['String']['output'];
  total_containers: Scalars['Int']['output'];
  tour_ids: Array<Scalars['String']['output']>;
};

export type PositionInput = {
  lat: Scalars['Float']['input'];
  lng: Scalars['Float']['input'];
};

export type ProvidingVisibilityCompaniesFilterInput = {
  companyName?: InputMaybe<Scalars['String']['input']>;
  tourStatusConsent?: InputMaybe<Array<ConsentState>>;
};

export enum ProvidingVisibilityCompaniesSortKey {
  COMPANY_NAME = 'COMPANY_NAME',
  CONSENT_STATUS = 'CONSENT_STATUS',
}

export type ProvidingVisibilityCompaniesSortOrderInput = {
  direction: SortDirection;
  key: ProvidingVisibilityCompaniesSortKey;
};

export type ProvidingVisibilityCompany = {
  __typename: 'ProvidingVisibilityCompany';
  companyId: Scalars['String']['output'];
  companyIdentifiers: Array<CompanyIdentifier>;
  companyName: Maybe<Scalars['String']['output']>;
  dateAdded: Scalars['DateTime']['output'];
  relationIdentifiers: Array<CompanyIdentifier>;
  signupStatus: Maybe<UnifiedCompanyRelationshipSignupStatus>;
  tourStatusConsent: ConsentState;
  transporeonId: Maybe<Scalars['String']['output']>;
  vatNumbers: Array<CompanyVatNumber>;
};

export type ProvidingVisibilityCompanyConnection = {
  __typename: 'ProvidingVisibilityCompanyConnection';
  edges: Maybe<Array<Maybe<ProvidingVisibilityCompanyEdge>>>;
  pageInfo: PageInfo;
};

export type ProvidingVisibilityCompanyEdge = {
  __typename: 'ProvidingVisibilityCompanyEdge';
  cursor: Maybe<Scalars['String']['output']>;
  node: Maybe<ProvidingVisibilityCompany>;
};

export type ProvisionCompanyTfsSpaceInput = {
  companyId: Scalars['String']['input'];
  region: TfsRegion;
  spaceName: Scalars['String']['input'];
};

export type ProvisionCompanyTfsSpaceResult = {
  __typename: 'ProvisionCompanyTFSSpaceResult';
  accountId: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  region: Maybe<Scalars['String']['output']>;
  rootFolderId: Scalars['String']['output'];
  spaceId: Scalars['String']['output'];
  spaceName: Scalars['String']['output'];
};

export type Query = {
  __typename: 'Query';
  acceptedTransporeonUserAgreement: Maybe<Scalars['Boolean']['output']>;
  apiEndpointUsageLogs: ApiEndpointUsageLogConnection;
  apiEndpointUsageLogsEndpoints: Array<ApiEndpointUsageLogsEndpoint>;
  apiEndpointUsageLogsReportDownloadURI: Scalars['String']['output'];
  apiMetricsMessages: ApiMetricsEntryConnection;
  availableCompanyTags: Array<CompanyTag>;
  availableTourTags: Array<TourTag>;
  backofficeScopes: Array<Scalars['String']['output']>;
  bigQueryMessages: Array<BigQueryMessageEntry>;
  companies: Maybe<CompanyConnection>;
  company: Maybe<Company>;
  companyInvitations: Array<CompanyInvite>;
  companyLemLicenses: CompanyLemLicenses;
  companyPlatform: Maybe<CompanyPlatform>;
  companyRelationships: Maybe<CompanyRelationshipConnection>;
  documentDownloadUrl: Maybe<Scalars['String']['output']>;
  featureFlagMetadata: Array<FeatureFlagMetadata>;
  featureFlags: Maybe<FeatureFlags>;
  intercomTokenUrl: Scalars['String']['output'];
  licensePlateLookup: LicensePlateLookupResultSet;
  missingLicensePlates: MissingLicensePlatesResult;
  notificationTemplateMetadata: Maybe<NotificationTemplateMetadata>;
  notificationTemplateMetadataList: Array<NotificationTemplateMetadata>;
  oceanTourByIdentifier: Maybe<Tour>;
  ovdToken: Maybe<OvdToken>;
  ovdTokens: Array<OvdToken>;
  platforms: Maybe<PlatformConnection>;
  sensitiveCliCommandData: Maybe<Scalars['String']['output']>;
  sensitiveConnectionData: Maybe<Scalars['GraphQLJSON']['output']>;
  sensitiveData: Maybe<SensitiveData>;
  sharedViewViewer: Maybe<SharedViewViewer>;
  status: Maybe<Scalars['String']['output']>;
  telematicsIntegration: Maybe<TelematicsIntegration>;
  telematicsIntegrations: Maybe<CountedTelematicsIntegrationConnection>;
  telematicsProvider: Maybe<TelematicsProvider>;
  /** @deprecated Use telematicsProvidersV2 instead */
  telematicsProviders: TelematicsProviderConnection;
  telematicsProvidersV2: CountedTelematicsProviderConnection;
  token: Maybe<TokenResources>;
  tour: Maybe<Tour>;
  tours: CountedTourConnection;
  transportAnalyzerResults: TransportAnalysisResultConnection;
  transportUploads: Array<TransportUpload>;
  user: Maybe<User>;
  userNotificationConfig: Maybe<UserNotificationConfig>;
  users: Maybe<UserConnection>;
  vehicle: Maybe<Vehicle>;
  vehicleTrackerByTelematicsIntegrationAndVehicleDetails: Maybe<VehicleTrackerSearchResult>;
  vehicles: Maybe<VehicleConnection>;
  viewer: Maybe<User>;
  visibilityAgentConversation: Maybe<VisibilityAgentConversationMessages>;
  visibilityAgentConversations: VisibilityAgentConversationsResponse;
};

export type QueryAcceptedTransporeonUserAgreementArgs = {
  companyId: Scalars['String']['input'];
};

export type QueryApiEndpointUsageLogsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryApiEndpointUsageLogsReportDownloadUriArgs = {
  apiHealth?: InputMaybe<Scalars['String']['input']>;
  companyId?: InputMaybe<Scalars['String']['input']>;
  endpoint?: InputMaybe<Scalars['String']['input']>;
  implementationStatus?: InputMaybe<Scalars['String']['input']>;
};

export type QueryApiMetricsMessagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['String']['input'];
  endDate: Scalars['DateTime']['input'];
  endpointId: Scalars['String']['input'];
  errorMessage?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<SortDirection>;
  startDate: Scalars['DateTime']['input'];
  statusCode?: InputMaybe<Scalars['String']['input']>;
};

export type QueryBigQueryMessagesArgs = {
  from: Scalars['DateTime']['input'];
  keys: Array<Scalars['String']['input']>;
  messageTypes: Array<Scalars['String']['input']>;
  to: Scalars['DateTime']['input'];
  topics: Array<Scalars['String']['input']>;
};

export type QueryCompaniesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  agreementStatuses?: InputMaybe<Array<CompanyAgreementStatus>>;
  before?: InputMaybe<Scalars['String']['input']>;
  featureFlags?: InputMaybe<Array<Scalars['String']['input']>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  showOnlyOnboardingRolledBack?: InputMaybe<Scalars['Boolean']['input']>;
  signupStatus?: InputMaybe<UnifiedCompanySignupStatus>;
  tagName?: InputMaybe<Scalars['String']['input']>;
  textSearch?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<CompanyTypeInput>;
};

export type QueryCompanyArgs = {
  company_id: Scalars['String']['input'];
};

export type QueryCompanyInvitationsArgs = {
  company_id?: InputMaybe<Scalars['String']['input']>;
};

export type QueryCompanyLemLicensesArgs = {
  company_id: Scalars['String']['input'];
};

export type QueryCompanyPlatformArgs = {
  company_id: Scalars['String']['input'];
  platform_id: Scalars['String']['input'];
};

export type QueryCompanyRelationshipsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  companyId?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  relationshipType?: InputMaybe<CompanyRelationshipType>;
  sourceCompanyId?: InputMaybe<Scalars['String']['input']>;
  targetCompanyId?: InputMaybe<Scalars['String']['input']>;
};

export type QueryDocumentDownloadUrlArgs = {
  documentId: Scalars['String']['input'];
  sharedViewId?: InputMaybe<Scalars['String']['input']>;
};

export type QueryFeatureFlagMetadataArgs = {
  applies_to: Scalars['String']['input'];
};

export type QueryFeatureFlagsArgs = {
  applies_to: Scalars['String']['input'];
};

export type QueryIntercomTokenUrlArgs = {
  baseUrl: Scalars['String']['input'];
};

export type QueryLicensePlateLookupArgs = {
  licensePlateInput: LicensePlateLookupInput;
};

export type QueryMissingLicensePlatesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  companyNameSearch?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  integrationIds?: InputMaybe<Array<Scalars['String']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  licensePlateSearch?: InputMaybe<Scalars['String']['input']>;
  trackerType?: InputMaybe<VehicleTrackerType>;
  trackerTypes?: InputMaybe<Array<VehicleTrackerType>>;
};

export type QueryNotificationTemplateMetadataArgs = {
  template_name: Scalars['String']['input'];
};

export type QueryOceanTourByIdentifierArgs = {
  input: OceanTourLookupInput;
};

export type QueryOvdTokenArgs = {
  tokenId: Scalars['String']['input'];
};

export type QueryPlatformsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type QuerySensitiveCliCommandDataArgs = {
  captcha_token: Scalars['String']['input'];
  telematics_integration_id: Scalars['String']['input'];
};

export type QuerySensitiveConnectionDataArgs = {
  captcha_token: Scalars['String']['input'];
  telematics_integration_id: Scalars['String']['input'];
};

export type QuerySensitiveDataArgs = {
  captcha_token: Scalars['String']['input'];
  telematics_integration_id: Scalars['String']['input'];
};

export type QueryTelematicsIntegrationArgs = {
  telematics_integration_id: Scalars['String']['input'];
};

export type QueryTelematicsIntegrationsArgs = {
  companyId?: InputMaybe<Scalars['String']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  sort?: InputMaybe<TelematicsIntegrationsSortInput>;
  textSearch?: InputMaybe<Scalars['String']['input']>;
};

export type QueryTelematicsProviderArgs = {
  telematics_provider_id: Scalars['String']['input'];
};

export type QueryTelematicsProvidersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  integrationType?: InputMaybe<Scalars['String']['input']>;
  isAddingIntegrationDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  isDeprecated?: InputMaybe<Scalars['Boolean']['input']>;
  isExternalConfigurationNeeded?: InputMaybe<Scalars['Boolean']['input']>;
  isGlobalAllocationForbidden?: InputMaybe<Scalars['Boolean']['input']>;
  isInternalUseOnly?: InputMaybe<Scalars['Boolean']['input']>;
  isTourBasedProvider?: InputMaybe<Scalars['Boolean']['input']>;
  isVehicleManagementEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<TelematicsProvidersSortInput>;
  textSearch?: InputMaybe<Scalars['String']['input']>;
};

export type QueryTelematicsProvidersV2Args = {
  integrationType?: InputMaybe<Scalars['String']['input']>;
  isAddingIntegrationDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  isDeprecated?: InputMaybe<Scalars['Boolean']['input']>;
  isExternalConfigurationNeeded?: InputMaybe<Scalars['Boolean']['input']>;
  isGlobalAllocationForbidden?: InputMaybe<Scalars['Boolean']['input']>;
  isInternalUseOnly?: InputMaybe<Scalars['Boolean']['input']>;
  isTourBasedProvider?: InputMaybe<Scalars['Boolean']['input']>;
  isVehicleManagementEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  sort?: InputMaybe<TelematicsProvidersSortInput>;
  textSearch?: InputMaybe<Scalars['String']['input']>;
};

export type QueryTourArgs = {
  tour_id: Scalars['Int']['input'];
};

export type QueryToursArgs = {
  allocationStatus?: InputMaybe<TourAllocationStatus>;
  assignedToUserIds?: InputMaybe<Array<Scalars['String']['input']>>;
  carrierIds?: InputMaybe<Array<Scalars['String']['input']>>;
  customFields?: InputMaybe<Array<TourCustomFieldSearch>>;
  customerIds?: InputMaybe<Array<Scalars['String']['input']>>;
  delayStatus?: InputMaybe<TourDelayStatusFilter>;
  delayTime?: InputMaybe<TimeRangeInput>;
  documentTypes?: InputMaybe<Array<DocumentType>>;
  endTimeEnd?: InputMaybe<Scalars['DateTime']['input']>;
  endTimeStart?: InputMaybe<Scalars['DateTime']['input']>;
  endTimeSugarTimezone?: InputMaybe<Scalars['IANATimezone']['input']>;
  exceptionTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  failureReasons?: InputMaybe<Array<TourFailureReasonType>>;
  filterV2?: InputMaybe<Scalars['GraphQLJSON']['input']>;
  hasDocuments?: InputMaybe<Scalars['Boolean']['input']>;
  hasNotes?: InputMaybe<Scalars['Boolean']['input']>;
  hasTemperature?: InputMaybe<Scalars['Boolean']['input']>;
  lastActualLocationsAndMilestones?: InputMaybe<LastActualLocationsAndMilestonesFilterInput>;
  lastSignalTimestamp?: InputMaybe<LastSignalTimestampFilterInput>;
  mainCarrierIds?: InputMaybe<Array<Scalars['String']['input']>>;
  mainVisibilityIssues?: InputMaybe<Array<VisibilityIssueType>>;
  orderItemCustomFields?: InputMaybe<OrderItemCustomFieldInput>;
  orderItemGroups?: InputMaybe<OrderItemGroupsInput>;
  orderItemIsHazardous?: InputMaybe<Scalars['Boolean']['input']>;
  orderItemNames?: InputMaybe<Array<Scalars['String']['input']>>;
  placeIds?: InputMaybe<Array<Scalars['String']['input']>>;
  platformBranchId?: InputMaybe<Scalars['String']['input']>;
  platformId?: InputMaybe<Scalars['String']['input']>;
  serviceExceptionCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  shipmentType?: InputMaybe<Array<ShipmentTypeFilter>>;
  shipperIds?: InputMaybe<Array<Scalars['String']['input']>>;
  siteIds?: InputMaybe<Array<Scalars['String']['input']>>;
  sortOrder?: InputMaybe<TourSortOrder>;
  startTimeEnd?: InputMaybe<Scalars['DateTime']['input']>;
  startTimeStart?: InputMaybe<Scalars['DateTime']['input']>;
  startTimeSugarTimezone?: InputMaybe<Scalars['IANATimezone']['input']>;
  status?: InputMaybe<TourStatusFilter>;
  statuses?: InputMaybe<Array<TourStatusFilter>>;
  stopBookingLocationNames?: InputMaybe<Array<Scalars['String']['input']>>;
  stopCompanyNames?: InputMaybe<Array<Scalars['String']['input']>>;
  stopCountries?: InputMaybe<Array<Scalars['String']['input']>>;
  stopFilters?: InputMaybe<Array<StopFilterInput>>;
  stopStates?: InputMaybe<Array<StopStatesInput>>;
  temperatureEverOutOfRange?: InputMaybe<TemperatureEverOutOfRangeFilterInput>;
  textSearch?: InputMaybe<TourTextSearch>;
  timeSpentAtStop?: InputMaybe<TimeRangeInput>;
  transportMode?: InputMaybe<Array<TourFilteringTransportMode>>;
  vehicleId?: InputMaybe<Scalars['String']['input']>;
  vehicleLicensePlates?: InputMaybe<Array<TourVehicleLicensePlateFilterInput>>;
  vesselName?: InputMaybe<VesselNameFilterInput>;
  voyageIds?: InputMaybe<Array<Scalars['String']['input']>>;
  warnings?: InputMaybe<Array<TourWarningType>>;
  workingStopStatus?: InputMaybe<WorkingStopStatusFilter>;
  workingStopTimeslotBeginEnd?: InputMaybe<Scalars['DateTime']['input']>;
};

export type QueryTransportAnalyzerResultsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryTransportUploadsArgs = {
  companyId: Scalars['String']['input'];
  mode?: InputMaybe<TransportUploadMode>;
};

export type QueryUserArgs = {
  user_id: Scalars['String']['input'];
};

export type QueryUserNotificationConfigArgs = {
  company_id: Scalars['String']['input'];
  user_id: Scalars['String']['input'];
};

export type QueryUsersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type QueryVehicleArgs = {
  vehicle_id: Scalars['String']['input'];
};

export type QueryVehicleTrackerByTelematicsIntegrationAndVehicleDetailsArgs = {
  licensePlate?: InputMaybe<Scalars['String']['input']>;
  remoteId?: InputMaybe<Scalars['String']['input']>;
  telematicsIntegrationId: Scalars['String']['input'];
};

export type QueryVehiclesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  company_id?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  integrationIds?: InputMaybe<Array<Scalars['String']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  licensePlateSearch?: InputMaybe<Scalars['String']['input']>;
  trackerTypes?: InputMaybe<Array<VehicleTrackerType>>;
};

export type QueryVisibilityAgentConversationArgs = {
  conversationId: Scalars['String']['input'];
  cursor?: InputMaybe<Scalars['String']['input']>;
};

export type QueryVisibilityAgentConversationsArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
};

export type RawExternalEvents = {
  __typename: 'RawExternalEvents';
  logitoneRoadStatusCallback: Maybe<LogitoneRoadStatusCallback>;
  tourDemurrageDetentionLogs: Array<TourDemurrageDetentionLog>;
  tourExternalTracking: Array<TourExternalTracking>;
  tourExternalTrackingLogs: Array<TourExternalTrackingLog>;
  tourExternalTrackingRequests: Array<TourExternalTrackingRequest>;
};

export type ReceivingVisibilityCompaniesFilterInput = {
  companyName?: InputMaybe<Scalars['String']['input']>;
  signupStatus?: InputMaybe<Array<UnifiedCompanyRelationshipSignupStatus>>;
  tourStatusConsent?: InputMaybe<Array<InputMaybe<ConsentState>>>;
};

export enum ReceivingVisibilityCompaniesSortKey {
  COMPANY_NAME = 'COMPANY_NAME',
  CONSENT_STATUS = 'CONSENT_STATUS',
  SIGNUP_STATUS = 'SIGNUP_STATUS',
}

export type ReceivingVisibilityCompaniesSortOrderInput = {
  direction: SortDirection;
  key: ReceivingVisibilityCompaniesSortKey;
};

export type ReceivingVisibilityCompany = {
  __typename: 'ReceivingVisibilityCompany';
  allocated: Maybe<Scalars['Float']['output']>;
  companyId: Scalars['String']['output'];
  companyIdentifiers: Array<CompanyIdentifier>;
  companyInvite: Maybe<CompanyInvite>;
  companyName: Maybe<Scalars['String']['output']>;
  dateAdded: Scalars['DateTime']['output'];
  latestPendingInvite: Maybe<CompanyInvite>;
  relationIdentifiers: Array<CompanyIdentifier>;
  signupStatus: Maybe<UnifiedCompanyRelationshipSignupStatus>;
  signupStatusTransitionedAt: Maybe<Scalars['DateTime']['output']>;
  statusContext: Maybe<CarrierNetworkStatusContext>;
  tourStatusConsent: ConsentState;
  tracked: Maybe<Scalars['Float']['output']>;
  transporeonId: Maybe<Scalars['String']['output']>;
  transports: Maybe<Scalars['Int']['output']>;
  vatNumbers: Array<CompanyVatNumber>;
};

export type ReceivingVisibilityCompanyConnection = {
  __typename: 'ReceivingVisibilityCompanyConnection';
  edges: Maybe<Array<Maybe<ReceivingVisibilityCompanyEdge>>>;
  pageInfo: PageInfo;
};

export type ReceivingVisibilityCompanyEdge = {
  __typename: 'ReceivingVisibilityCompanyEdge';
  cursor: Maybe<Scalars['String']['output']>;
  node: Maybe<ReceivingVisibilityCompany>;
};

export type Recipient = EmailRecipient | SmsRecipient | StopContactRecipient;

export type RecipientInput = {
  email?: InputMaybe<EmailRecipientInput>;
  sms?: InputMaybe<SmsRecipientInput>;
  stopContact?: InputMaybe<StopContactRecipientInput>;
};

export type RelatedTransportForListView = {
  __typename: 'RelatedTransportForListView';
  shipper_transport_number: Maybe<Scalars['String']['output']>;
  tour_id: Scalars['Int']['output'];
};

export type RelationIdentifier = {
  __typename: 'RelationIdentifier';
  companyIdentifierId: Scalars['String']['output'];
  identifierValue: Scalars['String']['output'];
};

export type RelationIdentifierWithValidation = {
  __typename: 'RelationIdentifierWithValidation';
  companyId: Scalars['String']['output'];
  companyIdentifierId: Scalars['String']['output'];
  discriminatorCountry: Maybe<Scalars['String']['output']>;
  identifierType: CompanyIdentifierType;
  identifierValue: Scalars['String']['output'];
  isDuplicateInExistingValue: Scalars['Boolean']['output'];
  source: Scalars['String']['output'];
};

export type RemoveCredentialsFromUserInput = {
  type: CredentialType;
  userId: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type RemoveUserFromCompanyInput = {
  companyId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type RemoveVehiclesFromCompanyVehicleGroupInput = {
  companyId: Scalars['String']['input'];
  companyVehicleGroupId: Scalars['String']['input'];
  vehicleIds: Array<Scalars['String']['input']>;
};

export type ResendCompanyInvitationInput = {
  externalInvitation: ExternalCompanyInvitation;
};

export type ResendSharedViewEmailInvitationInput = {
  email: Scalars['String']['input'];
  locale: Scalars['String']['input'];
  sharedViewAccessId: Scalars['String']['input'];
};

export type ResendSharedViewEmailInvitationResult = {
  __typename: 'ResendSharedViewEmailInvitationResult';
  emailAccess: SharedViewEmailAccess;
  success: Scalars['Boolean']['output'];
};

export type ResolvedDateTimeRange = {
  __typename: 'ResolvedDateTimeRange';
  end: Scalars['DateTime']['output'];
  start: Scalars['DateTime']['output'];
};

export type RestrictedVehicleStatus = {
  __typename: 'RestrictedVehicleStatus';
  heading: Maybe<Scalars['Float']['output']>;
  latitude: Scalars['Float']['output'];
  longitude: Scalars['Float']['output'];
  source: VehicleSignalSource;
  timeBasedStatus: TimeBasedStatus;
  timestamp: Scalars['DateTime']['output'];
  vehicle_id: Scalars['String']['output'];
};

export type RevokeVehicleGrantsInput = {
  revokedByCompany: Scalars['String']['input'];
  revokedFromCompany: Scalars['String']['input'];
};

export type Route = {
  __typename: 'Route';
  legs: Array<RouteLeg>;
  provider: Scalars['String']['output'];
};

export type RouteLeg = {
  __typename: 'RouteLeg';
  metadata: RouteLegMetadata;
  polyline: Polyline;
};

export type RouteLegMetadata = {
  __typename: 'RouteLegMetadata';
  isExtendedRoute: Scalars['Boolean']['output'];
};

export type SaveCustomerFeedbackInput = {
  companyId: Scalars['String']['input'];
  feedback: Scalars['String']['input'];
};

export type SendBulkInvitationSetInput = {
  bulkInvitationSetId: Scalars['String']['input'];
  companyName?: InputMaybe<Scalars['String']['input']>;
  includeInviterInCC?: InputMaybe<Scalars['Boolean']['input']>;
  selectInvitationType: BulkInvitationSendSelectType;
  selectedInvitationItemIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type SendBulkInvitationSetResult = {
  __typename: 'SendBulkInvitationSetResult';
  success: Scalars['Boolean']['output'];
};

export type SendVisibilityAgentMessageInput = {
  companyId: Scalars['String']['input'];
  conversationId: Scalars['String']['input'];
  currentUrl?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  message: Scalars['String']['input'];
  timezone?: InputMaybe<Scalars['String']['input']>;
};

export type SendVisibilityAgentMessageResult = VisibilityAgentChatResult | VisibilityAgentValidationError;

export type SensitiveData = {
  __typename: 'SensitiveData';
  connectionData: Maybe<Scalars['GraphQLJSON']['output']>;
  syncStateData: Maybe<Scalars['String']['output']>;
};

export type ServiceException = {
  __typename: 'ServiceException';
  code: Scalars['String']['output'];
  description: Scalars['String']['output'];
  exceptionId: Scalars['String']['output'];
  source: ExceptionSource;
  time: Scalars['DateTime']['output'];
};

export type SetBulkVehicleAlternativeIdentifiersInput = {
  companyId: Scalars['String']['input'];
  items: Array<SetBulkVehicleAlternativeIdentifiersItemInput>;
};

export type SetBulkVehicleAlternativeIdentifiersItemInput = {
  alternativeIdentifiers: Array<Scalars['String']['input']>;
  vehicleId: Scalars['String']['input'];
};

export type SetBulkVehicleAlternativeIdentifiersResult = {
  __typename: 'SetBulkVehicleAlternativeIdentifiersResult';
  items: Array<BulkVehicleAlternativeIdentifiersItemResult>;
  success: Scalars['Boolean']['output'];
};

export type SetVehicleAlternativeIdentifiersInput = {
  alternativeIdentifiers: Array<Scalars['String']['input']>;
  companyId: Scalars['String']['input'];
  vehicleId: Scalars['String']['input'];
};

export type SetVehicleAlternativeIdentifiersResult = {
  __typename: 'SetVehicleAlternativeIdentifiersResult';
  alternativeIdentifiers: Array<VehicleAlternativeIdentifier>;
  conflicts: Array<VehicleAlternativeIdentifierConflict>;
  success: Scalars['Boolean']['output'];
};

export type SharedCompanyInvite = {
  __typename: 'SharedCompanyInvite';
  allowedSignups: Array<AllowedCompanyInviteSignup>;
  companyInviteId: Scalars['String']['output'];
  invitedByCompany: Maybe<CompanyProfile>;
  invitedByUser: Maybe<UserProfile>;
  invitedCompany: Maybe<CompanyProfile>;
};

export type SharedNotificationReport = {
  __typename: 'SharedNotificationReport';
  downloadUrl: Scalars['String']['output'];
  reportId: Scalars['String']['output'];
};

export type SharedStopViewConfiguration = {
  __typename: 'SharedStopViewConfiguration';
  visibleTransportIdentifiers: Array<TransportIdentifier>;
};

export type SharedStopViewConfigurationInput = {
  visibleTransportIdentifiers: Array<TransportIdentifier>;
};

export type SharedStopViewConfigurationValueInput = {
  value?: InputMaybe<SharedStopViewConfigurationInput>;
};

export type SharedTourDelivery = {
  __typename: 'SharedTourDelivery';
  delivery: Maybe<TourDelivery>;
  tourStop: Maybe<SharedTourStop>;
};

export type SharedTourStop = {
  __typename: 'SharedTourStop';
  allocationDeviceType: Maybe<TourAllocationDeviceType>;
  latestSignalTimestamp: Maybe<Scalars['DateTime']['output']>;
  shipper: Maybe<CompanyProfile>;
  shipperTransportNumber: Maybe<Scalars['String']['output']>;
  stop: TourStop;
  tourStatus: Maybe<Scalars['String']['output']>;
  transportContactDetails: Array<CompanyTransportContactDetails>;
  vehicleLicensePlateNumber: Maybe<Scalars['String']['output']>;
  vehicleStatus: Maybe<VehicleStatus>;
};

export type SharedTourViewConfiguration = {
  __typename: 'SharedTourViewConfiguration';
  visibleTransportIdentifiers: Array<TransportIdentifier>;
};

export type SharedTourViewConfigurationInput = {
  visibleTransportIdentifiers: Array<TransportIdentifier>;
};

export type SharedTourViewConfigurationValueInput = {
  value?: InputMaybe<SharedTourViewConfigurationInput>;
};

export type SharedUserLogin = {
  __typename: 'SharedUserLogin';
  user: LoginUser;
};

export type SharedView = {
  __typename: 'SharedView';
  companyTourFilterId: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdByUser: Maybe<SharedViewUserProfile>;
  emailAccesses: Maybe<Array<SharedViewEmailAccess>>;
  filter: Maybe<TourFilter>;
  filterV1: Maybe<TourFilter>;
  filterV2: Maybe<Scalars['GraphQLJSON']['output']>;
  isActive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  sharedViewId: Scalars['String']['output'];
  sharingLinks: Maybe<Array<SharedViewLink>>;
  transportType: TransportType;
  updatedAt: Scalars['DateTime']['output'];
  updatedByUser: Maybe<SharedViewUserProfile>;
  viewerHasAccessToAllUserGroups: Scalars['Boolean']['output'];
};

export type SharedViewAccessLogin = {
  __typename: 'SharedViewAccessLogin';
  email: Scalars['String']['output'];
  sharedViews: Array<LoginSharedView>;
};

export type SharedViewBrandingAsset = {
  __typename: 'SharedViewBrandingAsset';
  url: Scalars['String']['output'];
};

export type SharedViewBrandingAssets = {
  __typename: 'SharedViewBrandingAssets';
  logo: Maybe<SharedViewBrandingAsset>;
};

export type SharedViewConnection = {
  __typename: 'SharedViewConnection';
  edges: Maybe<Array<Maybe<SharedViewEdge>>>;
  pageInfo: PageInfo;
};

export type SharedViewConsignee = {
  __typename: 'SharedViewConsignee';
  isActive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  owner: Maybe<CompanyProfile>;
  tour: Maybe<Tour>;
  tours: Maybe<CountedTourConnection>;
};

export type SharedViewConsigneeTourArgs = {
  tourId: Scalars['String']['input'];
};

export type SharedViewConsigneeToursArgs = {
  sortOrder?: InputMaybe<TourSortOrder>;
  textSearch?: InputMaybe<TourTextSearch>;
};

export type SharedViewContent = {
  __typename: 'SharedViewContent';
  accessStatus: Maybe<SharedViewEmailAccessStatus>;
  branding: Maybe<SharedViewBrandingAssets>;
  canShowVehiclePositions: Scalars['Boolean']['output'];
  filterV1: Maybe<TourFilter>;
  filterV2: Maybe<Scalars['GraphQLJSON']['output']>;
  isActive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  owner: Maybe<CompanyProfile>;
  sharedViewId: Scalars['String']['output'];
  tour: Maybe<Tour>;
  tourFilterOptions: Maybe<TourFilterOptions>;
  tours: Maybe<CountedTourConnection>;
  transportType: TransportType;
  tripsTours: Maybe<CountedTripsTourConnection>;
};

export type SharedViewContentTourArgs = {
  tourId: Scalars['Int']['input'];
};

export type SharedViewContentToursArgs = {
  delayStatus?: InputMaybe<TourDelayStatusFilter>;
  delayTime?: InputMaybe<TimeRangeInput>;
  endTimeEnd?: InputMaybe<Scalars['DateTime']['input']>;
  endTimeStart?: InputMaybe<Scalars['DateTime']['input']>;
  endTimeSugarTimezone?: InputMaybe<Scalars['IANATimezone']['input']>;
  hasNotes?: InputMaybe<Scalars['Boolean']['input']>;
  sortOrder?: InputMaybe<TourSortOrder>;
  startTimeEnd?: InputMaybe<Scalars['DateTime']['input']>;
  startTimeStart?: InputMaybe<Scalars['DateTime']['input']>;
  startTimeSugarTimezone?: InputMaybe<Scalars['IANATimezone']['input']>;
  statuses?: InputMaybe<Array<TourStatusFilter>>;
  stopFilters?: InputMaybe<Array<StopFilterInput>>;
  textSearch?: InputMaybe<TourTextSearch>;
};

export type SharedViewContentTripsToursArgs = {
  delayStatus?: InputMaybe<TourDelayStatusFilter>;
  sortOrder?: InputMaybe<TourSortOrder>;
  statuses?: InputMaybe<Array<TourStatusFilter>>;
  tripsSearch?: InputMaybe<TripsTextSearch>;
};

export type SharedViewDeprecated = {
  __typename: 'SharedViewDeprecated';
  companyTourFilterId: Maybe<Scalars['String']['output']>;
  createdByUser: Maybe<SharedViewUserProfile>;
  filter: Maybe<TourFilter>;
  filterV2: Maybe<Scalars['GraphQLJSON']['output']>;
  isActive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  sharedViewId: Scalars['String']['output'];
  sharingLinks: Maybe<Array<SharedViewLink>>;
  transportType: TransportType;
};

export type SharedViewEdge = {
  __typename: 'SharedViewEdge';
  cursor: Maybe<Scalars['String']['output']>;
  node: Maybe<SharedView>;
};

export type SharedViewEmailAccess = {
  __typename: 'SharedViewEmailAccess';
  acceptedAt: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  email: Scalars['String']['output'];
  expiredAt: Maybe<Scalars['DateTime']['output']>;
  locale: Scalars['String']['output'];
  sharedViewAccessId: Scalars['String']['output'];
  status: SharedViewEmailAccessStatus;
  token: Maybe<SharedViewEmailAccessToken>;
  updatedAt: Scalars['DateTime']['output'];
};

export enum SharedViewEmailAccessStatus {
  ACCEPTED = 'ACCEPTED',
  EXPIRED = 'EXPIRED',
  INVITED = 'INVITED',
}

export type SharedViewEmailAccessToken = {
  __typename: 'SharedViewEmailAccessToken';
  createdAt: Scalars['DateTime']['output'];
  expiresAt: Maybe<Scalars['DateTime']['output']>;
  tokenId: Scalars['String']['output'];
};

export type SharedViewInvitationLogin = {
  __typename: 'SharedViewInvitationLogin';
  email: Scalars['String']['output'];
  sharedView: LoginSharedView;
};

export type SharedViewLink = {
  __typename: 'SharedViewLink';
  name: Maybe<Scalars['String']['output']>;
  publicLinkId: Maybe<Scalars['String']['output']>;
  token: Maybe<Scalars['String']['output']>;
};

export type SharedViewUserProfile = {
  __typename: 'SharedViewUserProfile';
  firstName: Maybe<Scalars['String']['output']>;
  isDeleted: Scalars['Boolean']['output'];
  isSupport: Scalars['Boolean']['output'];
  lastName: Maybe<Scalars['String']['output']>;
  userId: Scalars['String']['output'];
};

export type SharedViewViewer = {
  __typename: 'SharedViewViewer';
  email: Maybe<Scalars['String']['output']>;
  sharedView: Maybe<SharedViewContent>;
  sharedViews: Array<SharedViewContent>;
  viewerId: Scalars['String']['output'];
};

export type SharedViewViewerSharedViewArgs = {
  sharedViewId: Scalars['String']['input'];
};

export type SharedViewsFilterInput = {
  createdByUserIds?: InputMaybe<Array<Scalars['String']['input']>>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  textSearch?: InputMaybe<Scalars['String']['input']>;
  transportType?: InputMaybe<TransportType>;
};

export enum SharedViewsSortKey {
  CREATED_AT = 'CREATED_AT',
  NAME = 'NAME',
}

export type SharedViewsSortOrder = {
  direction: SortDirection;
  key: SharedViewsSortKey;
};

export type SharingToken = {
  __typename: 'SharingToken';
  createdBy: Maybe<UserProfile>;
  token: Scalars['String']['output'];
};

export enum ShipmentType {
  FCL = 'FCL',
  LCL = 'LCL',
}

export enum ShipmentTypeFilter {
  ALL = 'ALL',
  FCL = 'FCL',
  LCL = 'LCL',
}

export type ShipperReport = {
  __typename: 'ShipperReport';
  allocatedToursCount: Scalars['Int']['output'];
  shipper: Maybe<CompanyProfile>;
  toursCount: Scalars['Int']['output'];
  visibilityIndex: Maybe<Scalars['Float']['output']>;
};

export type ShipperReportConnection = {
  __typename: 'ShipperReportConnection';
  edges: Maybe<Array<Maybe<ShipperReportEdge>>>;
  pageInfo: PageInfo;
};

export type ShipperReportEdge = {
  __typename: 'ShipperReportEdge';
  cursor: Maybe<Scalars['String']['output']>;
  node: Maybe<ShipperReport>;
};

export enum SignupAction {
  CONNECT_VEHICLES = 'CONNECT_VEHICLES',
  INVALID_INTEGRATION = 'INVALID_INTEGRATION',
}

export type SignupPageOpenedCompanyInput = {
  companyId: Scalars['String']['input'];
};

export type SignupPageOpenedInput = {
  company?: InputMaybe<SignupPageOpenedCompanyInput>;
  platformCompany?: InputMaybe<SignupPageOpenedPlatformCompanyInput>;
};

export type SignupPageOpenedPlatformCompanyInput = {
  companyIdOnPlatform: Scalars['String']['input'];
  platformId: Scalars['String']['input'];
};

export type SignupPlatformCompanyInput = {
  companyName: Scalars['String']['input'];
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  fromPlatform: FromPlatformData;
  lastName: Scalars['String']['input'];
  referralToken?: InputMaybe<Scalars['String']['input']>;
};

export enum SignupType {
  EMAIL = 'EMAIL',
  TRANSPOREON_PLATFORM = 'TRANSPOREON_PLATFORM',
}

export type SignupUrls = {
  __typename: 'SignupUrls';
  newRegistrationUrl: Scalars['String']['output'];
  updateRegistrationUrl: Scalars['String']['output'];
};

export type SimpleTimeslot = {
  __typename: 'SimpleTimeslot';
  begin: Maybe<Scalars['DateTime']['output']>;
  end: Maybe<Scalars['DateTime']['output']>;
};

export type SingleTourStopEstimate = {
  __typename: 'SingleTourStopEstimate';
  estimated_arrival: Maybe<Scalars['DateTime']['output']>;
  estimated_arrival_accuracy: Maybe<Scalars['String']['output']>;
  estimated_arrival_delay_in_seconds: Maybe<Scalars['Int']['output']>;
  estimated_arrival_distance_in_meters: Maybe<Scalars['Int']['output']>;
  estimated_arrival_regulated: Maybe<Scalars['DateTime']['output']>;
  estimated_arrival_status: Maybe<Scalars['String']['output']>;
  estimated_arrival_unregulated: Maybe<Scalars['DateTime']['output']>;
  etaType: Maybe<EtaType>;
  externalEtaSource: Maybe<ExternalEtaSource>;
  stop_id: Maybe<Scalars['String']['output']>;
};

export type Site = {
  __typename: 'Site';
  name: Scalars['String']['output'];
  siteIdOnPlatform: Scalars['String']['output'];
  site_id: Scalars['String']['output'];
};

export type SiteConnection = {
  __typename: 'SiteConnection';
  edges: Maybe<Array<Maybe<SiteEdge>>>;
  pageInfo: PageInfo;
};

export type SiteEdge = {
  __typename: 'SiteEdge';
  cursor: Maybe<Scalars['String']['output']>;
  node: Maybe<Site>;
};

export type SiteProfile = {
  __typename: 'SiteProfile';
  name: Scalars['String']['output'];
  site_id: Scalars['String']['output'];
};

export enum SiteTourStatusFilter {
  AT_STOP = 'AT_STOP',
  EN_ROUTE = 'EN_ROUTE',
}

export type SmsRecipient = {
  __typename: 'SmsRecipient';
  locale: Scalars['String']['output'];
  phoneNumber: Scalars['String']['output'];
};

export type SmsRecipientInput = {
  locale: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
};

export enum SortDirection {
  ASCENDING = 'ASCENDING',
  DESCENDING = 'DESCENDING',
}

export type StopAllocation = {
  __typename: 'StopAllocation';
  startTrackingAt: Maybe<Scalars['DateTime']['output']>;
  stopId: Scalars['String']['output'];
  vehicleId: Maybe<Scalars['String']['output']>;
  vehicleLicensePlateNumber: Maybe<Scalars['String']['output']>;
  vehicleTrackerTypes: Maybe<Array<VehicleTrackerType>>;
};

export type StopAllocationInput = {
  startTrackingAt?: InputMaybe<Scalars['DateTime']['input']>;
  stopId: Scalars['String']['input'];
  vehicleId?: InputMaybe<Scalars['String']['input']>;
};

export type StopCitiesInput = {
  city: Scalars['String']['input'];
  country: Scalars['String']['input'];
};

export type StopCityOption = {
  __typename: 'StopCityOption';
  city: Scalars['String']['output'];
  country: Scalars['String']['output'];
};

export type StopCityOptionPage = {
  __typename: 'StopCityOptionPage';
  nextCursor: Maybe<Scalars['String']['output']>;
  values: Array<StopCityOption>;
};

export type StopCityOptions = {
  __typename: 'StopCityOptions';
  hasAny: Scalars['Boolean']['output'];
  page: StopCityOptionPage;
};

export type StopCityOptionsPageArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  textSearch?: InputMaybe<Scalars['String']['input']>;
};

export type StopCompanyName = {
  __typename: 'StopCompanyName';
  value: Scalars['String']['output'];
};

export type StopCompanyNameConnection = {
  __typename: 'StopCompanyNameConnection';
  edges: Maybe<Array<Maybe<StopCompanyNameEdge>>>;
  pageInfo: PageInfo;
};

export type StopCompanyNameEdge = {
  __typename: 'StopCompanyNameEdge';
  cursor: Maybe<Scalars['String']['output']>;
  node: Maybe<StopCompanyName>;
};

export type StopCompanyNameOption = {
  __typename: 'StopCompanyNameOption';
  companyName: Scalars['String']['output'];
};

export type StopCompanyNameOptionPage = {
  __typename: 'StopCompanyNameOptionPage';
  nextCursor: Maybe<Scalars['String']['output']>;
  values: Array<StopCompanyNameOption>;
};

export type StopCompanyNameOptions = {
  __typename: 'StopCompanyNameOptions';
  hasAny: Scalars['Boolean']['output'];
  page: StopCompanyNameOptionPage;
};

export type StopCompanyNameOptionsPageArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  textSearch?: InputMaybe<Scalars['String']['input']>;
};

export type StopContact = {
  __typename: 'StopContact';
  contactNames: Array<Scalars['String']['output']>;
  emailAddresses: Array<Scalars['String']['output']>;
  phoneNumberExtensions: Array<Scalars['String']['output']>;
  phoneNumbers: Array<Scalars['String']['output']>;
};

export type StopContactRecipient = {
  __typename: 'StopContactRecipient';
  emailStopContact: Maybe<Scalars['Boolean']['output']>;
  smsStopContact: Maybe<Scalars['Boolean']['output']>;
};

export type StopContactRecipientInput = {
  email?: InputMaybe<Scalars['Boolean']['input']>;
  sms?: InputMaybe<Scalars['Boolean']['input']>;
};

export type StopEvent = {
  __typename: 'StopEvent';
  created_at: Scalars['DateTime']['output'];
  event_id: Scalars['Int']['output'];
  event_index: Scalars['Int']['output'];
  event_name: StopEventName;
  event_time: Maybe<Scalars['DateTime']['output']>;
  external_event_created_at: Maybe<Scalars['DateTime']['output']>;
  metadata: Maybe<StopEventMetadata>;
  stop_id: Scalars['Int']['output'];
  tour_id: Scalars['Int']['output'];
  vehicle_id: Maybe<Scalars['String']['output']>;
  vehicle_lat: Maybe<Scalars['Float']['output']>;
  vehicle_license_plate_number: Maybe<Scalars['String']['output']>;
  vehicle_lng: Maybe<Scalars['Float']['output']>;
  visibilitySource: Maybe<TourVisibilitySource>;
};

export type StopEventMetadata = {
  __typename: 'StopEventMetadata';
  algorithm: Maybe<Scalars['String']['output']>;
  parameters: Maybe<Scalars['GraphQLJSON']['output']>;
};

export enum StopEventName {
  APPROACH = 'APPROACH',
  /** @deprecated Field no longer supported */
  APPROACHING = 'APPROACHING',
  APPROACH_UNKNOWN = 'APPROACH_UNKNOWN',
  DELETE = 'DELETE',
  DEPART = 'DEPART',
  /** @deprecated Field no longer supported */
  DEPARTED = 'DEPARTED',
  DEPART_UNKNOWN = 'DEPART_UNKNOWN',
  NAVIGATE = 'NAVIGATE',
  SKIP = 'SKIP',
  TRACTOR_SWITCH = 'TRACTOR_SWITCH',
  TRACTOR_SWITCH_WAITING = 'TRACTOR_SWITCH_WAITING',
  VISIBILITY_ENDED = 'VISIBILITY_ENDED',
}

export type StopEventV2 = {
  __typename: 'StopEventV2';
  eventId: Scalars['String']['output'];
  eventName: StopEventName;
  eventTime: Maybe<Scalars['DateTime']['output']>;
  externalEventCreatedAt: Maybe<Scalars['DateTime']['output']>;
  stopId: Scalars['String']['output'];
  tourId: Scalars['String']['output'];
  visibilitySource: Maybe<TourVisibilitySource>;
};

export type StopFilterInput = {
  bookingLocationNames?: InputMaybe<Array<Scalars['String']['input']>>;
  cities?: InputMaybe<Array<StopCitiesInput>>;
  companyNames?: InputMaybe<Array<Scalars['String']['input']>>;
  countries?: InputMaybe<Array<Scalars['String']['input']>>;
  gateIds?: InputMaybe<Array<Scalars['String']['input']>>;
  placeIds?: InputMaybe<Array<Scalars['String']['input']>>;
  postalCodes?: InputMaybe<Array<StopPostalCodesInput>>;
  states?: InputMaybe<Array<StopStatesInput>>;
  stopTypes?: InputMaybe<Array<FilterRoadStopType>>;
};

export type StopFilterOutput = {
  __typename: 'StopFilterOutput';
  bookingLocationNames: Maybe<Array<Scalars['String']['output']>>;
  cities: Maybe<Array<CompanyStopCities>>;
  companyNames: Maybe<Array<Scalars['String']['output']>>;
  countries: Maybe<Array<Scalars['String']['output']>>;
  gateIds: Maybe<Array<Scalars['String']['output']>>;
  placeIds: Maybe<Array<Scalars['String']['output']>>;
  postalCodes: Maybe<Array<CompanyStopPostalCodes>>;
  states: Maybe<Array<CompanyStopStates>>;
  stopTypes: Maybe<Array<FilterRoadStopType>>;
};

export type StopLocationInput = {
  city: Scalars['String']['input'];
  country: Scalars['String']['input'];
  state?: InputMaybe<Scalars['String']['input']>;
  streetAddress: Scalars['String']['input'];
  zipcode: Scalars['String']['input'];
};

export type StopPostalCodeOption = {
  __typename: 'StopPostalCodeOption';
  country: Scalars['String']['output'];
  postalCode: Scalars['String']['output'];
};

export type StopPostalCodeOptionPage = {
  __typename: 'StopPostalCodeOptionPage';
  nextCursor: Maybe<Scalars['String']['output']>;
  values: Array<StopPostalCodeOption>;
};

export type StopPostalCodeOptions = {
  __typename: 'StopPostalCodeOptions';
  hasAny: Scalars['Boolean']['output'];
  page: StopPostalCodeOptionPage;
};

export type StopPostalCodeOptionsPageArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  textSearch?: InputMaybe<Scalars['String']['input']>;
};

export type StopPostalCodesInput = {
  country: Scalars['String']['input'];
  postalCode: Scalars['String']['input'];
};

export type StopStateOption = {
  __typename: 'StopStateOption';
  country: Scalars['String']['output'];
  state: Scalars['String']['output'];
};

export type StopStateOptionPage = {
  __typename: 'StopStateOptionPage';
  nextCursor: Maybe<Scalars['String']['output']>;
  values: Array<StopStateOption>;
};

export type StopStateOptions = {
  __typename: 'StopStateOptions';
  hasAny: Scalars['Boolean']['output'];
  page: StopStateOptionPage;
};

export type StopStateOptionsPageArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  textSearch?: InputMaybe<Scalars['String']['input']>;
};

export type StopStatesInput = {
  country: Scalars['String']['input'];
  state: Scalars['String']['input'];
};

export type StopTimeslotInput = {
  begin: Scalars['DateTime']['input'];
  end: Scalars['DateTime']['input'];
  timezone: Scalars['IANATimezone']['input'];
};

export enum StopType {
  loading = 'loading',
  unloading = 'unloading',
}

export type StopVisited = {
  __typename: 'StopVisited';
  includeStopLevelTrackingLinkForPickupStopEvent: Maybe<Scalars['Boolean']['output']>;
  stopTypes: Array<StopVisitedStopType>;
};

export type StopVisitedInput = {
  includeStopLevelTrackingLinkForPickupStopEvent?: InputMaybe<Scalars['Boolean']['input']>;
  stopTypes: Array<StopVisitedStopType>;
};

export enum StopVisitedStopType {
  DELIVERY = 'DELIVERY',
  PICKUP = 'PICKUP',
}

export type SubmitUnsupportedTelematicsProviderDetailsInput = {
  companyId: Scalars['String']['input'];
  telematicsContactPersonEmail: Scalars['String']['input'];
  telematicsContactPersonFirstName: Scalars['String']['input'];
  telematicsContactPersonLastName: Scalars['String']['input'];
  telematicsContactPersonPhone?: InputMaybe<Scalars['String']['input']>;
  telematicsProviderHomepage: Scalars['String']['input'];
  telematicsProviderName: Scalars['String']['input'];
};

export type SubmitVisibilityAgentFeedbackInput = {
  companyId: Scalars['String']['input'];
  conversationId: Scalars['String']['input'];
  feedbackText?: InputMaybe<Scalars['String']['input']>;
  feedbackType: VisibilityAgentFeedbackType;
  messageId: Scalars['String']['input'];
};

export type SubmitVisibilityAgentFeedbackResult = VisibilityAgentFeedbackResult | VisibilityAgentValidationError;

export enum TfsRegion {
  EU = 'EU',
  US = 'US',
}

export type TfsSpace = {
  __typename: 'TFSSpace';
  accountId: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  region: Maybe<Scalars['String']['output']>;
  rootFolderId: Scalars['String']['output'];
  spaceId: Scalars['String']['output'];
  spaceName: Maybe<Scalars['String']['output']>;
};

export type TelematicsIntegration = {
  __typename: 'TelematicsIntegration';
  activeTrucksCount: Scalars['Int']['output'];
  company: CompanyProfile;
  company_id: Scalars['String']['output'];
  company_integration_id: Scalars['String']['output'];
  connection_data: Maybe<Scalars['GraphQLJSON']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy: Maybe<UserProfile>;
  diagnosticComment: Maybe<Scalars['String']['output']>;
  diagnosticStatus: Maybe<TelematicsIntegrationDiagnosticStatus>;
  enabled: Scalars['Boolean']['output'];
  generatedToken: Maybe<Scalars['String']['output']>;
  integrationApiDebugUrl: Scalars['String']['output'];
  integrationApiDebugWithSyncStateUrl: Scalars['String']['output'];
  integrationSyncHistory: Maybe<Array<IntegrationSyncResult>>;
  isAllowedToUpdateCredentials: Scalars['Boolean']['output'];
  isDeletable: Scalars['Boolean']['output'];
  isImmutable: Scalars['Boolean']['output'];
  recentAllocationsCount: Scalars['Int']['output'];
  telematicsProvider: TelematicsProvider;
  telematics_integration_id: Scalars['String']['output'];
  telematics_provider_id: Scalars['String']['output'];
  totalTrucksCount: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Maybe<UserProfile>;
};

export type TelematicsIntegrationConnection = {
  __typename: 'TelematicsIntegrationConnection';
  edges: Maybe<Array<Maybe<TelematicsIntegrationEdge>>>;
  pageInfo: PageInfo;
};

export enum TelematicsIntegrationDiagnosticStatus {
  INTERMITTENT = 'INTERMITTENT',
  INVALID_CREDENTIALS = 'INVALID_CREDENTIALS',
  INVESTIGATING = 'INVESTIGATING',
  PROVIDER_ERROR = 'PROVIDER_ERROR',
}

export type TelematicsIntegrationEdge = {
  __typename: 'TelematicsIntegrationEdge';
  cursor: Maybe<Scalars['String']['output']>;
  node: Maybe<TelematicsIntegration>;
};

export type TelematicsIntegrationsSortInput = {
  direction: SortDirection;
  key: TelematicsIntegrationsSortKey;
};

export enum TelematicsIntegrationsSortKey {
  ACTIVE_TRUCKS_COUNT = 'ACTIVE_TRUCKS_COUNT',
  COMPANY_NAME = 'COMPANY_NAME',
  CREATED_AT = 'CREATED_AT',
  INTEGRATION_ID = 'INTEGRATION_ID',
  PROVIDER_ID = 'PROVIDER_ID',
  RECENT_ALLOCATIONS_COUNT = 'RECENT_ALLOCATIONS_COUNT',
  TRUCKS_COUNT = 'TRUCKS_COUNT',
  UPDATED_AT = 'UPDATED_AT',
}

export type TelematicsProvider = {
  __typename: 'TelematicsProvider';
  activeTrucksCount: Scalars['Int']['output'];
  connectionParameters: Array<ConnectionParameter>;
  contact_info: Maybe<TelematicsProviderContactInfo>;
  integrationInstructionsURL: Maybe<Scalars['String']['output']>;
  integrationType: Maybe<Scalars['String']['output']>;
  isAddingIntegrationDisabled: Maybe<Scalars['Boolean']['output']>;
  isDeprecated: Maybe<Scalars['Boolean']['output']>;
  isExternalConfigurationNeeded: Scalars['Boolean']['output'];
  isGlobalAllocationForbidden: Maybe<Scalars['Boolean']['output']>;
  isInternalUseOnly: Scalars['Boolean']['output'];
  isTourBasedProvider: Maybe<Scalars['Boolean']['output']>;
  isVehicleManagementEnabled: Maybe<Scalars['Boolean']['output']>;
  recentAllocationsCount: Scalars['Int']['output'];
  telematicsIntegrations: CountedTelematicsIntegrationConnection;
  telematicsProviderId: Scalars['String']['output'];
  telematicsProviderName: Scalars['String']['output'];
  totalTrucksCount: Scalars['Int']['output'];
};

export type TelematicsProviderConnectionParametersArgs = {
  includeInternal?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TelematicsProviderTelematicsIntegrationsArgs = {
  companyId?: InputMaybe<Scalars['String']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  sort?: InputMaybe<TelematicsIntegrationsSortInput>;
  textSearch?: InputMaybe<Scalars['String']['input']>;
};

export type TelematicsProviderConnection = {
  __typename: 'TelematicsProviderConnection';
  edges: Maybe<Array<Maybe<TelematicsProviderEdge>>>;
  pageInfo: PageInfo;
};

export type TelematicsProviderContactInfo = {
  __typename: 'TelematicsProviderContactInfo';
  comment: Maybe<Scalars['String']['output']>;
  email_address: Maybe<Scalars['String']['output']>;
  updated_at: Maybe<Scalars['String']['output']>;
};

export type TelematicsProviderContactInfoInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  email_address?: InputMaybe<Scalars['String']['input']>;
};

export type TelematicsProviderEdge = {
  __typename: 'TelematicsProviderEdge';
  cursor: Maybe<Scalars['String']['output']>;
  node: Maybe<TelematicsProvider>;
};

export type TelematicsProvidersSortInput = {
  direction: SortDirection;
  key: TelematicsProvidersSortKey;
};

export enum TelematicsProvidersSortKey {
  ACTIVE_INTEGRATIONS_COUNT = 'ACTIVE_INTEGRATIONS_COUNT',
  ACTIVE_TRUCKS_COUNT = 'ACTIVE_TRUCKS_COUNT',
  INTEGRATIONS_COUNT = 'INTEGRATIONS_COUNT',
  PROVIDER_NAME = 'PROVIDER_NAME',
  RECENT_ALLOCATIONS_COUNT = 'RECENT_ALLOCATIONS_COUNT',
  TRUCKS_COUNT = 'TRUCKS_COUNT',
}

export type TelematicsValidation = {
  __typename: 'TelematicsValidation';
  areValidCredentials: Scalars['Boolean']['output'];
};

export type TemperatureEverOutOfRangeFilter = {
  __typename: 'TemperatureEverOutOfRangeFilter';
  maxTemperature: Maybe<Scalars['Float']['output']>;
  minTemperature: Maybe<Scalars['Float']['output']>;
  outOfRange: Scalars['Boolean']['output'];
  temperatureUnit: Maybe<TemperatureUnit>;
};

export type TemperatureEverOutOfRangeFilterInput = {
  maxTemperature?: InputMaybe<Scalars['Float']['input']>;
  minTemperature?: InputMaybe<Scalars['Float']['input']>;
  outOfRange: Scalars['Boolean']['input'];
  temperatureUnit?: InputMaybe<TemperatureUnit>;
};

export type TemperatureSensor = {
  __typename: 'TemperatureSensor';
  name: Scalars['String']['output'];
  readings: Array<TemperatureSensorReading>;
};

export type TemperatureSensorReading = {
  __typename: 'TemperatureSensorReading';
  timestamp: Scalars['DateTime']['output'];
  value: Scalars['Float']['output'];
};

export enum TemperatureUnit {
  C = 'C',
  F = 'F',
}

export type TestOvdTokenFilterInput = {
  carrierIds?: InputMaybe<Array<Scalars['String']['input']>>;
  deliveryCustomFields?: InputMaybe<Array<Scalars['String']['input']>>;
  platformIds?: InputMaybe<Array<Scalars['String']['input']>>;
  shipperIds?: InputMaybe<Array<Scalars['String']['input']>>;
  tourCustomFields?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type TimeAggregateByInput = {
  interval: VisibilityReportTimeUnit;
  order: Scalars['Int']['input'];
};

export enum TimeBasedStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
}

export type TimeRange = {
  __typename: 'TimeRange';
  comparison: ComparisonOperator;
  endInSeconds: Maybe<Scalars['Int']['output']>;
  startInSeconds: Scalars['Int']['output'];
  unit: TimeUnit;
};

export type TimeRangeInput = {
  comparison: ComparisonOperator;
  endInSeconds?: InputMaybe<Scalars['Int']['input']>;
  startInSeconds: Scalars['Int']['input'];
  unit?: InputMaybe<TimeUnit>;
};

export type TimeRangeSugarDate = {
  comparison: ExtendedComparisonOperator;
  endSugarDate?: InputMaybe<Scalars['String']['input']>;
  startSugarDate?: InputMaybe<Scalars['String']['input']>;
};

export type TimeRangeSugarDateOutput = {
  __typename: 'TimeRangeSugarDateOutput';
  comparison: ExtendedComparisonOperator;
  endSugarDate: Maybe<Scalars['String']['output']>;
  startSugarDate: Maybe<Scalars['String']['output']>;
};

export enum TimeUnit {
  DAY = 'DAY',
  HOUR = 'HOUR',
  MINUTE = 'MINUTE',
  MONTH = 'MONTH',
  WEEK = 'WEEK',
}

export type Timeslot = {
  __typename: 'Timeslot';
  begin: Maybe<Scalars['DateTime']['output']>;
  end: Maybe<Scalars['DateTime']['output']>;
  timezone: Maybe<Scalars['IANATimezone']['output']>;
};

export type TokenBrandingAsset = {
  __typename: 'TokenBrandingAsset';
  url: Scalars['String']['output'];
};

export type TokenBrandingAssets = {
  __typename: 'TokenBrandingAssets';
  background: Maybe<TokenBrandingAsset>;
  logo: Maybe<TokenBrandingAsset>;
};

export enum TokenResourceType {
  COMPANY_INVITE = 'COMPANY_INVITE',
  COMPANY_PROFILE = 'COMPANY_PROFILE',
  COMPANY_RELATION = 'COMPANY_RELATION',
  COMPANY_SIGNUP = 'COMPANY_SIGNUP',
  COMPANY_TOUR_FILTER = 'COMPANY_TOUR_FILTER',
  INTEGRATION_SYNC = 'INTEGRATION_SYNC',
  NOTIFICATION_REPORT = 'NOTIFICATION_REPORT',
  PLATFORM_COMPANY_INVITE = 'PLATFORM_COMPANY_INVITE',
  SHARED_VIEW_ACCESS_LOGIN = 'SHARED_VIEW_ACCESS_LOGIN',
  SHARED_VIEW_INVITATION_LOGIN = 'SHARED_VIEW_INVITATION_LOGIN',
  TOUR = 'TOUR',
  TOUR_DELIVERY = 'TOUR_DELIVERY',
  TOUR_STOP = 'TOUR_STOP',
  TOUR_STOP_AUTO_GENERATED = 'TOUR_STOP_AUTO_GENERATED',
  USER_LOGIN = 'USER_LOGIN',
}

export type TokenResources = {
  __typename: 'TokenResources';
  branding: Maybe<TokenBrandingAssets>;
  companyInvite: Maybe<SharedCompanyInvite>;
  companyProfile: Maybe<CompanyProfile>;
  companyRelation: Maybe<CompanyProfile>;
  notificationReport: Maybe<SharedNotificationReport>;
  platformCompanyInvite: Maybe<PlatformCompanyInvite>;
  resourceType: TokenResourceType;
  sharedView: Maybe<SharedViewConsignee>;
  sharedViewAccessLogin: Maybe<SharedViewAccessLogin>;
  sharedViewInvitationLogin: Maybe<SharedViewInvitationLogin>;
  tour: Maybe<Tour>;
  tourDelivery: Maybe<SharedTourDelivery>;
  tourStop: Maybe<SharedTourStop>;
  userLogin: Maybe<SharedUserLogin>;
};

export type Tour = {
  __typename: 'Tour';
  abort_time: Maybe<Scalars['DateTime']['output']>;
  aborted_by_user: Maybe<UserProfile>;
  activeAllocations: Array<AllocationReference>;
  activeVehicleAllocation: Maybe<TourVehicleAllocation>;
  airWayBill: Maybe<Scalars['String']['output']>;
  allocatableVehicles: VehicleProfileConnection;
  allocationType: Maybe<TourVehicleAllocationType>;
  analyses: Maybe<Array<Maybe<TransportAnalysisResponse>>>;
  applicationDeepLinks: Maybe<Array<ApplicationDeepLink>>;
  assignedUser: Maybe<UserProfile>;
  billOfLading: Maybe<Scalars['String']['output']>;
  bill_of_lading: Maybe<Scalars['String']['output']>;
  bookingNumber: Maybe<Scalars['String']['output']>;
  canAbortTour: Scalars['Boolean']['output'];
  canAllocateToTrimbleMobileApp: Scalars['Boolean']['output'];
  canBeModified: Scalars['Boolean']['output'];
  carrier: Maybe<CompanyProfile>;
  carrierCode: Maybe<Scalars['String']['output']>;
  carrierName: Maybe<Scalars['String']['output']>;
  carrierPackageCount: Maybe<Scalars['Float']['output']>;
  carrierPackageWeight: Maybe<Scalars['Float']['output']>;
  carrier_id: Maybe<Scalars['String']['output']>;
  cleanedVehicleAllocationHistory: Array<TourVehicleAllocation>;
  complete_time: Maybe<Scalars['DateTime']['output']>;
  consigneeContactName: Maybe<Scalars['String']['output']>;
  consigneeLocationName: Maybe<Scalars['String']['output']>;
  containerNumber: Maybe<Scalars['String']['output']>;
  containerType: Maybe<Scalars['String']['output']>;
  createdBy: Maybe<CompanyProfile>;
  created_at: Scalars['DateTime']['output'];
  currentVehicle: Maybe<VehicleAllocation>;
  customFields: Array<CustomField>;
  customerContactName: Maybe<Scalars['String']['output']>;
  customerLocationName: Maybe<Scalars['String']['output']>;
  customerPackageCount: Maybe<Scalars['Float']['output']>;
  customerPackageWeight: Maybe<Scalars['Float']['output']>;
  deliveries: Array<TourDelivery>;
  deliveryExceptions: Array<TourDeliveryException>;
  documents: Array<Document>;
  drivenDistance: Maybe<TourDrivenDistance>;
  emissionsCalculationErrors: Array<CalculationError>;
  endToEndImpactDays: Maybe<Scalars['Int']['output']>;
  endToEndTransitTime: Maybe<Scalars['Int']['output']>;
  end_time: Maybe<Scalars['DateTime']['output']>;
  events: Array<CombinedEvent>;
  exceptions: Array<TourException>;
  externalCarrier: Maybe<ExternalCarrier>;
  externalDeliveryEvents: Array<ExternalTourDeliveryEvent>;
  externalDeliveryEventsVisibleToCustomers: Array<ExternalTourDeliveryEvent>;
  externalEmissions: Maybe<ExternalEmissions>;
  externalEvents: Array<ExternalTourEvent>;
  externalEventsVisibleToCustomers: Array<ExternalTourEvent>;
  externalStopEvents: Array<ExternalTourStopEvent>;
  externalStopEventsVisibleToCustomers: Array<ExternalTourStopEvent>;
  failureReason: Maybe<TourFailureReason>;
  forwardingChain: Array<TourForwardingLink>;
  fuelBasedEmissions: Maybe<FuelBasedEmissions>;
  fullVehicleAllocationHistory: Array<TourVehicleAllocation>;
  hasTemperatureData: Maybe<Scalars['Boolean']['output']>;
  hasTransportChain: Scalars['Boolean']['output'];
  hasTransportNotifications: Scalars['Boolean']['output'];
  impactDays: Maybe<Scalars['Int']['output']>;
  incoterm: Maybe<TourIncoterms>;
  isExtendedTrailAvailable: Scalars['Boolean']['output'];
  isGlobalAllocation: Scalars['Boolean']['output'];
  isGloballyAllocatedToViewerCompany: Scalars['Boolean']['output'];
  isOceanPlannedRouteHidden: Scalars['Boolean']['output'];
  isSendEtaToPlatformEnabled: Scalars['Boolean']['output'];
  isSubcontractingEnabled: Scalars['Boolean']['output'];
  isTimeslotUpdateEnabled: Scalars['Boolean']['output'];
  isTourAccessedByCreator: Scalars['Boolean']['output'];
  isTrackingDisabled: Scalars['Boolean']['output'];
  isTrailRetentionExpired: Scalars['Boolean']['output'];
  latestSignal: Maybe<TourSignal>;
  loadType: Maybe<LoadType>;
  mainMode: Maybe<MainMode>;
  mainVisibilityIssue: Maybe<VisibilityIssue>;
  /**
   * The active maritime disruptions affecting this one shipment.
   *
   * The forward direction of `MaritimeIntelligenceEvent.affectedTours`, for
   * callers that need "is *this* tour disrupted" (the tour details page) rather
   * than "which tours does this event disrupt" (the Containers table). Asking
   * that question through the event-centric field means resolving and hydrating
   * every event's full company-wide match set and discarding all but one tour;
   * this field scopes each event's match to the requested tours instead.
   *
   * Always active-only: a shipment should not be flagged as disrupted by a
   * monitoring or archived event. Empty when the caller's company cannot be
   * determined (token and shared-view sessions).
   */
  maritimeIntelligenceEvents: Array<MaritimeIntelligenceEvent>;
  metadata: Maybe<Scalars['GraphQLJSON']['output']>;
  milestones: Maybe<LocationsAndMilestones>;
  mobileTrackingToken: Maybe<Scalars['String']['output']>;
  notes: Array<Note>;
  oceanDemurrage: Maybe<OceanDemurrage>;
  oceanEtaAnalytics: Maybe<TourOceanEtaAnalytics>;
  packageCount: Maybe<Scalars['String']['output']>;
  parent_tour_id: Maybe<Scalars['String']['output']>;
  plannedEmissions: Maybe<TourCalculatedEmissions>;
  platform: Maybe<Platform>;
  platformBranchId: Maybe<Scalars['String']['output']>;
  platformCallbacks: Array<PlatformCallbackMessage>;
  platformCallbacksV2: Array<PlatformCallbackMessage>;
  platformPageUrl: Maybe<Scalars['String']['output']>;
  platformTransportURL: Maybe<Scalars['String']['output']>;
  platform_carrier_id: Maybe<Scalars['String']['output']>;
  platform_shipper_id: Maybe<Scalars['String']['output']>;
  platform_transport_number: Maybe<Scalars['String']['output']>;
  previousTransportsIds: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  rawExternalEvents: Maybe<RawExternalEvents>;
  recalculate_time: Maybe<Scalars['DateTime']['output']>;
  relatedChildTours: Maybe<Array<Tour>>;
  relatedTransports: Array<Tour>;
  relatedTransportsForListView: Array<RelatedTransportForListView>;
  route: Maybe<Route>;
  sharingToken: Maybe<Scalars['String']['output']>;
  shipmentType: Maybe<ShipmentType>;
  shipper: Maybe<CompanyProfile>;
  shipperContactName: Maybe<Scalars['String']['output']>;
  shipperLocationName: Maybe<Scalars['String']['output']>;
  shipper_id: Maybe<Scalars['String']['output']>;
  shipper_transport_number: Maybe<Scalars['String']['output']>;
  site: Maybe<SiteProfile>;
  start_time: Maybe<Scalars['DateTime']['output']>;
  status: Maybe<Scalars['String']['output']>;
  status_events: Array<TourEvent>;
  stops: Array<TourStop>;
  subcontractor: Maybe<CompanyProfile>;
  suggestedVehicles: Array<VehicleProfile>;
  tags: Array<TourTag>;
  telemetryEmissions: Maybe<TourCalculatedEmissions>;
  temperatureAssets: Array<TourTemperatureAsset>;
  tourAssignment: Maybe<TourAssignment>;
  tourDistance: Maybe<TourDistance>;
  tourEmissionsReceived: Maybe<TourEmissionsReceived>;
  tourPositionHistory: Maybe<Array<VehiclePosition>>;
  tourRoute: Maybe<Route>;
  tourTrafficEntries: TourTrafficEntryConnection;
  tour_area: Maybe<Geofence>;
  tour_id: Scalars['Int']['output'];
  tour_type: Maybe<TourType>;
  trackedVehicles: Array<TrackedVehicle>;
  trackingAbandonTime: Maybe<Scalars['DateTime']['output']>;
  trackingEndTime: Maybe<Scalars['DateTime']['output']>;
  trackingMetadata: Maybe<TourTrackingMetadata>;
  trackingSegments: Array<TrackingSegment>;
  trackingStartTime: Maybe<Scalars['DateTime']['output']>;
  transitTime: Maybe<Scalars['Int']['output']>;
  translateTransportAnalysis: Maybe<Scalars['String']['output']>;
  transportAlerts: Array<TransportAlert>;
  transportAlertsCount: Scalars['Int']['output'];
  transportAlertsHighestSeverity: Maybe<TransportAlertSeverity>;
  transportChain: Maybe<TransportChain>;
  transportContactDetails: Array<CompanyTransportContactDetails>;
  transportGroupId: Maybe<Scalars['String']['output']>;
  transportIdentifiers: Maybe<Array<Scalars['String']['output']>>;
  transportMode: Maybe<TransportMode>;
  transportNotifications: Array<FilterBasedTransportNotification>;
  transport_id: Maybe<Scalars['String']['output']>;
  tripDeliveryItems: Maybe<Array<TripDeliveryItem>>;
  tripLocations: Maybe<Array<TripLocation>>;
  tripSegments: Maybe<Array<TripSegment>>;
  tripsVehicleHistory: Maybe<Array<VehicleHistoryPolyline>>;
  tripsVehicleStatus: Maybe<VehicleStatus>;
  tripsVesselPosition: Maybe<VesselPosition>;
  tripsVesselRoute: Maybe<Array<VesselRoutePolyline>>;
  userGroupsOnPlatform: Array<UserGroupOnPlatform>;
  vehicleAllocationHistory: Array<TourVehicleAllocation>;
  vehicleAllocations: Array<TourVehicleAllocation>;
  vehicleBreakHistory: Maybe<Array<VehicleBreakHistoryEntry>>;
  vehicleChangePositions: Maybe<Array<VehicleChangePosition>>;
  vehicleHistory: Maybe<Array<VehicleHistoryPolyline>>;
  vehicleHistoryDownload: VehicleHistoryDownload;
  vehicleHistoryList: Maybe<Array<VehicleHistoryEntry>>;
  vehicleStatuses: Array<VehicleStatus>;
  vehicleTemperatures: Maybe<Array<VehicleTemperature>>;
  vehicle_status: Maybe<VehicleStatus>;
  vehicles: Array<VehicleProfile>;
  vesselNames: Maybe<TripVesselNames>;
  visibilityIndex: Maybe<Scalars['Float']['output']>;
  visibilityIssues: Maybe<Array<Maybe<VisibilityIssue>>>;
  visibilitySegments: Array<VisibilitySegment>;
  visibilityServices: Array<VisibilityService>;
  visibilitySources: Array<TourVisibilitySource>;
  visibility_end_time: Maybe<Scalars['DateTime']['output']>;
  visibility_start_time: Maybe<Scalars['DateTime']['output']>;
  visibleTrackingStartTime: Maybe<Scalars['DateTime']['output']>;
  visibleVehicleBreakHistory: Maybe<Array<VehicleBreakHistoryEntry>>;
  volume: Maybe<TourVolume>;
  warnings: Array<TourWarning>;
  working_stop_id: Maybe<Scalars['Int']['output']>;
};

export type TourAllocatableVehiclesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  licensePlateSearch: Scalars['String']['input'];
};

export type TourCanAllocateToTrimbleMobileAppArgs = {
  companyId: Scalars['String']['input'];
};

export type TourCustomFieldsArgs = {
  includeDeliveries?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TourHasTransportNotificationsArgs = {
  companyId: Scalars['String']['input'];
};

export type TourOceanDemurrageArgs = {
  type?: InputMaybe<DemurrageType>;
};

export type TourPlatformPageUrlArgs = {
  pageType: TransportPlatformPageType;
};

export type TourRouteArgs = {
  include_extended?: InputMaybe<Scalars['Boolean']['input']>;
  limit_to_remaining?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TourTourAssignmentArgs = {
  company_id?: InputMaybe<Scalars['String']['input']>;
  tour_id?: InputMaybe<Scalars['Int']['input']>;
};

export type TourTourPositionHistoryArgs = {
  include_extended?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TourTourTrafficEntriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  apiName: TrafficApiName;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['DateTime']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  to: Scalars['DateTime']['input'];
};

export type TourTranslateTransportAnalysisArgs = {
  input: TranslateTransportAnalysisInput;
};

export type TourTransportNotificationsArgs = {
  companyId: Scalars['String']['input'];
};

export type TourTripsVehicleHistoryArgs = {
  simplificationTolerance?: InputMaybe<Scalars['Float']['input']>;
};

export type TourVehicleBreakHistoryArgs = {
  end_time: Scalars['String']['input'];
  start_time: Scalars['String']['input'];
};

export type TourVehicleHistoryArgs = {
  include_extended?: InputMaybe<Scalars['Boolean']['input']>;
  simplificationTolerance?: InputMaybe<Scalars['Float']['input']>;
};

export type TourVehicleHistoryListArgs = {
  end_time: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  simplification_tolerance?: InputMaybe<Scalars['Float']['input']>;
  start_time: Scalars['String']['input'];
};

export type TourAdditionalAsset = {
  __typename: 'TourAdditionalAsset';
  identifier: Scalars['String']['output'];
  reason: TourAdditionalAssetReason;
  vehicleId: Maybe<Scalars['String']['output']>;
};

export type TourAdditionalAssetInput = {
  identifier: Scalars['String']['input'];
  reason: TourAdditionalAssetReason;
  vehicleId: Scalars['String']['input'];
};

export enum TourAdditionalAssetReason {
  temperature = 'temperature',
}

export enum TourAllocationDeviceType {
  AIR = 'AIR',
  CONTAINER = 'CONTAINER',
  IOT_DEVICE = 'IOT_DEVICE',
  MOBILE = 'MOBILE',
  TRACTOR = 'TRACTOR',
  TRAILER = 'TRAILER',
  TRAIN = 'TRAIN',
  VESSEL = 'VESSEL',
}

export type TourAllocationInput = {
  allocatedByCompanyId?: InputMaybe<Scalars['String']['input']>;
  allocationType: TourVehicleAllocationType;
  startTrackingAt?: InputMaybe<Scalars['DateTime']['input']>;
  tourId: Scalars['String']['input'];
  vehicleId?: InputMaybe<Scalars['String']['input']>;
};

export enum TourAllocationStatus {
  Allocated = 'Allocated',
  Unallocated = 'Unallocated',
}

export enum TourAllocationSwitchType {
  AUTO_SWITCH = 'AUTO_SWITCH',
}

export type TourAssignment = {
  __typename: 'TourAssignment';
  assignedToUser: Maybe<UserProfile>;
};

export type TourCalculatedEmissions = {
  __typename: 'TourCalculatedEmissions';
  cargo: Cargo;
  co2TankToWheelTonnes: Scalars['Float']['output'];
  co2WellToTankTonnes: Scalars['Float']['output'];
  co2WellToWheelTonnes: Scalars['Float']['output'];
  emissionsIntensityGramPerTonneKms: Maybe<Scalars['Float']['output']>;
  legs: Array<Leg>;
  routePolyline: Maybe<Scalars['String']['output']>;
  transportActivityTonneKms: Maybe<Scalars['Float']['output']>;
};

export enum TourCompanyRole {
  CARRIER = 'CARRIER',
  SHIPPER = 'SHIPPER',
}

export type TourConnection = {
  __typename: 'TourConnection';
  edges: Maybe<Array<Maybe<TourEdge>>>;
  pageInfo: PageInfo;
};

export type TourCountByFailureReason = {
  __typename: 'TourCountByFailureReason';
  count: Scalars['Int']['output'];
  failureReason: Maybe<TourFailureReasonType>;
};

export type TourCreationInput = {
  companyId: Scalars['String']['input'];
  creator_transport_number: Scalars['String']['input'];
  delivery: TourDeliveryInput;
  shipperId?: InputMaybe<Scalars['String']['input']>;
};

export type TourCustomFieldSearch = {
  fieldName: Scalars['String']['input'];
  value: TourCustomFieldSearchValue;
};

export type TourCustomFieldSearchType = {
  __typename: 'TourCustomFieldSearchType';
  fieldName: Scalars['String']['output'];
  value: TourCustomFieldSearchValueType;
};

export type TourCustomFieldSearchValue = {
  values?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type TourCustomFieldSearchValueType = {
  __typename: 'TourCustomFieldSearchValueType';
  /** @deprecated Use values instead */
  value: Maybe<Scalars['String']['output']>;
  values: Maybe<Array<Scalars['String']['output']>>;
};

export enum TourDelayStatusFilter {
  /** @deprecated Use DELAYED_ON_ANY instead */
  DELAYED = 'DELAYED',
  DELAYED_DELIVERY = 'DELAYED_DELIVERY',
  DELAYED_DELIVERY_AND_PICKUP = 'DELAYED_DELIVERY_AND_PICKUP',
  DELAYED_ON_ALL = 'DELAYED_ON_ALL',
  DELAYED_ON_ANY = 'DELAYED_ON_ANY',
  DELAYED_PICKUP = 'DELAYED_PICKUP',
  ON_TIME = 'ON_TIME',
  UNKNOWN = 'UNKNOWN',
}

export type TourDeletionInput = {
  companyId: Scalars['String']['input'];
  tourId: Scalars['String']['input'];
};

export type TourDelivery = {
  __typename: 'TourDelivery';
  consigneeContacts: Maybe<Array<Maybe<Contact>>>;
  customFields: Array<CustomField>;
  customerContacts: Maybe<Array<Maybe<Contact>>>;
  deliveryId: Scalars['String']['output'];
  deliveryNumber: Maybe<Scalars['String']['output']>;
  deliveryTourId: Maybe<Scalars['String']['output']>;
  incoterms: Maybe<TourIncoterms>;
  loadingLength: Maybe<TourLoadingLength>;
  mainMode: Maybe<MainMode>;
  orderDate: Maybe<Scalars['DateTime']['output']>;
  orderItems: Maybe<Array<OrderItem>>;
  orderNumber: Maybe<Scalars['String']['output']>;
  purchaseOrderNumber: Maybe<Scalars['String']['output']>;
  sequenceNumber: Maybe<Scalars['Int']['output']>;
  shipperContacts: Maybe<Array<Maybe<Contact>>>;
  storagePositions: Maybe<Scalars['Int']['output']>;
  transportUnit: Maybe<TourTransportUnit>;
  volume: Maybe<TourVolume>;
};

export type TourDeliveryException = {
  __typename: 'TourDeliveryException';
  createdAt: Scalars['DateTime']['output'];
  customExceptionType: Maybe<Scalars['String']['output']>;
  customExceptionTypeDescription: Maybe<Scalars['String']['output']>;
  deliveryIds: Array<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  exceptionFiles: Array<ExceptionFile>;
  exceptionId: Scalars['String']['output'];
  exceptionType: Maybe<ExceptionType>;
  stopId: Maybe<Scalars['String']['output']>;
};

export type TourDeliveryInput = {
  customFields?: InputMaybe<Array<CustomFieldInput>>;
  deliveryNumber?: InputMaybe<Scalars['String']['input']>;
  loading: TourStopInput;
  orderNumber?: InputMaybe<Scalars['String']['input']>;
  purchaseOrderNumber?: InputMaybe<Scalars['String']['input']>;
  unloading: TourStopInput;
};

export type TourDemurrageDetentionLog = {
  __typename: 'TourDemurrageDetentionLog';
  content: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  demurrageDetentionLogId: Scalars['String']['output'];
  tourId: Scalars['String']['output'];
};

export type TourDistance = {
  __typename: 'TourDistance';
  totalDistanceInMeters: Scalars['Float']['output'];
};

export type TourDrivenDistance = {
  __typename: 'TourDrivenDistance';
  distanceInKilometers: Maybe<Scalars['Float']['output']>;
  source: Maybe<Scalars['String']['output']>;
};

export type TourEdge = {
  __typename: 'TourEdge';
  cursor: Maybe<Scalars['String']['output']>;
  node: Maybe<Tour>;
};

export type TourEmissionsReceived = {
  __typename: 'TourEmissionsReceived';
  epKgCo2: Maybe<Scalars['Float']['output']>;
};

export type TourEvent = {
  __typename: 'TourEvent';
  created_at: Scalars['DateTime']['output'];
  event_id: Scalars['Int']['output'];
  event_index: Scalars['Int']['output'];
  event_name: TourEventName;
  event_time: Maybe<Scalars['DateTime']['output']>;
  metadata: Maybe<TourEventMetadata>;
  tour_id: Scalars['Int']['output'];
  vehicle_id: Maybe<Scalars['String']['output']>;
  vehicle_lat: Maybe<Scalars['Float']['output']>;
  vehicle_license_plate_number: Maybe<Scalars['String']['output']>;
  vehicle_lng: Maybe<Scalars['Float']['output']>;
  visibilitySource: Maybe<TourVisibilitySource>;
  warning: Maybe<TourWarning>;
};

export type TourEventMetadata = {
  __typename: 'TourEventMetadata';
  algorithm: Maybe<Scalars['String']['output']>;
  parameters: Maybe<Scalars['GraphQLJSON']['output']>;
};

export enum TourEventName {
  ABANDON = 'ABANDON',
  ABORT = 'ABORT',
  /** @deprecated Field no longer supported */
  AT_STOP = 'AT_STOP',
  COMPLETE = 'COMPLETE',
  /** @deprecated Field no longer supported */
  COMPLETED = 'COMPLETED',
  DEALLOCATION = 'DEALLOCATION',
  DELETE = 'DELETE',
  /** @deprecated Field no longer supported */
  EN_ROUTE = 'EN_ROUTE',
  EVENT_STREAM_STARTED = 'EVENT_STREAM_STARTED',
  FAILED = 'FAILED',
  SHIPPER_VISIBLE = 'SHIPPER_VISIBLE',
  TRACKING_START = 'TRACKING_START',
  TRUCK_ALLOCATION = 'TRUCK_ALLOCATION',
  VISIBLE_TRACKING_START = 'VISIBLE_TRACKING_START',
  WARNING_ENDED = 'WARNING_ENDED',
  WARNING_TRIGGERED = 'WARNING_TRIGGERED',
}

export type TourException = DeliveryException | ServiceException;

export type TourExternalTracking = {
  __typename: 'TourExternalTracking';
  createdAt: Scalars['String']['output'];
  deletedAt: Maybe<Scalars['String']['output']>;
  externalId: Maybe<Scalars['String']['output']>;
  provider: Scalars['String']['output'];
  status: Maybe<Scalars['String']['output']>;
  statusReason: Maybe<Scalars['String']['output']>;
  tourId: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
};

export type TourExternalTrackingLog = {
  __typename: 'TourExternalTrackingLog';
  content: Scalars['String']['output'];
  contentType: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  provider: Scalars['String']['output'];
  tourId: Scalars['String']['output'];
};

export type TourExternalTrackingRequest = {
  __typename: 'TourExternalTrackingRequest';
  createdAt: Scalars['String']['output'];
  requestPayload: Scalars['String']['output'];
  responsePayload: Maybe<Scalars['String']['output']>;
  responseStatus: Maybe<Scalars['String']['output']>;
  tourId: Scalars['String']['output'];
  trackingRequestId: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type TourFailureReason = {
  __typename: 'TourFailureReason';
  metadata: Maybe<TourFailureReasonMetadata>;
  type: TourFailureReasonType;
};

export type TourFailureReasonMetadata = {
  __typename: 'TourFailureReasonMetadata';
  allocated_license_plates: Maybe<Scalars['String']['output']>;
  nr_of_stops_visited: Maybe<Scalars['String']['output']>;
};

export enum TourFailureReasonType {
  ABORTED = 'ABORTED',
  /** @deprecated No longer produced */
  BAD_TELEMETRY = 'BAD_TELEMETRY',
  /** @deprecated No longer produced */
  BAD_TELEMETRY_BAD_DATA = 'BAD_TELEMETRY_BAD_DATA',
  BAD_TELEMETRY_NO_MOVEMENT = 'BAD_TELEMETRY_NO_MOVEMENT',
  /** @deprecated No longer produced */
  BAD_TELEMETRY_SHORT_VISIBILITY = 'BAD_TELEMETRY_SHORT_VISIBILITY',
  /** @deprecated No longer produced */
  BAD_TELEMETRY_SMALL_MOVEMENT = 'BAD_TELEMETRY_SMALL_MOVEMENT',
  BAD_TOUR_DATA = 'BAD_TOUR_DATA',
  /** @deprecated No longer produced */
  BAD_TOUR_DATA_SHORT_DISTANCE = 'BAD_TOUR_DATA_SHORT_DISTANCE',
  /** @deprecated No longer produced */
  CARRIER_NOT_INTEGRATED = 'CARRIER_NOT_INTEGRATED',
  CARRIER_NOT_REGISTERED = 'CARRIER_NOT_REGISTERED',
  /** @deprecated No longer produced */
  CARRIER_NOT_SPECIFIED = 'CARRIER_NOT_SPECIFIED',
  DATA_SHARING_ISSUE = 'DATA_SHARING_ISSUE',
  /** @deprecated No longer produced */
  GEOCODING_SERVICE_FAILED = 'GEOCODING_SERVICE_FAILED',
  INSUFFICIENT_ALLOCATION = 'INSUFFICIENT_ALLOCATION',
  /** @deprecated No longer produced */
  MISSING_START_TELEMETRY = 'MISSING_START_TELEMETRY',
  MISSING_STOP_GEOCODING = 'MISSING_STOP_GEOCODING',
  MISSING_STOP_TIMESLOT = 'MISSING_STOP_TIMESLOT',
  MISSING_TELEMETRY = 'MISSING_TELEMETRY',
  NO_VEHICLE_ALLOCATED = 'NO_VEHICLE_ALLOCATED',
  /** @deprecated No longer produced */
  SIXFOLD_INCIDENT = 'SIXFOLD_INCIDENT',
  TRACTOR_SWITCH_NOT_DETECTED = 'TRACTOR_SWITCH_NOT_DETECTED',
  UNKNOWN_LICENSE_PLATE = 'UNKNOWN_LICENSE_PLATE',
  /** @deprecated No longer produced */
  UNSPECIFIED = 'UNSPECIFIED',
  /** @deprecated No longer produced */
  VEHICLE_NOT_INTEGRATED = 'VEHICLE_NOT_INTEGRATED',
  VISIBILITY_THRESHOLD_EXCEEDED = 'VISIBILITY_THRESHOLD_EXCEEDED',
  /** @deprecated No longer produced */
  WRONG_PLATFORM_COORDINATES = 'WRONG_PLATFORM_COORDINATES',
}

export type TourFilter = {
  __typename: 'TourFilter';
  airWayBillNumbers: Maybe<Array<Scalars['String']['output']>>;
  allocationStatus: Maybe<TourAllocationStatus>;
  assignedToUserIds: Maybe<Array<Scalars['String']['output']>>;
  billOfLadingNumbers: Maybe<Array<Scalars['String']['output']>>;
  bookingNumbers: Maybe<Array<Scalars['String']['output']>>;
  carrierCodes: Maybe<Array<Scalars['String']['output']>>;
  carrierIds: Maybe<Array<Scalars['String']['output']>>;
  carrierNames: Maybe<Array<Scalars['String']['output']>>;
  consigneeContactNames: Maybe<Array<Scalars['String']['output']>>;
  consigneeLocationNames: Maybe<Array<Scalars['String']['output']>>;
  containerNumbers: Maybe<Array<Scalars['String']['output']>>;
  createdAtEnd: Maybe<Scalars['DateTime']['output']>;
  createdAtStart: Maybe<Scalars['DateTime']['output']>;
  customFields: Maybe<Array<TourCustomFieldSearchType>>;
  customerContactNames: Maybe<Array<Scalars['String']['output']>>;
  customerIds: Maybe<Array<Scalars['String']['output']>>;
  customerLocationNames: Maybe<Array<Scalars['String']['output']>>;
  delayStatus: Maybe<TourDelayStatusFilter>;
  delayTime: Maybe<TimeRange>;
  demurrage: Maybe<OceanDemurrageFilterOutput>;
  documentTypes: Maybe<Array<DocumentType>>;
  endTimeEnd: Maybe<Scalars['DateTime']['output']>;
  endTimeStart: Maybe<Scalars['DateTime']['output']>;
  endTimeSugarTimezone: Maybe<Scalars['IANATimezone']['output']>;
  exceptionTypes: Maybe<Array<Scalars['String']['output']>>;
  failureReasons: Maybe<Array<TourFailureReasonType>>;
  flightNumbers: Maybe<Array<Scalars['String']['output']>>;
  hasDocuments: Maybe<Scalars['Boolean']['output']>;
  hasNotes: Maybe<Scalars['Boolean']['output']>;
  hasTemperature: Maybe<Scalars['Boolean']['output']>;
  impactDays: Maybe<ImpactDaysOutput>;
  incoterm: Maybe<Array<IncotermTerm>>;
  lastActualLocationsAndMilestones: Maybe<LastActualLocationsAndMilestonesFilter>;
  lastSignalTimestamp: Maybe<LastSignalTimestampFilter>;
  locations: Maybe<Array<TransportLocationOutput>>;
  mainCarrierIds: Maybe<Array<Scalars['String']['output']>>;
  mainVisibilityIssues: Maybe<Array<VisibilityIssueType>>;
  orderItemCustomFields: Maybe<OrderItemCustomFieldOutput>;
  orderItemGroups: Maybe<OrderItemGroupOutput>;
  orderItemIsHazardous: Maybe<Scalars['Boolean']['output']>;
  orderItemNames: Maybe<Array<Scalars['String']['output']>>;
  orderNumbers: Maybe<Array<Scalars['String']['output']>>;
  placeIds: Maybe<Array<Scalars['String']['output']>>;
  platformId: Maybe<Scalars['String']['output']>;
  serviceExceptionCodes: Maybe<Array<Scalars['String']['output']>>;
  shipmentType: Maybe<Array<ShipmentTypeFilter>>;
  shipperContactNames: Maybe<Array<Scalars['String']['output']>>;
  shipperIds: Maybe<Array<Scalars['String']['output']>>;
  shipperLocationNames: Maybe<Array<Scalars['String']['output']>>;
  siteIds: Maybe<Array<Scalars['String']['output']>>;
  sortOrder: Maybe<TourSortOrderType>;
  startTimeEnd: Maybe<Scalars['DateTime']['output']>;
  startTimeStart: Maybe<Scalars['DateTime']['output']>;
  startTimeSugarTimezone: Maybe<Scalars['IANATimezone']['output']>;
  status: Maybe<TourStatusFilter>;
  statuses: Maybe<Array<TourStatusFilter>>;
  stopBookingLocationNames: Maybe<Array<Scalars['String']['output']>>;
  stopCompanyNames: Maybe<Array<Scalars['String']['output']>>;
  stopCountries: Maybe<Array<Scalars['String']['output']>>;
  stopFilters: Maybe<Array<StopFilterOutput>>;
  stopStates: Maybe<Array<CompanyStopStates>>;
  temperatureEverOutOfRange: Maybe<TemperatureEverOutOfRangeFilter>;
  textSearch: Maybe<TourTextSearchType>;
  timeSpentAtStop: Maybe<TimeRange>;
  transportAlerts: Maybe<TransportAlertsFilterOutput>;
  transportGroupIds: Maybe<Array<Scalars['String']['output']>>;
  transportMode: Maybe<Array<TourFilteringTransportMode>>;
  vehicleId: Maybe<Scalars['String']['output']>;
  vehicleLicensePlates: Maybe<Array<TourVehicleLicensePlateFilter>>;
  vesselName: Maybe<VesselNameFilterOutput>;
  voyageIds: Maybe<Array<Scalars['String']['output']>>;
  warnings: Maybe<Array<TourWarningType>>;
  workingStopStatus: Maybe<WorkingStopStatusFilter>;
  workingStopTimeslotBeginEnd: Maybe<Scalars['DateTime']['output']>;
};

export type TourFilterInput = {
  airWayBillNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
  allocationStatus?: InputMaybe<TourAllocationStatus>;
  assignedToUserIds?: InputMaybe<Array<Scalars['String']['input']>>;
  billOfLadingNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
  bookingNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
  boundingBox?: InputMaybe<BoundingBoxInput>;
  carrierCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  carrierIds?: InputMaybe<Array<Scalars['String']['input']>>;
  carrierNames?: InputMaybe<Array<Scalars['String']['input']>>;
  consigneeContactNames?: InputMaybe<Array<Scalars['String']['input']>>;
  consigneeLocationNames?: InputMaybe<Array<Scalars['String']['input']>>;
  containerNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
  customFields?: InputMaybe<Array<TourCustomFieldSearch>>;
  customerContactNames?: InputMaybe<Array<Scalars['String']['input']>>;
  customerIds?: InputMaybe<Array<Scalars['String']['input']>>;
  customerLocationNames?: InputMaybe<Array<Scalars['String']['input']>>;
  delayStatus?: InputMaybe<TourDelayStatusFilter>;
  delayTime?: InputMaybe<TimeRangeInput>;
  demurrage?: InputMaybe<OceanDemurrageFilter>;
  documentTypes?: InputMaybe<Array<DocumentType>>;
  endTimeEnd?: InputMaybe<Scalars['DateTime']['input']>;
  endTimeStart?: InputMaybe<Scalars['DateTime']['input']>;
  endTimeSugarTimezone?: InputMaybe<Scalars['IANATimezone']['input']>;
  exceptionTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  failureReasons?: InputMaybe<Array<TourFailureReasonType>>;
  filterV2?: InputMaybe<Scalars['GraphQLJSON']['input']>;
  flightNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
  hasDocuments?: InputMaybe<Scalars['Boolean']['input']>;
  hasNotes?: InputMaybe<Scalars['Boolean']['input']>;
  hasTemperature?: InputMaybe<Scalars['Boolean']['input']>;
  impactDays?: InputMaybe<ImpactDaysFilter>;
  incoterm?: InputMaybe<Array<IncotermTerm>>;
  lastActualLocationsAndMilestones?: InputMaybe<LastActualLocationsAndMilestonesFilterInput>;
  lastSignalTimestamp?: InputMaybe<LastSignalTimestampFilterInput>;
  locations?: InputMaybe<Array<TransportLocation>>;
  mainCarrierIds?: InputMaybe<Array<Scalars['String']['input']>>;
  mainVisibilityIssues?: InputMaybe<Array<VisibilityIssueType>>;
  orderItemCustomFields?: InputMaybe<OrderItemCustomFieldInput>;
  orderItemGroups?: InputMaybe<OrderItemGroupsInput>;
  orderItemIsHazardous?: InputMaybe<Scalars['Boolean']['input']>;
  orderItemNames?: InputMaybe<Array<Scalars['String']['input']>>;
  orderNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
  placeIds?: InputMaybe<Array<Scalars['String']['input']>>;
  platformBranchId?: InputMaybe<Scalars['String']['input']>;
  platformId?: InputMaybe<Scalars['String']['input']>;
  serviceExceptionCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  shipmentType?: InputMaybe<Array<ShipmentTypeFilter>>;
  shipperContactNames?: InputMaybe<Array<Scalars['String']['input']>>;
  shipperId?: InputMaybe<Scalars['String']['input']>;
  shipperIds?: InputMaybe<Array<Scalars['String']['input']>>;
  shipperLocationNames?: InputMaybe<Array<Scalars['String']['input']>>;
  siteIds?: InputMaybe<Array<Scalars['String']['input']>>;
  sortOrder?: InputMaybe<TourSortOrder>;
  startTimeEnd?: InputMaybe<Scalars['DateTime']['input']>;
  startTimeStart?: InputMaybe<Scalars['DateTime']['input']>;
  startTimeSugarTimezone?: InputMaybe<Scalars['IANATimezone']['input']>;
  status?: InputMaybe<TourStatusFilter>;
  statuses?: InputMaybe<Array<TourStatusFilter>>;
  stopBookingLocationNames?: InputMaybe<Array<Scalars['String']['input']>>;
  stopCompanyNames?: InputMaybe<Array<Scalars['String']['input']>>;
  stopCountries?: InputMaybe<Array<Scalars['String']['input']>>;
  stopFilters?: InputMaybe<Array<StopFilterInput>>;
  stopStates?: InputMaybe<Array<StopStatesInput>>;
  temperatureEverOutOfRange?: InputMaybe<TemperatureEverOutOfRangeFilterInput>;
  textSearch?: InputMaybe<TourTextSearch>;
  timeSpentAtStop?: InputMaybe<TimeRangeInput>;
  transportAlerts?: InputMaybe<TransportAlertsFilterInput>;
  transportGroupIds?: InputMaybe<Array<Scalars['String']['input']>>;
  transportMode?: InputMaybe<Array<TourFilteringTransportMode>>;
  tripsSearch?: InputMaybe<TripsTextSearch>;
  vehicleId?: InputMaybe<Scalars['String']['input']>;
  vehicleLicensePlates?: InputMaybe<Array<TourVehicleLicensePlateFilterInput>>;
  vesselName?: InputMaybe<VesselNameFilterInput>;
  voyageIds?: InputMaybe<Array<Scalars['String']['input']>>;
  warnings?: InputMaybe<Array<TourWarningType>>;
  workingStopStatus?: InputMaybe<WorkingStopStatusFilter>;
  workingStopTimeslotBeginEnd?: InputMaybe<Scalars['DateTime']['input']>;
};

export type TourFilterOptions = {
  __typename: 'TourFilterOptions';
  notes: NotesFilterOptions;
  stopCities: StopCityOptions;
  stopCompanyNames: StopCompanyNameOptions;
  stopPostalCodes: StopPostalCodeOptions;
  stopStates: StopStateOptions;
};

export enum TourFilteringTransportMode {
  Air = 'Air',
  Inland = 'Inland',
  Ocean = 'Ocean',
  Road = 'Road',
}

export type TourForwardingLink = {
  __typename: 'TourForwardingLink';
  forwardedAt: Scalars['DateTime']['output'];
  forwardedBy: Maybe<UserProfile>;
  from: Maybe<CompanyProfile>;
  to: CompanyProfile;
  triggeredByAllocationId: Maybe<Scalars['String']['output']>;
};

export type TourIncoterms = {
  __typename: 'TourIncoterms';
  city: Maybe<Scalars['String']['output']>;
  term: Maybe<Scalars['String']['output']>;
};

export type TourLoadingLength = {
  __typename: 'TourLoadingLength';
  unit: Scalars['String']['output'];
  value: Scalars['Float']['output'];
};

export type TourLocation = {
  __typename: 'TourLocation';
  address: Maybe<Address>;
  bookingLocationName: Maybe<Scalars['String']['output']>;
  customerProvidedAddress: Maybe<Address>;
  gate: Maybe<Scalars['String']['output']>;
  gate_id: Maybe<Scalars['String']['output']>;
  location_id: Maybe<Scalars['String']['output']>;
  location_reference_id: Maybe<Scalars['String']['output']>;
  name: Maybe<Scalars['String']['output']>;
  place: Maybe<CompanyPlace>;
  position: Maybe<GeoPosition>;
};

export type TourMetricsListRow = {
  __typename: 'TourMetricsListRow';
  allocationRemoteSource: Maybe<TourRemoteAllocationSource>;
  allocationSource: Maybe<TourVehicleAllocationSource>;
  allocation_late_minutes: Maybe<Scalars['Float']['output']>;
  allocation_timeliness_percentage: Maybe<Scalars['Float']['output']>;
  carrierIsConnected: Maybe<Scalars['Boolean']['output']>;
  carrierSCAC: Maybe<Scalars['String']['output']>;
  eta_count: Maybe<Scalars['Int']['output']>;
  event_visited_stop_count: Maybe<Scalars['Int']['output']>;
  external_arrival_event_average_delay_minutes: Maybe<Scalars['Float']['output']>;
  external_eta_count: Maybe<Scalars['Int']['output']>;
  failure_type: Maybe<TourFailureReasonType>;
  forwardeeCompanyName: Maybe<Scalars['String']['output']>;
  forwardeeSignupStatus: Maybe<UnifiedCompanySignupStatus>;
  /**
   * Context describing whether the forwardee relationship's onboarding status
   * was reverted (e.g. rolled back to "Visibility source pending"). Computed
   * from the same relationship-level transitions as
   * `CarrierNetworkItem.statusContext` in the data network API, so the
   * warning matches the Visibility Control Center. Used by customer-web to
   * render the "status reverted" warning icon in the Analytics → Road
   * Visibility Performance Transports table.
   */
  forwardeeSignupStatusContext: Maybe<CarrierNetworkStatusContext>;
  forwarderCompanyName: Maybe<Scalars['String']['output']>;
  has_all_stops_arrived_real_time: Maybe<Scalars['Boolean']['output']>;
  has_arrivals_to_all_stops: Maybe<Scalars['Boolean']['output']>;
  has_eta_to_all_stops: Maybe<Scalars['Boolean']['output']>;
  has_telemetry: Maybe<Scalars['Boolean']['output']>;
  isTourDeleted: Maybe<Scalars['Boolean']['output']>;
  is_allocated: Maybe<Scalars['Boolean']['output']>;
  is_tracked: Maybe<Scalars['Boolean']['output']>;
  licensePlateNumber: Maybe<Scalars['String']['output']>;
  locationDataSource: Maybe<TourSignalSource>;
  mean_telemetry_delay_minutes: Maybe<Scalars['Float']['output']>;
  moving_duration_hours: Maybe<Scalars['Float']['output']>;
  moving_pings_count: Maybe<Scalars['Int']['output']>;
  moving_pings_per_hour: Maybe<Scalars['Float']['output']>;
  real_time_stop_arrivals_count: Maybe<Scalars['Int']['output']>;
  relationIdentifiers: Maybe<Array<RelationIdentifier>>;
  shipper_transport_number: Maybe<Scalars['String']['output']>;
  smart_break_visited_stop_count: Maybe<Scalars['Int']['output']>;
  start_time: Maybe<Scalars['DateTime']['output']>;
  status: Maybe<Scalars['String']['output']>;
  stop_count: Maybe<Scalars['Int']['output']>;
  stops_with_eta_count: Maybe<Scalars['Int']['output']>;
  stops_with_external_eta_count: Maybe<Scalars['Int']['output']>;
  telemetry_consistency_percentage: Maybe<Scalars['Float']['output']>;
  telemetry_visited_stop_count: Maybe<Scalars['Int']['output']>;
  tour_id: Maybe<Scalars['String']['output']>;
  tour_segments_count: Maybe<Scalars['Int']['output']>;
  tour_segments_ping_count: Maybe<Scalars['Int']['output']>;
  visited_stop_count: Maybe<Scalars['Int']['output']>;
};

export type TourMetricsListRowConnection = {
  __typename: 'TourMetricsListRowConnection';
  edges: Maybe<Array<Maybe<TourMetricsListRowEdge>>>;
  pageInfo: PageInfo;
};

export type TourMetricsListRowEdge = {
  __typename: 'TourMetricsListRowEdge';
  cursor: Maybe<Scalars['String']['output']>;
  node: Maybe<TourMetricsListRow>;
};

export type TourOceanEtaAnalytics = {
  __typename: 'TourOceanEtaAnalytics';
  accuracyWindow: Maybe<Scalars['String']['output']>;
  arrivalTime: Maybe<Scalars['DateTime']['output']>;
  carrierEta: Maybe<Scalars['DateTime']['output']>;
  carrierEtaSource: Maybe<Scalars['String']['output']>;
  comparedAt: Scalars['DateTime']['output'];
  milestoneId: Maybe<Scalars['String']['output']>;
  modelVariant: Maybe<Scalars['String']['output']>;
  modelVersion: Maybe<Scalars['String']['output']>;
  processingDurationMs: Maybe<Scalars['Int']['output']>;
  qualifier: Maybe<Scalars['String']['output']>;
  timeDifferenceMinutes: Maybe<Scalars['Int']['output']>;
};

export enum TourRemoteAllocationSource {
  PLATFORM_CARRIER_INTERFACE = 'PLATFORM_CARRIER_INTERFACE',
  PLATFORM_UI = 'PLATFORM_UI',
}

export type TourSignal = {
  __typename: 'TourSignal';
  source: TourSignalSource;
  timestamp: Scalars['DateTime']['output'];
};

export enum TourSignalSource {
  CARRIER_API = 'CARRIER_API',
  FMS = 'FMS',
  MOBILE = 'MOBILE',
  PLATFORM_API = 'PLATFORM_API',
  PLATFORM_RTV_API = 'PLATFORM_RTV_API',
  TTC = 'TTC',
  TTC_MOBILE = 'TTC_MOBILE',
}

export enum TourSortKey {
  ARRIVAL_TO_POD = 'ARRIVAL_TO_POD',
  CARRIER_NAME = 'CARRIER_NAME',
  DEPARTURE_FROM_POL = 'DEPARTURE_FROM_POL',
  SHIPPER_NAME = 'SHIPPER_NAME',
  START_TIME = 'START_TIME',
  VEHICLE_LICENSE_PLATE_NUMBER = 'VEHICLE_LICENSE_PLATE_NUMBER',
  WORKING_STOP_TIMESLOT_BEGIN = 'WORKING_STOP_TIMESLOT_BEGIN',
}

export type TourSortOrder = {
  direction: SortDirection;
  key: TourSortKey;
};

export type TourSortOrderType = {
  __typename: 'TourSortOrderType';
  direction: SortDirection;
  key: TourSortKey;
};

export enum TourStatusFilter {
  ABANDONED = 'ABANDONED',
  ABORTED = 'ABORTED',
  ALL = 'ALL',
  ALLOCATED = 'ALLOCATED',
  CANCELLED = 'CANCELLED',
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
  FINISHED = 'FINISHED',
  UNALLOCATED = 'UNALLOCATED',
  UNFINISHED = 'UNFINISHED',
  UPCOMING = 'UPCOMING',
  WAITING = 'WAITING',
  WORKING = 'WORKING',
}

export type TourStop = {
  __typename: 'TourStop';
  actual_sequence_number: Maybe<Scalars['Int']['output']>;
  arrival_delay_in_seconds: Maybe<Scalars['Int']['output']>;
  arrival_time: Maybe<Scalars['DateTime']['output']>;
  booking_id: Maybe<Scalars['String']['output']>;
  deadline: Maybe<Scalars['DateTime']['output']>;
  deliveries: Array<TourDelivery>;
  deliveryExceptions: Array<TourDeliveryException>;
  delivery_ids: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  departure_time: Maybe<Scalars['DateTime']['output']>;
  display_actual_sequence_number: Scalars['Int']['output'];
  display_sequence_number: Scalars['Int']['output'];
  documents: Array<Document>;
  estimated_arrival: Maybe<Scalars['DateTime']['output']>;
  estimated_arrival_accuracy: Maybe<Scalars['String']['output']>;
  estimated_arrival_delay_in_seconds: Maybe<Scalars['Int']['output']>;
  estimated_arrival_distance_in_meters: Maybe<Scalars['Int']['output']>;
  estimated_arrival_regulated: Maybe<Scalars['DateTime']['output']>;
  estimated_arrival_status: Maybe<Scalars['String']['output']>;
  estimated_arrival_unregulated: Maybe<Scalars['DateTime']['output']>;
  etaType: Maybe<EtaType>;
  etas: Maybe<Array<SingleTourStopEstimate>>;
  exceptions: Array<TourException>;
  expected_duration: Maybe<Scalars['String']['output']>;
  externalEtaSource: Maybe<ExternalEtaSource>;
  external_type: Maybe<Scalars['String']['output']>;
  geofenceZones: Array<GeofenceZone>;
  informationalEvents: Array<StopEventV2>;
  location: Maybe<TourLocation>;
  notes: Array<Note>;
  originalTimeslot: Maybe<SimpleTimeslot>;
  place_reference_id: Maybe<Scalars['String']['output']>;
  platformSequenceNumber: Maybe<Scalars['Int']['output']>;
  revisedTimeslot: Maybe<SimpleTimeslot>;
  sequence_number: Maybe<Scalars['Int']['output']>;
  sharingToken: Maybe<Scalars['String']['output']>;
  sharingTokenV2: Maybe<SharingToken>;
  status: Maybe<Scalars['String']['output']>;
  status_events: Array<StopEvent>;
  stopContacts: Array<StopContact>;
  stop_id: Scalars['Int']['output'];
  stop_reference_id: Maybe<Scalars['String']['output']>;
  timeslot: Maybe<Timeslot>;
  tour_id: Scalars['String']['output'];
  type: Maybe<Scalars['String']['output']>;
  /** @deprecated Stop allocation is deprecated. Please use TOUR_ALLOCATION instead. */
  vehicleAllocation: Maybe<VehicleAllocation>;
};

export type TourStopSharingTokenArgs = {
  company_id: Scalars['String']['input'];
};

export type TourStopSharingTokenV2Args = {
  company_id: Scalars['String']['input'];
};

export type TourStopInput = {
  location: StopLocationInput;
  timeslot: StopTimeslotInput;
  type: StopType;
};

export type TourStopTimeslotInput = {
  changedByCompanyId?: InputMaybe<Scalars['String']['input']>;
  endTime?: InputMaybe<Scalars['DateTime']['input']>;
  startTime?: InputMaybe<Scalars['DateTime']['input']>;
  stopId: Scalars['String']['input'];
  tourId: Scalars['String']['input'];
};

export type TourTag = {
  __typename: 'TourTag';
  name: Scalars['String']['output'];
};

export type TourTemperatureAsset = {
  __typename: 'TourTemperatureAsset';
  compartments: Array<VehicleTemperature>;
  isMainAsset: Scalars['Boolean']['output'];
  licensePlateNumber: Maybe<Scalars['String']['output']>;
  vehicleId: Maybe<Scalars['String']['output']>;
};

export type TourTextSearch = {
  field: TourTextSearchField;
  query: Scalars['String']['input'];
};

export enum TourTextSearchField {
  ALL = 'ALL',
  ALL_EXTENDED = 'ALL_EXTENDED',
  ALL_PUBLIC = 'ALL_PUBLIC',
  BILL_OF_LADING = 'BILL_OF_LADING',
  DELIVERY_NUMBER = 'DELIVERY_NUMBER',
  DELIVERY_ORDER_NUMBER = 'DELIVERY_ORDER_NUMBER',
  DELIVERY_PURCHASE_ORDER_NUMBER = 'DELIVERY_PURCHASE_ORDER_NUMBER',
  PLATFORM_TRANSPORT_NUMBER = 'PLATFORM_TRANSPORT_NUMBER',
  SHIPPER_TRANSPORT_NUMBER = 'SHIPPER_TRANSPORT_NUMBER',
  STOP_ADDRESS = 'STOP_ADDRESS',
  STOP_NAME = 'STOP_NAME',
  TOUR_ID = 'TOUR_ID',
  VEHICLE_LICENSE_PLATE_NUMBER = 'VEHICLE_LICENSE_PLATE_NUMBER',
}

export type TourTextSearchType = {
  __typename: 'TourTextSearchType';
  field: TourTextSearchField;
  query: Scalars['String']['output'];
};

export type TourTrackingMetadata = {
  __typename: 'TourTrackingMetadata';
  carrierUpdateReceivedAt: Maybe<Scalars['DateTime']['output']>;
  externalStatusReceivedAt: Maybe<Scalars['DateTime']['output']>;
  lastTrackingEventAt: Maybe<Scalars['DateTime']['output']>;
  milestoneState: Maybe<Scalars['String']['output']>;
};

export type TourTrafficEntry = {
  __typename: 'TourTrafficEntry';
  entry: Maybe<Scalars['GraphQLJSON']['output']>;
  timestamp: Maybe<Scalars['DateTime']['output']>;
};

export type TourTrafficEntryConnection = {
  __typename: 'TourTrafficEntryConnection';
  edges: Maybe<Array<Maybe<TourTrafficEntryEdge>>>;
  pageInfo: PageInfo;
};

export type TourTrafficEntryEdge = {
  __typename: 'TourTrafficEntryEdge';
  cursor: Maybe<Scalars['String']['output']>;
  node: Maybe<TourTrafficEntry>;
};

export type TourTransportUnit = {
  __typename: 'TourTransportUnit';
  unit: Scalars['String']['output'];
  value: Scalars['Float']['output'];
};

export enum TourType {
  DELIVERY_TOUR = 'DELIVERY_TOUR',
  PARENT_TOUR = 'PARENT_TOUR',
}

export type TourUpdateInput = {
  companyId: Scalars['String']['input'];
  creator_transport_number: Scalars['String']['input'];
  delivery: TourDeliveryInput;
  shipperId?: InputMaybe<Scalars['String']['input']>;
  tourId: Scalars['String']['input'];
};

export type TourVehicleAllocation = {
  __typename: 'TourVehicleAllocation';
  additionalAssets: Array<TourAdditionalAsset>;
  allocatedAt: Maybe<Scalars['DateTime']['output']>;
  allocatedByCompany: Maybe<CompanyProfile>;
  allocationDeviceType: Maybe<TourAllocationDeviceType>;
  allocationId: Maybe<Scalars['String']['output']>;
  allocationSwitchType: Maybe<TourAllocationSwitchType>;
  allocationType: Maybe<TourVehicleAllocationType>;
  clearAllocation: Maybe<Scalars['Boolean']['output']>;
  disableVehicleMatching: Maybe<Scalars['Boolean']['output']>;
  isAutoAllocation: Maybe<Scalars['Boolean']['output']>;
  isLimitedVisibilityAllocation: Maybe<Scalars['Boolean']['output']>;
  isVehicleOutsideOfTransportPool: Maybe<Scalars['Boolean']['output']>;
  matchedAlternativeIdentifier: Maybe<Scalars['String']['output']>;
  remoteAllocationSource: Maybe<TourRemoteAllocationSource>;
  remoteTrackerId: Maybe<Scalars['String']['output']>;
  source: TourVehicleAllocationSource;
  startTrackingAt: Maybe<Scalars['DateTime']['output']>;
  /** @deprecated Stop allocation is deprecated. Please use TOUR_ALLOCATION instead. */
  stopAllocations: Maybe<Array<StopAllocation>>;
  vehicleId: Maybe<Scalars['String']['output']>;
  vehicleLicensePlateNumber: Maybe<Scalars['String']['output']>;
  vehicleTrackerTypes: Maybe<Array<VehicleTrackerType>>;
};

export enum TourVehicleAllocationSource {
  CARRIER_API = 'CARRIER_API',
  FMS = 'FMS',
  PLATFORM = 'PLATFORM',
  PLATFORM_RTV_API = 'PLATFORM_RTV_API',
  PLATFORM_VERSIONED = 'PLATFORM_VERSIONED',
  SIXFOLD = 'SIXFOLD',
  TOUR_BASED_STREAM = 'TOUR_BASED_STREAM',
  TTC = 'TTC',
  WEB_UI = 'WEB_UI',
}

export enum TourVehicleAllocationType {
  /** @deprecated Stop allocation is deprecated. Please use TOUR_ALLOCATION instead. */
  STOP_ALLOCATION = 'STOP_ALLOCATION',
  TOUR_ALLOCATION = 'TOUR_ALLOCATION',
}

export type TourVehicleAllocationsInput = {
  allocatedByCompanyId?: InputMaybe<Scalars['String']['input']>;
  tourId: Scalars['String']['input'];
  vehicleAllocations: Array<VehicleAllocationInput>;
};

export type TourVehicleLicensePlateFilter = {
  __typename: 'TourVehicleLicensePlateFilter';
  plate: Scalars['String']['output'];
};

export type TourVehicleLicensePlateFilterInput = {
  plate: Scalars['String']['input'];
};

export type TourVisibilityPerformance = {
  __typename: 'TourVisibilityPerformance';
  reportDownloadURI: Maybe<Scalars['String']['output']>;
  reportMaxRows: Maybe<Scalars['Int']['output']>;
  tourMetrics: TourMetricsListRowConnection;
};

export type TourVisibilityPerformanceReportDownloadUriArgs = {
  timezone?: InputMaybe<Scalars['IANATimezone']['input']>;
};

export type TourVisibilityPerformanceTourMetricsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export enum TourVisibilityPerformanceListSortKey {
  allocationLateMinutes = 'allocationLateMinutes',
  allocationTimelinessPercentage = 'allocationTimelinessPercentage',
  etaCount = 'etaCount',
  eventVisitedStopCount = 'eventVisitedStopCount',
  externalArrivalEventAverageDelayMinutes = 'externalArrivalEventAverageDelayMinutes',
  externalEtaCount = 'externalEtaCount',
  failureType = 'failureType',
  hasAllStopsArrivedRealTime = 'hasAllStopsArrivedRealTime',
  hasArrivalsToAllStops = 'hasArrivalsToAllStops',
  hasEtaToAllStops = 'hasEtaToAllStops',
  hasTelemetry = 'hasTelemetry',
  isAllocated = 'isAllocated',
  isTracked = 'isTracked',
  meanTelemetryDelayMinutes = 'meanTelemetryDelayMinutes',
  movingDurationHours = 'movingDurationHours',
  movingPingsCount = 'movingPingsCount',
  movingPingsPerHour = 'movingPingsPerHour',
  realTimeStopArrivalsCount = 'realTimeStopArrivalsCount',
  relativeForwarding = 'relativeForwarding',
  shipperTransportNumber = 'shipperTransportNumber',
  smartBreakVisitedStopCount = 'smartBreakVisitedStopCount',
  startTime = 'startTime',
  start_time = 'start_time',
  status = 'status',
  stopCount = 'stopCount',
  stopsWithEtaCount = 'stopsWithEtaCount',
  stopsWithExternalEtaCount = 'stopsWithExternalEtaCount',
  telemetryConsistencyPercentage = 'telemetryConsistencyPercentage',
  telemetryVisitedStopCount = 'telemetryVisitedStopCount',
  tourId = 'tourId',
  tourSegmentsCount = 'tourSegmentsCount',
  tourSegmentsPingCount = 'tourSegmentsPingCount',
  visitedStopCount = 'visitedStopCount',
}

export type TourVisibilityPerformanceListSortOrderInput = {
  direction: SortDirection;
  key: TourVisibilityPerformanceListSortKey;
};

export enum TourVisibilityPrecisionType {
  EVENT = 'EVENT',
  GPS = 'GPS',
}

export type TourVisibilitySource = {
  __typename: 'TourVisibilitySource';
  eventOrigin: Maybe<Scalars['String']['output']>;
  primaryEventSource: TourVisibilitySourceType;
  sourceCompany: Maybe<CompanyProfile>;
  sourcePlatform: Maybe<PlatformProfile>;
  streamPrecision: Maybe<TourVisibilityPrecisionType>;
};

export enum TourVisibilitySourceType {
  CARRIER_API = 'CARRIER_API',
  FMS = 'FMS',
  IOT_TRACKER = 'IOT_TRACKER',
  MOBILE = 'MOBILE',
  PLATFORM_API = 'PLATFORM_API',
  PLATFORM_RTV_API = 'PLATFORM_RTV_API',
  TTC = 'TTC',
  TTC_MOBILE = 'TTC_MOBILE',
}

export type TourVolume = {
  __typename: 'TourVolume';
  unit: Scalars['String']['output'];
  value: Scalars['Float']['output'];
};

export type TourWarning = {
  __typename: 'TourWarning';
  metadata: Maybe<Scalars['GraphQLJSON']['output']>;
  severity: Maybe<TourWarningSeverity>;
  type: TourWarningType;
};

export enum TourWarningSeverity {
  DEBUG = 'DEBUG',
  ERROR = 'ERROR',
  INFO = 'INFO',
  WARNING = 'WARNING',
}

export enum TourWarningType {
  AUTO_ALLOCATION = 'AUTO_ALLOCATION',
  ETA_AND_STATUSES_ONLY = 'ETA_AND_STATUSES_ONLY',
  ETA_EXPECT_BORDER_RELATED_DELAYS = 'ETA_EXPECT_BORDER_RELATED_DELAYS',
  ETA_PENDING_TRACTOR_SWITCH = 'ETA_PENDING_TRACTOR_SWITCH',
  ETA_PREREQUISITE_DELIVERY_DELAYED = 'ETA_PREREQUISITE_DELIVERY_DELAYED',
  ETA_STALE_VEHICLE_STATUS = 'ETA_STALE_VEHICLE_STATUS',
  LAST_MILESTONE_IS_NOT_COMPLETED = 'LAST_MILESTONE_IS_NOT_COMPLETED',
  STATUS_BASED_ON_PLATFORM_EVENTS = 'STATUS_BASED_ON_PLATFORM_EVENTS',
  STATUS_BREAK_OUTSIDE_OF_SECURED_PARKING_STOPS = 'STATUS_BREAK_OUTSIDE_OF_SECURED_PARKING_STOPS',
  STATUS_EARLY_LOADING = 'STATUS_EARLY_LOADING',
  STATUS_INVALID_TIMESLOT_DATA = 'STATUS_INVALID_TIMESLOT_DATA',
  STATUS_NO_DEPARTURE_TIME = 'STATUS_NO_DEPARTURE_TIME',
  STATUS_NO_ETA_TRANSPORT_MODE = 'STATUS_NO_ETA_TRANSPORT_MODE',
  STATUS_POSSIBLE_WRONG_VEHICLE = 'STATUS_POSSIBLE_WRONG_VEHICLE',
  STATUS_PREREQUISITE_DELIVERY_NOT_COMPLETED = 'STATUS_PREREQUISITE_DELIVERY_NOT_COMPLETED',
  STATUS_STOPS_OUT_OF_SEQUENCE = 'STATUS_STOPS_OUT_OF_SEQUENCE',
  STATUS_STOP_MISSING_GEOCODING = 'STATUS_STOP_MISSING_GEOCODING',
  STATUS_STOP_MISSING_TIMESLOT = 'STATUS_STOP_MISSING_TIMESLOT',
  STATUS_TELEMETRY_CONTAINS_LONG_JUMPS = 'STATUS_TELEMETRY_CONTAINS_LONG_JUMPS',
  STATUS_TRANSPORT_EVENT_TELEMETRY_MISMATCH = 'STATUS_TRANSPORT_EVENT_TELEMETRY_MISMATCH',
  STATUS_UNABLE_TO_REACH_SECURED_PARKING_STOPS_WITHIN_DEADLINE = 'STATUS_UNABLE_TO_REACH_SECURED_PARKING_STOPS_WITHIN_DEADLINE',
  STATUS_UNUSED_ALLOCATION = 'STATUS_UNUSED_ALLOCATION',
  STATUS_VEHICLE_DOING_ANOTHER_TOUR = 'STATUS_VEHICLE_DOING_ANOTHER_TOUR',
  STATUS_VEHICLE_NOT_INTEGRATED = 'STATUS_VEHICLE_NOT_INTEGRATED',
  TELEMETRY_MISSING_AT_STOP = 'TELEMETRY_MISSING_AT_STOP',
  UNMET_PREREQUISITES_FOR_OCEAN_TRACKING = 'UNMET_PREREQUISITES_FOR_OCEAN_TRACKING',
  UNSTABLE_ETA_HIDDEN = 'UNSTABLE_ETA_HIDDEN',
}

export type ToursCountByDelayStatus = {
  __typename: 'ToursCountByDelayStatus';
  count: Scalars['Int']['output'];
  delayStatus: Maybe<TourDelayStatusFilter>;
};

export type ToursCountByStatus = {
  __typename: 'ToursCountByStatus';
  countByFailureReason: Array<TourCountByFailureReason>;
  countByTourDelayStatus: Array<ToursCountByDelayStatus>;
  totalCount: Scalars['Int']['output'];
};

export type TrackedVehicle = {
  __typename: 'TrackedVehicle';
  vehicleId: Scalars['String']['output'];
  vehicleLicensePlateNumber: Maybe<Scalars['String']['output']>;
};

export type TrackingNotStarted = {
  __typename: 'TrackingNotStarted';
  remainingTime: TrackingNotStartedRemainingTime;
};

export type TrackingNotStartedInput = {
  remainingTime: TrackingNotStartedRemainingTimeInput;
};

export type TrackingNotStartedRemainingTime = {
  __typename: 'TrackingNotStartedRemainingTime';
  comparisonField: TrackingNotStartedRemainingTimeField;
  comparisonUnit: ComparisonUnit;
  comparisonValue: Scalars['Int']['output'];
};

export enum TrackingNotStartedRemainingTimeField {
  TIMESLOT_BEGIN = 'TIMESLOT_BEGIN',
  TIMESLOT_END = 'TIMESLOT_END',
}

export type TrackingNotStartedRemainingTimeInput = {
  comparisonField: TrackingNotStartedRemainingTimeField;
  comparisonUnit: ComparisonUnit;
  comparisonValue: Scalars['Int']['input'];
};

export type TrackingSegment = {
  __typename: 'TrackingSegment';
  trackingEndDate: Scalars['DateTime']['output'];
  trackingStartDate: Scalars['DateTime']['output'];
  vehicleId: Scalars['String']['output'];
};

export enum TrafficApiName {
  CREATE_OR_UPDATE_TRANSPORT = 'CREATE_OR_UPDATE_TRANSPORT',
  CREATE_OR_UPDATE_VEHICLE_ALLOCATION = 'CREATE_OR_UPDATE_VEHICLE_ALLOCATION',
  DELETE_TRANSPORT = 'DELETE_TRANSPORT',
  FORWARD_TRANSPORT = 'FORWARD_TRANSPORT',
  STATUS_UPDATE_TRANSPORT = 'STATUS_UPDATE_TRANSPORT',
}

export type TranslateTransportAnalysisInput = {
  analyzeId: Scalars['String']['input'];
  language: Scalars['String']['input'];
};

export type TransportAlert = {
  __typename: 'TransportAlert';
  alertId: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  description: Maybe<Scalars['String']['output']>;
  severity: TransportAlertSeverity;
  type: TransportAlertType;
};

export enum TransportAlertSeverity {
  BLOCKER = 'BLOCKER',
  CRITICAL = 'CRITICAL',
  INFO = 'INFO',
  WARNING = 'WARNING',
}

export enum TransportAlertType {
  CARRIER_DATA_FETCHED_USING_CONTAINER_NUMBER = 'CARRIER_DATA_FETCHED_USING_CONTAINER_NUMBER',
  CARRIER_DATA_MISMATCH = 'CARRIER_DATA_MISMATCH',
  CARRIER_NOT_FOUND = 'CARRIER_NOT_FOUND',
  CARRIER_NO_DATA = 'CARRIER_NO_DATA',
  CARRIER_REFERENCE_NOT_ACCEPTED = 'CARRIER_REFERENCE_NOT_ACCEPTED',
  CARRIER_UNSUPPORTED = 'CARRIER_UNSUPPORTED',
  CHANGE_IN_POD = 'CHANGE_IN_POD',
  CHANGE_IN_POL = 'CHANGE_IN_POL',
  CN_TRACKING_NOT_SUPPORTED = 'CN_TRACKING_NOT_SUPPORTED',
  CONTAINER_DELETED = 'CONTAINER_DELETED',
  CONTAINER_ROLLOVER_AT_POL = 'CONTAINER_ROLLOVER_AT_POL',
  CONTAINER_ROLLOVER_AT_TSP = 'CONTAINER_ROLLOVER_AT_TSP',
  DELAYED_ARRIVAL_AT_AIRPORT_OF_ARRIVAL = 'DELAYED_ARRIVAL_AT_AIRPORT_OF_ARRIVAL',
  DELAYED_ARRIVAL_AT_DESTINATION = 'DELAYED_ARRIVAL_AT_DESTINATION',
  DELAYED_ARRIVAL_AT_POD = 'DELAYED_ARRIVAL_AT_POD',
  DELAYED_DEPARTURE_FROM_AIRPORT_OF_DEPARTURE = 'DELAYED_DEPARTURE_FROM_AIRPORT_OF_DEPARTURE',
  DELAYED_DEPARTURE_FROM_POL = 'DELAYED_DEPARTURE_FROM_POL',
  DEVIATION_LOCATION_GROUP = 'DEVIATION_LOCATION_GROUP',
  DEVIATION_ROUTE = 'DEVIATION_ROUTE',
  INVALID_SHIPMENT_REFERENCE_AWB = 'INVALID_SHIPMENT_REFERENCE_AWB',
  INVALID_SHIPMENT_REFERENCE_BN = 'INVALID_SHIPMENT_REFERENCE_BN',
  INVALID_SHIPMENT_REFERENCE_BOL = 'INVALID_SHIPMENT_REFERENCE_BOL',
  MISSING_GCO2 = 'MISSING_GCO2',
  PACKAGE_COUNT_MISMATCH = 'PACKAGE_COUNT_MISMATCH',
  POST_CARRIAGE_IN_DIFFERENT_CONTINENTS = 'POST_CARRIAGE_IN_DIFFERENT_CONTINENTS',
  POTENTIALLY_INCORRECT_ROUTE = 'POTENTIALLY_INCORRECT_ROUTE',
  POTENTIAL_CARRIER_MISMATCH = 'POTENTIAL_CARRIER_MISMATCH',
  PRE_CARRIAGE_IN_DIFFERENT_CONTINENTS = 'PRE_CARRIAGE_IN_DIFFERENT_CONTINENTS',
  REFERENCE_UPDATE = 'REFERENCE_UPDATE',
  UNKNOWN = 'UNKNOWN',
}

export type TransportAlertsFilterInput = {
  severities?: InputMaybe<Array<TransportAlertSeverity>>;
  types?: InputMaybe<Array<TransportAlertType>>;
};

export type TransportAlertsFilterOutput = {
  __typename: 'TransportAlertsFilterOutput';
  severities: Maybe<Array<TransportAlertSeverity>>;
  types: Maybe<Array<TransportAlertType>>;
};

export type TransportAnalysisResponse = {
  __typename: 'TransportAnalysisResponse';
  analyzeId: Scalars['String']['output'];
  companyId: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  error: Maybe<Scalars['String']['output']>;
  finishedAt: Maybe<Scalars['DateTime']['output']>;
  result: Maybe<Scalars['String']['output']>;
  status: AnalyzeStatus;
};

export type TransportAnalysisResult = {
  __typename: 'TransportAnalysisResult';
  analyzeId: Scalars['String']['output'];
  companyId: Scalars['String']['output'];
  companyName: Maybe<Scalars['String']['output']>;
  companyType: Maybe<ViewerCompanyType>;
  createdAt: Scalars['DateTime']['output'];
  createdByUserId: Maybe<Scalars['String']['output']>;
  createdByUserName: Maybe<Scalars['String']['output']>;
  debugLog: Maybe<Array<Maybe<DebugLog>>>;
  error: Maybe<Scalars['String']['output']>;
  finishedAt: Maybe<Scalars['DateTime']['output']>;
  result: Maybe<Scalars['String']['output']>;
  status: AnalyzeStatus;
  tourId: Scalars['String']['output'];
};

export type TransportAnalysisResultConnection = {
  __typename: 'TransportAnalysisResultConnection';
  edges: Maybe<Array<Maybe<TransportAnalysisResultEdge>>>;
  pageInfo: PageInfo;
};

export type TransportAnalysisResultEdge = {
  __typename: 'TransportAnalysisResultEdge';
  cursor: Maybe<Scalars['String']['output']>;
  node: Maybe<TransportAnalysisResult>;
};

export type TransportChain = {
  __typename: 'TransportChain';
  tours: Array<TransportChainTour>;
};

export type TransportChainTour = {
  __typename: 'TransportChainTour';
  group: Maybe<Scalars['String']['output']>;
  parentTourId: Maybe<Scalars['String']['output']>;
  tour: Tour;
};

export enum TransportIdentifier {
  BILL_OF_LADING = 'BILL_OF_LADING',
  DELIVERY_NUMBER = 'DELIVERY_NUMBER',
  ORDER_NUMBER = 'ORDER_NUMBER',
  PURCHASE_ORDER_NUMBER = 'PURCHASE_ORDER_NUMBER',
  TRANSPORT_NUMBER = 'TRANSPORT_NUMBER',
}

export enum TransportIdentifierType {
  CONTAINER = 'CONTAINER',
  DELIVERY = 'DELIVERY',
  IMO = 'IMO',
  LICENSE_PLATE = 'LICENSE_PLATE',
  MMSI = 'MMSI',
}

export type TransportLocation = {
  byLastActualMilestone?: InputMaybe<Scalars['Boolean']['input']>;
  countries?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  iatas?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  locodes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  milestones?: InputMaybe<Array<InputMaybe<LocationMilestone>>>;
  names?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  types?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type TransportLocationOutput = {
  __typename: 'TransportLocationOutput';
  byLastActualMilestone: Maybe<Scalars['Boolean']['output']>;
  countries: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  iatas: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  locodes: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  milestones: Maybe<Array<Maybe<LocationMilestoneOutput>>>;
  names: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  types: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type TransportMethod = {
  __typename: 'TransportMethod';
  identifiers: Maybe<Array<TripTransportIdentifier>>;
  mode: TripTransportMode;
  name: Maybe<Scalars['String']['output']>;
};

export enum TransportMode {
  AIR = 'AIR',
  MULTIMODAL = 'MULTIMODAL',
  RAIL = 'RAIL',
  RIVER = 'RIVER',
  ROAD = 'ROAD',
  SEA = 'SEA',
  UNKNOWN = 'UNKNOWN',
}

export type TransportNetworkCustomFieldSearchType = {
  __typename: 'TransportNetworkCustomFieldSearchType';
  fieldName: Scalars['String']['output'];
  value: TransportNetworkCustomFieldSearchValueType;
};

export type TransportNetworkCustomFieldSearchValueType = {
  __typename: 'TransportNetworkCustomFieldSearchValueType';
  /** @deprecated Use values instead */
  value: Maybe<Scalars['String']['output']>;
  values: Maybe<Array<Scalars['String']['output']>>;
};

export type TransportNetworkFilter = {
  __typename: 'TransportNetworkFilter';
  carrierIds: Maybe<Array<Scalars['String']['output']>>;
  customFields: Maybe<Array<TransportNetworkCustomFieldSearchType>>;
  customerIds: Maybe<Array<Scalars['String']['output']>>;
  endTimeEnd: Maybe<Scalars['DateTime']['output']>;
  endTimeStart: Maybe<Scalars['DateTime']['output']>;
  mainVisibilityIssues: Maybe<Array<VisibilityIssueType>>;
  onboardingStatus: Maybe<Array<UnifiedCompanyRelationshipOnboardingStatus>>;
  placeIds: Maybe<Array<Scalars['String']['output']>>;
  relationIdentifierIds: Maybe<Array<Scalars['String']['output']>>;
  shipperIds: Maybe<Array<Scalars['String']['output']>>;
  siteIds: Maybe<Array<Scalars['String']['output']>>;
  startTimeEnd: Scalars['DateTime']['output'];
  startTimeStart: Scalars['DateTime']['output'];
  stopBookingLocationNames: Maybe<Array<Scalars['String']['output']>>;
  stopCountries: Maybe<Array<Scalars['String']['output']>>;
  stopFilters: Maybe<Array<StopFilterOutput>>;
  stopStates: Maybe<Array<CompanyStopStates>>;
};

export enum TransportPlatformPageType {
  tpa_dev_transport_page = 'tpa_dev_transport_page',
  tpa_int_transport_page = 'tpa_int_transport_page',
  tpa_production_transport_page = 'tpa_production_transport_page',
  tpa_test_transport_page = 'tpa_test_transport_page',
}

export enum TransportType {
  AIR = 'AIR',
  OCEAN = 'OCEAN',
  ROAD = 'ROAD',
}

export type TransportUpload = {
  __typename: 'TransportUpload';
  description: Scalars['String']['output'];
  documentId: Scalars['ID']['output'];
  fileSize: Scalars['Int']['output'];
  internalDownloadUrl: Maybe<Scalars['String']['output']>;
  invalidRows: Maybe<Scalars['Int']['output']>;
  mode: TransportUploadMode;
  status: TransportUploadStatus;
  totalRows: Maybe<Scalars['Int']['output']>;
  uploadedAt: Scalars['String']['output'];
  uploadedBy: Maybe<TransportUploadUploader>;
  validRows: Maybe<Scalars['Int']['output']>;
  validationErrorMessage: Maybe<Scalars['String']['output']>;
};

export enum TransportUploadMode {
  AIR = 'AIR',
  OCEAN = 'OCEAN',
}

export enum TransportUploadStatus {
  FAILED = 'FAILED',
  PROCESSING = 'PROCESSING',
  VALIDATED = 'VALIDATED',
}

export type TransportUploadUploader = {
  __typename: 'TransportUploadUploader';
  firstName: Maybe<Scalars['String']['output']>;
  lastName: Maybe<Scalars['String']['output']>;
  userId: Scalars['ID']['output'];
};

export type TripDeliveryItem = {
  __typename: 'TripDeliveryItem';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  type: TransportIdentifierType;
};

export type TripLocation = {
  __typename: 'TripLocation';
  country: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  identifiers: Maybe<Array<LocationIdentifier>>;
  name: Scalars['String']['output'];
  position: Maybe<Position>;
  type: Maybe<TripLocationType>;
};

export enum TripLocationType {
  COLLECTION = 'COLLECTION',
  DELIVERY = 'DELIVERY',
  DESTINATION = 'DESTINATION',
  EMPTY_CONTAINER_DELIVERY = 'EMPTY_CONTAINER_DELIVERY',
  EMPTY_CONTAINER_GATE_IN = 'EMPTY_CONTAINER_GATE_IN',
  EMPTY_CONTAINER_GATE_OUT = 'EMPTY_CONTAINER_GATE_OUT',
  EMPTY_CONTAINER_PICKUP = 'EMPTY_CONTAINER_PICKUP',
  EMPTY_POD = 'EMPTY_POD',
  EMPTY_POL = 'EMPTY_POL',
  FULL_CONTAINER_GATE_IN = 'FULL_CONTAINER_GATE_IN',
  FULL_CONTAINER_GATE_OUT = 'FULL_CONTAINER_GATE_OUT',
  GATEWAY = 'GATEWAY',
  IN_TRANSIT_DESTINATION = 'IN_TRANSIT_DESTINATION',
  IN_TRANSIT_ORIGIN = 'IN_TRANSIT_ORIGIN',
  LAYOVER = 'LAYOVER',
  LOADING = 'LOADING',
  ORIGIN = 'ORIGIN',
  OTHER = 'OTHER',
  PORT_OF_DISCHARGE = 'PORT_OF_DISCHARGE',
  PORT_OF_LOADING = 'PORT_OF_LOADING',
  TRANSSHIPMENT = 'TRANSSHIPMENT',
  TRANSSHIPMENT_PORT = 'TRANSSHIPMENT_PORT',
  UNLOADING = 'UNLOADING',
}

export type TripLocationWithMilestones = {
  __typename: 'TripLocationWithMilestones';
  location: Maybe<TripLocation>;
  milestones: Array<TripMilestone>;
};

export type TripMilestone = {
  __typename: 'TripMilestone';
  actualTime: Maybe<DateTimeWithTimezone>;
  deliveryItemIds: Maybe<Array<Scalars['String']['output']>>;
  estimatedTime: Maybe<DateTimeWithTimezone>;
  name: Scalars['String']['output'];
  qualifier: Scalars['String']['output'];
  scheduledTime: Maybe<DateTimeWithTimezone>;
};

export type TripSegment = {
  __typename: 'TripSegment';
  id: Scalars['String']['output'];
  locations: Maybe<Array<TripLocationWithMilestones>>;
  polylines: Maybe<Array<TripSegmentPolyline>>;
  previousTripIds: Maybe<Array<Scalars['String']['output']>>;
  transportMethod: Maybe<TransportMethod>;
};

export type TripSegmentPolyline = {
  __typename: 'TripSegmentPolyline';
  endLocationId: Scalars['String']['output'];
  polyline: Polyline;
  startLocationId: Scalars['String']['output'];
};

export type TripTransportIdentifier = {
  __typename: 'TripTransportIdentifier';
  type: TransportIdentifierType;
  value: Scalars['String']['output'];
};

export enum TripTransportMode {
  BARGE = 'BARGE',
  PLANE = 'PLANE',
  RAIL = 'RAIL',
  ROAD = 'ROAD',
  UNKNOWN = 'UNKNOWN',
  VESSEL = 'VESSEL',
}

export type TripVesselNames = {
  __typename: 'TripVesselNames';
  pod: Maybe<Scalars['String']['output']>;
  podVoyageId: Maybe<Scalars['String']['output']>;
  pol: Maybe<Scalars['String']['output']>;
  polVoyageId: Maybe<Scalars['String']['output']>;
  voyageId: Maybe<Scalars['String']['output']>;
};

export enum TripsIdentifierType {
  air_way_bill = 'air_way_bill',
  bill_of_lading = 'bill_of_lading',
  booking_number = 'booking_number',
  carrier_code = 'carrier_code',
  carrier_name = 'carrier_name',
  consignee_contact_name = 'consignee_contact_name',
  consignee_location_name = 'consignee_location_name',
  container_number = 'container_number',
  customer_contact_name = 'customer_contact_name',
  customer_location_name = 'customer_location_name',
  flight_number = 'flight_number',
  ocean_demurrage_currency = 'ocean_demurrage_currency',
  order_number = 'order_number',
  package_count = 'package_count',
  shipper_contact_name = 'shipper_contact_name',
  shipper_location_name = 'shipper_location_name',
  vessel_name = 'vessel_name',
  voyage_id = 'voyage_id',
}

export type TripsOption = {
  __typename: 'TripsOption';
  value: Scalars['String']['output'];
};

export type TripsOptionConnection = {
  __typename: 'TripsOptionConnection';
  edges: Maybe<Array<Maybe<TripsOptionEdge>>>;
  pageInfo: PageInfo;
};

export type TripsOptionEdge = {
  __typename: 'TripsOptionEdge';
  cursor: Maybe<Scalars['String']['output']>;
  node: Maybe<TripsOption>;
};

export type TripsTextSearch = {
  field: TripsTextSearchField;
  query: Scalars['String']['input'];
};

export enum TripsTextSearchField {
  AIR_WAY_BILL_NUMBER = 'AIR_WAY_BILL_NUMBER',
  ALL = 'ALL',
  BILL_OF_LADING_NUMBER = 'BILL_OF_LADING_NUMBER',
  BOOKING_NUMBER = 'BOOKING_NUMBER',
  EQUIPMENT_NUMBER = 'EQUIPMENT_NUMBER',
}

export type TripsTourIdentifier = {
  __typename: 'TripsTourIdentifier';
  companyId: Scalars['String']['output'];
  identifierType: TripsIdentifierType;
  identifierValue: Scalars['String']['output'];
};

export type TripsTourIdentifierConnection = {
  __typename: 'TripsTourIdentifierConnection';
  edges: Maybe<Array<Maybe<TripsTourIdentifierEdge>>>;
  pageInfo: PageInfo;
};

export type TripsTourIdentifierEdge = {
  __typename: 'TripsTourIdentifierEdge';
  cursor: Maybe<Scalars['String']['output']>;
  node: Maybe<TripsTourIdentifier>;
};

export enum TripsTransportMode {
  AIR = 'AIR',
  INLAND = 'INLAND',
  OCEAN = 'OCEAN',
}

export type UnforwardTourInput = {
  tourId: Scalars['String']['input'];
  unforwardByCompanyId: Scalars['String']['input'];
  unforwardFromCompanyId: Scalars['String']['input'];
};

export enum UnifiedCompanyOnboardingStatus {
  NOT_REGISTERED = 'NOT_REGISTERED',
  ONBOARDED = 'ONBOARDED',
  ONBOARDING_STUCK = 'ONBOARDING_STUCK',
  READY_FOR_ONBOARDING = 'READY_FOR_ONBOARDING',
  REGISTERED = 'REGISTERED',
}

export enum UnifiedCompanyOnboardingStuckReason {
  CARRIER_API_WORK_IN_PROGRESS = 'CARRIER_API_WORK_IN_PROGRESS',
  COMPANY_UNRESPONSIVE = 'COMPANY_UNRESPONSIVE',
  FMS_CREDENTIALS_NOT_PROVIDED = 'FMS_CREDENTIALS_NOT_PROVIDED',
  FMS_PROVIDER_UNRESPONSIVE = 'FMS_PROVIDER_UNRESPONSIVE',
  NO_VISIBILITY_PROVIDED = 'NO_VISIBILITY_PROVIDED',
  NO_VISIBILITY_SOURCE_IDENTIFIED = 'NO_VISIBILITY_SOURCE_IDENTIFIED',
  REFUSES_COOPERATION = 'REFUSES_COOPERATION',
  SUBCARRIER_ONBOARDING_BLOCKED = 'SUBCARRIER_ONBOARDING_BLOCKED',
}

export enum UnifiedCompanyRelationshipOnboardingStatus {
  INVITED = 'INVITED',
  NOT_REGISTERED = 'NOT_REGISTERED',
  ONBOARDED = 'ONBOARDED',
  ONBOARDING_STUCK = 'ONBOARDING_STUCK',
  OUT_OF_SCOPE = 'OUT_OF_SCOPE',
  PLATFORM_REGISTERED = 'PLATFORM_REGISTERED',
  READY_FOR_ONBOARDING = 'READY_FOR_ONBOARDING',
  REGISTERED = 'REGISTERED',
}

export type UnifiedCompanyRelationshipSignupEvent = {
  __typename: 'UnifiedCompanyRelationshipSignupEvent';
  eventTime: Scalars['DateTime']['output'];
  triggeredByUser: Maybe<UserProfile>;
  type: UnifiedCompanyRelationshipSignupEventType;
};

export enum UnifiedCompanyRelationshipSignupEventType {
  INVITE_REMINDER_SENT = 'INVITE_REMINDER_SENT',
  INVITE_SENT = 'INVITE_SENT',
  ONBOARDED = 'ONBOARDED',
  ONBOARDING_OUT_OF_SCOPE = 'ONBOARDING_OUT_OF_SCOPE',
  ONBOARDING_RESET_TO_AUTOMATIC = 'ONBOARDING_RESET_TO_AUTOMATIC',
  PLATFORM_SIGNUP_ENDED = 'PLATFORM_SIGNUP_ENDED',
  PLATFORM_SIGNUP_STARTED = 'PLATFORM_SIGNUP_STARTED',
}

export enum UnifiedCompanyRelationshipSignupStatus {
  INVITED = 'INVITED',
  NO_VISIBILITY_SOURCE = 'NO_VISIBILITY_SOURCE',
  ONBOARDED = 'ONBOARDED',
  OUT_OF_SCOPE = 'OUT_OF_SCOPE',
  REGISTERED = 'REGISTERED',
}

export enum UnifiedCompanyRelationshipSignupStatusUpdateType {
  OUT_OF_SCOPE = 'OUT_OF_SCOPE',
  RESET_TO_AUTOMATIC = 'RESET_TO_AUTOMATIC',
}

export type UnifiedCompanySignupEvent = {
  __typename: 'UnifiedCompanySignupEvent';
  eventTime: Scalars['DateTime']['output'];
  triggeredByUser: Maybe<UserProfile>;
  type: UnifiedCompanySignupEventType;
  visibilitySource: Maybe<TourVisibilitySourceType>;
};

export enum UnifiedCompanySignupEventType {
  COMPANY_REGISTERED = 'COMPANY_REGISTERED',
  FIRST_INTEGRATION_REMINDER_SENT = 'FIRST_INTEGRATION_REMINDER_SENT',
  FIRST_INVITE_SUBCONTRACTORS_REMINDER_SENT = 'FIRST_INVITE_SUBCONTRACTORS_REMINDER_SENT',
  MANUALLY_ONBOARDED = 'MANUALLY_ONBOARDED',
  ONBOARDED = 'ONBOARDED',
  ONBOARDING_RESET_TO_AUTOMATIC = 'ONBOARDING_RESET_TO_AUTOMATIC',
  PLATFORM_ACTIVATED = 'PLATFORM_ACTIVATED',
  SECOND_INTEGRATION_REMINDER_SENT = 'SECOND_INTEGRATION_REMINDER_SENT',
  SECOND_INVITE_SUBCONTRACTORS_REMINDER_SENT = 'SECOND_INVITE_SUBCONTRACTORS_REMINDER_SENT',
  SIGNUP_PAGE_OPENED = 'SIGNUP_PAGE_OPENED',
  TELEMATICS_INTEGRATION_ADDED = 'TELEMATICS_INTEGRATION_ADDED',
  UNSUPPORTED_TELEMATICS_SUBMITTED = 'UNSUPPORTED_TELEMATICS_SUBMITTED',
  VISIBILITY_SOURCE_ACTIVATED = 'VISIBILITY_SOURCE_ACTIVATED',
  VISIBILITY_SOURCE_DEACTIVATED = 'VISIBILITY_SOURCE_DEACTIVATED',
  VISIBILITY_SOURCE_IDENTIFIED = 'VISIBILITY_SOURCE_IDENTIFIED',
}

export enum UnifiedCompanySignupStatus {
  INVITED = 'INVITED',
  NO_VISIBILITY_SOURCE = 'NO_VISIBILITY_SOURCE',
  ONBOARDED = 'ONBOARDED',
  REGISTERED = 'REGISTERED',
}

export type UnifiedCompanySignupStatusUpdateInput = {
  update: UnifiedCompanySignupStatusUpdateType;
};

export enum UnifiedCompanySignupStatusUpdateType {
  ONBOARDED = 'ONBOARDED',
  RESET_TO_AUTOMATIC = 'RESET_TO_AUTOMATIC',
}

export type UpdateBulkInvitationSetInput = {
  bulkInvitationSetId: Scalars['String']['input'];
  deleteSelectType?: InputMaybe<BulkInvitationSendSelectType>;
  itemIdsToDelete: Array<Scalars['String']['input']>;
  itemsToCreate: Array<CreateBulkInvitationSetItemInput>;
  itemsToUpdate: Array<UpdateBulkInvitationSetItemInput>;
  setName?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateBulkInvitationSetItemInput = {
  bulkInvitationSetItemId: Scalars['String']['input'];
  companyName?: InputMaybe<Scalars['String']['input']>;
  identifierValues?: InputMaybe<Array<Scalars['String']['input']>>;
  recipients: Array<CompanyBulkInvitationRecipient>;
};

export type UpdateBulkInvitationSetResult = {
  __typename: 'UpdateBulkInvitationSetResult';
  createdBulkInvitationSetItemIds: Array<Scalars['String']['output']>;
  hadDuplicates: Scalars['Boolean']['output'];
  invalidIdentifiers: Array<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type UpdateCompanyAnalyticsFilterInput = {
  companyAnalyticsFilterId: Scalars['String']['input'];
  filterV2?: InputMaybe<VisibilityPerformanceFilterInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  visibilityType?: InputMaybe<CompanyAnalyticsFilterVisibility>;
};

export type UpdateCompanyConfigurationInput = {
  companyId: Scalars['String']['input'];
  configuration: ConfigurationUpdateInput;
};

export type UpdateCompanyInput = {
  address?: InputMaybe<CompanyAddressInput>;
  company_name?: InputMaybe<Scalars['String']['input']>;
  consigneeBackground?: InputMaybe<NullableUpload>;
  consigneeLogo?: InputMaybe<NullableUpload>;
  feature_flags?: InputMaybe<Scalars['GraphQLJSON']['input']>;
  is_carrier?: InputMaybe<Scalars['Boolean']['input']>;
  is_paying_customer?: InputMaybe<Scalars['Boolean']['input']>;
  is_pilot?: InputMaybe<Scalars['Boolean']['input']>;
  is_shipper?: InputMaybe<Scalars['Boolean']['input']>;
  is_test?: InputMaybe<Scalars['Boolean']['input']>;
  sharedViewLogo?: InputMaybe<NullableUpload>;
};

export type UpdateCompanyPlaceInput = {
  companyId: Scalars['String']['input'];
  fromTourId?: InputMaybe<Scalars['String']['input']>;
  geodata?: InputMaybe<Array<PlaceGeodataInput>>;
  location?: InputMaybe<PointLocationInput>;
  name: Scalars['String']['input'];
  placeId: Scalars['String']['input'];
  referenceId?: InputMaybe<Scalars['String']['input']>;
  stopAddressIds: Array<Scalars['String']['input']>;
};

export type UpdateCompanyPlatformInput = {
  company_id_on_platform: Scalars['String']['input'];
};

export type UpdateCompanyRelationshipSignupStatusInput = {
  companyRelationshipId: Scalars['String']['input'];
  update: UnifiedCompanyRelationshipSignupStatusUpdateType;
};

export type UpdateCompanySettingsInput = {
  companyId: Scalars['String']['input'];
  settings: CompanySettingsInput;
};

export type UpdateCompanySharedViewBrandingInput = {
  logo?: InputMaybe<CompanySharedViewLogoInput>;
};

export type UpdateCompanyTransportContactsInput = {
  companyId: Scalars['String']['input'];
  transportContactDetails: Array<CompanyTransportContactDetailsInput>;
};

export type UpdateCompanyVehicleGroupInput = {
  companyId: Scalars['String']['input'];
  companyVehicleGroupId: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type UpdateCompanyWebhookSubscriptionInput = {
  companyId: Scalars['String']['input'];
  status?: InputMaybe<CompanyWebhookSubscriptionStatus>;
  webhookSubscriptionId: Scalars['String']['input'];
};

export enum UpdateCompanyWebhookSubscriptionStatus {
  PAUSED = 'PAUSED',
  WORKING = 'WORKING',
}

export type UpdateCustomFieldDisplayNamesInput = {
  companyId: Scalars['String']['input'];
  fields: Array<CustomFieldDisplayNameInput>;
};

export type UpdateDashboardInput = {
  dashboardId: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  isExample?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  sharedWithUserIds?: InputMaybe<Array<Scalars['String']['input']>>;
  sharingType: DashboardSharingType;
  widgetIdsOrder?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdateEmailAccessInput = {
  emailAccessId: Scalars['String']['input'];
};

export type UpdateFilterBasedTransportNotificationInput = {
  addRecipientsV2?: InputMaybe<Array<RecipientInput>>;
  companyId: Scalars['String']['input'];
  deliverySettings?: InputMaybe<DeliverySettingsInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  notificationCustomization?: InputMaybe<NotificationCustomizationInput>;
  notificationId: Scalars['String']['input'];
  notificationTrigger?: InputMaybe<NotificationTriggerInput>;
  recipientsV2?: InputMaybe<Array<RecipientInput>>;
  removeRecipientsV2?: InputMaybe<Array<RecipientInput>>;
  status?: InputMaybe<NotificationStatus>;
  transportFilter?: InputMaybe<TourFilterInput>;
  transportFilterV2?: InputMaybe<Scalars['GraphQLJSON']['input']>;
};

export type UpdateInviteCompanyNameInput = {
  companyId: Scalars['String']['input'];
  companyInviteId: Scalars['String']['input'];
  newCompanyName: Scalars['String']['input'];
};

export type UpdateMergedRowRelationIdentifiersInput = {
  companyName: Scalars['String']['input'];
  identifierValues: Array<Scalars['String']['input']>;
  ownerCompanyId: Scalars['String']['input'];
};

export type UpdateMergedRowRelationIdentifiersResult = {
  __typename: 'UpdateMergedRowRelationIdentifiersResult';
  success: Scalars['Boolean']['output'];
};

export type UpdateNoteInput = {
  companyId: Scalars['String']['input'];
  noteId: Scalars['String']['input'];
  noteText?: InputMaybe<Scalars['String']['input']>;
  noteVisibility?: InputMaybe<NoteVisibility>;
};

export type UpdateOvdTokenInput = {
  carrierIds?: InputMaybe<Array<Scalars['String']['input']>>;
  deliveryCustomFields?: InputMaybe<Array<Scalars['String']['input']>>;
  enableApiEta?: InputMaybe<Scalars['Boolean']['input']>;
  enableCancellationReason?: InputMaybe<Scalars['Boolean']['input']>;
  enableCustomFields?: InputMaybe<Scalars['Boolean']['input']>;
  enableStatus?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  platformIds?: InputMaybe<Array<Scalars['String']['input']>>;
  shipperIds?: InputMaybe<Array<Scalars['String']['input']>>;
  tokenId: Scalars['String']['input'];
  tourCustomFields?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdateSharedViewInput = {
  agreeToTermsAndConditions: Scalars['Boolean']['input'];
  emailAccesses?: InputMaybe<Array<CreateOrUpdateEmailAccessInput>>;
  filterV1?: InputMaybe<TourFilterInput>;
  filterV2?: InputMaybe<Scalars['GraphQLJSON']['input']>;
  isActive: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  sharedViewId: Scalars['String']['input'];
  sharingLinks: Array<CreateOrUpdateSharingLinkInput>;
};

export type UpdateTelematicsIntegrationConnectionParametersInput = {
  connectionData?: InputMaybe<Scalars['GraphQLJSON']['input']>;
  telematicsIntegrationId: Scalars['String']['input'];
};

export type UpdateTelematicsIntegrationInput = {
  company_integration_id?: InputMaybe<Scalars['String']['input']>;
  connection_data?: InputMaybe<Scalars['GraphQLJSON']['input']>;
  diagnosticComment?: InputMaybe<Scalars['String']['input']>;
  diagnosticStatus?: InputMaybe<TelematicsIntegrationDiagnosticStatus>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  telematics_integration_id: Scalars['String']['input'];
};

export type UpdateTelematicsProviderInput = {
  contact_info?: InputMaybe<TelematicsProviderContactInfoInput>;
  telematics_provider_id: Scalars['String']['input'];
};

export type UpdateUserInCompanyConfigurationInput = {
  companyId: Scalars['String']['input'];
  configuration: UserInCompanyConfigurationInput;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateUserNotificationConfigInput = {
  action: Action;
  company_id: Scalars['String']['input'];
  types: Array<EmailType>;
  user_id: Scalars['String']['input'];
};

export type UpdateUserNotificationConfigResponse = {
  __typename: 'UpdateUserNotificationConfigResponse';
  success: Scalars['Boolean']['output'];
};

export type UpdateViewerProfileInput = {
  locale?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateWebhookSubscriptionInput = {
  companyId: Scalars['String']['input'];
  contactEmails: Array<Scalars['String']['input']>;
  discriminator?: InputMaybe<Scalars['GraphQLJSON']['input']>;
  expirationDate: Scalars['DateTime']['input'];
  headers: Scalars['GraphQLJSON']['input'];
  payloadContentType: WebhookPayloadContentType;
  status: UpdateCompanyWebhookSubscriptionStatus;
  subscriptionId: Scalars['String']['input'];
  topics: Array<Scalars['String']['input']>;
  url: Scalars['String']['input'];
};

export type UpdateWidgetInput = {
  dashboardId: Scalars['String']['input'];
  filters?: InputMaybe<Array<WidgetFilterInput>>;
  filtersV2?: InputMaybe<Array<WidgetFilterInputV2>>;
  name: Scalars['String']['input'];
  widgetId: Scalars['String']['input'];
};

export type UploadFileError = {
  __typename: 'UploadFileError';
  code: UploadFileErrorCode;
  message: Scalars['String']['output'];
};

export enum UploadFileErrorCode {
  FILE_TOO_LARGE = 'FILE_TOO_LARGE',
  UNSUPPORTED_FILE_TYPE = 'UNSUPPORTED_FILE_TYPE',
}

export type UploadSharedViewLogoResult = UploadFileError | UploadedCompanyAsset;

export type UploadedCompanyAsset = {
  __typename: 'UploadedCompanyAsset';
  assetId: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type User = {
  __typename: 'User';
  allCompanies: Array<Company>;
  avatar_url: Maybe<Scalars['String']['output']>;
  backoffice_access_enabled: Maybe<Scalars['Boolean']['output']>;
  backoffice_role: Maybe<BackofficeRole>;
  backoffice_scopes: Maybe<Array<Scalars['String']['output']>>;
  companies: Array<Company>;
  company: Maybe<Company>;
  companyIdAndVisibilityServicesForTour: Maybe<CompanyIdAndVisibilityServices>;
  created_at: Maybe<Scalars['DateTime']['output']>;
  credentials: Array<Credentials>;
  deleted_at: Maybe<Scalars['DateTime']['output']>;
  email: Maybe<Scalars['String']['output']>;
  first_name: Maybe<Scalars['String']['output']>;
  isVisibilityAgentEnabled: Scalars['Boolean']['output'];
  is_internal: Maybe<Scalars['Boolean']['output']>;
  lastUiActivityAt: Maybe<Scalars['DateTime']['output']>;
  last_name: Maybe<Scalars['String']['output']>;
  locale: Maybe<Scalars['String']['output']>;
  updated_at: Maybe<Scalars['DateTime']['output']>;
  user_id: Scalars['String']['output'];
};

export type UserCompanyArgs = {
  company_id: Scalars['String']['input'];
};

export type UserCompanyIdAndVisibilityServicesForTourArgs = {
  tourId: Scalars['String']['input'];
};

export type UserIsVisibilityAgentEnabledArgs = {
  companyId?: InputMaybe<Scalars['String']['input']>;
};

export type UserAttributesInput = {
  avatar_url?: InputMaybe<Scalars['String']['input']>;
  backoffice_role?: InputMaybe<BackofficeRole>;
  backoffice_scopes?: InputMaybe<Array<Scalars['String']['input']>>;
  email?: InputMaybe<Scalars['String']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
};

export type UserConnection = {
  __typename: 'UserConnection';
  edges: Maybe<Array<Maybe<UserEdge>>>;
  pageInfo: PageInfo;
};

export type UserEdge = {
  __typename: 'UserEdge';
  cursor: Maybe<Scalars['String']['output']>;
  node: Maybe<User>;
};

export type UserFilter = {
  __typename: 'UserFilter';
  filter: Maybe<TourFilter>;
  filterV2: Maybe<Scalars['GraphQLJSON']['output']>;
  name: Scalars['String']['output'];
  tourCount: Scalars['Int']['output'];
  tours: Array<Tour>;
  userFilterId: Scalars['String']['output'];
};

export type UserFilterToursArgs = {
  included_filter_ids?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type UserFilterConnection = {
  __typename: 'UserFilterConnection';
  edges: Maybe<Array<Maybe<UserFilterEdge>>>;
  pageInfo: PageInfo;
};

export type UserFilterEdge = {
  __typename: 'UserFilterEdge';
  cursor: Maybe<Scalars['String']['output']>;
  node: Maybe<UserFilter>;
};

export type UserGroupOnPlatform = {
  __typename: 'UserGroupOnPlatform';
  company: Maybe<CompanyProfile>;
  groupId: Scalars['String']['output'];
  name: Scalars['String']['output'];
  platform: PlatformProfile;
  users: UserProfileConnection;
};

export type UserGroupOnPlatformUsersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type UserGroupOnPlatformConnection = {
  __typename: 'UserGroupOnPlatformConnection';
  edges: Maybe<Array<Maybe<UserGroupOnPlatformEdge>>>;
  pageInfo: PageInfo;
};

export type UserGroupOnPlatformEdge = {
  __typename: 'UserGroupOnPlatformEdge';
  cursor: Maybe<Scalars['String']['output']>;
  node: Maybe<UserGroupOnPlatform>;
};

export type UserInCompany = {
  __typename: 'UserInCompany';
  configuration: UserInCompanyConfiguration;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  dashboard: Maybe<Dashboard>;
  dashboardsConnection: CountedDashboardsConnection;
  invitedByUser: Maybe<UserProfile>;
  metadata: Maybe<UserMetadataInCompany>;
  profile: UserProfile;
  role: UserRoleInCompany;
  transporeonPlatform: Maybe<UserOnPlatform>;
  user: User;
  userFiltersConnection: CountedUserFilterConnection;
};

export type UserInCompanyDashboardArgs = {
  dashboardId: Scalars['String']['input'];
};

export type UserInCompanyDashboardsConnectionArgs = {
  queryType?: InputMaybe<DashboardQueryType>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type UserInCompanyUserFiltersConnectionArgs = {
  filterType?: InputMaybe<FilterType>;
  textSearch?: InputMaybe<Scalars['String']['input']>;
};

export type UserInCompanyConfiguration = {
  __typename: 'UserInCompanyConfiguration';
  isUserSessionInvalidationOnUiInactivityEnabled: Scalars['Boolean']['output'];
  vehicleDwellTimeThresholdMinutes: Scalars['Int']['output'];
};

export type UserInCompanyConfigurationInput = {
  vehicleDwellTimeThresholdMinutes: Scalars['Int']['input'];
};

export type UserInCompanyProfile = {
  __typename: 'UserInCompanyProfile';
  configuration: UserInCompanyConfiguration;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  invitedByUser: Maybe<UserProfile>;
  lastUiActivityAt: Maybe<Scalars['DateTime']['output']>;
  metadata: Maybe<UserMetadataInCompany>;
  profile: UserProfile;
  role: UserRoleInCompany;
  user: User;
  userOnPlatforms: Array<UserOnPlatformProfile>;
};

export type UserInCompanyProfileConnection = {
  __typename: 'UserInCompanyProfileConnection';
  edges: Maybe<Array<Maybe<UserInCompanyProfileEdge>>>;
  pageInfo: PageInfo;
};

export type UserInCompanyProfileEdge = {
  __typename: 'UserInCompanyProfileEdge';
  cursor: Maybe<Scalars['String']['output']>;
  node: Maybe<UserInCompanyProfile>;
};

export type UserMetadataInCompany = {
  __typename: 'UserMetadataInCompany';
  persona: Maybe<UserPersonaInCompany>;
};

export type UserMetadataInCompanyInput = {
  persona?: InputMaybe<UserPersonaInCompany>;
};

export type UserNotificationConfig = {
  __typename: 'UserNotificationConfig';
  company_id: Scalars['String']['output'];
  created_at: Scalars['String']['output'];
  disabled_types: Array<EmailType>;
  updated_at: Scalars['String']['output'];
  user_id: Scalars['String']['output'];
  user_notification_config_id: Scalars['String']['output'];
};

export type UserOnPlatform = {
  __typename: 'UserOnPlatform';
  userIdOnPlatform: Scalars['String']['output'];
};

export type UserOnPlatformProfile = {
  __typename: 'UserOnPlatformProfile';
  company: CompanyProfile;
  platform: PlatformProfile;
  user: UserProfile;
  userIdOnPlatform: Scalars['String']['output'];
};

export enum UserPersonaInCompany {
  CUSTOMER_SUPPORT = 'CUSTOMER_SUPPORT',
  DEVELOPER = 'DEVELOPER',
  TRANSPORT_PLANNER = 'TRANSPORT_PLANNER',
  WAREHOUSE_MANAGER = 'WAREHOUSE_MANAGER',
}

export type UserProfile = {
  __typename: 'UserProfile';
  avatar_url: Maybe<Scalars['String']['output']>;
  email: Maybe<Scalars['String']['output']>;
  first_name: Maybe<Scalars['String']['output']>;
  last_name: Maybe<Scalars['String']['output']>;
  locale: Maybe<Scalars['String']['output']>;
  user_id: Scalars['String']['output'];
};

export type UserProfileConnection = {
  __typename: 'UserProfileConnection';
  edges: Maybe<Array<Maybe<UserProfileEdge>>>;
  pageInfo: PageInfo;
};

export type UserProfileEdge = {
  __typename: 'UserProfileEdge';
  cursor: Maybe<Scalars['String']['output']>;
  node: Maybe<UserProfile>;
};

export enum UserRoleInCompany {
  ADMIN = 'ADMIN',
  REGULAR_USER = 'REGULAR_USER',
}

export type ValidateTelematicsIntegrationConnectionParametersUpdateInput = {
  connectionData?: InputMaybe<Scalars['GraphQLJSON']['input']>;
  telematicsIntegrationId: Scalars['String']['input'];
};

export type ValidateTelematicsIntegrationInput = {
  connection_data?: InputMaybe<Scalars['GraphQLJSON']['input']>;
  telematics_integration_id?: InputMaybe<Scalars['String']['input']>;
  telematics_provider_id: Scalars['String']['input'];
};

export type Vehicle = {
  __typename: 'Vehicle';
  alternativeIdentifiers: Array<VehicleAlternativeIdentifier>;
  archived: Scalars['Boolean']['output'];
  boundingBox: Maybe<Array<PointLocation>>;
  breakHistory: Maybe<Array<VehicleBreakHistory>>;
  breakStatus: Maybe<VehicleBreakStatus>;
  company: CompanyProfile;
  created_at: Maybe<Scalars['DateTime']['output']>;
  history: Maybe<Array<VehicleHistory>>;
  historyCustomer: Array<VehicleHistoryCustomer>;
  inGlobalPool: Scalars['Boolean']['output'];
  isActive: Maybe<Scalars['Boolean']['output']>;
  isConstantPositionAccessAllowed: Scalars['Boolean']['output'];
  latestVehicleTemperatures: Array<LatestVehicleTemperature>;
  license_plate_number: Maybe<Scalars['String']['output']>;
  mapTilesTemplateURI: Maybe<Scalars['String']['output']>;
  receivedGrant: Maybe<VehicleGrant>;
  sentGrants: Array<VehicleGrant>;
  sharedBy: Maybe<CompanyProfile>;
  sharedTo: Array<CompanyProfile>;
  status: Maybe<RestrictedVehicleStatus>;
  telematicsIntegrations: Array<TelematicsIntegration>;
  tours: Maybe<Array<Tour>>;
  updated_at: Maybe<Scalars['DateTime']['output']>;
  vehicleMapState: Maybe<VehicleMapState>;
  vehicleTrackers: Array<VehicleTracker>;
  vehicle_id: Scalars['String']['output'];
};

export type VehicleBreakHistoryArgs = {
  endTime: Scalars['String']['input'];
  startTime: Scalars['String']['input'];
};

export type VehicleHistoryArgs = {
  end_time: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  simplification_tolerance?: InputMaybe<Scalars['Float']['input']>;
  start_time: Scalars['String']['input'];
};

export type VehicleHistoryCustomerArgs = {
  endTime: Scalars['DateTime']['input'];
  startTime: Scalars['DateTime']['input'];
};

export type VehicleMapTilesTemplateUriArgs = {
  dwellTime?: InputMaybe<Scalars['Int']['input']>;
  returnTimeBasedStatus?: InputMaybe<Scalars['Boolean']['input']>;
  returnVehicleState?: InputMaybe<Scalars['Boolean']['input']>;
};

export type VehicleToursArgs = {
  fromTime: Scalars['DateTime']['input'];
  status?: InputMaybe<Array<TourStatusFilter>>;
  toTime: Scalars['DateTime']['input'];
};

export type VehicleVehicleMapStateArgs = {
  dwellTimeThresholdMinutes?: InputMaybe<Scalars['Int']['input']>;
};

export type VehicleVehicleTrackersArgs = {
  trackerTypes?: InputMaybe<Array<VehicleTrackerType>>;
};

export type VehicleAllocation = {
  __typename: 'VehicleAllocation';
  startTrackingAt: Maybe<Scalars['DateTime']['output']>;
  vehicleId: Maybe<Scalars['String']['output']>;
  vehicleLicensePlateNumber: Maybe<Scalars['String']['output']>;
};

export type VehicleAllocationInput = {
  additionalAssets?: InputMaybe<Array<TourAdditionalAssetInput>>;
  allocationId?: InputMaybe<Scalars['String']['input']>;
  allocationSwitchType?: InputMaybe<TourAllocationSwitchType>;
  matchedAlternativeIdentifierId?: InputMaybe<Scalars['String']['input']>;
  startTrackingAt?: InputMaybe<Scalars['DateTime']['input']>;
  vehicleId?: InputMaybe<Scalars['String']['input']>;
};

export type VehicleAlternativeIdentifier = {
  __typename: 'VehicleAlternativeIdentifier';
  alternativeIdentifier: Scalars['String']['output'];
  normalizedAlternativeIdentifier: Scalars['String']['output'];
  vehicleAlternativeIdentifierId: Scalars['String']['output'];
};

export type VehicleAlternativeIdentifierConflict = {
  __typename: 'VehicleAlternativeIdentifierConflict';
  alternativeIdentifier: Maybe<Scalars['String']['output']>;
  conflictedBy: VehicleAlternativeIdentifierConflictedBy;
  licensePlate: Maybe<Scalars['String']['output']>;
  submittedAlternativeIdentifier: Scalars['String']['output'];
};

export enum VehicleAlternativeIdentifierConflictedBy {
  ALTERNATIVE_IDENTIFIER = 'ALTERNATIVE_IDENTIFIER',
  LICENSE_PLATE = 'LICENSE_PLATE',
}

export enum VehicleAvailability {
  ALWAYS = 'ALWAYS',
  TRANSPORT_POOL = 'TRANSPORT_POOL',
}

export type VehicleBreakHistory = {
  __typename: 'VehicleBreakHistory';
  breakId: Scalars['String']['output'];
  center: BreakCenterPosition;
  configurationId: Scalars['String']['output'];
  from: Scalars['DateTime']['output'];
  to: Maybe<Scalars['DateTime']['output']>;
};

export type VehicleBreakHistoryEntry = {
  __typename: 'VehicleBreakHistoryEntry';
  breaks: Array<VehicleBreakHistory>;
  vehicle_id: Scalars['String']['output'];
};

export type VehicleBreakStatus = {
  __typename: 'VehicleBreakStatus';
  from: Scalars['DateTime']['output'];
  to: Maybe<Scalars['DateTime']['output']>;
  vehicleBreakStatusId: Scalars['String']['output'];
};

export type VehicleChangePosition = {
  __typename: 'VehicleChangePosition';
  currentLicensePlate: Maybe<Scalars['String']['output']>;
  lat: Scalars['Float']['output'];
  lng: Scalars['Float']['output'];
  previousLicensePlate: Maybe<Scalars['String']['output']>;
  receivedAt: Maybe<Scalars['DateTime']['output']>;
  vehicleId: Scalars['String']['output'];
};

export type VehicleConnection = {
  __typename: 'VehicleConnection';
  edges: Maybe<Array<Maybe<VehicleEdge>>>;
  pageInfo: PageInfo;
};

export type VehicleCountByStatus = {
  __typename: 'VehicleCountByStatus';
  active: Scalars['Int']['output'];
  inActive: Scalars['Int']['output'];
};

export type VehicleData = {
  __typename: 'VehicleData';
  flightNumber: Maybe<Scalars['String']['output']>;
  identificator: Maybe<Scalars['String']['output']>;
  name: Maybe<Scalars['String']['output']>;
  type: TripTransportMode;
  vehicleId: Scalars['String']['output'];
  voyageId: Maybe<Scalars['String']['output']>;
};

export type VehicleEdge = {
  __typename: 'VehicleEdge';
  cursor: Maybe<Scalars['String']['output']>;
  node: Maybe<Vehicle>;
};

export enum VehicleFilterSortKey {
  ALTERNATIVE_IDENTIFIER = 'ALTERNATIVE_IDENTIFIER',
  GRANTED_BY_COMPANY = 'GRANTED_BY_COMPANY',
  LAST_SIGNAL = 'LAST_SIGNAL',
  LICENSE_PLATE = 'LICENSE_PLATE',
  STATUS = 'STATUS',
}

export type VehicleFilterSortOrderInput = {
  direction: SortDirection;
  key: VehicleFilterSortKey;
};

export type VehicleGrant = {
  __typename: 'VehicleGrant';
  grantId: Scalars['String']['output'];
  grantedAt: Scalars['DateTime']['output'];
  grantedByCompany: CompanyProfile;
  grantedByUser: Maybe<UserProfile>;
  grantedToCompany: CompanyProfile;
  permissions: VehiclePermissions;
  vehicle: VehicleProfile;
};

export type VehicleGrantConnection = {
  __typename: 'VehicleGrantConnection';
  edges: Maybe<Array<Maybe<VehicleGrantEdge>>>;
  pageInfo: PageInfo;
};

export type VehicleGrantEdge = {
  __typename: 'VehicleGrantEdge';
  cursor: Maybe<Scalars['String']['output']>;
  node: Maybe<VehicleGrant>;
};

export type VehicleGrantPartner = {
  __typename: 'VehicleGrantPartner';
  company: CompanyProfile;
  grantCount: Scalars['Int']['output'];
};

export type VehicleGrantPartnerGrantCountArgs = {
  permissions?: InputMaybe<VehiclePermissionsInput>;
};

export type VehicleGrantPartnerConnection = {
  __typename: 'VehicleGrantPartnerConnection';
  edges: Maybe<Array<Maybe<VehicleGrantPartnerEdge>>>;
  pageInfo: PageInfo;
};

export type VehicleGrantPartnerEdge = {
  __typename: 'VehicleGrantPartnerEdge';
  cursor: Maybe<Scalars['String']['output']>;
  node: Maybe<VehicleGrantPartner>;
};

export type VehicleGrantVisibilityInput = {
  grantedByCompanyId: Scalars['String']['input'];
  grantedToCompanyId: Scalars['String']['input'];
  isConstantPositionAccessAllowed: Scalars['Boolean']['input'];
  vehicleId: Scalars['String']['input'];
};

export type VehicleHistory = {
  __typename: 'VehicleHistory';
  company: Maybe<CompanyProfile>;
  created_at: Maybe<Scalars['String']['output']>;
  hdg: Maybe<Scalars['Float']['output']>;
  lat: Scalars['Float']['output'];
  lng: Scalars['Float']['output'];
  modeChangesLeft: Maybe<Scalars['Int']['output']>;
  received_at: Maybe<Scalars['String']['output']>;
  source: Maybe<HistorySource>;
  timestamp: Scalars['DateTime']['output'];
  type: Maybe<HistoryType>;
  vehicleTracker: Maybe<VehicleTracker>;
  vehicleType: Maybe<Scalars['String']['output']>;
};

export type VehicleHistoryCustomer = {
  __typename: 'VehicleHistoryCustomer';
  heading: Maybe<Scalars['Float']['output']>;
  latitude: Scalars['Float']['output'];
  longitude: Scalars['Float']['output'];
  metainfo: VehicleStatusMetainfo;
  speed: Maybe<Scalars['Float']['output']>;
  timestamp: Scalars['DateTime']['output'];
};

export type VehicleHistoryDownload = {
  __typename: 'VehicleHistoryDownload';
  isTruncated: Scalars['Boolean']['output'];
  rows: Array<VehicleHistoryDownloadRow>;
};

export type VehicleHistoryDownloadRow = {
  __typename: 'VehicleHistoryDownloadRow';
  companyId: Maybe<Scalars['String']['output']>;
  isExtendedTrail: Scalars['Boolean']['output'];
  latitude: Scalars['Float']['output'];
  licensePlateNumber: Maybe<Scalars['String']['output']>;
  longitude: Scalars['Float']['output'];
  positionReceivedAt: Maybe<Scalars['DateTime']['output']>;
  source: Maybe<HistorySource>;
  telematicsIntegrationId: Maybe<Scalars['String']['output']>;
  telematicsProviderName: Maybe<Scalars['String']['output']>;
  timestamp: Scalars['DateTime']['output'];
  type: Maybe<HistoryType>;
  vehicleId: Scalars['String']['output'];
};

export type VehicleHistoryEntry = {
  __typename: 'VehicleHistoryEntry';
  history: Array<VehicleHistory>;
  vehicle_id: Scalars['String']['output'];
};

export type VehicleHistoryPolyline = {
  __typename: 'VehicleHistoryPolyline';
  metadata: VehicleHistoryPolylineMetadata;
  polyline: Polyline;
};

export type VehicleHistoryPolylineMetadata = {
  __typename: 'VehicleHistoryPolylineMetadata';
  endTime: Scalars['DateTime']['output'];
  isExtendedTrail: Scalars['Boolean']['output'];
  /** @deprecated Use isExtendedTrail */
  isTroubleshootingRange: Scalars['Boolean']['output'];
  startTime: Scalars['DateTime']['output'];
  type: VehicleHistoryPolylineType;
  vehicleId: Scalars['String']['output'];
};

export enum VehicleHistoryPolylineType {
  TELEMETRY = 'TELEMETRY',
  TELEMETRY_GAP = 'TELEMETRY_GAP',
}

export enum VehicleMapState {
  ALLOCATED_BREAK = 'ALLOCATED_BREAK',
  ALLOCATED_MOVING = 'ALLOCATED_MOVING',
  LONG_BREAK = 'LONG_BREAK',
  STALE_GPS = 'STALE_GPS',
  UNALLOCATED_BREAK = 'UNALLOCATED_BREAK',
  UNALLOCATED_MOVING = 'UNALLOCATED_MOVING',
}

export type VehiclePermissions = {
  __typename: 'VehiclePermissions';
  withConstantPositionAccess: Scalars['Boolean']['output'];
};

export type VehiclePermissionsInput = {
  withConstantPositionAccess: Scalars['Boolean']['input'];
};

export type VehiclePosition = {
  __typename: 'VehiclePosition';
  lat: Scalars['Float']['output'];
  lng: Scalars['Float']['output'];
  receivedAt: Maybe<Scalars['DateTime']['output']>;
  vehicleId: Scalars['String']['output'];
};

export type VehicleProfile = {
  __typename: 'VehicleProfile';
  alternativeIdentifier: Maybe<Scalars['String']['output']>;
  alternativeIdentifierId: Maybe<Scalars['String']['output']>;
  isOutsideOfTransportPool: Maybe<Scalars['Boolean']['output']>;
  license_plate_number: Maybe<Scalars['String']['output']>;
  timeBasedStatus: Maybe<TimeBasedStatus>;
  vehicle_id: Scalars['String']['output'];
};

export type VehicleProfileConnection = {
  __typename: 'VehicleProfileConnection';
  edges: Maybe<Array<Maybe<VehicleProfileEdge>>>;
  pageInfo: PageInfo;
};

export type VehicleProfileEdge = {
  __typename: 'VehicleProfileEdge';
  cursor: Maybe<Scalars['String']['output']>;
  node: Maybe<VehicleProfile>;
};

export type VehicleSelectionInput = {
  filter?: InputMaybe<CompanyVehiclesFilterInput>;
  mode: VehicleSelectionMode;
  vehicleIds: Array<Scalars['String']['input']>;
};

export enum VehicleSelectionMode {
  EXCLUDE = 'EXCLUDE',
  INCLUDE = 'INCLUDE',
}

export enum VehicleSignalSource {
  CARRIER_API = 'CARRIER_API',
  FMS = 'FMS',
  MOBILE = 'MOBILE',
  PLATFORM_API = 'PLATFORM_API',
  PLATFORM_RTV_API = 'PLATFORM_RTV_API',
  TTC = 'TTC',
  TTC_MOBILE = 'TTC_MOBILE',
}

export enum VehicleState {
  ALLOCATED = 'ALLOCATED',
  ON_BREAK = 'ON_BREAK',
  UNALLOCATED = 'UNALLOCATED',
}

export type VehicleStateFilterInput = {
  breakDurationInMinutes?: InputMaybe<Scalars['Int']['input']>;
  vehicleState: VehicleState;
};

export type VehicleStatus = {
  __typename: 'VehicleStatus';
  accuracyInMeters: Maybe<Scalars['Float']['output']>;
  heading: Maybe<Scalars['Float']['output']>;
  latitude: Maybe<Scalars['Float']['output']>;
  longitude: Maybe<Scalars['Float']['output']>;
  timestamp: Maybe<Scalars['DateTime']['output']>;
  vehicle_id: Scalars['String']['output'];
};

export type VehicleStatusMetainfo = {
  __typename: 'VehicleStatusMetainfo';
  fuelLevelLiters: Maybe<Scalars['Float']['output']>;
  fuelLevelPct: Maybe<Scalars['Float']['output']>;
  fuelUsedLiters: Maybe<Scalars['Float']['output']>;
  fuelUsedPct: Maybe<Scalars['Float']['output']>;
};

export type VehicleTemperature = {
  __typename: 'VehicleTemperature';
  compartmentName: Scalars['String']['output'];
  sensors: Array<TemperatureSensor>;
};

export enum VehicleTemperatureEventLevel {
  TOUR = 'TOUR',
  VEHICLE = 'VEHICLE',
}

export type VehicleTemperatureOutOfRange = {
  __typename: 'VehicleTemperatureOutOfRange';
  duration: Scalars['Int']['output'];
  durationUnit: ComparisonUnit;
  maxTemperature: Maybe<Scalars['Float']['output']>;
  minTemperature: Maybe<Scalars['Float']['output']>;
  resolutionNotificationEnabled: Scalars['Boolean']['output'];
  temperatureUnit: Maybe<VehicleTemperatureOutOfRangeTemperatureUnit>;
};

export type VehicleTemperatureOutOfRangeInput = {
  duration: Scalars['Int']['input'];
  durationUnit: ComparisonUnit;
  maxTemperature?: InputMaybe<Scalars['Float']['input']>;
  minTemperature?: InputMaybe<Scalars['Float']['input']>;
  resolutionNotificationEnabled: Scalars['Boolean']['input'];
  temperatureUnit?: InputMaybe<VehicleTemperatureOutOfRangeTemperatureUnit>;
};

export enum VehicleTemperatureOutOfRangeTemperatureUnit {
  C = 'C',
  F = 'F',
}

export type VehicleTemperatureSensorReading = {
  __typename: 'VehicleTemperatureSensorReading';
  compartmentDoorOpen: Maybe<Scalars['Boolean']['output']>;
  compartmentId: Scalars['String']['output'];
  sensorId: Scalars['String']['output'];
  temperatureCelsius: Scalars['Float']['output'];
};

export enum VehicleTemperatureSource {
  CARRIER_API = 'CARRIER_API',
  FMS = 'FMS',
  IOT_TRACKER = 'IOT_TRACKER',
  MOBILE = 'MOBILE',
  PLATFORM_API = 'PLATFORM_API',
  PLATFORM_RTV_API = 'PLATFORM_RTV_API',
}

export type VehicleTemperatureVisibilitySource = {
  __typename: 'VehicleTemperatureVisibilitySource';
  eventLevel: VehicleTemperatureEventLevel;
  eventOrigin: Maybe<Scalars['String']['output']>;
  platformId: Maybe<Scalars['String']['output']>;
  primaryEventSource: VehicleTemperatureSource;
  sourceCompanyId: Maybe<Scalars['String']['output']>;
};

export type VehicleTracker = FmsVehicleTracker | MobileVehicleTracker;

export type VehicleTrackerSearchResult = {
  __typename: 'VehicleTrackerSearchResult';
  licensePlate: Scalars['String']['output'];
  remoteId: Scalars['String']['output'];
  telematicsIntegrationId: Scalars['String']['output'];
  vehicleId: Scalars['String']['output'];
  vehicleTrackerId: Scalars['String']['output'];
};

export type VehicleTrackerTour = {
  __typename: 'VehicleTrackerTour';
  shipper: Maybe<CompanyProfile>;
  shipper_transport_number: Maybe<Scalars['String']['output']>;
  startTime: Maybe<Scalars['DateTime']['output']>;
  status: Maybe<Scalars['String']['output']>;
  stops: Array<VehicleTrackerTourStop>;
  tour_id: Scalars['Int']['output'];
};

export type VehicleTrackerTourConnection = {
  __typename: 'VehicleTrackerTourConnection';
  edges: Maybe<Array<Maybe<VehicleTrackerTourEdge>>>;
  pageInfo: PageInfo;
};

export type VehicleTrackerTourEdge = {
  __typename: 'VehicleTrackerTourEdge';
  cursor: Maybe<Scalars['String']['output']>;
  node: Maybe<VehicleTrackerTour>;
};

export type VehicleTrackerTourStop = {
  __typename: 'VehicleTrackerTourStop';
  actual_arrival_time: Maybe<Scalars['DateTime']['output']>;
  arrival_delay_in_seconds: Maybe<Scalars['Int']['output']>;
  /** @deprecated Use actual_arrival_time instead */
  arrival_time: Maybe<Scalars['DateTime']['output']>;
  departure_time: Maybe<Scalars['DateTime']['output']>;
  estimated_arrival_time: Maybe<Scalars['DateTime']['output']>;
  location: Maybe<TourLocation>;
  sequence_number: Scalars['Int']['output'];
  status: Maybe<Scalars['String']['output']>;
  stop_id: Scalars['Int']['output'];
  timeslot: Maybe<Timeslot>;
  type: Maybe<Scalars['String']['output']>;
};

export enum VehicleTrackerType {
  FMS_DEVICE = 'FMS_DEVICE',
  MOBILE_APP = 'MOBILE_APP',
}

export enum VehicleType {
  BARGE = 'BARGE',
  PLANE = 'PLANE',
  RAIL = 'RAIL',
  TERMINAL = 'TERMINAL',
  TRACTOR = 'TRACTOR',
  TRAILER = 'TRAILER',
  UNKNOWN = 'UNKNOWN',
  VESSEL = 'VESSEL',
}

export type VesselNameFilterInput = {
  current?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  fromPol?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  toPod?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type VesselNameFilterOutput = {
  __typename: 'VesselNameFilterOutput';
  current: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  fromPol: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  toPod: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type VesselPosition = {
  __typename: 'VesselPosition';
  heading: Maybe<Scalars['Float']['output']>;
  latitude: Scalars['Float']['output'];
  longitude: Scalars['Float']['output'];
  timestamp: Scalars['DateTime']['output'];
};

export type VesselRoutePolyline = {
  __typename: 'VesselRoutePolyline';
  endTime: Scalars['DateTime']['output'];
  polyline: Polyline;
  startTime: Scalars['DateTime']['output'];
  type: Scalars['String']['output'];
};

export enum ViewMode {
  PROVIDING_VISIBILITY = 'PROVIDING_VISIBILITY',
  RECEIVING_VISIBILITY = 'RECEIVING_VISIBILITY',
}

export enum ViewerCompanyType {
  CARRIER = 'CARRIER',
  SHIPPER = 'SHIPPER',
}

export type VisibilityAgentChatResult = {
  __typename: 'VisibilityAgentChatResult';
  conversationId: Scalars['String']['output'];
  error: Maybe<VisibilityAgentResponseError>;
  messageId: Maybe<Scalars['String']['output']>;
  metadata: VisibilityAgentResponseMetadata;
  response: Scalars['String']['output'];
};

export type VisibilityAgentConversation = {
  __typename: 'VisibilityAgentConversation';
  conversationId: Scalars['String']['output'];
  title: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type VisibilityAgentConversationCreated = {
  __typename: 'VisibilityAgentConversationCreated';
  conversationId: Scalars['String']['output'];
};

export type VisibilityAgentConversationMessages = {
  __typename: 'VisibilityAgentConversationMessages';
  conversationId: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  messages: Array<VisibilityAgentMessage>;
  pageInfo: VisibilityAgentPageInfo;
  title: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  userId: Scalars['String']['output'];
};

export type VisibilityAgentConversationsResponse = {
  __typename: 'VisibilityAgentConversationsResponse';
  conversations: Array<VisibilityAgentConversation>;
  pageInfo: VisibilityAgentPageInfo;
};

export type VisibilityAgentFeedbackResult = {
  __typename: 'VisibilityAgentFeedbackResult';
  createdAt: Scalars['DateTime']['output'];
  feedbackText: Maybe<Scalars['String']['output']>;
  feedbackType: VisibilityAgentFeedbackType;
  id: Scalars['String']['output'];
  messageId: Scalars['String']['output'];
};

export enum VisibilityAgentFeedbackType {
  negative = 'negative',
  positive = 'positive',
}

export type VisibilityAgentMessage = {
  __typename: 'VisibilityAgentMessage';
  content: Scalars['String']['output'];
  conversationId: Scalars['String']['output'];
  messageId: Scalars['String']['output'];
  metadata: Maybe<VisibilityAgentMessageMetadata>;
  role: Scalars['String']['output'];
  timestamp: Scalars['DateTime']['output'];
};

export type VisibilityAgentMessageMetadata = {
  __typename: 'VisibilityAgentMessageMetadata';
  intent: Maybe<Scalars['String']['output']>;
  tokensUsed: Maybe<Scalars['Int']['output']>;
  toolsUsed: Maybe<Array<Scalars['String']['output']>>;
};

export type VisibilityAgentPageInfo = {
  __typename: 'VisibilityAgentPageInfo';
  cursor: Maybe<Scalars['String']['output']>;
};

export type VisibilityAgentResponseError = {
  __typename: 'VisibilityAgentResponseError';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  recoverable: Scalars['Boolean']['output'];
  suggestions: Maybe<Array<Scalars['String']['output']>>;
};

export type VisibilityAgentResponseMetadata = {
  __typename: 'VisibilityAgentResponseMetadata';
  intent: Maybe<Scalars['String']['output']>;
  reasoning: Maybe<Scalars['String']['output']>;
  responseTime: Scalars['Float']['output'];
  route: Maybe<Scalars['String']['output']>;
  tokensUsed: Scalars['Int']['output'];
  toolsUsed: Array<Scalars['String']['output']>;
};

export type VisibilityAgentValidationError = {
  __typename: 'VisibilityAgentValidationError';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  recoverable: Scalars['Boolean']['output'];
  suggestions: Maybe<Array<Scalars['String']['output']>>;
};

export type VisibilityIssue = {
  __typename: 'VisibilityIssue';
  index: Scalars['Float']['output'];
  type: VisibilityIssueType;
};

export enum VisibilityIssueType {
  EARLY_LOADING_VISIT = 'EARLY_LOADING_VISIT',
  INFREQUENT_TELEMETRY = 'INFREQUENT_TELEMETRY',
  LATE_ALLOCATION = 'LATE_ALLOCATION',
  LATE_TELEMETRY = 'LATE_TELEMETRY',
  MISSING_TELEMETRY = 'MISSING_TELEMETRY',
  NO_VEHICLE_ALLOCATED = 'NO_VEHICLE_ALLOCATED',
  UNVISITED_STOPS = 'UNVISITED_STOPS',
  VEHICLE_NOT_INTEGRATED = 'VEHICLE_NOT_INTEGRATED',
}

export type VisibilityPerformanceFilter = {
  __typename: 'VisibilityPerformanceFilter';
  assignedToUserIds: Maybe<Array<Scalars['String']['output']>>;
  carrierIds: Maybe<Array<Scalars['String']['output']>>;
  customFields: Maybe<Array<TourCustomFieldSearchType>>;
  customerIds: Maybe<Array<Scalars['String']['output']>>;
  endTime: Maybe<DateTimeRange>;
  failureReasons: Maybe<Array<TourFailureReasonType>>;
  hasTelemetry: Maybe<Scalars['Boolean']['output']>;
  isAllocated: Maybe<Scalars['Boolean']['output']>;
  isTracked: Maybe<Scalars['Boolean']['output']>;
  mainCarrierIds: Maybe<Array<Scalars['String']['output']>>;
  placeIds: Maybe<Array<Scalars['String']['output']>>;
  shipperIds: Maybe<Array<Scalars['String']['output']>>;
  siteIds: Maybe<Array<Scalars['String']['output']>>;
  startTime: Maybe<DateTimeRange>;
  stopCountries: Maybe<Array<Scalars['String']['output']>>;
  stopFilters: Maybe<Array<StopFilterOutput>>;
  stopStates: Maybe<Array<CompanyStopStates>>;
};

export type VisibilityPerformanceFilterInput = {
  allocationLateMinutes?: InputMaybe<NumericFilterInput>;
  assignedToUserIds?: InputMaybe<Array<Scalars['String']['input']>>;
  carrierIds?: InputMaybe<Array<Scalars['String']['input']>>;
  customFields?: InputMaybe<Array<TourCustomFieldSearch>>;
  customerIds?: InputMaybe<Array<Scalars['String']['input']>>;
  endTime?: InputMaybe<DateTimeRangeInput>;
  etaCount?: InputMaybe<NumericFilterInput>;
  eventVisitedStopCount?: InputMaybe<NumericFilterInput>;
  externalArrivalEventAverageDelayMinutes?: InputMaybe<NumericFilterInput>;
  externalEtaCount?: InputMaybe<NumericFilterInput>;
  failureReasons?: InputMaybe<Array<TourFailureReasonType>>;
  hasAllStopsArrivedRealTime?: InputMaybe<Scalars['Boolean']['input']>;
  hasArrivalsToAllStops?: InputMaybe<Scalars['Boolean']['input']>;
  hasEtaToAllStops?: InputMaybe<Scalars['Boolean']['input']>;
  hasTelemetry?: InputMaybe<Scalars['Boolean']['input']>;
  isAllocated?: InputMaybe<Scalars['Boolean']['input']>;
  isTracked?: InputMaybe<Scalars['Boolean']['input']>;
  isTrackedRealTimeFull?: InputMaybe<Scalars['Boolean']['input']>;
  mainCarrierIds?: InputMaybe<Array<Scalars['String']['input']>>;
  movingDurationHours?: InputMaybe<NumericFilterInput>;
  movingPingsCount?: InputMaybe<NumericFilterInput>;
  movingPingsPerHour?: InputMaybe<NumericFilterInput>;
  placeIds?: InputMaybe<Array<Scalars['String']['input']>>;
  realTimeStopArrivalsCount?: InputMaybe<NumericFilterInput>;
  realTimeTrackingFraction?: InputMaybe<NumericFilterInput>;
  shipperIds?: InputMaybe<Array<Scalars['String']['input']>>;
  siteIds?: InputMaybe<Array<Scalars['String']['input']>>;
  smartBreakVisitedStopCount?: InputMaybe<NumericFilterInput>;
  startTime?: InputMaybe<DateTimeRangeInput>;
  statuses?: InputMaybe<Array<TourStatusFilter>>;
  stopCount?: InputMaybe<NumericFilterInput>;
  stopCountries?: InputMaybe<Array<Scalars['String']['input']>>;
  stopFilters?: InputMaybe<Array<StopFilterInput>>;
  stopStates?: InputMaybe<Array<StopStatesInput>>;
  stopsWithEtaCount?: InputMaybe<NumericFilterInput>;
  stopsWithExternalEtaCount?: InputMaybe<NumericFilterInput>;
  telemetryConsistencyPercentage?: InputMaybe<NumericFilterInput>;
  telemetryLateMinutes?: InputMaybe<NumericFilterInput>;
  telemetryVisitedStopCount?: InputMaybe<NumericFilterInput>;
  tourIds?: InputMaybe<Array<Scalars['String']['input']>>;
  tourSegmentsCount?: InputMaybe<NumericFilterInput>;
  tourSegmentsPingCount?: InputMaybe<NumericFilterInput>;
  transportMode?: InputMaybe<Array<TourFilteringTransportMode>>;
  tripsCarrierNames?: InputMaybe<Array<Scalars['String']['input']>>;
  visitedStopCount?: InputMaybe<NumericFilterInput>;
};

export type VisibilityPerformanceOverview = {
  __typename: 'VisibilityPerformanceOverview';
  companies: VisibilityPerformanceOverviewConnection;
  currentPeriod: Maybe<ResolvedDateTimeRange>;
  previousPeriod: Maybe<ResolvedDateTimeRange>;
  previousPeriodTotalMetrics: Maybe<VisibilityPerformanceOverviewMetrics>;
  reportDownloadURI: Maybe<Scalars['String']['output']>;
  reportMaxRows: Maybe<Scalars['Int']['output']>;
  totalMetrics: Maybe<VisibilityPerformanceOverviewMetrics>;
};

export type VisibilityPerformanceOverviewReportDownloadUriArgs = {
  timezone?: InputMaybe<Scalars['IANATimezone']['input']>;
};

export type VisibilityPerformanceOverviewAggregateByInput = {
  failureReason?: InputMaybe<OrderedAggregateByInput>;
  isTracked?: InputMaybe<OrderedAggregateByInput>;
  startTime?: InputMaybe<TimeAggregateByInput>;
  visibilityProviderForViewer?: InputMaybe<OrderedAggregateByInput>;
  visibilityReceiverFromViewer?: InputMaybe<OrderedAggregateByInput>;
};

export type VisibilityPerformanceOverviewAggregateInput = {
  aggregateBy?: InputMaybe<VisibilityPerformanceOverviewAggregateByInput>;
  aggregations?: InputMaybe<Array<VisibilityPerformanceOverviewAggregationType>>;
};

export enum VisibilityPerformanceOverviewAggregationType {
  allStopsHaveEtaFraction = 'allStopsHaveEtaFraction',
  allStopsVisitedFraction = 'allStopsVisitedFraction',
  allStopsVisitedRealtimeFraction = 'allStopsVisitedRealtimeFraction',
  allocatedFraction = 'allocatedFraction',
  avgMeanTelemetryDelayMinutes = 'avgMeanTelemetryDelayMinutes',
  avgMovingPingsPerHour = 'avgMovingPingsPerHour',
  avgTelemetryConsistency = 'avgTelemetryConsistency',
  completedFraction = 'completedFraction',
  completedTourCount = 'completedTourCount',
  eventVisitedStopsFraction = 'eventVisitedStopsFraction',
  onTimeAllocationFraction = 'onTimeAllocationFraction',
  realTimeVisitedStopsFraction = 'realTimeVisitedStopsFraction',
  smartBreakVisitedStopsFraction = 'smartBreakVisitedStopsFraction',
  telemetryVisitedStopsFraction = 'telemetryVisitedStopsFraction',
  totalStopCount = 'totalStopCount',
  totalStopsWithEtaFraction = 'totalStopsWithEtaFraction',
  totalStopsWithExternalEtaFraction = 'totalStopsWithExternalEtaFraction',
  tourCount = 'tourCount',
  trackedFraction = 'trackedFraction',
  trackedTourCount = 'trackedTourCount',
  transportsWithTelemetryFraction = 'transportsWithTelemetryFraction',
  visitedStopsFraction = 'visitedStopsFraction',
}

export type VisibilityPerformanceOverviewConnection = {
  __typename: 'VisibilityPerformanceOverviewConnection';
  companies: VisibilityPerformanceOverviewRowConnection;
};

export type VisibilityPerformanceOverviewConnectionCompaniesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type VisibilityPerformanceOverviewMetrics = {
  __typename: 'VisibilityPerformanceOverviewMetrics';
  allStopsHaveEtaFraction: Maybe<Scalars['Float']['output']>;
  allStopsVisitedFraction: Maybe<Scalars['Float']['output']>;
  allStopsVisitedRealtimeFraction: Maybe<Scalars['Float']['output']>;
  allocatedFraction: Maybe<Scalars['Float']['output']>;
  avgMeanTelemetryDelayMinutes: Maybe<Scalars['Float']['output']>;
  avgMovingPingsPerHour: Maybe<Scalars['Float']['output']>;
  avgTelemetryConsistency: Maybe<Scalars['Float']['output']>;
  completedFraction: Maybe<Scalars['Float']['output']>;
  completedTourCount: Maybe<Scalars['Int']['output']>;
  eventVisitedStopsFraction: Maybe<Scalars['Float']['output']>;
  onTimeAllocationFraction: Maybe<Scalars['Float']['output']>;
  realTimeVisitedStopsFraction: Maybe<Scalars['Float']['output']>;
  smartBreakVisitedStopsFraction: Maybe<Scalars['Float']['output']>;
  telemetryVisitedStopsFraction: Maybe<Scalars['Float']['output']>;
  totalStopCount: Scalars['Int']['output'];
  totalStopsWithEtaFraction: Maybe<Scalars['Float']['output']>;
  totalStopsWithExternalEtaFraction: Maybe<Scalars['Float']['output']>;
  tourCount: Scalars['Int']['output'];
  trackedFraction: Maybe<Scalars['Float']['output']>;
  trackedTourCount: Maybe<Scalars['Int']['output']>;
  transportsWithTelemetryFraction: Maybe<Scalars['Float']['output']>;
  visitedStopsFraction: Maybe<Scalars['Float']['output']>;
};

export type VisibilityPerformanceOverviewRow = {
  __typename: 'VisibilityPerformanceOverviewRow';
  companyId: Maybe<Scalars['String']['output']>;
  companyName: Maybe<Scalars['String']['output']>;
  companySignupStatus: Maybe<UnifiedCompanySignupStatus>;
  /**
   * Context describing whether the carrier relationship's onboarding status
   * was reverted (e.g. rolled back to "Visibility source pending"). Computed
   * from the same relationship-level transitions as
   * `CarrierNetworkItem.statusContext` in the data network API, so the
   * warning matches the Visibility Control Center. Used by customer-web to
   * render the "status reverted" warning icon in the Analytics → Road
   * Visibility Performance Carrier table.
   */
  companySignupStatusContext: Maybe<CarrierNetworkStatusContext>;
  failureReason: Maybe<TourFailureReasonType>;
  key: Array<Scalars['String']['output']>;
  metrics: VisibilityPerformanceOverviewMetrics;
  relationIdentifiers: Maybe<Array<RelationIdentifier>>;
};

export type VisibilityPerformanceOverviewRowConnection = {
  __typename: 'VisibilityPerformanceOverviewRowConnection';
  edges: Maybe<Array<Maybe<VisibilityPerformanceOverviewRowEdge>>>;
  pageInfo: PageInfo;
};

export type VisibilityPerformanceOverviewRowEdge = {
  __typename: 'VisibilityPerformanceOverviewRowEdge';
  cursor: Maybe<Scalars['String']['output']>;
  node: Maybe<VisibilityPerformanceOverviewRow>;
};

export enum VisibilityPerformanceOverviewSortKey {
  allStopsHaveEtaFraction = 'allStopsHaveEtaFraction',
  allStopsVisitedFraction = 'allStopsVisitedFraction',
  allStopsVisitedRealtimeFraction = 'allStopsVisitedRealtimeFraction',
  allocatedFraction = 'allocatedFraction',
  avgMovingPingsPerHour = 'avgMovingPingsPerHour',
  completedFraction = 'completedFraction',
  onTimeAllocationFraction = 'onTimeAllocationFraction',
  tourCount = 'tourCount',
  trackedFraction = 'trackedFraction',
}

export type VisibilityPerformanceOverviewSortOrderInput = {
  direction: SortDirection;
  key: VisibilityPerformanceOverviewSortKey;
};

export enum VisibilityReportTimeUnit {
  DAY = 'DAY',
  HOUR = 'HOUR',
  MINUTE = 'MINUTE',
  MONTH = 'MONTH',
  QUARTER = 'QUARTER',
  WEEK = 'WEEK',
}

export type VisibilitySegment = {
  __typename: 'VisibilitySegment';
  vehicleId: Scalars['String']['output'];
  visibilityEndDate: Scalars['DateTime']['output'];
  visibilityStartDate: Scalars['DateTime']['output'];
};

export enum VisibilityService {
  VISIBILITY_AIR = 'VISIBILITY_AIR',
  VISIBILITY_CARBON = 'VISIBILITY_CARBON',
  VISIBILITY_INLAND = 'VISIBILITY_INLAND',
  VISIBILITY_OCEAN = 'VISIBILITY_OCEAN',
  VISIBILITY_RAIL = 'VISIBILITY_RAIL',
  VISIBILITY_ROAD = 'VISIBILITY_ROAD',
}

export enum VolumeUnit {
  CUBIC_FEET = 'CUBIC_FEET',
  CUBIC_METERS = 'CUBIC_METERS',
  GALLONS = 'GALLONS',
  LITERS = 'LITERS',
  OUNCES = 'OUNCES',
}

export enum WebhookPayloadContentType {
  JSON = 'JSON',
  XML = 'XML',
}

export enum WeightUnit {
  GRAMS = 'GRAMS',
  KILOGRAMS = 'KILOGRAMS',
  METRIC_TONS = 'METRIC_TONS',
  OUNCES = 'OUNCES',
  POUNDS = 'POUNDS',
  SHORT_TONS = 'SHORT_TONS',
}

export type Widget = {
  __typename: 'Widget';
  dashboardId: Scalars['String']['output'];
  filters: Array<WidgetFilter>;
  filtersV2: Array<WidgetFilterV2>;
  name: Maybe<Scalars['String']['output']>;
  type: WidgetType;
  widgetId: Scalars['String']['output'];
  widgetResult: Maybe<Scalars['String']['output']>;
};

export type WidgetConnection = {
  __typename: 'WidgetConnection';
  edges: Maybe<Array<Maybe<WidgetEdge>>>;
  pageInfo: PageInfo;
};

export type WidgetEdge = {
  __typename: 'WidgetEdge';
  cursor: Maybe<Scalars['String']['output']>;
  node: Maybe<Widget>;
};

export type WidgetFilter = {
  __typename: 'WidgetFilter';
  filter: TourFilter;
  tourCount: Scalars['Int']['output'];
};

export type WidgetFilterInput = {
  filter: TourFilterInput;
};

export type WidgetFilterInputV2 = {
  filter?: InputMaybe<Scalars['GraphQLJSON']['input']>;
};

export type WidgetFilterV2 = {
  __typename: 'WidgetFilterV2';
  filter: Scalars['GraphQLJSON']['output'];
  tourCount: Scalars['Int']['output'];
};

export type WidgetPreview = {
  __typename: 'WidgetPreview';
  filters: Array<WidgetFilter>;
  filtersV2: Array<WidgetFilterV2>;
  widgetResult: Maybe<Scalars['String']['output']>;
};

export enum WidgetType {
  COUNT = 'COUNT',
  RATIO = 'RATIO',
}

export type WithdrawCompanyInvitationInput = {
  companyInvitationId: Scalars['String']['input'];
};

export type WithdrawCompanyInvitationResult = {
  __typename: 'WithdrawCompanyInvitationResult';
  success: Scalars['Boolean']['output'];
};

export enum WorkingStopStatusFilter {
  AT_LOADING = 'AT_LOADING',
  AT_UNLOADING = 'AT_UNLOADING',
  TOWARDS_LOADING = 'TOWARDS_LOADING',
  TOWARDS_UNLOADING = 'TOWARDS_UNLOADING',
}

export type OceanPortOptionsQueryVariables = Exact<{
  companyId: Scalars['String']['input'];
  type: OceanPortLocationType;
  transportMode: TripsTransportMode;
  textSearch?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;

export type OceanPortOptionsQuery = {
  viewer:
    | ({
        user_id: string;
        company:
          | ({
              company_id: string;
              oceanPortOptions: Array<{ locode: string; name: string } & { __typename: 'OceanPortOption' }>;
            } & { __typename: 'Company' })
          | null;
      } & { __typename: 'User' })
    | null;
} & { __typename: 'Query' };

export type CreateCompanyAnalyticsFilterMutationVariables = Exact<{
  companyFilterInput: CreateCompanyAnalyticsFilterInput;
}>;

export type CreateCompanyAnalyticsFilterMutation = {
  createCompanyAnalyticsFilter:
    | ({ companyAnalyticsFilterId: string; name: string; visibilityType: CompanyAnalyticsFilterVisibility } & {
        __typename: 'CompanyAnalyticsFilter';
      })
    | null;
} & { __typename: 'Mutation' };

export type DeleteCompanyAnalyticsFilterMutationVariables = Exact<{
  companyAnalyticsFilterId: Scalars['String']['input'];
}>;

export type DeleteCompanyAnalyticsFilterMutation = { deleteCompanyAnalyticsFilter: boolean | null } & {
  __typename: 'Mutation';
};

export type TrackingPerformanceCompaniesQueryVariables = Exact<{
  viewMode: ViewMode;
  companyId: Scalars['String']['input'];
  carrierIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  customerIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  siteIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  startTimeEnd?: InputMaybe<Scalars['DateTime']['input']>;
  startTimeStart: Scalars['DateTime']['input'];
  startTimeSugarTimezone?: InputMaybe<Scalars['IANATimezone']['input']>;
  endTimeStart?: InputMaybe<Scalars['DateTime']['input']>;
  endTimeEnd?: InputMaybe<Scalars['DateTime']['input']>;
  endTimeSugarTimezone?: InputMaybe<Scalars['IANATimezone']['input']>;
  aggregate: VisibilityPerformanceOverviewAggregateInput;
  stopFilters?: InputMaybe<Array<StopFilterInput> | StopFilterInput>;
  customFields?: InputMaybe<Array<TourCustomFieldSearch> | TourCustomFieldSearch>;
  assignedToUserIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  failureReasons?: InputMaybe<Array<TourFailureReasonType> | TourFailureReasonType>;
  sort?: InputMaybe<VisibilityPerformanceOverviewSortOrderInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['IANATimezone']['input']>;
}>;

export type TrackingPerformanceCompaniesQuery = {
  viewer:
    | ({
        user_id: string;
        company:
          | ({
              company_id: string;
              visibilityPerformanceOverview:
                | ({
                    reportDownloadURI: string | null;
                    reportMaxRows: number | null;
                    companies: {
                      companies: {
                        edges: Array<
                          | ({
                              node:
                                | ({
                                    key: Array<string>;
                                    companyId: string | null;
                                    companyName: string | null;
                                    companySignupStatus: UnifiedCompanySignupStatus | null;
                                    companySignupStatusContext:
                                      | ({
                                          type: CarrierNetworkStatusContextType;
                                          transitionedAt: string;
                                          previousStatus: CarrierNetworkStatus;
                                        } & { __typename: 'CarrierNetworkStatusContext' })
                                      | null;
                                    metrics: {
                                      tourCount: number;
                                      totalStopCount: number;
                                      totalStopsWithEtaFraction: number | null;
                                      totalStopsWithExternalEtaFraction: number | null;
                                      allocatedFraction: number | null;
                                      trackedFraction: number | null;
                                      completedFraction: number | null;
                                      allStopsVisitedFraction: number | null;
                                      allStopsVisitedRealtimeFraction: number | null;
                                      allStopsHaveEtaFraction: number | null;
                                      transportsWithTelemetryFraction: number | null;
                                      avgMovingPingsPerHour: number | null;
                                      avgTelemetryConsistency: number | null;
                                      onTimeAllocationFraction: number | null;
                                      visitedStopsFraction: number | null;
                                      realTimeVisitedStopsFraction: number | null;
                                      telemetryVisitedStopsFraction: number | null;
                                      eventVisitedStopsFraction: number | null;
                                      smartBreakVisitedStopsFraction: number | null;
                                    } & { __typename: 'VisibilityPerformanceOverviewMetrics' };
                                    relationIdentifiers: Array<
                                      { companyIdentifierId: string; identifierValue: string } & {
                                        __typename: 'RelationIdentifier';
                                      }
                                    > | null;
                                  } & { __typename: 'VisibilityPerformanceOverviewRow' })
                                | null;
                            } & { __typename: 'VisibilityPerformanceOverviewRowEdge' })
                          | null
                        > | null;
                        pageInfo: { hasNextPage: boolean; startCursor: string | null; endCursor: string | null } & {
                          __typename: 'PageInfo';
                        };
                      } & { __typename: 'VisibilityPerformanceOverviewRowConnection' };
                    } & { __typename: 'VisibilityPerformanceOverviewConnection' };
                  } & { __typename: 'VisibilityPerformanceOverview' })
                | null;
            } & { __typename: 'Company' })
          | null;
      } & { __typename: 'User' })
    | null;
} & { __typename: 'Query' };

export type TrackingPerformanceTransportsQueryVariables = Exact<{
  viewMode: ViewMode;
  companyId: Scalars['String']['input'];
  carrierIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  customerIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  siteIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  startTimeEnd?: InputMaybe<Scalars['DateTime']['input']>;
  startTimeStart: Scalars['DateTime']['input'];
  startTimeSugarTimezone?: InputMaybe<Scalars['IANATimezone']['input']>;
  endTimeStart?: InputMaybe<Scalars['DateTime']['input']>;
  endTimeEnd?: InputMaybe<Scalars['DateTime']['input']>;
  endTimeSugarTimezone?: InputMaybe<Scalars['IANATimezone']['input']>;
  stopFilters?: InputMaybe<Array<StopFilterInput> | StopFilterInput>;
  customFields?: InputMaybe<Array<TourCustomFieldSearch> | TourCustomFieldSearch>;
  assignedToUserIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  failureReasons?: InputMaybe<Array<TourFailureReasonType> | TourFailureReasonType>;
  sort?: InputMaybe<TourVisibilityPerformanceListSortOrderInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['IANATimezone']['input']>;
}>;

export type TrackingPerformanceTransportsQuery = {
  viewer:
    | ({
        user_id: string;
        company:
          | ({
              company_id: string;
              tourVisibilityPerformance:
                | ({
                    reportDownloadURI: string | null;
                    reportMaxRows: number | null;
                    tourMetrics: {
                      edges: Array<
                        | ({
                            node:
                              | ({
                                  tour_id: string | null;
                                  is_tracked: boolean | null;
                                  is_allocated: boolean | null;
                                  has_telemetry: boolean | null;
                                  stop_count: number | null;
                                  start_time: string | null;
                                  status: string | null;
                                  shipper_transport_number: string | null;
                                  real_time_stop_arrivals_count: number | null;
                                  has_all_stops_arrived_real_time: boolean | null;
                                  allocation_late_minutes: number | null;
                                  allocation_timeliness_percentage: number | null;
                                  external_arrival_event_average_delay_minutes: number | null;
                                  has_arrivals_to_all_stops: boolean | null;
                                  visited_stop_count: number | null;
                                  telemetry_visited_stop_count: number | null;
                                  event_visited_stop_count: number | null;
                                  smart_break_visited_stop_count: number | null;
                                  has_eta_to_all_stops: boolean | null;
                                  eta_count: number | null;
                                  stops_with_eta_count: number | null;
                                  external_eta_count: number | null;
                                  moving_duration_hours: number | null;
                                  moving_pings_count: number | null;
                                  moving_pings_per_hour: number | null;
                                  tour_segments_count: number | null;
                                  tour_segments_ping_count: number | null;
                                  failure_type: TourFailureReasonType | null;
                                  telemetry_consistency_percentage: number | null;
                                  mean_telemetry_delay_minutes: number | null;
                                  licensePlateNumber: string | null;
                                  allocationSource: TourVehicleAllocationSource | null;
                                  locationDataSource: TourSignalSource | null;
                                  forwardeeCompanyName: string | null;
                                  forwarderCompanyName: string | null;
                                  isTourDeleted: boolean | null;
                                  forwardeeSignupStatus: UnifiedCompanySignupStatus | null;
                                  carrierIsConnected: boolean | null;
                                  carrierSCAC: string | null;
                                  forwardeeSignupStatusContext:
                                    | ({
                                        type: CarrierNetworkStatusContextType;
                                        transitionedAt: string;
                                        previousStatus: CarrierNetworkStatus;
                                      } & { __typename: 'CarrierNetworkStatusContext' })
                                    | null;
                                } & { __typename: 'TourMetricsListRow' })
                              | null;
                          } & { __typename: 'TourMetricsListRowEdge' })
                        | null
                      > | null;
                      pageInfo: { hasNextPage: boolean; startCursor: string | null; endCursor: string | null } & {
                        __typename: 'PageInfo';
                      };
                    } & { __typename: 'TourMetricsListRowConnection' };
                  } & { __typename: 'TourVisibilityPerformance' })
                | null;
            } & { __typename: 'Company' })
          | null;
      } & { __typename: 'User' })
    | null;
} & { __typename: 'Query' };

export type TrackingPerformanceScorecardsQueryVariables = Exact<{
  viewMode: ViewMode;
  companyId: Scalars['String']['input'];
  carrierIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  customerIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  siteIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  startTimeEnd?: InputMaybe<Scalars['DateTime']['input']>;
  startTimeStart: Scalars['DateTime']['input'];
  startTimeSugarTimezone?: InputMaybe<Scalars['IANATimezone']['input']>;
  endTimeStart?: InputMaybe<Scalars['DateTime']['input']>;
  endTimeEnd?: InputMaybe<Scalars['DateTime']['input']>;
  endTimeSugarTimezone?: InputMaybe<Scalars['IANATimezone']['input']>;
  stopFilters?: InputMaybe<Array<StopFilterInput> | StopFilterInput>;
  customFields?: InputMaybe<Array<TourCustomFieldSearch> | TourCustomFieldSearch>;
  assignedToUserIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  failureReasons?: InputMaybe<Array<TourFailureReasonType> | TourFailureReasonType>;
  timezone?: InputMaybe<Scalars['IANATimezone']['input']>;
}>;

export type TrackingPerformanceScorecardsQuery = {
  viewer:
    | ({
        user_id: string;
        company:
          | ({
              company_id: string;
              visibilityPerformanceOverview:
                | ({
                    totalMetrics:
                      | ({
                          tourCount: number;
                          trackedTourCount: number | null;
                          trackedFraction: number | null;
                          allocatedFraction: number | null;
                          completedFraction: number | null;
                          completedTourCount: number | null;
                          avgMovingPingsPerHour: number | null;
                          realTimeVisitedStopsFraction: number | null;
                        } & { __typename: 'VisibilityPerformanceOverviewMetrics' })
                      | null;
                    previousPeriodTotalMetrics:
                      | ({
                          tourCount: number;
                          trackedTourCount: number | null;
                          trackedFraction: number | null;
                          allocatedFraction: number | null;
                          completedFraction: number | null;
                          completedTourCount: number | null;
                          avgMovingPingsPerHour: number | null;
                          realTimeVisitedStopsFraction: number | null;
                        } & { __typename: 'VisibilityPerformanceOverviewMetrics' })
                      | null;
                    currentPeriod: ({ start: string; end: string } & { __typename: 'ResolvedDateTimeRange' }) | null;
                    previousPeriod: ({ start: string; end: string } & { __typename: 'ResolvedDateTimeRange' }) | null;
                  } & { __typename: 'VisibilityPerformanceOverview' })
                | null;
            } & { __typename: 'Company' })
          | null;
      } & { __typename: 'User' })
    | null;
} & { __typename: 'Query' };

export type TrackingPerformanceSummaryQueryVariables = Exact<{
  viewMode: ViewMode;
  companyId: Scalars['String']['input'];
  carrierIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  customerIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  siteIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  startTimeEnd?: InputMaybe<Scalars['DateTime']['input']>;
  startTimeStart: Scalars['DateTime']['input'];
  startTimeSugarTimezone?: InputMaybe<Scalars['IANATimezone']['input']>;
  endTimeStart?: InputMaybe<Scalars['DateTime']['input']>;
  endTimeEnd?: InputMaybe<Scalars['DateTime']['input']>;
  endTimeSugarTimezone?: InputMaybe<Scalars['IANATimezone']['input']>;
  aggregate: VisibilityPerformanceOverviewAggregateInput;
  stopFilters?: InputMaybe<Array<StopFilterInput> | StopFilterInput>;
  customFields?: InputMaybe<Array<TourCustomFieldSearch> | TourCustomFieldSearch>;
  assignedToUserIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  failureReasons?: InputMaybe<Array<TourFailureReasonType> | TourFailureReasonType>;
  first?: InputMaybe<Scalars['Int']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
}>;

export type TrackingPerformanceSummaryQuery = {
  viewer:
    | ({
        user_id: string;
        company:
          | ({
              company_id: string;
              visibilityPerformanceOverview:
                | ({
                    companies: {
                      companies: {
                        edges: Array<
                          | ({
                              node:
                                | ({
                                    key: Array<string>;
                                    companyId: string | null;
                                    failureReason: TourFailureReasonType | null;
                                    metrics: { tourCount: number } & {
                                      __typename: 'VisibilityPerformanceOverviewMetrics';
                                    };
                                  } & { __typename: 'VisibilityPerformanceOverviewRow' })
                                | null;
                            } & { __typename: 'VisibilityPerformanceOverviewRowEdge' })
                          | null
                        > | null;
                      } & { __typename: 'VisibilityPerformanceOverviewRowConnection' };
                    } & { __typename: 'VisibilityPerformanceOverviewConnection' };
                  } & { __typename: 'VisibilityPerformanceOverview' })
                | null;
            } & { __typename: 'Company' })
          | null;
      } & { __typename: 'User' })
    | null;
} & { __typename: 'Query' };

export type OceanPerformanceSummaryQueryVariables = Exact<{
  companyId: Scalars['String']['input'];
  completedFilter: Scalars['GraphQLJSON']['input'];
  inTransitFilter: Scalars['GraphQLJSON']['input'];
}>;

export type OceanPerformanceSummaryQuery = {
  viewer:
    | ({
        user_id: string;
        company:
          | ({
              company_id: string;
              oceanCompletedTours: { count: number } & { __typename: 'CountedTourConnection' };
              oceanInTransitTours: { count: number } & { __typename: 'CountedTourConnection' };
            } & { __typename: 'Company' })
          | null;
      } & { __typename: 'User' })
    | null;
} & { __typename: 'Query' };

export type OceanMilestonePerformanceQueryVariables = Exact<{
  companyId: Scalars['String']['input'];
  filter?: InputMaybe<Scalars['GraphQLJSON']['input']>;
}>;

export type OceanMilestonePerformanceQuery = {
  viewer:
    | ({
        user_id: string;
        company:
          | ({
              company_id: string;
              oceanMilestonePerformance: {
                totalContainers: number;
                locationTypeCounts: Array<
                  { locationType: string; count: number } & { __typename: 'OceanLocationTypeCount' }
                >;
                milestones: Array<
                  { locationType: string; milestoneQualifier: string; count: number } & {
                    __typename: 'OceanMilestonePerformanceRow';
                  }
                >;
              } & { __typename: 'OceanMilestonePerformanceResult' };
            } & { __typename: 'Company' })
          | null;
      } & { __typename: 'User' })
    | null;
} & { __typename: 'Query' };

export type OceanContainersTableQueryVariables = Exact<{
  companyId: Scalars['String']['input'];
  filter?: InputMaybe<Scalars['GraphQLJSON']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['IANATimezone']['input']>;
}>;

export type OceanContainersTableQuery = {
  viewer:
    | ({
        user_id: string;
        company:
          | ({
              company_id: string;
              tripsTours: {
                count: number;
                reportDownloadURI: string | null;
                tours: {
                  edges: Array<
                    | ({
                        cursor: string | null;
                        node:
                          | ({
                              tour_id: number;
                              shipper_transport_number: string | null;
                              containerNumber: string | null;
                              carrierName: string | null;
                              carrierCode: string | null;
                              status: string | null;
                              billOfLading: string | null;
                              bookingNumber: string | null;
                              site: ({ site_id: string; name: string } & { __typename: 'SiteProfile' }) | null;
                              milestones:
                                | ({
                                    locations: Array<
                                      {
                                        name: string;
                                        type: LocationType | null;
                                        milestones: Array<
                                          {
                                            qualifier: MilestoneQualifier | null;
                                            actualTimeOfArrival:
                                              | ({ dateTime: string; timezone: string } & {
                                                  __typename: 'DateTimeWithTimezone';
                                                })
                                              | null;
                                          } & { __typename: 'MilestoneWithLocation' }
                                        >;
                                      } & { __typename: 'MilestoneLocation' }
                                    >;
                                  } & { __typename: 'LocationsAndMilestones' })
                                | null;
                            } & { __typename: 'Tour' })
                          | null;
                      } & { __typename: 'TourEdge' })
                    | null
                  > | null;
                  pageInfo: { hasNextPage: boolean; endCursor: string | null } & { __typename: 'PageInfo' };
                } & { __typename: 'TourConnection' };
              } & { __typename: 'CountedTripsTourConnection' };
            } & { __typename: 'Company' })
          | null;
      } & { __typename: 'User' })
    | null;
} & { __typename: 'Query' };

export type CompanyAnalyticsFiltersQueryVariables = Exact<{
  companyId: Scalars['String']['input'];
  textSearch?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
}>;

export type CompanyAnalyticsFiltersQuery = {
  viewer:
    | ({
        user_id: string;
        company:
          | ({
              company_id: string;
              me: ({ role: UserRoleInCompany } & { __typename: 'UserInCompany' }) | null;
              companyAnalyticsFiltersConnection: {
                count: number;
                companyAnalyticsFilters: {
                  edges: Array<
                    | ({
                        node:
                          | ({
                              companyAnalyticsFilterId: string;
                              name: string;
                              visibilityType: CompanyAnalyticsFilterVisibility;
                              filterV2: {
                                shipperIds: Array<string> | null;
                                carrierIds: Array<string> | null;
                                customerIds: Array<string> | null;
                                mainCarrierIds: Array<string> | null;
                                siteIds: Array<string> | null;
                                stopCountries: Array<string> | null;
                                placeIds: Array<string> | null;
                                isTracked: boolean | null;
                                isAllocated: boolean | null;
                                assignedToUserIds: Array<string> | null;
                                failureReasons: Array<TourFailureReasonType> | null;
                                startTime:
                                  | ({ start: string | null; end: string | null; sugarTimezone: string | null } & {
                                      __typename: 'DateTimeRange';
                                    })
                                  | null;
                                endTime:
                                  | ({ start: string | null; end: string | null; sugarTimezone: string | null } & {
                                      __typename: 'DateTimeRange';
                                    })
                                  | null;
                                stopStates: Array<
                                  { state: string; country: string } & { __typename: 'CompanyStopStates' }
                                > | null;
                                customFields: Array<
                                  {
                                    fieldName: string;
                                    value: { values: Array<string> | null } & {
                                      __typename: 'TourCustomFieldSearchValueType';
                                    };
                                  } & { __typename: 'TourCustomFieldSearchType' }
                                > | null;
                                stopFilters: Array<
                                  {
                                    placeIds: Array<string> | null;
                                    bookingLocationNames: Array<string> | null;
                                    countries: Array<string> | null;
                                    stopTypes: Array<FilterRoadStopType> | null;
                                    companyNames: Array<string> | null;
                                    states: Array<
                                      { country: string; state: string } & { __typename: 'CompanyStopStates' }
                                    > | null;
                                    cities: Array<
                                      { city: string; country: string } & { __typename: 'CompanyStopCities' }
                                    > | null;
                                    postalCodes: Array<
                                      { postalCode: string; country: string } & { __typename: 'CompanyStopPostalCodes' }
                                    > | null;
                                  } & { __typename: 'StopFilterOutput' }
                                > | null;
                              } & { __typename: 'VisibilityPerformanceFilter' };
                            } & { __typename: 'CompanyAnalyticsFilter' })
                          | null;
                      } & { __typename: 'CompanyAnalyticsFilterEdge' })
                    | null
                  > | null;
                  pageInfo: { hasNextPage: boolean; endCursor: string | null } & { __typename: 'PageInfo' };
                } & { __typename: 'CompanyAnalyticsFilterConnection' };
              } & { __typename: 'CountedCompanyAnalyticsFilterConnection' };
            } & { __typename: 'Company' })
          | null;
      } & { __typename: 'User' })
    | null;
} & { __typename: 'Query' };

export type SessionViewerQueryVariables = Exact<{ [key: string]: never }>;

export type SessionViewerQuery = {
  viewer: ({ user_id: string } & { __typename: 'User' }) | null;
  sharedViewViewer: ({ viewerId: string } & { __typename: 'SharedViewViewer' }) | null;
} & { __typename: 'Query' };

export type ViewerCompanyQueryVariables = Exact<{
  companyId: Scalars['String']['input'];
}>;

export type ViewerCompanyQuery = {
  viewer:
    | ({
        user_id: string;
        company:
          | ({
              company_id: string;
              company_name: string | null;
              is_carrier: boolean | null;
              is_shipper: boolean | null;
              is_test: boolean | null;
              arePlacesEnabled: boolean | null;
              defaultVehicleDwellTimeThresholdMinutes: number | null;
              isVehicleHistoryUiEnabled: boolean;
              isVisibilityReportingVisible: boolean;
              isTrimbleVisibilityCustomer: boolean;
              roadToursCount: number;
              oceanToursCount: number;
              airToursCount: number;
              onboardingStatus: UnifiedCompanySignupStatus | null;
              isUIDisabled: boolean;
              isInvitationFlowDisabled: boolean;
              isVisibilityControlCenterDisabled: boolean;
              isMapVehicleLocationsEnabled: boolean;
              isRoadUiDisabled: boolean;
              isOceanMapViewEnabled: boolean;
              isEmailLoginEnabled: boolean;
              showNotesOnEveryTour: boolean;
              isFilesUploadEnabled: boolean;
              isStandalonePagesEnabled: boolean;
              isOceanUIEnabled: boolean;
              isAirUIEnabled: boolean;
              isInlandVisibilityEnabled: boolean;
              isOceanAnalyticsEnabled: boolean;
              isPolPodInTransportHeaderEnabled: boolean;
              isMaritimeIntelligenceEnabled: boolean;
              isTableExportConfigEnabled: boolean;
              isOceanTransportExcelUploadEnabled: boolean;
              isBulkTourUserAssignmentEnabled: boolean;
              settings: {
                allowAllocatingFromGlobalPool: boolean;
                enableAutoAllocation: boolean;
                enableAutoAllocationFullVisibility: boolean;
              } & { __typename: 'CompanySettings' };
              me:
                | ({
                    role: UserRoleInCompany;
                    profile: {
                      user_id: string;
                      first_name: string | null;
                      last_name: string | null;
                      email: string | null;
                    } & { __typename: 'UserProfile' };
                    transporeonPlatform: ({ userIdOnPlatform: string } & { __typename: 'UserOnPlatform' }) | null;
                    configuration: {
                      vehicleDwellTimeThresholdMinutes: number;
                      isUserSessionInvalidationOnUiInactivityEnabled: boolean;
                    } & { __typename: 'UserInCompanyConfiguration' };
                  } & { __typename: 'UserInCompany' })
                | null;
            } & { __typename: 'Company' })
          | null;
      } & { __typename: 'User' })
    | null;
} & { __typename: 'Query' };

export type ViewerCompaniesQueryVariables = Exact<{ [key: string]: never }>;

export type ViewerCompaniesQuery = {
  viewer:
    | ({
        user_id: string;
        companies: Array<
          {
            company_id: string;
            company_name: string | null;
            is_carrier: boolean | null;
            is_shipper: boolean | null;
            is_test: boolean | null;
            isTrimbleVisibilityCustomer: boolean;
            onboardingStatus: UnifiedCompanySignupStatus | null;
          } & { __typename: 'Company' }
        >;
      } & { __typename: 'User' })
    | null;
} & { __typename: 'Query' };

export type CompanyUsersQueryVariables = Exact<{
  companyId: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
}>;

export type CompanyUsersQuery = {
  viewer:
    | ({
        user_id: string;
        company:
          | ({
              company_id: string;
              is_shipper: boolean | null;
              isPresentOnTransporeonPlatform: boolean | null;
              users: {
                count: number;
                users: {
                  edges: Array<
                    | ({
                        node:
                          | ({
                              role: UserRoleInCompany;
                              profile: {
                                user_id: string;
                                first_name: string | null;
                                last_name: string | null;
                                email: string | null;
                              } & { __typename: 'UserProfile' };
                            } & { __typename: 'UserInCompanyProfile' })
                          | null;
                      } & { __typename: 'UserInCompanyProfileEdge' })
                    | null
                  > | null;
                  pageInfo: { hasNextPage: boolean; endCursor: string | null } & { __typename: 'PageInfo' };
                } & { __typename: 'UserInCompanyProfileConnection' };
              } & { __typename: 'CountedUserInCompanyProfileConnection' };
            } & { __typename: 'Company' })
          | null;
      } & { __typename: 'User' })
    | null;
} & { __typename: 'Query' };

export type RemoveUserFromCompanyMutationVariables = Exact<{
  input: RemoveUserFromCompanyInput;
}>;

export type RemoveUserFromCompanyMutation = { removeUserFromCompany: boolean | null } & { __typename: 'Mutation' };

export type ChangeUserRoleInCompanyMutationVariables = Exact<{
  input: ChangeUserRoleInCompanyInput;
}>;

export type ChangeUserRoleInCompanyMutation = {
  changeUserRoleInCompany:
    | ({
        role: UserRoleInCompany;
        profile: { user_id: string; first_name: string | null; last_name: string | null; email: string | null } & {
          __typename: 'UserProfile';
        };
      } & { __typename: 'UserInCompanyProfile' })
    | null;
} & { __typename: 'Mutation' };

export type AddUserToCompanyMutationVariables = Exact<{
  input: AddUserToCompanyInput;
}>;

export type AddUserToCompanyMutation = {
  addUserToCompany:
    | ({
        role: UserRoleInCompany;
        profile: { user_id: string; first_name: string | null; last_name: string | null; email: string | null } & {
          __typename: 'UserProfile';
        };
      } & { __typename: 'UserInCompanyProfile' })
    | null;
} & { __typename: 'Mutation' };

export type IsPresentOnTransporeonPlatformQueryVariables = Exact<{
  companyId: Scalars['String']['input'];
}>;

export type IsPresentOnTransporeonPlatformQuery = {
  viewer:
    | ({
        user_id: string;
        company:
          | ({ company_id: string; isPresentOnTransporeonPlatform: boolean | null } & { __typename: 'Company' })
          | null;
      } & { __typename: 'User' })
    | null;
} & { __typename: 'Query' };

export type UpdateUserInCompanyConfigurationMutationVariables = Exact<{
  input: UpdateUserInCompanyConfigurationInput;
}>;

export type UpdateUserInCompanyConfigurationMutation = {
  updateUserInCompanyConfiguration:
    | ({
        role: UserRoleInCompany;
        profile: { user_id: string; first_name: string | null; last_name: string | null; email: string | null } & {
          __typename: 'UserProfile';
        };
        configuration: { vehicleDwellTimeThresholdMinutes: number } & { __typename: 'UserInCompanyConfiguration' };
      } & { __typename: 'UserInCompany' })
    | null;
} & { __typename: 'Mutation' };

export type TourStopDetailsFragment = {
  tourStatus: string | null;
  latestSignalTimestamp: string | null;
  vehicleLicensePlateNumber: string | null;
  allocationDeviceType: TourAllocationDeviceType | null;
  shipperTransportNumber: string | null;
  stop: {
    stop_id: number;
    status: string | null;
    type: string | null;
    externalEtaSource: ExternalEtaSource | null;
    estimated_arrival_status: string | null;
    estimated_arrival_accuracy: string | null;
    estimated_arrival: string | null;
    estimated_arrival_distance_in_meters: number | null;
    estimated_arrival_delay_in_seconds: number | null;
    arrival_delay_in_seconds: number | null;
    arrival_time: string | null;
    departure_time: string | null;
    deadline: string | null;
    display_sequence_number: number;
    display_actual_sequence_number: number;
    sequence_number: number | null;
    actual_sequence_number: number | null;
    location:
      | ({
          name: string | null;
          location_id: string | null;
          bookingLocationName: string | null;
          gate: string | null;
          gate_id: string | null;
          address:
            | ({ full_address: string | null; city: string | null; country: string | null } & { __typename: 'Address' })
            | null;
          position: ({ lat: number | null; lng: number | null } & { __typename: 'GeoPosition' }) | null;
        } & { __typename: 'TourLocation' })
      | null;
    deliveries: Array<
      {
        deliveryId: string;
        deliveryNumber: string | null;
        orderNumber: string | null;
        purchaseOrderNumber: string | null;
        customFields: Array<
          {
            fieldName: string;
            visibility: string | null;
            values: Array<{ value: string } & { __typename: 'CustomFieldValue' }>;
          } & { __typename: 'CustomField' }
        >;
      } & { __typename: 'TourDelivery' }
    >;
    timeslot:
      | ({ begin: string | null; end: string | null; timezone: string | null } & { __typename: 'Timeslot' })
      | null;
    originalTimeslot: ({ begin: string | null; end: string | null } & { __typename: 'SimpleTimeslot' }) | null;
    revisedTimeslot: ({ begin: string | null; end: string | null } & { __typename: 'SimpleTimeslot' }) | null;
    stopContacts: Array<
      {
        contactNames: Array<string>;
        phoneNumbers: Array<string>;
        emailAddresses: Array<string>;
        phoneNumberExtensions: Array<string>;
      } & { __typename: 'StopContact' }
    >;
    geofenceZones: Array<
      {
        zone: GeofenceZoneType;
        geofence:
          | ({
              type: GeofenceType;
              radiusInMeters: number;
              origin: { lat: number; lng: number } & { __typename: 'Position' };
            } & { __typename: 'GeofenceCircle' })
          | ({ type: GeofenceType; points: Array<{ lat: number; lng: number } & { __typename: 'Position' }> } & {
              __typename: 'GeofencePolygon';
            });
      } & { __typename: 'GeofenceZone' }
    >;
    exceptions: Array<
      | ({
          exceptionId: string;
          description: string;
          stopId: string | null;
          type: string;
          deliveryIds: Array<string>;
          createdAt: string;
          source: ExceptionSource;
          exceptionFiles: Array<
            { documentUrl: string; platformDocumentId: string; description: string | null } & {
              __typename: 'ExceptionFile';
            }
          >;
        } & { __typename: 'DeliveryException' })
      | ({ exceptionId: string; code: string; description: string; time: string; source: ExceptionSource } & {
          __typename: 'ServiceException';
        })
    >;
  } & { __typename: 'TourStop' };
  vehicleStatus:
    | ({
        latitude: number | null;
        longitude: number | null;
        heading: number | null;
        timestamp: string | null;
        accuracyInMeters: number | null;
      } & { __typename: 'VehicleStatus' })
    | null;
  shipper: ({ company_id: string; company_name: string | null } & { __typename: 'CompanyProfile' }) | null;
  transportContactDetails: Array<
    {
      firstName: string | null;
      lastName: string | null;
      emails: Array<string | null>;
      phones: Array<string | null>;
      customText: string | null;
    } & { __typename: 'CompanyTransportContactDetails' }
  >;
} & { __typename: 'SharedTourStop' };

export type TokenResourcesQueryVariables = Exact<{ [key: string]: never }>;

export type TokenResourcesQuery = {
  token:
    | ({
        tourStop:
          | ({
              stop: {
                deliveries: Array<
                  {
                    orderItems: Array<
                      {
                        orderItemId: string;
                        orderItemName: string | null;
                        pieceCount: number | null;
                        pieceDescription: string | null;
                        pieceUnit: PieceUnit | null;
                        volume: number | null;
                        volumeUnit: VolumeUnit | null;
                        weightAmount: number | null;
                        weightUnit: WeightUnit | null;
                        isHazardous: boolean | null;
                        itemHeight: number | null;
                        itemLength: number | null;
                        itemWidth: number | null;
                        linearUnit: LinearUnit | null;
                        orderItemCustomFields: Array<
                          { name: string; value: string } & { __typename: 'OrderItemCustomField' }
                        > | null;
                      } & { __typename: 'OrderItem' }
                    > | null;
                  } & { __typename: 'TourDelivery' }
                >;
                documents: Array<
                  {
                    documentId: string;
                    stopId: string | null;
                    documentType: DocumentType;
                    documentUrl: string;
                    internalDownloadUrl: string | null;
                    storageFileId: string;
                    description: string | null;
                    createdAt: string;
                    fileSize: number | null;
                    associatedDeliveries: Array<
                      { deliveryId: string; deliveryNumber: string | null } & { __typename: 'TourDelivery' }
                    >;
                    createdBy:
                      | ({ firstName: string | null; lastName: string | null } & { __typename: 'DocumentCreator' })
                      | null;
                  } & { __typename: 'Document' }
                >;
                notes: Array<
                  {
                    noteId: string;
                    stopId: string | null;
                    noteText: string;
                    noteVisibility: NoteVisibility;
                    isEditable: boolean | null;
                    noteSentToDriver: boolean;
                    creatorCompanyId: string | null;
                    creatorCompanyName: string | null;
                    noteOrigin: NoteOrigin;
                    createdBy: NoteCreatedBy;
                    createdAt: string;
                    updatedAt: string;
                    associatedDeliveries: Array<
                      { deliveryId: string; deliveryNumber: string | null } & { __typename: 'TourDelivery' }
                    >;
                  } & { __typename: 'Note' }
                >;
              } & { __typename: 'TourStop' };
            } & TourStopDetailsFragment & { __typename: 'SharedTourStop' })
          | null;
        tourDelivery:
          | ({ tourStop: (TourStopDetailsFragment & { __typename: 'SharedTourStop' }) | null } & {
              __typename: 'SharedTourDelivery';
            })
          | null;
        branding:
          | ({
              background: ({ url: string } & { __typename: 'TokenBrandingAsset' }) | null;
              logo: ({ url: string } & { __typename: 'TokenBrandingAsset' }) | null;
            } & { __typename: 'TokenBrandingAssets' })
          | null;
      } & { __typename: 'TokenResources' })
    | null;
} & { __typename: 'Query' };

export type TrackTokenViewMutationVariables = Exact<{ [key: string]: never }>;

export type TrackTokenViewMutation = { trackTokenView: boolean } & { __typename: 'Mutation' };

export type ResourceTypeFromTokenQueryVariables = Exact<{ [key: string]: never }>;

export type ResourceTypeFromTokenQuery = {
  token: ({ resourceType: TokenResourceType } & { __typename: 'TokenResources' }) | null;
} & { __typename: 'Query' };

export type SaveCustomerFeedbackMutationVariables = Exact<{
  input: SaveCustomerFeedbackInput;
}>;

export type SaveCustomerFeedbackMutation = { saveCustomerFeedback: boolean | null } & { __typename: 'Mutation' };

export type CustomerPortalBrandingFragment = {
  branding:
    | ({
        background: ({ url: string } & { __typename: 'TokenBrandingAsset' }) | null;
        logo: ({ url: string } & { __typename: 'TokenBrandingAsset' }) | null;
      } & { __typename: 'TokenBrandingAssets' })
    | null;
} & { __typename: 'TokenResources' };

export type CustomerPortalTourDetailsFragment = {
  tour_id: number;
  created_at: string;
  shipper_transport_number: string | null;
  bill_of_lading: string | null;
  transportIdentifiers: Array<string> | null;
  status: string | null;
  working_stop_id: number | null;
  start_time: string | null;
  visibility_start_time: string | null;
  visibleTrackingStartTime: string | null;
  visibility_end_time: string | null;
  hasTemperatureData: boolean | null;
  isTrailRetentionExpired: boolean;
  transport_id: string | null;
  platform_shipper_id: string | null;
  platform_carrier_id: string | null;
  allocationType: TourVehicleAllocationType | null;
  visibilityServices: Array<VisibilityService>;
  canBeModified: boolean;
  isGlobalAllocation: boolean;
  isGloballyAllocatedToViewerCompany: boolean;
  warnings: Array<
    {
      type: TourWarningType;
      severity: TourWarningSeverity | null;
      metadata: { [key: string]: string | number | boolean } | null;
    } & { __typename: 'TourWarning' }
  >;
  carrier: ({ company_id: string; company_name: string | null } & { __typename: 'CompanyProfile' }) | null;
  shipper: ({ company_id: string; company_name: string | null } & { __typename: 'CompanyProfile' }) | null;
  subcontractor: ({ company_id: string; company_name: string | null } & { __typename: 'CompanyProfile' }) | null;
  vehicleHistory: Array<
    {
      polyline: { points: string } & { __typename: 'Polyline' };
      metadata: {
        isExtendedTrail: boolean;
        type: VehicleHistoryPolylineType;
        startTime: string;
        endTime: string;
        vehicleId: string;
      } & { __typename: 'VehicleHistoryPolylineMetadata' };
    } & { __typename: 'VehicleHistoryPolyline' }
  > | null;
  trackedVehicles: Array<
    { vehicleId: string; vehicleLicensePlateNumber: string | null } & { __typename: 'TrackedVehicle' }
  >;
  vehicle_status:
    | ({
        timestamp: string | null;
        latitude: number | null;
        longitude: number | null;
        heading: number | null;
        accuracyInMeters: number | null;
      } & { __typename: 'VehicleStatus' })
    | null;
  failureReason: ({ type: TourFailureReasonType } & { __typename: 'TourFailureReason' }) | null;
  currentVehicle:
    | ({ vehicleId: string | null; vehicleLicensePlateNumber: string | null } & { __typename: 'VehicleAllocation' })
    | null;
  vehicleAllocations: Array<
    { vehicleId: string | null; vehicleLicensePlateNumber: string | null } & { __typename: 'TourVehicleAllocation' }
  >;
  activeVehicleAllocation:
    | ({
        vehicleId: string | null;
        vehicleLicensePlateNumber: string | null;
        vehicleTrackerTypes: Array<VehicleTrackerType> | null;
        allocationDeviceType: TourAllocationDeviceType | null;
        remoteTrackerId: string | null;
        matchedAlternativeIdentifier: string | null;
      } & { __typename: 'TourVehicleAllocation' })
    | null;
  visibleVehicleBreakHistory: Array<
    {
      vehicle_id: string;
      breaks: Array<
        {
          breakId: string;
          from: string;
          to: string | null;
          center: { lat: number; lng: number } & { __typename: 'BreakCenterPosition' };
        } & { __typename: 'VehicleBreakHistory' }
      >;
    } & { __typename: 'VehicleBreakHistoryEntry' }
  > | null;
  route:
    | ({
        legs: Array<
          {
            polyline: { points: string } & { __typename: 'Polyline' };
            metadata: { isExtendedRoute: boolean } & { __typename: 'RouteLegMetadata' };
          } & { __typename: 'RouteLeg' }
        >;
      } & { __typename: 'Route' })
    | null;
  latestSignal: ({ source: TourSignalSource; timestamp: string } & { __typename: 'TourSignal' }) | null;
  customFields: Array<
    { fieldName: string; values: Array<{ value: string } & { __typename: 'CustomFieldValue' }> } & {
      __typename: 'CustomField';
    }
  >;
  stops: Array<
    {
      stop_id: number;
      status: string | null;
      type: string | null;
      display_sequence_number: number;
      display_actual_sequence_number: number;
      sequence_number: number | null;
      actual_sequence_number: number | null;
      externalEtaSource: ExternalEtaSource | null;
      estimated_arrival: string | null;
      estimated_arrival_status: string | null;
      estimated_arrival_accuracy: string | null;
      estimated_arrival_delay_in_seconds: number | null;
      estimated_arrival_distance_in_meters: number | null;
      arrival_delay_in_seconds: number | null;
      arrival_time: string | null;
      departure_time: string | null;
      deadline: string | null;
      geofenceZones?: Array<
        {
          zone: GeofenceZoneType;
          geofence:
            | ({
                type: GeofenceType;
                radiusInMeters: number;
                origin: { lat: number; lng: number } & { __typename: 'Position' };
              } & { __typename: 'GeofenceCircle' })
            | ({ type: GeofenceType; points: Array<{ lat: number; lng: number } & { __typename: 'Position' }> } & {
                __typename: 'GeofencePolygon';
              });
        } & { __typename: 'GeofenceZone' }
      >;
      timeslot:
        | ({ begin: string | null; end: string | null; timezone: string | null } & { __typename: 'Timeslot' })
        | null;
      originalTimeslot: ({ begin: string | null; end: string | null } & { __typename: 'SimpleTimeslot' }) | null;
      revisedTimeslot: ({ begin: string | null; end: string | null } & { __typename: 'SimpleTimeslot' }) | null;
      deliveries: Array<
        {
          deliveryId: string;
          deliveryNumber: string | null;
          orderNumber: string | null;
          purchaseOrderNumber: string | null;
          orderDate: string | null;
          orderItems: Array<
            {
              orderItemId: string;
              orderItemName: string | null;
              pieceCount: number | null;
              pieceDescription: string | null;
              pieceUnit: PieceUnit | null;
              volume: number | null;
              volumeUnit: VolumeUnit | null;
              weightAmount: number | null;
              weightUnit: WeightUnit | null;
              isHazardous: boolean | null;
              itemHeight: number | null;
              itemLength: number | null;
              itemWidth: number | null;
              linearUnit: LinearUnit | null;
              orderItemCustomFields: Array<
                { name: string; value: string } & { __typename: 'OrderItemCustomField' }
              > | null;
            } & { __typename: 'OrderItem' }
          > | null;
          customFields: Array<
            { fieldName: string; values: Array<{ value: string } & { __typename: 'CustomFieldValue' }> } & {
              __typename: 'CustomField';
            }
          >;
        } & { __typename: 'TourDelivery' }
      >;
      location:
        | ({
            location_id: string | null;
            name: string | null;
            bookingLocationName: string | null;
            gate: string | null;
            gate_id: string | null;
            address:
              | ({
                  full_address: string | null;
                  city: string | null;
                  country: string | null;
                  street_address: string | null;
                  state: string | null;
                  zipcode: string | null;
                  shortAreaCode: string | null;
                } & { __typename: 'Address' })
              | null;
            position:
              | ({ lat: number | null; lng: number | null; provider: string | null } & { __typename: 'GeoPosition' })
              | null;
          } & { __typename: 'TourLocation' })
        | null;
      stopContacts: Array<
        {
          contactNames: Array<string>;
          emailAddresses: Array<string>;
          phoneNumbers: Array<string>;
          phoneNumberExtensions: Array<string>;
        } & { __typename: 'StopContact' }
      >;
    } & { __typename: 'TourStop' }
  >;
  events: Array<
    | ({
        stop_id: number;
        tour_id: number;
        event_id: number;
        vehicle_id: string | null;
        vehicle_lat: number | null;
        vehicle_lng: number | null;
        vehicle_license_plate_number: string | null;
        event_index: number;
        event_time: string | null;
        created_at: string;
        stop_event_name: StopEventName;
        externalEventCreatedAt: string | null;
        visibilitySource:
          | ({
              primaryEventSource: TourVisibilitySourceType;
              streamPrecision: TourVisibilityPrecisionType | null;
              sourcePlatform:
                | ({ platform_id: string; platform_name: string } & { __typename: 'PlatformProfile' })
                | null;
            } & { __typename: 'TourVisibilitySource' })
          | null;
      } & { __typename: 'StopEvent' })
    | ({
        tour_id: number;
        event_id: number;
        vehicle_id: string | null;
        vehicle_lat: number | null;
        vehicle_lng: number | null;
        event_index: number;
        event_time: string | null;
        created_at: string;
        tour_event_name: TourEventName;
        warning:
          | ({ type: TourWarningType; severity: TourWarningSeverity | null } & { __typename: 'TourWarning' })
          | null;
        visibilitySource:
          | ({
              primaryEventSource: TourVisibilitySourceType;
              streamPrecision: TourVisibilityPrecisionType | null;
              sourcePlatform:
                | ({ platform_id: string; platform_name: string } & { __typename: 'PlatformProfile' })
                | null;
            } & { __typename: 'TourVisibilitySource' })
          | null;
      } & { __typename: 'TourEvent' })
  >;
  documents: Array<
    {
      documentId: string;
      stopId: string | null;
      documentType: DocumentType;
      documentUrl: string;
      internalDownloadUrl: string | null;
      storageFileId: string;
      description: string | null;
      createdAt: string;
      fileSize: number | null;
      associatedDeliveries: Array<
        { deliveryId: string; deliveryNumber: string | null } & { __typename: 'TourDelivery' }
      >;
      createdBy: ({ firstName: string | null; lastName: string | null } & { __typename: 'DocumentCreator' }) | null;
    } & { __typename: 'Document' }
  >;
  notes: Array<
    {
      noteId: string;
      stopId: string | null;
      noteText: string;
      noteVisibility: NoteVisibility;
      isEditable: boolean | null;
      noteSentToDriver: boolean;
      creatorCompanyId: string | null;
      creatorCompanyName: string | null;
      noteOrigin: NoteOrigin;
      createdBy: NoteCreatedBy;
      createdAt: string;
      updatedAt: string;
      associatedDeliveries: Array<
        { deliveryId: string; deliveryNumber: string | null } & { __typename: 'TourDelivery' }
      >;
    } & { __typename: 'Note' }
  >;
  exceptions: Array<
    | ({
        exceptionId: string;
        description: string;
        stopId: string | null;
        type: string;
        deliveryIds: Array<string>;
        createdAt: string;
        source: ExceptionSource;
        exceptionFiles: Array<
          { documentUrl: string; platformDocumentId: string; description: string | null } & {
            __typename: 'ExceptionFile';
          }
        >;
      } & { __typename: 'DeliveryException' })
    | ({ exceptionId: string; code: string; description: string; time: string; source: ExceptionSource } & {
        __typename: 'ServiceException';
      })
  >;
  transportContactDetails: Array<
    {
      firstName: string | null;
      lastName: string | null;
      emails: Array<string | null>;
      phones: Array<string | null>;
      customText: string | null;
    } & { __typename: 'CompanyTransportContactDetails' }
  >;
} & { __typename: 'Tour' };

export type ToursFromTokenQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  textSearch?: InputMaybe<TourTextSearch>;
}>;

export type ToursFromTokenQuery = {
  token:
    | ({
        sharedView:
          | ({
              isActive: boolean;
              owner: ({ company_name: string | null; company_id: string } & { __typename: 'CompanyProfile' }) | null;
              tours:
                | ({
                    count: number;
                    tours: {
                      edges: Array<
                        | ({ node: (ShipmentFragment & { __typename: 'Tour' }) | null } & { __typename: 'TourEdge' })
                        | null
                      > | null;
                      pageInfo: { hasNextPage: boolean; startCursor: string | null; endCursor: string | null } & {
                        __typename: 'PageInfo';
                      };
                    } & { __typename: 'TourConnection' };
                  } & { __typename: 'CountedTourConnection' })
                | null;
            } & { __typename: 'SharedViewConsignee' })
          | null;
      } & CustomerPortalBrandingFragment & { __typename: 'TokenResources' })
    | null;
} & { __typename: 'Query' };

export type TourFromTokenQueryVariables = Exact<{
  tourId: Scalars['String']['input'];
  skipGeofenceZones?: InputMaybe<Scalars['Boolean']['input']>;
  includeDeliveriesCustomFieldsInTourCustomFields?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type TourFromTokenQuery = {
  token:
    | ({
        sharedView:
          | ({
              isActive: boolean;
              owner: ({ company_name: string | null; company_id: string } & { __typename: 'CompanyProfile' }) | null;
              tour:
                | ({
                    temperatureAssets: Array<
                      {
                        isMainAsset: boolean;
                        vehicleId: string | null;
                        licensePlateNumber: string | null;
                        compartments: Array<
                          {
                            compartmentName: string;
                            sensors: Array<
                              {
                                name: string;
                                readings: Array<
                                  { timestamp: string; value: number } & { __typename: 'TemperatureSensorReading' }
                                >;
                              } & { __typename: 'TemperatureSensor' }
                            >;
                          } & { __typename: 'VehicleTemperature' }
                        >;
                      } & { __typename: 'TourTemperatureAsset' }
                    >;
                  } & CustomerPortalTourDetailsFragment & { __typename: 'Tour' })
                | null;
            } & { __typename: 'SharedViewConsignee' })
          | null;
      } & CustomerPortalBrandingFragment & { __typename: 'TokenResources' })
    | null;
} & { __typename: 'Query' };

export type TrackCustomerPortalViewMutationVariables = Exact<{ [key: string]: never }>;

export type TrackCustomerPortalViewMutation = { trackTokenView: boolean } & { __typename: 'Mutation' };

export type CreatePlatformSupportTicketMutationVariables = Exact<{
  input: CreatePlatformSupportTicketInput;
}>;

export type CreatePlatformSupportTicketMutation = { createPlatformSupportTicket: boolean | null } & {
  __typename: 'Mutation';
};

export type CreateVisibilitySolutionsTicketMutationVariables = Exact<{
  input: CreateVisibilitySolutionsTicketInput;
}>;

export type CreateVisibilitySolutionsTicketMutation = { createVisibilitySolutionsTicket: boolean | null } & {
  __typename: 'Mutation';
};

export type DashboardsQueryVariables = Exact<{
  companyId: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  queryType?: InputMaybe<DashboardQueryType>;
}>;

export type DashboardsQuery = {
  viewer:
    | ({
        user_id: string;
        company:
          | ({
              company_id: string;
              dashboardsConnection: {
                dashboards: {
                  edges: Array<
                    | ({
                        node:
                          | ({ dashboardId: string; name: string; isOwnedByMe: boolean } & { __typename: 'Dashboard' })
                          | null;
                      } & { __typename: 'DashboardEdge' })
                    | null
                  > | null;
                  pageInfo: { hasNextPage: boolean; endCursor: string | null } & { __typename: 'PageInfo' };
                } & { __typename: 'DashboardConnection' };
              } & { __typename: 'CountedDashboardsConnection' };
            } & { __typename: 'Company' })
          | null;
      } & { __typename: 'User' })
    | null;
} & { __typename: 'Query' };

export type DashboardsCountQueryVariables = Exact<{
  companyId: Scalars['String']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
}>;

export type DashboardsCountQuery = {
  viewer:
    | ({
        user_id: string;
        company:
          | ({
              company_id: string;
              createdByMe: { count: number } & { __typename: 'CountedDashboardsConnection' };
              sharedWithMe: { count: number } & { __typename: 'CountedDashboardsConnection' };
            } & { __typename: 'Company' })
          | null;
      } & { __typename: 'User' })
    | null;
} & { __typename: 'Query' };

export type DashboardsFirstIdQueryVariables = Exact<{
  companyId: Scalars['String']['input'];
}>;

export type DashboardsFirstIdQuery = {
  viewer:
    | ({
        user_id: string;
        company:
          | ({
              company_id: string;
              dashboardsConnection: {
                count: number;
                dashboards: {
                  edges: Array<
                    | ({ node: ({ dashboardId: string } & { __typename: 'Dashboard' }) | null } & {
                        __typename: 'DashboardEdge';
                      })
                    | null
                  > | null;
                } & { __typename: 'DashboardConnection' };
              } & { __typename: 'CountedDashboardsConnection' };
            } & { __typename: 'Company' })
          | null;
      } & { __typename: 'User' })
    | null;
} & { __typename: 'Query' };

export type DashboardFragment = {
  dashboardId: string;
  name: string;
  description: string | null;
  sharingType: DashboardSharingType;
  isOwnedByMe: boolean;
  canUserEdit: boolean;
  isExample: boolean;
  sharedWithUsers: Array<
    { user_id: string; email: string | null; first_name: string | null; last_name: string | null } & {
      __typename: 'UserProfile';
    }
  > | null;
  owner: { user_id: string; email: string | null; first_name: string | null; last_name: string | null } & {
    __typename: 'UserProfile';
  };
} & { __typename: 'Dashboard' };

export type DashboardQueryVariables = Exact<{
  companyId: Scalars['String']['input'];
  dashboardId: Scalars['String']['input'];
}>;

export type DashboardQuery = {
  viewer:
    | ({
        user_id: string;
        company:
          | ({ company_id: string; dashboard: (DashboardFragment & { __typename: 'Dashboard' }) | null } & {
              __typename: 'Company';
            })
          | null;
      } & { __typename: 'User' })
    | null;
} & { __typename: 'Query' };

export type CreateDashboardMutationVariables = Exact<{
  input: CreateDashboardInput;
}>;

export type CreateDashboardMutation = { createDashboard: (DashboardFragment & { __typename: 'Dashboard' }) | null } & {
  __typename: 'Mutation';
};

export type CreateExampleDashboardMutationVariables = Exact<{
  input: CreateExampleDashboardInput;
}>;

export type CreateExampleDashboardMutation = {
  createExampleDashboard: (DashboardFragment & { __typename: 'Dashboard' }) | null;
} & { __typename: 'Mutation' };

export type UpdateDashboardMutationVariables = Exact<{
  input: UpdateDashboardInput;
}>;

export type UpdateDashboardMutation = { updateDashboard: (DashboardFragment & { __typename: 'Dashboard' }) | null } & {
  __typename: 'Mutation';
};

export type DeleteDashboardMutationVariables = Exact<{
  dashboardId: Scalars['String']['input'];
}>;

export type DeleteDashboardMutation = { deleteDashboard: boolean | null } & { __typename: 'Mutation' };

export type CopyDashboardMutationVariables = Exact<{
  input: CopyDashboardInput;
}>;

export type CopyDashboardMutation = { copyDashboard: (DashboardFragment & { __typename: 'Dashboard' }) | null } & {
  __typename: 'Mutation';
};

export type CompanyQueryVariables = Exact<{
  companyId: Scalars['String']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
}>;

export type CompanyQuery = {
  viewer:
    | ({
        user_id: string;
        company:
          | ({
              company_id: string;
              users: {
                users: {
                  edges: Array<
                    | ({
                        node:
                          | ({
                              profile: {
                                user_id: string;
                                email: string | null;
                                first_name: string | null;
                                last_name: string | null;
                              } & { __typename: 'UserProfile' };
                            } & { __typename: 'UserInCompanyProfile' })
                          | null;
                      } & { __typename: 'UserInCompanyProfileEdge' })
                    | null
                  > | null;
                  pageInfo: { hasNextPage: boolean; endCursor: string | null } & { __typename: 'PageInfo' };
                } & { __typename: 'UserInCompanyProfileConnection' };
              } & { __typename: 'CountedUserInCompanyProfileConnection' };
            } & { __typename: 'Company' })
          | null;
      } & { __typename: 'User' })
    | null;
} & { __typename: 'Query' };

export type WidgetFragment = {
  widgetId: string;
  dashboardId: string;
  name: string | null;
  type: WidgetType;
  widgetResult: string | null;
  filters: Array<
    { tourCount: number; filter: FilterFragment & { __typename: 'TourFilter' } } & { __typename: 'WidgetFilter' }
  >;
} & { __typename: 'Widget' };

export type WidgetsQueryVariables = Exact<{
  companyId: Scalars['String']['input'];
  dashboardId: Scalars['String']['input'];
  timezone?: InputMaybe<Scalars['IANATimezone']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
}>;

export type WidgetsQuery = {
  viewer:
    | ({
        user_id: string;
        company:
          | ({
              company_id: string;
              dashboard:
                | ({
                    dashboardId: string;
                    widgets: {
                      count: number;
                      widgets: {
                        edges: Array<
                          | ({ node: (WidgetFragment & { __typename: 'Widget' }) | null } & {
                              __typename: 'WidgetEdge';
                            })
                          | null
                        > | null;
                        pageInfo: { hasNextPage: boolean; endCursor: string | null } & { __typename: 'PageInfo' };
                      } & { __typename: 'WidgetConnection' };
                    } & { __typename: 'CountedWidgetsConnection' };
                  } & { __typename: 'Dashboard' })
                | null;
            } & { __typename: 'Company' })
          | null;
      } & { __typename: 'User' })
    | null;
} & { __typename: 'Query' };

export type WidgetsPreviewQueryVariables = Exact<{
  companyId: Scalars['String']['input'];
  filters: Array<WidgetFilterInput> | WidgetFilterInput;
  type: WidgetType;
  operator?: InputMaybe<OperatorType>;
}>;

export type WidgetsPreviewQuery = {
  viewer:
    | ({
        user_id: string;
        company:
          | ({
              company_id: string;
              widgetPreview:
                | ({
                    widgetResult: string | null;
                    filters: Array<
                      { tourCount: number; filter: FilterFragment & { __typename: 'TourFilter' } } & {
                        __typename: 'WidgetFilter';
                      }
                    >;
                  } & { __typename: 'WidgetPreview' })
                | null;
            } & { __typename: 'Company' })
          | null;
      } & { __typename: 'User' })
    | null;
} & { __typename: 'Query' };

export type CreateWidgetMutationVariables = Exact<{
  input: CreateWidgetInput;
}>;

export type CreateWidgetMutation = { createWidget: (WidgetFragment & { __typename: 'Widget' }) | null } & {
  __typename: 'Mutation';
};

export type UpdateWidgetMutationVariables = Exact<{
  input: UpdateWidgetInput;
}>;

export type UpdateWidgetMutation = { updateWidget: (WidgetFragment & { __typename: 'Widget' }) | null } & {
  __typename: 'Mutation';
};

export type DeleteWidgetMutationVariables = Exact<{
  input: DeleteWidgetInput;
}>;

export type DeleteWidgetMutation = { deleteWidget: boolean | null } & { __typename: 'Mutation' };

export type CreateCompanyDataNetworkFilterMutationVariables = Exact<{
  companyFilterInput: CreateCompanyTransportNetworkFilterInput;
}>;

export type CreateCompanyDataNetworkFilterMutation = {
  createCompanyTransportNetworkFilter:
    | ({
        companyTransportNetworkFilterId: string;
        name: string;
        visibilityType: CompanyTransportNetworkFilterVisibility;
      } & { __typename: 'CompanyTransportNetworkFilter' })
    | null;
} & { __typename: 'Mutation' };

export type DeleteCompanyDataNetworkFilterMutationVariables = Exact<{
  companyTransportNetworkFilterId: Scalars['String']['input'];
}>;

export type DeleteCompanyDataNetworkFilterMutation = { deleteCompanyTransportNetworkFilter: boolean | null } & {
  __typename: 'Mutation';
};

export type InvitedCompanyQueryVariables = Exact<{
  companyId: Scalars['String']['input'];
  invitationId: Scalars['String']['input'];
}>;

export type InvitedCompanyQuery = {
  viewer:
    | ({
        user_id: string;
        company:
          | ({
              company_id: string;
              companyInvitation:
                | ({
                    companyInviteId: string;
                    companyName: string | null;
                    status: CompanyInviteStatus;
                    type: CompanyInviteType;
                    invitationLink: string | null;
                    recipients: Array<{ email: string; locale: string } & { __typename: 'CompanyInvitationRecipient' }>;
                    historyLog: Array<
                      {
                        type: InvitationHistoryLogItemType | null;
                        time: string;
                        performedByEmail: string | null;
                        inviteSentByLabel: string | null;
                        recipients: Array<
                          { email: string; locale: string } & { __typename: 'InvitationHistoryItemRecipient' }
                        > | null;
                      } & { __typename: 'InvitationHistoryItem' }
                    >;
                    identifiers: Array<
                      { companyIdentifierId: string; identifierValue: string } & { __typename: 'CompanyIdentifier' }
                    > | null;
                  } & { __typename: 'CompanyInvite' })
                | null;
            } & { __typename: 'Company' })
          | null;
      } & { __typename: 'User' })
    | null;
} & { __typename: 'Query' };

export type ProvidingVisibilityCompaniesQueryVariables = Exact<{
  companyId: Scalars['String']['input'];
  filter: ProvidingVisibilityCompaniesFilterInput;
  sort?: InputMaybe<ProvidingVisibilityCompaniesSortOrderInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
}>;

export type ProvidingVisibilityCompaniesQuery = {
  viewer:
    | ({
        user_id: string;
        company:
          | ({
              company_id: string;
              providingVisibilityCompanies:
                | ({
                    count: number;
                    companies: {
                      edges: Array<
                        | ({
                            node:
                              | ({
                                  companyId: string;
                                  companyName: string | null;
                                  dateAdded: string;
                                  tourStatusConsent: ConsentState;
                                  signupStatus: UnifiedCompanyRelationshipSignupStatus | null;
                                  companyIdentifiers: Array<
                                    {
                                      companyIdentifierId: string;
                                      identifierType: CompanyIdentifierType;
                                      identifierValue: string;
                                    } & { __typename: 'CompanyIdentifier' }
                                  >;
                                } & { __typename: 'ProvidingVisibilityCompany' })
                              | null;
                          } & { __typename: 'ProvidingVisibilityCompanyEdge' })
                        | null
                      > | null;
                      pageInfo: { hasNextPage: boolean; startCursor: string | null; endCursor: string | null } & {
                        __typename: 'PageInfo';
                      };
                    } & { __typename: 'ProvidingVisibilityCompanyConnection' };
                  } & { __typename: 'CountedProvidingVisibilityCompaniesConnection' })
                | null;
            } & { __typename: 'Company' })
          | null;
      } & { __typename: 'User' })
    | null;
} & { __typename: 'Query' };

export type ProvidingVisibilityCompanyQueryVariables = Exact<{
  companyId: Scalars['String']['input'];
  customerId: Scalars['String']['input'];
}>;

export type ProvidingVisibilityCompanyQuery = {
  viewer:
    | ({
        user_id: string;
        company:
          | ({
              company_id: string;
              canChangeTourStatusConsent: boolean;
              providingVisibilityCompany:
                | ({
                    companyId: string;
                    companyName: string | null;
                    dateAdded: string;
                    tourStatusConsent: ConsentState;
                    signupStatus: UnifiedCompanyRelationshipSignupStatus | null;
                    transporeonId: string | null;
                    vatNumbers: Array<{ vatNumber: string } & { __typename: 'CompanyVatNumber' }>;
                    companyIdentifiers: Array<
                      {
                        companyId: string;
                        companyIdentifierId: string;
                        identifierType: CompanyIdentifierType;
                        identifierValue: string;
                        discriminatorCountry: string | null;
                        source: string;
                      } & { __typename: 'CompanyIdentifier' }
                    >;
                  } & { __typename: 'ProvidingVisibilityCompany' })
                | null;
            } & { __typename: 'Company' })
          | null;
      } & { __typename: 'User' })
    | null;
} & { __typename: 'Query' };

export type SignupNetworkRelationStatisticsQueryVariables = Exact<{
  companyId: Scalars['String']['input'];
}>;

export type SignupNetworkRelationStatisticsQuery = {
  viewer:
    | ({
        user_id: string;
        company:
          | ({
              company_id: string;
              networkRelationStatistics: {
                companyCountsBySignupStatus: Array<
                  { count: number; signupStatus: UnifiedCompanyRelationshipSignupStatus | null } & {
                    __typename: 'CompanyCountBySignupStatus';
                  }
                >;
              } & { __typename: 'NetworkRelationStatistics' };
            } & { __typename: 'Company' })
          | null;
      } & { __typename: 'User' })
    | null;
} & { __typename: 'Query' };

export type CarrierNetworkStatisticsQueryVariables = Exact<{
  companyId: Scalars['String']['input'];
  bulkInvitationSetId?: InputMaybe<Scalars['String']['input']>;
}>;

export type CarrierNetworkStatisticsQuery = {
  viewer:
    | ({
        user_id: string;
        company:
          | ({
              company_id: string;
              notInvitedItems: ({ count: number } & { __typename: 'CountedCarrierNetworkConnection' }) | null;
              invitedItems: ({ count: number } & { __typename: 'CountedCarrierNetworkConnection' }) | null;
              registeredItems: ({ count: number } & { __typename: 'CountedCarrierNetworkConnection' }) | null;
              noVisibilitySourceItems: ({ count: number } & { __typename: 'CountedCarrierNetworkConnection' }) | null;
              onboardedItems: ({ count: number } & { __typename: 'CountedCarrierNetworkConnection' }) | null;
              archivedItems: ({ count: number } & { __typename: 'CountedCarrierNetworkConnection' }) | null;
              noVisibilitySourcePreviouslyOnboardedItems:
                | ({ count: number } & { __typename: 'CountedCarrierNetworkConnection' })
                | null;
            } & { __typename: 'Company' })
          | null;
      } & { __typename: 'User' })
    | null;
} & { __typename: 'Query' };

export type SignupNetworkRelationStatisticsByDateQueryVariables = Exact<{
  companyId: Scalars['String']['input'];
  firstDate: Scalars['String']['input'];
  secondDate: Scalars['String']['input'];
}>;

export type SignupNetworkRelationStatisticsByDateQuery = {
  viewer:
    | ({
        user_id: string;
        company:
          | ({
              company_id: string;
              networkRelationStatistics: {
                firstDateStatistics: Array<
                  { count: number; signupStatus: UnifiedCompanyRelationshipSignupStatus | null } & {
                    __typename: 'CompanyCountBySignupStatus';
                  }
                >;
                secondDateStatistics: Array<
                  { count: number; signupStatus: UnifiedCompanyRelationshipSignupStatus | null } & {
                    __typename: 'CompanyCountBySignupStatus';
                  }
                >;
              } & { __typename: 'NetworkRelationStatistics' };
            } & { __typename: 'Company' })
          | null;
      } & { __typename: 'User' })
    | null;
} & { __typename: 'Query' };

export type NetworkRelationCompaniesQueryVariables = Exact<{
  companyId: Scalars['String']['input'];
  filter: NetworkRelationFilter;
  sort?: InputMaybe<NetworkRelationsSortOrderInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
}>;

export type NetworkRelationCompaniesQuery = {
  viewer:
    | ({
        user_id: string;
        company:
          | ({
              company_id: string;
              networkRelations:
                | ({
                    count: number;
                    reportDownloadURI: string;
                    networkRelations: {
                      edges: Array<
                        | ({
                            node:
                              | ({
                                  entityId: string;
                                  companyName: string;
                                  relationCompanyName: string;
                                  companyReferenceName: string | null;
                                  type: NetworkRelationType;
                                  signupStatus: UnifiedCompanyRelationshipSignupStatus | null;
                                  tourStatusConsent: NetworkRelationConsentState;
                                  invitation:
                                    | ({
                                        companyInviteId: string;
                                        type: CompanyInviteType;
                                        invitationLink: string | null;
                                        recipients: Array<
                                          { email: string; locale: string } & {
                                            __typename: 'CompanyInvitationRecipient';
                                          }
                                        >;
                                      } & { __typename: 'CompanyInvite' })
                                    | null;
                                  companyIdentifiers: Array<
                                    {
                                      companyIdentifierId: string;
                                      identifierType: CompanyIdentifierType;
                                      identifierValue: string;
                                    } & { __typename: 'CompanyIdentifier' }
                                  >;
                                  relationIdentifiers: Array<
                                    { companyIdentifierId: string; identifierValue: string } & {
                                      __typename: 'CompanyIdentifier';
                                    }
                                  >;
                                } & { __typename: 'NetworkRelation' })
                              | null;
                          } & { __typename: 'NetworkRelationEdge' })
                        | null
                      > | null;
                      pageInfo: { hasNextPage: boolean; startCursor: string | null; endCursor: string | null } & {
                        __typename: 'PageInfo';
                      };
                    } & { __typename: 'NetworkRelationConnection' };
                  } & { __typename: 'CountedCompanyRelationConnection' })
                | null;
              acceptedInvitations: ({ count: number } & { __typename: 'CountedCompanyRelationConnection' }) | null;
              pendingInvitations: ({ count: number } & { __typename: 'CountedCompanyRelationConnection' }) | null;
            } & { __typename: 'Company' })
          | null;
      } & { __typename: 'User' })
    | null;
} & { __typename: 'Query' };

export type ReceivingVisibilityCompanyQueryVariables = Exact<{
  companyId: Scalars['String']['input'];
  subcontractorId: Scalars['String']['input'];
}>;

export type ReceivingVisibilityCompanyQuery = {
  viewer:
    | ({
        user_id: string;
        company:
          | ({
              company_id: string;
              invitationHistoryLogs: Array<
                {
                  performedByEmail: string | null;
                  inviteSentByLabel: string | null;
                  time: string;
                  type: InvitationHistoryLogItemType | null;
                  recipients: Array<
                    { email: string; locale: string } & { __typename: 'InvitationHistoryItemRecipient' }
                  > | null;
                } & { __typename: 'InvitationHistoryItem' }
              >;
              receivingVisibilityCompany:
                | ({
                    companyId: string;
                    transporeonId: string | null;
                    companyName: string | null;
                    dateAdded: string;
                    tourStatusConsent: ConsentState;
                    transports: number | null;
                    allocated: number | null;
                    tracked: number | null;
                    signupStatus: UnifiedCompanyRelationshipSignupStatus | null;
                    signupStatusTransitionedAt: string | null;
                    companyInvite:
                      | ({ companyInviteId: string; companyName: string | null; status: CompanyInviteStatus } & {
                          __typename: 'CompanyInvite';
                        })
                      | null;
                    vatNumbers: Array<{ vatNumber: string } & { __typename: 'CompanyVatNumber' }>;
                    companyIdentifiers: Array<
                      {
                        companyId: string;
                        companyIdentifierId: string;
                        identifierType: CompanyIdentifierType;
                        identifierValue: string;
                        discriminatorCountry: string | null;
                        source: string;
                      } & { __typename: 'CompanyIdentifier' }
                    >;
                    relationIdentifiers: Array<
                      { companyIdentifierId: string; identifierValue: string } & { __typename: 'CompanyIdentifier' }
                    >;
                    statusContext:
                      | ({ type: CarrierNetworkStatusContextType; transitionedAt: string } & {
                          __typename: 'CarrierNetworkStatusContext';
                        })
                      | null;
                    latestPendingInvite:
                      | ({
                          companyInviteId: string;
                          deadlineAt: string;
                          invitedAt: string;
                          recipient: { name: string; email: string } & { __typename: 'CompanyInviteRecipient' };
                          metadata: { locale: string } & { __typename: 'CompanyInviteMetadata' };
                        } & { __typename: 'CompanyInvite' })
                      | null;
                  } & { __typename: 'ReceivingVisibilityCompany' })
                | null;
            } & { __typename: 'Company' })
          | null;
      } & { __typename: 'User' })
    | null;
} & { __typename: 'Query' };

export type DataNetworkPerformanceReportQueryVariables = Exact<{
  type: DataNetworkReportType;
  sort?: InputMaybe<DataNetworkReportSortOrderInput>;
  companyId: Scalars['String']['input'];
  siteIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  placeIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  customFields?: InputMaybe<Array<TourCustomFieldSearch> | TourCustomFieldSearch>;
  carrierIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  customerIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  startTimeEnd?: InputMaybe<Scalars['DateTime']['input']>;
  startTimeStart: Scalars['DateTime']['input'];
  startTimeSugarTimezone?: InputMaybe<Scalars['IANATimezone']['input']>;
  endTimeStart?: InputMaybe<Scalars['DateTime']['input']>;
  endTimeEnd?: InputMaybe<Scalars['DateTime']['input']>;
  endTimeSugarTimezone?: InputMaybe<Scalars['IANATimezone']['input']>;
  stopCountries?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  stopStates?: InputMaybe<Array<StopStatesInput> | StopStatesInput>;
  mainVisibilityIssues?: InputMaybe<Array<VisibilityIssueType> | VisibilityIssueType>;
  onboardingStatus?: InputMaybe<
    Array<UnifiedCompanyRelationshipOnboardingStatus> | UnifiedCompanyRelationshipOnboardingStatus
  >;
  stopBookingLocationNames?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  stopFilters?: InputMaybe<Array<StopFilterInput> | StopFilterInput>;
  skipPlatforms: Scalars['Boolean']['input'];
  skipTotalCount: Scalars['Boolean']['input'];
  skipUpcomingCount: Scalars['Boolean']['input'];
  skipWorkingCount: Scalars['Boolean']['input'];
  skipCompletedCount: Scalars['Boolean']['input'];
  skipCancelledCount: Scalars['Boolean']['input'];
  skipUnassignedCount: Scalars['Boolean']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
}>;

export type DataNetworkPerformanceReportQuery = {
  viewer:
    | ({
        user_id: string;
        company:
          | ({
              company_id: string;
              dataNetworkVisibilityReport:
                | ({
                    reportDownloadURI: string;
                    companyOverview: {
                      companyId: string;
                      visibilityIndex: number | null;
                      visibilityIndexChange: number | null;
                      assignmentPercentage: number | null;
                      assignmentPercentageChange: number | null;
                      tourTotalCount?: number;
                      tourUpcomingCount?: number;
                      tourUnassignedCount?: number;
                      tourCompletedCount?: number;
                      tourCancelledCount?: number;
                      tourWorkingCount?: number;
                    } & { __typename: 'CompanyOverview' };
                    companies: {
                      count: number;
                      companies: {
                        edges: Array<
                          | ({
                              node:
                                | ({
                                    companyId: string;
                                    companyName: string | null;
                                    companyIsShipper: boolean;
                                    signupStatus: UnifiedCompanyRelationshipSignupStatus | null;
                                    tourTotalCount?: number;
                                    tourUpcomingCount?: number;
                                    tourWorkingCount?: number;
                                    tourCompletedCount?: number;
                                    tourCancelledCount?: number;
                                    tourUnassignedCount?: number;
                                    visibilityIndex: number | null;
                                    visibilityIndexChange: number | null;
                                    mainVisibilityIssueType: VisibilityIssueType | null;
                                    assignmentPercentage: number | null;
                                    assignmentPercentageChange: number | null;
                                    id: string;
                                    latestPendingInvite:
                                      | ({
                                          companyInviteId: string;
                                          deadlineAt: string;
                                          invitedAt: string;
                                          recipient: { name: string; email: string } & {
                                            __typename: 'CompanyInviteRecipient';
                                          };
                                          metadata: { locale: string } & { __typename: 'CompanyInviteMetadata' };
                                        } & { __typename: 'CompanyInvite' })
                                      | null;
                                    platforms?: Array<
                                      { platform_id: string; platform_name: string; company_id_on_platform: string } & {
                                        __typename: 'CompanyPlatform';
                                      }
                                    >;
                                    relationIdentifiers: Array<
                                      { companyIdentifierId: string; identifierValue: string } & {
                                        __typename: 'CompanyIdentifier';
                                      }
                                    >;
                                  } & { __typename: 'DataNetworkVisibilityReportCompany' })
                                | null;
                            } & { __typename: 'DataNetworkVisibilityReportCompanyEdge' })
                          | null
                        > | null;
                        pageInfo: { hasNextPage: boolean; startCursor: string | null; endCursor: string | null } & {
                          __typename: 'PageInfo';
                        };
                      } & { __typename: 'DataNetworkVisibilityReportCompanyConnection' };
                    } & { __typename: 'CountedDataNetworkVisibilityReportCompanyConnection' };
                  } & { __typename: 'DataNetworkVisibilityReport' })
                | null;
            } & { __typename: 'Company' })
          | null;
      } & { __typename: 'User' })
    | null;
} & { __typename: 'Query' };

export type LicensePlateLookupQueryVariables = Exact<{
  licensePlateInput: LicensePlateLookupInput;
}>;

export type LicensePlateLookupQuery = {
  licensePlateLookup: {
    result: Array<
      {
        licensePlate: string;
        matches: Array<
          {
            licensePlate: string;
            alternativeIdentifier: string | null;
            lastStatusTimestamp: string | null;
            availability: VehicleAvailability;
          } & { __typename: 'LicensePlateLookupVehicle' }
        >;
      } & { __typename: 'LicensePlateLookupResult' }
    >;
  } & { __typename: 'LicensePlateLookupResultSet' };
} & { __typename: 'Query' };

export type DataNetworkTransportGraphsQueryVariables = Exact<{
  type: DataNetworkReportType;
  companyId: Scalars['String']['input'];
  siteIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  placeIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  customFields?: InputMaybe<Array<TourCustomFieldSearch> | TourCustomFieldSearch>;
  carrierIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  customerIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  startTimeEnd?: InputMaybe<Scalars['DateTime']['input']>;
  startTimeStart: Scalars['DateTime']['input'];
  startTimeSugarTimezone?: InputMaybe<Scalars['IANATimezone']['input']>;
  endTimeStart?: InputMaybe<Scalars['DateTime']['input']>;
  endTimeEnd?: InputMaybe<Scalars['DateTime']['input']>;
  endTimeSugarTimezone?: InputMaybe<Scalars['IANATimezone']['input']>;
  stopCountries?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  onboardingStatus?: InputMaybe<
    Array<UnifiedCompanyRelationshipOnboardingStatus> | UnifiedCompanyRelationshipOnboardingStatus
  >;
  stopStates?: InputMaybe<Array<StopStatesInput> | StopStatesInput>;
  stopFilters?: InputMaybe<Array<StopFilterInput> | StopFilterInput>;
  mainVisibilityIssues?: InputMaybe<Array<VisibilityIssueType> | VisibilityIssueType>;
}>;

export type DataNetworkTransportGraphsQuery = {
  viewer:
    | ({
        user_id: string;
        company:
          | ({
              company_id: string;
              dataNetworkVisibilityReport:
                | ({
                    workingTours: {
                      totalCount: number;
                      countByTourDelayStatus: Array<
                        { count: number; delayStatus: TourDelayStatusFilter | null } & {
                          __typename: 'ToursCountByDelayStatus';
                        }
                      >;
                    } & { __typename: 'ToursCountByStatus' };
                    completedTours: {
                      totalCount: number;
                      countByTourDelayStatus: Array<
                        { count: number; delayStatus: TourDelayStatusFilter | null } & {
                          __typename: 'ToursCountByDelayStatus';
                        }
                      >;
                    } & { __typename: 'ToursCountByStatus' };
                    cancelledTours: {
                      totalCount: number;
                      countByFailureReason: Array<
                        { count: number; failureReason: TourFailureReasonType | null } & {
                          __typename: 'TourCountByFailureReason';
                        }
                      >;
                    } & { __typename: 'ToursCountByStatus' };
                  } & { __typename: 'DataNetworkVisibilityReport' })
                | null;
            } & { __typename: 'Company' })
          | null;
      } & { __typename: 'User' })
    | null;
} & { __typename: 'Query' };

export type AddOrUpdateDataSharingConsentMutationVariables = Exact<{
  input: AddOrUpdateConsentInput;
}>;

export type AddOrUpdateDataSharingConsentMutation = { addOrUpdateDataSharingConsent: boolean | null } & {
  __typename: 'Mutation';
};

export type CompanyDataNetworkFiltersQueryVariables = Exact<{
  companyId: Scalars['String']['input'];
  textSearch?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
}>;

export type CompanyDataNetworkFiltersQuery = {
  viewer:
    | ({
        user_id: string;
        company:
          | ({
              company_id: string;
              me: ({ role: UserRoleInCompany } & { __typename: 'UserInCompany' }) | null;
              companyTransportNetworkFiltersConnection: {
                count: number;
                companyTransportNetworkFilters: {
                  edges: Array<
                    | ({
                        node:
                          | ({
                              companyTransportNetworkFilterId: string;
                              name: string;
                              visibilityType: CompanyTransportNetworkFilterVisibility;
                              filter: {
                                onboardingStatus: Array<UnifiedCompanyRelationshipOnboardingStatus> | null;
                                startTimeStart: string;
                                startTimeEnd: string;
                                endTimeStart: string | null;
                                endTimeEnd: string | null;
                                siteIds: Array<string> | null;
                                carrierIds: Array<string> | null;
                                customerIds: Array<string> | null;
                                relationIdentifierIds: Array<string> | null;
                                placeIds: Array<string> | null;
                                stopCountries: Array<string> | null;
                                stopBookingLocationNames: Array<string> | null;
                                mainVisibilityIssues: Array<VisibilityIssueType> | null;
                                customFields: Array<
                                  {
                                    fieldName: string;
                                    value: { values: Array<string> | null } & {
                                      __typename: 'TransportNetworkCustomFieldSearchValueType';
                                    };
                                  } & { __typename: 'TransportNetworkCustomFieldSearchType' }
                                > | null;
                                stopStates: Array<
                                  { state: string; country: string } & { __typename: 'CompanyStopStates' }
                                > | null;
                                stopFilters: Array<
                                  {
                                    placeIds: Array<string> | null;
                                    bookingLocationNames: Array<string> | null;
                                    countries: Array<string> | null;
                                    stopTypes: Array<FilterRoadStopType> | null;
                                    companyNames: Array<string> | null;
                                    states: Array<
                                      { country: string; state: string } & { __typename: 'CompanyStopStates' }
                                    > | null;
                                    cities: Array<
                                      { city: string; country: string } & { __typename: 'CompanyStopCities' }
                                    > | null;
                                    postalCodes: Array<
                                      { postalCode: string; country: string } & { __typename: 'CompanyStopPostalCodes' }
                                    > | null;
                                  } & { __typename: 'StopFilterOutput' }
                                > | null;
                              } & { __typename: 'TransportNetworkFilter' };
                            } & { __typename: 'CompanyTransportNetworkFilter' })
                          | null;
                      } & { __typename: 'CompanyTransportNetworkFilterEdge' })
                    | null
                  > | null;
                  pageInfo: { hasNextPage: boolean; endCursor: string | null } & { __typename: 'PageInfo' };
                } & { __typename: 'CompanyTransportNetworkFilterConnection' };
              } & { __typename: 'CountedCompanyTransportNetworkFilterConnection' };
            } & { __typename: 'Company' })
          | null;
      } & { __typename: 'User' })
    | null;
} & { __typename: 'Query' };

export type CompanyExistingRelationshipsQueryVariables = Exact<{
  companyId: Scalars['String']['input'];
  companyNameSearch: Scalars['String']['input'];
}>;

export type CompanyExistingRelationshipsQuery = {
  viewer:
    | ({
        user_id: string;
        company:
          | ({
              company_id: string;
              networkRelations:
                | ({
                    networkRelations: {
                      edges: Array<
                        | ({
                            node:
                              | ({
                                  entityId: string;
                                  companyName: string;
                                  relationCompanyName: string;
                                  companyReferenceName: string | null;
                                  type: NetworkRelationType;
                                  signupStatus: UnifiedCompanyRelationshipSignupStatus | null;
                                } & { __typename: 'NetworkRelation' })
                              | null;
                          } & { __typename: 'NetworkRelationEdge' })
                        | null
                      > | null;
                    } & { __typename: 'NetworkRelationConnection' };
                  } & { __typename: 'CountedCompanyRelationConnection' })
                | null;
            } & { __typename: 'Company' })
          | null;
      } & { __typename: 'User' })
    | null;
} & { __typename: 'Query' };

export type CreateCompanyInvitationEmailMutationVariables = Exact<{
  companyId: Scalars['String']['input'];
  input: CreateCompanyInvitationEmailInput;
  dryRun: Scalars['Boolean']['input'];
}>;

export type CreateCompanyInvitationEmailMutation = {
  createCompanyInvitationEmail:
    | ({
        success: boolean;
        invalidEmails: Array<string>;
        invalidIdentifiers: Array<string>;
        companyInviteId: string | null;
      } & { __typename: 'CreateCompanyInvitationEmailResult' })
    | null;
} & { __typename: 'Mutation' };

export type CreateCompanyInvitationLinkMutationVariables = Exact<{
  companyId: Scalars['String']['input'];
  input: CreateCompanyInvitationLinkInput;
  dryRun: Scalars['Boolean']['input'];
}>;

export type CreateCompanyInvitationLinkMutation = {
  createCompanyInvitationLink:
    | ({ success: boolean; companyInviteId: string | null; invalidIdentifiers: Array<string> } & {
        __typename: 'CreateCompanyInvitationLinkResult';
      })
    | null;
} & { __typename: 'Mutation' };

export type CreateCompanyInvitationLinkWithRecipientsMutationVariables = Exact<{
  companyId: Scalars['String']['input'];
  input: CreateCompanyInvitationLinkWithRecipientsInput;
  dryRun: Scalars['Boolean']['input'];
}>;

export type CreateCompanyInvitationLinkWithRecipientsMutation = {
  createCompanyInvitationLinkWithRecipients:
    | ({
        success: boolean;
        companyInviteId: string | null;
        invalidEmails: Array<string>;
        invalidIdentifiers: Array<string>;
      } & { __typename: 'CreateCompanyInvitationLinkWithRecipientsResult' })
    | null;
} & { __typename: 'Mutation' };

export type ResendCompanyInvitationMutationVariables = Exact<{
  companyId: Scalars['String']['input'];
  input: ResendCompanyInvitationInput;
}>;

export type ResendCompanyInvitationMutation = {
  resendCompanyInvitation:
    | ({ success: boolean; invalidEmails: Array<string> } & { __typename: 'CreateCompanyInvitationsResult' })
    | null;
} & { __typename: 'Mutation' };

export type CreateBulkInvitationSetMutationVariables = Exact<{
  companyId: Scalars['String']['input'];
  input: CreateBulkInvitationSetInput;
}>;

export type CreateBulkInvitationSetMutation = {
  createBulkInvitationSet: {
    success: boolean;
    bulkInvitationSetId: string;
    createdBulkInvitationSetItemIds: Array<string>;
  } & { __typename: 'CreateBulkInvitationSetResult' };
} & { __typename: 'Mutation' };

export type UpdateBulkInvitationSetMutationVariables = Exact<{
  companyId: Scalars['String']['input'];
  input: UpdateBulkInvitationSetInput;
  dryRun: Scalars['Boolean']['input'];
}>;

export type UpdateBulkInvitationSetMutation = {
  updateBulkInvitationSet: {
    success: boolean;
    hadDuplicates: boolean;
    createdBulkInvitationSetItemIds: Array<string>;
  } & { __typename: 'UpdateBulkInvitationSetResult' };
} & { __typename: 'Mutation' };

export type MoveItemsToBulkInvitationSetMutationVariables = Exact<{
  companyId: Scalars['String']['input'];
  input: MoveItemsToBulkInvitationSetInput;
}>;

export type MoveItemsToBulkInvitationSetMutation = {
  moveItemsToBulkInvitationSet: { success: boolean; hadDuplicates: boolean } & {
    __typename: 'MoveItemsToBulkInvitationSetResult';
  };
} & { __typename: 'Mutation' };

export type AddItemsToBulkInvitationSetMutationVariables = Exact<{
  companyId: Scalars['String']['input'];
  input: AddItemsToBulkInvitationSetInput;
}>;

export type AddItemsToBulkInvitationSetMutation = {
  addItemsToBulkInvitationSet: { success: boolean; hadDuplicates: boolean } & {
    __typename: 'AddItemsToBulkInvitationSetResult';
  };
} & { __typename: 'Mutation' };

export type DeleteBulkInvitationSetMutationVariables = Exact<{
  companyId: Scalars['String']['input'];
  input: DeleteBulkInvitationSetInput;
}>;

export type DeleteBulkInvitationSetMutation = {
  deleteBulkInvitationSet: { success: boolean } & { __typename: 'DeleteBulkInvitationSetResult' };
} & { __typename: 'Mutation' };

export type SendBulkInvitationSetMutationVariables = Exact<{
  companyId: Scalars['String']['input'];
  input?: InputMaybe<SendBulkInvitationSetInput>;
}>;

export type SendBulkInvitationSetMutation = {
  sendBulkInvitationSet: ({ success: boolean } & { __typename: 'SendBulkInvitationSetResult' }) | null;
} & { __typename: 'Mutation' };

export type WithdrawCompanyInvitationMutationVariables = Exact<{
  companyId: Scalars['String']['input'];
  input: WithdrawCompanyInvitationInput;
}>;

export type WithdrawCompanyInvitationMutation = {
  withdrawCompanyInvitation: { success: boolean } & { __typename: 'WithdrawCompanyInvitationResult' };
} & { __typename: 'Mutation' };

export type DeleteInvitationsMutationVariables = Exact<{
  companyId: Scalars['String']['input'];
  input: DeleteInvitationsInput;
}>;

export type DeleteInvitationsMutation = {
  deleteInvitations: { success: boolean; deletedCount: number } & { __typename: 'DeleteInvitationsResult' };
} & { __typename: 'Mutation' };

export type ArchiveCarrierNetworkItemsMutationVariables = Exact<{
  companyId: Scalars['String']['input'];
  input: ArchiveCarrierNetworkItemsInput;
}>;

export type ArchiveCarrierNetworkItemsMutation = {
  archiveCarrierNetworkItems: { success: boolean; affectedCount: number; affectedGroupIds: Array<string> } & {
    __typename: 'ArchiveCarrierNetworkItemsResult';
  };
} & { __typename: 'Mutation' };

export type RestoreCarrierNetworkItemsMutationVariables = Exact<{
  companyId: Scalars['String']['input'];
  input: ArchiveCarrierNetworkItemsInput;
}>;

export type RestoreCarrierNetworkItemsMutation = {
  restoreCarrierNetworkItems: { success: boolean; affectedCount: number; affectedGroupIds: Array<string> } & {
    __typename: 'ArchiveCarrierNetworkItemsResult';
  };
} & { __typename: 'Mutation' };

export type BulkInvitationSetsQueryVariables = Exact<{
  companyId: Scalars['String']['input'];
  bulkInvitationSetId: Scalars['String']['input'];
  bulkInvitationSetIdDefined: Scalars['Boolean']['input'];
  companyName?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<BulkInvitationSetItemStatus>;
  isInvalid?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  sortKey: BulkInvitationSetsSortKey;
  sortDirection: SortDirection;
}>;

export type BulkInvitationSetsQuery = {
  viewer:
    | ({
        user_id: string;
        company:
          | ({
              company_id: string;
              latestBulkInvitationSetId: string | null;
              bulkInvitationSets: Array<
                {
                  bulkInvitationSetId: string;
                  companyId: string;
                  setName: string | null;
                  createdByUserId: string;
                  updatedByUserId: string;
                  createdAt: string;
                  updatedAt: string;
                  metadata: { fileName: string | null; fileSize: string | null } & {
                    __typename: 'BulkInvitationMetadata';
                  };
                  statistics: {
                    itemCountByStatus: Array<
                      { count: number; status: BulkInvitationSetItemStatus } & { __typename: 'ItemCountByStatus' }
                    >;
                  } & { __typename: 'BulkInvitationSetStatistics' };
                } & { __typename: 'BulkInvitationSet' }
              >;
              bulkInvitationSet?:
                | ({
                    bulkInvitationSetId: string;
                    companyId: string;
                    setName: string | null;
                    createdByUserId: string;
                    updatedByUserId: string;
                    createdAt: string;
                    updatedAt: string;
                    metadata: { fileName: string | null; fileSize: string | null } & {
                      __typename: 'BulkInvitationMetadata';
                    };
                    statistics: {
                      itemCountByStatus: Array<
                        { count: number; status: BulkInvitationSetItemStatus } & { __typename: 'ItemCountByStatus' }
                      >;
                    } & { __typename: 'BulkInvitationSetStatistics' };
                    items: {
                      count: number;
                      items: {
                        edges: Array<
                          | ({
                              node:
                                | ({
                                    bulkInvitationSetItemId: string;
                                    bulkInvitationSetId: string;
                                    companyReferenceName: string | null;
                                    relationCompanyName: string | null;
                                    consentStatus: ConsentStatus | null;
                                    companyInvitationId: string | null;
                                    invitedCompanyId: string | null;
                                    status: BulkInvitationSetItemStatus;
                                    isDataValid: boolean;
                                    createdByUserId: string;
                                    updatedByUserId: string;
                                    createdAt: string;
                                    updatedAt: string;
                                    recipients: Array<
                                      { email: string; locale: string | null } & {
                                        __typename: 'BulkInvitationRecipient';
                                      }
                                    >;
                                    identifierValues: Array<
                                      {
                                        value: string;
                                        isDuplicateInSameSet: boolean;
                                        isDuplicateInExistingValue: boolean;
                                      } & { __typename: 'BulkInvitationIdentifierValue' }
                                    >;
                                  } & { __typename: 'BulkInvitationSetItem' })
                                | null;
                            } & { __typename: 'BulkInvitationSetItemEdge' })
                          | null
                        > | null;
                        pageInfo: { hasNextPage: boolean; startCursor: string | null; endCursor: string | null } & {
                          __typename: 'PageInfo';
                        };
                      } & { __typename: 'BulkInvitationSetItemConnection' };
                      statistics: {
                        itemCountByStatus: Array<
                          { count: number; status: BulkInvitationSetItemStatus } & { __typename: 'ItemCountByStatus' }
                        >;
                      } & { __typename: 'BulkInvitationSetStatistics' };
                    } & { __typename: 'CountedBulkInvitationSetItemConnection' };
                  } & { __typename: 'BulkInvitationSet' })
                | null;
            } & { __typename: 'Company' })
          | null;
      } & { __typename: 'User' })
    | null;
} & { __typename: 'Query' };

export type BulkInvitationSetItemQueryVariables = Exact<{
  companyId: Scalars['String']['input'];
  bulkInvitationSetId: Scalars['String']['input'];
  bulkInvitationSetItemId: Scalars['String']['input'];
}>;

export type BulkInvitationSetItemQuery = {
  viewer:
    | ({
        user_id: string;
        company:
          | ({
              company_id: string;
              bulkInvitationSetItem:
                | ({
                    bulkInvitationSetItemId: string;
                    companyInvitationId: string | null;
                    companyReferenceName: string | null;
                    status: BulkInvitationSetItemStatus;
                    isDataValid: boolean;
                    createdAt: string;
                    updatedAt: string;
                    recipients: Array<
                      { email: string; locale: string | null } & { __typename: 'BulkInvitationRecipient' }
                    >;
                    identifierValues: Array<
                      { value: string; isDuplicateInSameSet: boolean; isDuplicateInExistingValue: boolean } & {
                        __typename: 'BulkInvitationIdentifierValue';
                      }
                    >;
                  } & { __typename: 'BulkInvitationSetItem' })
                | null;
            } & { __typename: 'Company' })
          | null;
      } & { __typename: 'User' })
    | null;
} & { __typename: 'Query' };

export type CreateOrUpdateRelationIdentifiersMutationVariables = Exact<{
  input: CreateOrUpdateRelationIdentifiersInput;
}>;

export type CreateOrUpdateRelationIdentifiersMutation = {
  createOrUpdateRelationIdentifiers:
    | ({ success: boolean; invalidIdentifiers: Array<string>; invalidFormatIdentifiers: Array<string> } & {
        __typename: 'CreateOrUpdateRelationIdentifiersResult';
      })
    | null;
} & { __typename: 'Mutation' };

export type UpdateInviteCompanyNameMutationVariables = Exact<{
  input: UpdateInviteCompanyNameInput;
}>;

export type UpdateInviteCompanyNameMutation = { updateInviteCompanyName: boolean | null } & { __typename: 'Mutation' };

export type RelationIdentifierSearchQueryVariables = Exact<{
  companyId: Scalars['String']['input'];
  textSearch?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  relationIdentifierIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;

export type RelationIdentifierSearchQuery = {
  viewer:
    | ({
        user_id: string;
        company:
          | ({
              company_id: string;
              relationIdentifiersConnection:
                | ({
                    edges: Array<
                      | ({
                          node:
                            | ({ companyId: string; companyIdentifierId: string; identifierValue: string } & {
                                __typename: 'CompanyIdentifier';
                              })
                            | null;
                        } & { __typename: 'CompanyIdentifierEdge' })
                      | null
                    > | null;
                  } & { __typename: 'CompanyIdentifierConnection' })
                | null;
            } & { __typename: 'Company' })
          | null;
      } & { __typename: 'User' })
    | null;
} & { __typename: 'Query' };

export type CarrierNetworkQueryVariables = Exact<{
  companyId: Scalars['String']['input'];
  filter?: InputMaybe<CarrierNetworkFilterInput>;
  sort?: InputMaybe<CarrierNetworkSortOrderInput>;
  timezone?: InputMaybe<Scalars['IANATimezone']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
}>;

export type CarrierNetworkQuery = {
  viewer:
    | ({
        user_id: string;
        company:
          | ({
              company_id: string;
              carrierNetwork:
                | ({
                    count: number;
                    reportDownloadURI: string;
                    items: {
                      edges: Array<
                        | ({
                            node:
                              | ({
                                  entityId: string;
                                  companyReferenceName: string | null;
                                  companyName: string | null;
                                  transports: number | null;
                                  allocated: number | null;
                                  tracked: number | null;
                                  status: CarrierNetworkStatus | null;
                                  consentStatus: CarrierNetworkConsentStatus | null;
                                  companyInvitationId: string | null;
                                  bulkInvitationSetItemId: string | null;
                                  bulkInvitationSetId: string | null;
                                  otherBulkInvitationSetIds: Array<string>;
                                  companyId: string | null;
                                  isDataValid: boolean | null;
                                  isInUngroupedBulkSet: boolean;
                                  isWithdrawn: boolean | null;
                                  isArchived: boolean;
                                  archivedAt: string | null;
                                  updatedAt: string | null;
                                  statusContext:
                                    | ({ type: CarrierNetworkStatusContextType; transitionedAt: string } & {
                                        __typename: 'CarrierNetworkStatusContext';
                                      })
                                    | null;
                                  relationIdentifiers: Array<
                                    {
                                      companyId: string;
                                      companyIdentifierId: string;
                                      identifierType: CompanyIdentifierType;
                                      identifierValue: string;
                                      discriminatorCountry: string | null;
                                      source: string;
                                      isDuplicateInExistingValue: boolean;
                                    } & { __typename: 'RelationIdentifierWithValidation' }
                                  >;
                                  companyIdentifiers: Array<
                                    {
                                      companyId: string;
                                      companyIdentifierId: string;
                                      identifierType: CompanyIdentifierType;
                                      identifierValue: string;
                                      discriminatorCountry: string | null;
                                      source: string;
                                    } & { __typename: 'CompanyIdentifier' }
                                  >;
                                  recipients: Array<
                                    { email: string; locale: string | null } & { __typename: 'BulkInvitationRecipient' }
                                  > | null;
                                } & { __typename: 'CarrierNetworkItem' })
                              | null;
                          } & { __typename: 'CarrierNetworkItemEdge' })
                        | null
                      > | null;
                      pageInfo: { hasNextPage: boolean; startCursor: string | null; endCursor: string | null } & {
                        __typename: 'PageInfo';
                      };
                    } & { __typename: 'CarrierNetworkItemConnection' };
                  } & { __typename: 'CountedCarrierNetworkConnection' })
                | null;
            } & { __typename: 'Company' })
          | null;
      } & { __typename: 'User' })
    | null;
} & { __typename: 'Query' };

export type FleetVehicleDetailsFragment = {
  license_plate_number: string | null;
  isConstantPositionAccessAllowed: boolean;
  company: { company_id: string; company_name: string | null } & { __typename: 'CompanyProfile' };
  status: ({ timestamp: string } & { __typename: 'RestrictedVehicleStatus' }) | null;
  vehicleTrackers: Array<
    | { __typename: 'FMSVehicleTracker' }
    | ({
        vehicleTrackerId: string;
        phoneNumber: string | null;
        trackerType: VehicleTrackerType;
        alias: string | null;
      } & { __typename: 'MobileVehicleTracker' })
  >;
} & { __typename: 'Vehicle' };

export type FleetReceivedGrantFragment = {
  receivedGrant:
    | ({
        grantId: string;
        grantedByCompany: { company_id: string; company_name: string | null } & { __typename: 'CompanyProfile' };
      } & { __typename: 'VehicleGrant' })
    | null;
} & { __typename: 'Vehicle' };

export type FleetTourAllocationDetailsFragment = {
  tour_id: number;
  status: string | null;
  shipper_transport_number: string | null;
  transportIdentifiers: Array<string> | null;
  start_time: string | null;
  end_time: string | null;
  isGloballyAllocatedToViewerCompany: boolean;
  failureReason: ({ type: TourFailureReasonType } & { __typename: 'TourFailureReason' }) | null;
  shipper: ({ company_id: string; company_name: string | null } & { __typename: 'CompanyProfile' }) | null;
  stops: Array<
    {
      stop_id: number;
      type: string | null;
      status: string | null;
      location:
        | ({
            name: string | null;
            address:
              | ({ country: string | null; city: string | null; state: string | null; shortAreaCode: string | null } & {
                  __typename: 'Address';
                })
              | null;
          } & { __typename: 'TourLocation' })
        | null;
    } & { __typename: 'TourStop' }
  >;
} & { __typename: 'Tour' };

export type FleetVehicleHistoryFragment = {
  vehicleHistory: Array<
    {
      polyline: { points: string } & { __typename: 'Polyline' };
      metadata: { type: VehicleHistoryPolylineType; startTime: string; endTime: string; vehicleId: string } & {
        __typename: 'VehicleHistoryPolylineMetadata';
      };
    } & { __typename: 'VehicleHistoryPolyline' }
  > | null;
} & { __typename: 'Tour' };

export type FleetTourDetailsFragment = {
  tour_id: number;
  shipper_transport_number: string | null;
  status: string | null;
  start_time: string | null;
  end_time: string | null;
  working_stop_id: number | null;
  isGlobalAllocation: boolean;
  isGloballyAllocatedToViewerCompany: boolean;
  warnings: Array<{ type: TourWarningType; severity: TourWarningSeverity | null } & { __typename: 'TourWarning' }>;
  failureReason: ({ type: TourFailureReasonType } & { __typename: 'TourFailureReason' }) | null;
  shipper: ({ company_id: string; company_name: string | null } & { __typename: 'CompanyProfile' }) | null;
  vehicleAllocations: Array<{ vehicleLicensePlateNumber: string | null } & { __typename: 'TourVehicleAllocation' }>;
  stops: Array<
    {
      stop_id: number;
      type: string | null;
      status: string | null;
      deadline: string | null;
      estimated_arrival_delay_in_seconds: number | null;
      estimated_arrival_status: string | null;
      estimated_arrival_distance_in_meters: number | null;
      arrival_delay_in_seconds: number | null;
      arrival_time: string | null;
      location:
        | ({
            location_id: string | null;
            name: string | null;
            address:
              | ({
                  full_address: string | null;
                  city: string | null;
                  country: string | null;
                  street_address: string | null;
                  state: string | null;
                  zipcode: string | null;
                  shortAreaCode: string | null;
                } & { __typename: 'Address' })
              | null;
          } & { __typename: 'TourLocation' })
        | null;
    } & { __typename: 'TourStop' }
  >;
} & { __typename: 'Tour' };

export type AllFleetVehiclesQueryVariables = Exact<{
  companyId: Scalars['String']['input'];
  fromTime: Scalars['DateTime']['input'];
  toTime: Scalars['DateTime']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  licensePlateSearch?: InputMaybe<Scalars['String']['input']>;
  vehicleStateFilter?: InputMaybe<VehicleStateFilterInput>;
  dwellTimeThresholdMinutes?: InputMaybe<Scalars['Int']['input']>;
}>;

export type AllFleetVehiclesQuery = {
  viewer:
    | ({
        user_id: string;
        company:
          | ({
              company_id: string;
              vehicles:
                | ({
                    vehicles:
                      | ({
                          count: number;
                          vehicles: {
                            edges: Array<
                              | ({
                                  node:
                                    | ({
                                        vehicle_id: string;
                                        vehicleMapState: VehicleMapState | null;
                                        tours: Array<FleetTourDetailsFragment & { __typename: 'Tour' }> | null;
                                      } & FleetVehicleDetailsFragment &
                                        FleetReceivedGrantFragment & { __typename: 'Vehicle' })
                                    | null;
                                } & { __typename: 'VehicleEdge' })
                              | null
                            > | null;
                            pageInfo: { hasNextPage: boolean; endCursor: string | null } & { __typename: 'PageInfo' };
                          } & { __typename: 'VehicleConnection' };
                        } & { __typename: 'CountedVehicleConnection' })
                      | null;
                  } & { __typename: 'CompanyVehicles' })
                | null;
            } & { __typename: 'Company' })
          | null;
      } & { __typename: 'User' })
    | null;
} & { __typename: 'Query' };

export type FleetGroupVehiclesQueryVariables = Exact<{
  companyId: Scalars['String']['input'];
  vehicleGroupId: Scalars['String']['input'];
  fromTime: Scalars['DateTime']['input'];
  toTime: Scalars['DateTime']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  licensePlateSearch?: InputMaybe<Scalars['String']['input']>;
  vehicleStateFilter?: InputMaybe<VehicleStateFilterInput>;
  dwellTimeThresholdMinutes?: InputMaybe<Scalars['Int']['input']>;
}>;

export type FleetGroupVehiclesQuery = {
  viewer:
    | ({
        user_id: string;
        company:
          | ({
              company_id: string;
              companyVehicleGroup:
                | ({
                    companyVehicleGroupId: string;
                    name: string;
                    vehiclesConnection: {
                      count: number;
                      vehicles:
                        | ({
                            edges: Array<
                              | ({
                                  node:
                                    | ({
                                        vehicle_id: string;
                                        vehicleMapState: VehicleMapState | null;
                                        tours: Array<FleetTourDetailsFragment & { __typename: 'Tour' }> | null;
                                      } & FleetVehicleDetailsFragment &
                                        FleetReceivedGrantFragment & { __typename: 'Vehicle' })
                                    | null;
                                } & { __typename: 'VehicleEdge' })
                              | null
                            > | null;
                            pageInfo: { hasNextPage: boolean; endCursor: string | null } & { __typename: 'PageInfo' };
                          } & { __typename: 'VehicleConnection' })
                        | null;
                    } & { __typename: 'CountedVehicleInGroupConnection' };
                  } & { __typename: 'CompanyVehicleGroup' })
                | null;
            } & { __typename: 'Company' })
          | null;
      } & { __typename: 'User' })
    | null;
} & { __typename: 'Query' };

export type VehicleGroupVehiclesQueryVariables = Exact<{
  companyId: Scalars['String']['input'];
  vehicleGroupId: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
}>;

export type VehicleGroupVehiclesQuery = {
  viewer:
    | ({
        user_id: string;
        company:
          | ({
              company_id: string;
              companyVehicleGroup:
                | ({
                    companyVehicleGroupId: string;
                    name: string;
                    vehiclesConnection: {
                      vehicles:
                        | ({
                            edges: Array<
                              | ({
                                  node:
                                    | ({
                                        vehicle_id: string;
                                        license_plate_number: string | null;
                                      } & FleetReceivedGrantFragment & { __typename: 'Vehicle' })
                                    | null;
                                } & { __typename: 'VehicleEdge' })
                              | null
                            > | null;
                            pageInfo: { hasNextPage: boolean; endCursor: string | null } & { __typename: 'PageInfo' };
                          } & { __typename: 'VehicleConnection' })
                        | null;
                    } & { __typename: 'CountedVehicleInGroupConnection' };
                  } & { __typename: 'CompanyVehicleGroup' })
                | null;
            } & { __typename: 'Company' })
          | null;
      } & { __typename: 'User' })
    | null;
} & { __typename: 'Query' };

export type VehicleGroupsQueryVariables = Exact<{
  companyId: Scalars['String']['input'];
}>;

export type VehicleGroupsQuery = {
  viewer:
    | ({
        user_id: string;
        company:
          | ({
              company_id: string;
              companyVehicleGroups: Array<
                ({ companyVehicleGroupId: string; name: string } & { __typename: 'CompanyVehicleGroup' }) | null
              > | null;
            } & { __typename: 'Company' })
          | null;
      } & { __typename: 'User' })
    | null;
} & { __typename: 'Query' };

export type VehicleGroupSearchVehiclesQueryVariables = Exact<{
  companyId: Scalars['String']['input'];
  licensePlateSearch: Scalars['String']['input'];
}>;

export type VehicleGroupSearchVehiclesQuery = {
  viewer:
    | ({
        user_id: string;
        company:
          | ({
              company_id: string;
              vehicles:
                | ({
                    allocatable:
                      | ({
                          vehicles: {
                            edges: Array<
                              | ({
                                  node:
                                    | ({
                                        vehicle_id: string;
                                        license_plate_number: string | null;
                                      } & FleetReceivedGrantFragment & { __typename: 'Vehicle' })
                                    | null;
                                } & { __typename: 'VehicleEdge' })
                              | null
                            > | null;
                          } & { __typename: 'VehicleConnection' };
                        } & { __typename: 'CountedVehicleConnection' })
                      | null;
                  } & { __typename: 'CompanyVehicles' })
                | null;
            } & { __typename: 'Company' })
          | null;
      } & { __typename: 'User' })
    | null;
} & { __typename: 'Query' };

export type CreateVehicleGroupMutationVariables = Exact<{
  input: CreateCompanyVehicleGroupInput;
}>;

export type CreateVehicleGroupMutation = {
  createCompanyVehicleGroup:
    | ({ companyVehicleGroupId: string; name: string } & { __typename: 'CompanyVehicleGroup' })
    | null;
} & { __typename: 'Mutation' };

export type UpdateVehicleGroupMutationVariables = Exact<{
  updateTitleInput: UpdateCompanyVehicleGroupInput;
  addVehiclesInput: AddVehiclesToCompanyVehicleGroupInput;
  removeVehiclesInput: RemoveVehiclesFromCompanyVehicleGroupInput;
}>;

export type UpdateVehicleGroupMutation = {
  addVehiclesToCompanyVehicleGroup: boolean | null;
  removeVehiclesFromCompanyVehicleGroup: boolean | null;
  updateCompanyVehicleGroup:
    | ({ companyVehicleGroupId: string; name: string } & { __typename: 'CompanyVehicleGroup' })
    | null;
} & { __typename: 'Mutation' };

export type DeleteCompanyVehicleGroupMutationVariables = Exact<{
  input: DeleteCompanyVehicleGroupInput;
}>;

export type DeleteCompanyVehicleGroupMutation = { deleteCompanyVehicleGroup: boolean | null } & {
  __typename: 'Mutation';
};

export type CreateTourMutationVariables = Exact<{
  input: TourCreationInput;
}>;

export type CreateTourMutation = { createTour: (FleetTourDetailsFragment & { __typename: 'Tour' }) | null } & {
  __typename: 'Mutation';
};

export type UpdateTourMutationVariables = Exact<{
  input: TourUpdateInput;
}>;

export type UpdateTourMutation = { updateTour: ({ tour_id: number } & { __typename: 'Tour' }) | null } & {
  __typename: 'Mutation';
};

export type UnallocatedShipmentsQueryVariables = Exact<{
  companyId: Scalars['String']['input'];
  role: TourCompanyRole;
  vehicleId: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  textSearch?: InputMaybe<TourTextSearch>;
  sortOrder?: InputMaybe<TourSortOrder>;
}>;

export type UnallocatedShipmentsQuery = {
  viewer:
    | ({
        user_id: string;
        company:
          | ({
              company_id: string;
              is_carrier: boolean | null;
              vehicle: ({ vehicle_id: string; license_plate_number: string | null } & { __typename: 'Vehicle' }) | null;
              tours: {
                count: number;
                tours: {
                  edges: Array<
                    | ({ node: (FleetTourAllocationDetailsFragment & { __typename: 'Tour' }) | null } & {
                        __typename: 'TourEdge';
                      })
                    | null
                  > | null;
                  pageInfo: { hasNextPage: boolean; endCursor: string | null } & { __typename: 'PageInfo' };
                } & { __typename: 'TourConnection' };
              } & { __typename: 'CountedTourConnection' };
            } & { __typename: 'Company' })
          | null;
      } & { __typename: 'User' })
    | null;
} & { __typename: 'Query' };

export type UnallocatedCompanyShipmentsQueryVariables = Exact<{
  companyId: Scalars['String']['input'];
  role: TourCompanyRole;
  first?: InputMaybe<Scalars['Int']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  textSearch?: InputMaybe<TourTextSearch>;
  sortOrder?: InputMaybe<TourSortOrder>;
}>;

export type UnallocatedCompanyShipmentsQuery = {
  viewer:
    | ({
        user_id: string;
        company:
          | ({
              company_id: string;
              is_carrier: boolean | null;
              tours: {
                count: number;
                tours: {
                  edges: Array<
                    | ({ node: (FleetTourAllocationDetailsFragment & { __typename: 'Tour' }) | null } & {
                        __typename: 'TourEdge';
                      })
                    | null
                  > | null;
                  pageInfo: { hasNextPage: boolean; endCursor: string | null } & { __typename: 'PageInfo' };
                } & { __typename: 'TourConnection' };
              } & { __typename: 'CountedTourConnection' };
            } & { __typename: 'Company' })
          | null;
      } & { __typename: 'User' })
    | null;
} & { __typename: 'Query' };

export type TransportDetailsQueryVariables = Exact<{
  companyId: Scalars['String']['input'];
  tourId: Scalars['Int']['input'];
  vehicleId: Scalars['String']['input'];
  skipSharingToken?: InputMaybe<Scalars['Boolean']['input']>;
  skipMobileTrackingToken?: InputMaybe<Scalars['Boolean']['input']>;
  skipPlace?: InputMaybe<Scalars['Boolean']['input']>;
  skipExternalEvents?: InputMaybe<Scalars['Boolean']['input']>;
  skipTemperature?: InputMaybe<Scalars['Boolean']['input']>;
  skipShortAreaCodes?: InputMaybe<Scalars['Boolean']['input']>;
  skipNotifications?: InputMaybe<Scalars['Boolean']['input']>;
  skipHasNotifications?: InputMaybe<Scalars['Boolean']['input']>;
  includeDeliveriesCustomFieldsInTourCustomFields?: InputMaybe<Scalars['Boolean']['input']>;
  skipDeliveriesCustomFields?: InputMaybe<Scalars['Boolean']['input']>;
  skipDocuments?: InputMaybe<Scalars['Boolean']['input']>;
  skipNotes?: InputMaybe<Scalars['Boolean']['input']>;
  skipExceptions?: InputMaybe<Scalars['Boolean']['input']>;
  skipGeofenceZones?: InputMaybe<Scalars['Boolean']['input']>;
  skipVehiclePositions?: InputMaybe<Scalars['Boolean']['input']>;
  skipVehicleChangePositions?: InputMaybe<Scalars['Boolean']['input']>;
  includeExtended?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type TransportDetailsQuery = {
  viewer:
    | ({
        user_id: string;
        company:
          | ({
              company_id: string;
              tour: ({ canBeModified: boolean } & TourContainerDetailsFragment & { __typename: 'Tour' }) | null;
              vehicle: ({ vehicle_id: string; license_plate_number: string | null } & { __typename: 'Vehicle' }) | null;
            } & { __typename: 'Company' })
          | null;
      } & { __typename: 'User' })
    | null;
} & { __typename: 'Query' };

export type TransportWithoutVehicleDetailsQueryVariables = Exact<{
  companyId: Scalars['String']['input'];
  tourId: Scalars['Int']['input'];
  skipSharingToken?: InputMaybe<Scalars['Boolean']['input']>;
  skipMobileTrackingToken?: InputMaybe<Scalars['Boolean']['input']>;
  skipPlace?: InputMaybe<Scalars['Boolean']['input']>;
  skipExternalEvents?: InputMaybe<Scalars['Boolean']['input']>;
  skipTemperature?: InputMaybe<Scalars['Boolean']['input']>;
  skipShortAreaCodes?: InputMaybe<Scalars['Boolean']['input']>;
  skipNotifications?: InputMaybe<Scalars['Boolean']['input']>;
  skipHasNotifications?: InputMaybe<Scalars['Boolean']['input']>;
  includeDeliveriesCustomFieldsInTourCustomFields?: InputMaybe<Scalars['Boolean']['input']>;
  skipDeliveriesCustomFields?: InputMaybe<Scalars['Boolean']['input']>;
  skipDocuments?: InputMaybe<Scalars['Boolean']['input']>;
  skipNotes?: InputMaybe<Scalars['Boolean']['input']>;
  skipExceptions?: InputMaybe<Scalars['Boolean']['input']>;
  skipGeofenceZones?: InputMaybe<Scalars['Boolean']['input']>;
  skipVehiclePositions?: InputMaybe<Scalars['Boolean']['input']>;
  skipVehicleChangePositions?: InputMaybe<Scalars['Boolean']['input']>;
  includeExtended?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type TransportWithoutVehicleDetailsQuery = {
  viewer:
    | ({
        user_id: string;
        company:
          | ({
              company_id: string;
              tour: ({ canBeModified: boolean } & TourContainerDetailsFragment & { __typename: 'Tour' }) | null;
            } & { __typename: 'Company' })
          | null;
      } & { __typename: 'User' })
    | null;
} & { __typename: 'Query' };

export type UpdateTransportDetailsQueryVariables = Exact<{
  companyId: Scalars['String']['input'];
  tourId: Scalars['Int']['input'];
}>;

export type UpdateTransportDetailsQuery = {
  viewer:
    | ({
        user_id: string;
        company:
          | ({
              company_id: string;
              tour:
                | ({
                    tour_id: number;
                    shipper_transport_number: string | null;
                    stops: Array<
                      {
                        stop_id: number;
                        display_sequence_number: number;
                        type: string | null;
                        location:
                          | ({
                              address:
                                | ({
                                    city: string | null;
                                    country: string | null;
                                    street_address: string | null;
                                    zipcode: string | null;
                                  } & { __typename: 'Address' })
                                | null;
                            } & { __typename: 'TourLocation' })
                          | null;
                        timeslot: ({ begin: string | null; end: string | null } & { __typename: 'Timeslot' }) | null;
                        deliveries: Array<
                          {
                            deliveryId: string;
                            purchaseOrderNumber: string | null;
                            deliveryNumber: string | null;
                            orderNumber: string | null;
                            customFields: Array<
                              {
                                fieldName: string;
                                values: Array<{ value: string } & { __typename: 'CustomFieldValue' }>;
                              } & { __typename: 'CustomField' }
                            >;
                          } & { __typename: 'TourDelivery' }
                        >;
                      } & { __typename: 'TourStop' }
                    >;
                  } & { __typename: 'Tour' })
                | null;
            } & { __typename: 'Company' })
          | null;
      } & { __typename: 'User' })
    | null;
} & { __typename: 'Query' };

export type DeleteTourMutationVariables = Exact<{
  input: TourDeletionInput;
}>;

export type DeleteTourMutation = { deleteTour: boolean | null } & { __typename: 'Mutation' };

export type VehicleDetailsQueryVariables = Exact<{
  companyId: Scalars['String']['input'];
  vehicleId: Scalars['String']['input'];
  returnVehicleState: Scalars['Boolean']['input'];
  dwellTimeThresholdMinutes?: InputMaybe<Scalars['Int']['input']>;
}>;

export type VehicleDetailsQuery = {
  viewer:
    | ({
        user_id: string;
        company:
          | ({
              company_id: string;
              vehicle:
                | ({
                    vehicle_id: string;
                    license_plate_number: string | null;
                    isConstantPositionAccessAllowed: boolean;
                    mapTilesTemplateURI: string | null;
                    vehicleMapState: VehicleMapState | null;
                    boundingBox: Array<{ lat: number; lng: number } & { __typename: 'PointLocation' }> | null;
                    status:
                      | ({ timestamp: string; source: VehicleSignalSource } & { __typename: 'RestrictedVehicleStatus' })
                      | null;
                  } & { __typename: 'Vehicle' })
                | null;
            } & { __typename: 'Company' })
          | null;
      } & { __typename: 'User' })
    | null;
} & { __typename: 'Query' };

export type MapViewVehiclesTileQueryVariables = Exact<{
  companyId: Scalars['String']['input'];
  vehicleGroupIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  vehicleStateFilter?: InputMaybe<VehicleStateFilterInput>;
  licensePlateSearch?: InputMaybe<Scalars['String']['input']>;
  ownVehiclesOnly: Scalars['Boolean']['input'];
  returnVehicleState: Scalars['Boolean']['input'];
  timeBasedStatusFilter?: InputMaybe<TimeBasedStatus>;
  dwellTime?: InputMaybe<Scalars['Int']['input']>;
}>;

export type MapViewVehiclesTileQuery = {
  viewer:
    | ({
        user_id: string;
        company:
          | ({
              company_id: string;
              vehicles:
                | ({
                    all:
                      | ({
                          mapTilesTemplateURI: string | null;
                          boundingBox: Array<{ lat: number; lng: number } & { __typename: 'PointLocation' }> | null;
                        } & { __typename: 'CountedVehicleConnection' })
                      | null;
                  } & { __typename: 'CompanyVehicles' })
                | null;
            } & { __typename: 'Company' })
          | null;
      } & { __typename: 'User' })
    | null;
} & { __typename: 'Query' };

export type FleetVehicleToursQueryVariables = Exact<{
  companyId: Scalars['String']['input'];
  vehicleId: Scalars['String']['input'];
  status?: InputMaybe<Array<TourStatusFilter> | TourStatusFilter>;
  fromTime: Scalars['DateTime']['input'];
  toTime: Scalars['DateTime']['input'];
  dwellTimeThresholdMinutes?: InputMaybe<Scalars['Int']['input']>;
}>;

export type FleetVehicleToursQuery = {
  viewer:
    | ({
        user_id: string;
        company:
          | ({
              company_id: string;
              vehicle:
                | ({
                    vehicle_id: string;
                    vehicleMapState: VehicleMapState | null;
                    boundingBox: Array<{ lat: number; lng: number } & { __typename: 'PointLocation' }> | null;
                    breakStatus:
                      | ({ vehicleBreakStatusId: string; from: string; to: string | null } & {
                          __typename: 'VehicleBreakStatus';
                        })
                      | null;
                    tours: Array<
                      FleetTourDetailsFragment & FleetVehicleHistoryFragment & { __typename: 'Tour' }
                    > | null;
                  } & FleetVehicleDetailsFragment &
                    FleetReceivedGrantFragment & { __typename: 'Vehicle' })
                | null;
            } & { __typename: 'Company' })
          | null;
      } & { __typename: 'User' })
    | null;
} & { __typename: 'Query' };

export type CompanyApiMetricsMessagesQueryVariables = Exact<{
  companyId: Scalars['String']['input'];
  endpointId: Scalars['String']['input'];
  statusCode: Scalars['String']['input'];
  startDate: Scalars['DateTime']['input'];
  endDate: Scalars['DateTime']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<SortDirection>;
}>;

export type CompanyApiMetricsMessagesQuery = {
  viewer:
    | ({
        user_id: string;
        company:
          | ({
              company_id: string;
              apiMetricsMessages: {
                edges: Array<
                  | ({
                      cursor: string | null;
                      node:
                        | ({
                            endpointId: string | null;
                            errorMessage: string | null;
                            statusCode: string | null;
                            requestPayload: string | null;
                            requestUrl: string | null;
                            timestamp: string | null;
                          } & { __typename: 'ApiMetricsEntry' })
                        | null;
                    } & { __typename: 'ApiMetricsEntryEdge' })
                  | null
                > | null;
                pageInfo: {
                  hasNextPage: boolean;
                  hasPreviousPage: boolean;
                  startCursor: string | null;
                  endCursor: string | null;
                } & { __typename: 'PageInfo' };
              } & { __typename: 'ApiMetricsEntryConnection' };
            } & { __typename: 'Company' })
          | null;
      } & { __typename: 'User' })
    | null;
} & { __typename: 'Query' };

export type TelematicsProviderDetailsFragment = {
  telematicsProviderId: string;
  telematicsProviderName: string;
  integrationInstructionsURL: string | null;
  isExternalConfigurationNeeded: boolean;
  integrationType: string | null;
  isDeprecated: boolean | null;
  isAddingIntegrationDisabled: boolean | null;
  connectionParameters: Array<
    {
      fieldName: string;
      fieldType: ConnectionParameterFieldType;
      isOptional: boolean;
      fieldDisplayName: string | null;
      defaultValue: string | null;
      enumFieldValues: Array<
        { value: string; display_name: string | null; is_default: boolean } & {
          __typename: 'ConnectionParameterEnumValue';
        }
      >;
    } & { __typename: 'ConnectionParameter' }
  >;
} & { __typename: 'TelematicsProvider' };

export type CompanyTelematicsIntegrationDetailsFragment = {
  companyId: string;
  telematicsIntegrationId: string;
  diagnosticStatus: TelematicsIntegrationDiagnosticStatus | null;
  updatedAt: string;
  connectionData: { [key: string]: string | number | boolean } | null;
  enabled: boolean;
  isAllowedToUpdateCredentials: boolean;
  telematicsProvider: TelematicsProviderDetailsFragment & { __typename: 'TelematicsProvider' };
} & { __typename: 'CompanyTelematicsIntegration' };

export type CompanyIntegrationsQueryVariables = Exact<{
  companyId: Scalars['String']['input'];
}>;

export type CompanyIntegrationsQuery = {
  viewer:
    | ({
        user_id: string;
        company:
          | ({
              company_id: string;
              telematicsIntegrations: Array<
                {
                  companyId: string;
                  telematicsIntegrationId: string;
                  diagnosticStatus: TelematicsIntegrationDiagnosticStatus | null;
                  diagnosticComment: string | null;
                  updatedAt: string;
                  enabled: boolean;
                  isAllowedToUpdateCredentials: boolean;
                  lastSuccess: string | null;
                  lastIntegrationSyncResult:
                    | ({
                        startTimeAt: string;
                        vehicleAmbiguityCount: number | null;
                        conflictingLicensePlates: Array<
                          { licensePlate: string; remoteIds: Array<string> | null } & {
                            __typename: 'ConflictingLicensePlate';
                          }
                        > | null;
                        conflictingRemoteIds: Array<
                          { remoteId: string; licensePlates: Array<string> | null } & {
                            __typename: 'ConflictingRemoteId';
                          }
                        > | null;
                      } & { __typename: 'IntegrationSyncResult' })
                    | null;
                  telematicsProvider: {
                    isDeprecated: boolean | null;
                    telematicsProviderId: string;
                    telematicsProviderName: string;
                  } & { __typename: 'TelematicsProvider' };
                } & { __typename: 'CompanyTelematicsIntegration' }
              >;
            } & { __typename: 'Company' })
          | null;
      } & { __typename: 'User' })
    | null;
} & { __typename: 'Query' };

export type CompanyApiEndpointUsageLogsQueryVariables = Exact<{
  companyId: Scalars['String']['input'];
}>;

export type CompanyApiEndpointUsageLogsQuery = {
  viewer:
    | ({
        user_id: string;
        company:
          | ({
              company_id: string;
              apiEndpointUsageLogs: Array<
                {
                  apiImplementedAt: string | null;
                  endpointId: string;
                  endpointName: string;
                  integrationIdentifier: string;
                  firstCallAt: string;
                  lastCallAt: string;
                  implementationStatus: ImplementationStatus;
                  apiHealthStatus: ApiHealth;
                  counters: Array<
                    { logDate: string; statusCode: number | null; noOfCalls: number } & {
                      __typename: 'EndpointUsageCounterByDate';
                    }
                  >;
                  webhookSubscription:
                    | ({ status: CompanyWebhookSubscriptionStatus; subscriptionId: string; companyId: string } & {
                        __typename: 'CompanyWebhookSubscription';
                      })
                    | null;
                } & { __typename: 'ApiEndpointUsageLog' }
              >;
            } & { __typename: 'Company' })
          | null;
      } & { __typename: 'User' })
    | null;
} & { __typename: 'Query' };

export type CompanyIntegrationQueryVariables = Exact<{
  companyId: Scalars['String']['input'];
  telematicsIntegrationId: Scalars['String']['input'];
}>;

export type CompanyIntegrationQuery = {
  viewer:
    | ({
        user_id: string;
        company:
          | ({
              company_id: string;
              telematicsIntegration:
                | (CompanyTelematicsIntegrationDetailsFragment & { __typename: 'CompanyTelematicsIntegration' })
                | null;
            } & { __typename: 'Company' })
          | null;
      } & { __typename: 'User' })
    | null;
} & { __typename: 'Query' };

export type TelematicsProvidersQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  textSearch?: InputMaybe<Scalars['String']['input']>;
  isDeprecated?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type TelematicsProvidersQuery = {
  telematicsProvidersV2: {
    providers: {
      edges: Array<
        | ({
            node:
              | ({ telematicsProviderId: string; telematicsProviderName: string } & {
                  __typename: 'TelematicsProvider';
                })
              | null;
          } & { __typename: 'TelematicsProviderEdge' })
        | null
      > | null;
      pageInfo: { hasNextPage: boolean; endCursor: string | null } & { __typename: 'PageInfo' };
    } & { __typename: 'TelematicsProviderConnection' };
  } & { __typename: 'CountedTelematicsProviderConnection' };
} & { __typename: 'Query' };

export type TelematicsProviderQueryVariables = Exact<{
  telematicsProviderId: Scalars['String']['input'];
}>;

export type TelematicsProviderQuery = {
  telematicsProvider: (TelematicsProviderDetailsFragment & { __typename: 'TelematicsProvider' }) | null;
} & { __typename: 'Query' };

export type CreateTelematicsIntegrationMutationVariables = Exact<{
  input: CreateTelematicsIntegrationInput;
}>;

export type CreateTelematicsIntegrationMutation = {
  createTelematicsIntegration:
    | ({
        telematics_integration_id: string;
        telematics_provider_id: string;
        enabled: boolean;
        updatedAt: string;
        diagnosticStatus: TelematicsIntegrationDiagnosticStatus | null;
        company_id: string;
        isAllowedToUpdateCredentials: boolean;
        generatedToken: string | null;
        telematicsProvider: {
          telematicsProviderId: string;
          telematicsProviderName: string;
          isDeprecated: boolean | null;
        } & { __typename: 'TelematicsProvider' };
      } & { __typename: 'TelematicsIntegration' })
    | null;
} & { __typename: 'Mutation' };

export type UpdateTelematicsIntegrationConnectionParametersMutationVariables = Exact<{
  input: UpdateTelematicsIntegrationConnectionParametersInput;
}>;

export type UpdateTelematicsIntegrationConnectionParametersMutation = {
  updateTelematicsIntegrationConnectionParameters:
    | (CompanyTelematicsIntegrationDetailsFragment & { __typename: 'CompanyTelematicsIntegration' })
    | null;
} & { __typename: 'Mutation' };

export type ValidateTelematicsIntegrationUpdateMutationVariables = Exact<{
  input: ValidateTelematicsIntegrationConnectionParametersUpdateInput;
}>;

export type ValidateTelematicsIntegrationUpdateMutation = {
  validateTelematicsIntegrationConnectionParametersUpdate:
    | ({ areValidCredentials: boolean } & { __typename: 'TelematicsValidation' })
    | null;
} & { __typename: 'Mutation' };

export type ValidateTelematicsIntegrationMutationVariables = Exact<{
  input: ValidateTelematicsIntegrationInput;
}>;

export type ValidateTelematicsIntegrationMutation = {
  validateTelematicsIntegration: ({ areValidCredentials: boolean } & { __typename: 'TelematicsValidation' }) | null;
} & { __typename: 'Mutation' };

export type SubmitUnsupportedTelematicsProviderDetailsMutationVariables = Exact<{
  input: SubmitUnsupportedTelematicsProviderDetailsInput;
}>;

export type SubmitUnsupportedTelematicsProviderDetailsMutation = {
  submitUnsupportedTelematicsProviderDetails: boolean;
} & { __typename: 'Mutation' };

export type DeleteTelematicsIntegrationMutationVariables = Exact<{
  telematicsIntegrationId: Scalars['String']['input'];
}>;

export type DeleteTelematicsIntegrationMutation = { deleteTelematicsIntegration: boolean } & { __typename: 'Mutation' };

export type ExclusiveVehicleCountByTelematicsIntegrationQueryVariables = Exact<{
  companyId: Scalars['String']['input'];
  telematicsIntegrationId: Scalars['String']['input'];
}>;

export type ExclusiveVehicleCountByTelematicsIntegrationQuery = {
  viewer:
    | ({
        user_id: string;
        company:
          | ({
              company_id: string;
              telematicsIntegration:
                | ({
                    telematicsIntegrationId: string;
                    exclusiveVehicleCount: number;
                    telematicsProvider: { telematicsProviderId: string; telematicsProviderName: string } & {
                      __typename: 'TelematicsProvider';
                    };
                  } & { __typename: 'CompanyTelematicsIntegration' })
                | null;
            } & { __typename: 'Company' })
          | null;
      } & { __typename: 'User' })
    | null;
} & { __typename: 'Query' };

export type TransportNotificationFragment = {
  notificationId: string;
  name: string;
  status: NotificationStatus;
  createdByUserId: string;
  createdAt: string;
  notificationTrigger:
    | ({
        failureReasons: Array<TourFailureReasonType> | null;
        warnings: Array<TourWarningType> | null;
        exceptionTypes: Array<string> | null;
        serviceExceptionCodes: Array<string> | null;
        etaComparison: Array<
          {
            comparisonTerm: ComparisonTerm;
            comparisonValueInSeconds: number;
            stopId: string | null;
            comparisonUnit: ComparisonUnit;
            remainingTimeInSeconds: number | null;
            remainingTimeUnit: ComparisonUnit | null;
          } & { __typename: 'EtaComparison' }
        > | null;
        trackingNotStarted:
          | ({
              remainingTime: {
                comparisonField: TrackingNotStartedRemainingTimeField;
                comparisonValue: number;
                comparisonUnit: ComparisonUnit;
              } & { __typename: 'TrackingNotStartedRemainingTime' };
            } & { __typename: 'TrackingNotStarted' })
          | null;
        vehicleTemperatureOutOfRange:
          | ({
              minTemperature: number | null;
              maxTemperature: number | null;
              temperatureUnit: VehicleTemperatureOutOfRangeTemperatureUnit | null;
              duration: number;
              durationUnit: ComparisonUnit;
              resolutionNotificationEnabled: boolean;
            } & { __typename: 'VehicleTemperatureOutOfRange' })
          | null;
        stopVisited:
          | ({
              stopTypes: Array<StopVisitedStopType>;
              includeStopLevelTrackingLinkForPickupStopEvent: boolean | null;
            } & { __typename: 'StopVisited' })
          | null;
      } & { __typename: 'NotificationTrigger' })
    | null;
  notificationCustomization:
    | ({ transportLevelSubjectLine: string | null; stopLevelSubjectLine: string | null } & {
        __typename: 'NotificationCustomization';
      })
    | null;
  recipientsV2: Array<
    | ({ email: string; locale: string } & { __typename: 'EmailRecipient' })
    | ({ phoneNumber: string; locale: string } & { __typename: 'SmsRecipient' })
    | ({ emailStopContact: boolean | null; smsStopContact: boolean | null } & { __typename: 'StopContactRecipient' })
  >;
  transportFilter: (FilterFragment & { __typename: 'TourFilter' }) | null;
  creator:
    | ({ userId: string; firstName: string | null; lastName: string | null } & {
        __typename: 'NotificationUserProfile';
      })
    | null;
  deliverySettings: ({ frequency: DeliveryFrequency } & { __typename: 'DeliverySettings' }) | null;
} & { __typename: 'FilterBasedTransportNotification' };

export type DeleteFilterBasedTransportNotificationMutationVariables = Exact<{
  input: DeleteFilterBasedTransportNotificationInput;
}>;

export type DeleteFilterBasedTransportNotificationMutation = { deleteFilterBasedTransportNotification: boolean } & {
  __typename: 'Mutation';
};

export type CreateOrUpdateFilterBasedTransportNotificationMutationVariables = Exact<{
  input: CreateOrUpdateFilterBasedTransportNotificationInput;
}>;

export type CreateOrUpdateFilterBasedTransportNotificationMutation = {
  createOrUpdateFilterBasedTransportNotification: string;
} & { __typename: 'Mutation' };

export type CompanyFilterBasedNotificationsQueryVariables = Exact<{
  companyId: Scalars['String']['input'];
  sort?: InputMaybe<NotificationSortOrder>;
  filter?: InputMaybe<NotificationFilterInput>;
}>;

export type CompanyFilterBasedNotificationsQuery = {
  viewer:
    | ({
        user_id: string;
        company:
          | ({
              company_id: string;
              filterBasedTransportNotifications: Array<
                TransportNotificationFragment & { __typename: 'FilterBasedTransportNotification' }
              >;
            } & { __typename: 'Company' })
          | null;
      } & { __typename: 'User' })
    | null;
} & { __typename: 'Query' };

export type CompanyFilterBasedNotificationQueryVariables = Exact<{
  companyId: Scalars['String']['input'];
  notificationId: Scalars['String']['input'];
}>;

export type CompanyFilterBasedNotificationQuery = {
  viewer:
    | ({
        user_id: string;
        company:
          | ({
              company_id: string;
              filterBasedTransportNotification:
                | (TransportNotificationFragment & { __typename: 'FilterBasedTransportNotification' })
                | null;
            } & { __typename: 'Company' })
          | null;
      } & { __typename: 'User' })
    | null;
} & { __typename: 'Query' };

export type NotificationCreatorsQueryVariables = Exact<{
  companyId: Scalars['String']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;

export type NotificationCreatorsQuery = {
  viewer:
    | ({
        user_id: string;
        company:
          | ({
              company_id: string;
              filterBasedTransportNotificationsCreators: Array<
                { userId: string; firstName: string | null; lastName: string | null; email: string | null } & {
                  __typename: 'NotificationUserProfile';
                }
              >;
            } & { __typename: 'Company' })
          | null;
      } & { __typename: 'User' })
    | null;
} & { __typename: 'Query' };

export type CompanyOnboardingActionQueryVariables = Exact<{
  companyId: Scalars['String']['input'];
}>;

export type CompanyOnboardingActionQuery = {
  viewer:
    | ({
        user_id: string;
        company:
          | ({
              company_id: string;
              signupStatusTransitionedAt: string | null;
              companySignupStatusRollbackProjectedAt: string | null;
              onboardingAction: ({ type: OnboardingActionKey } & { __typename: 'OnboardingAction' }) | null;
            } & { __typename: 'Company' })
          | null;
      } & { __typename: 'User' })
    | null;
} & { __typename: 'Query' };

export type AddressDetailsFragment = {
  stopAddressId: string;
  companyName: string | null;
  streetAddress: string | null;
  postalCode: string | null;
  city: string | null;
  state: string | null;
  country: string | null;
  invalidFields: Array<CompanyStopAddressField> | null;
  place: ({ place_id: string; name: string } & { __typename: 'CompanyPlace' }) | null;
} & { __typename: 'CompanyStopAddress' };

export type PlaceDetailsFragment = {
  name: string;
  place_id: string;
  isSixfoldGenerated: boolean;
  referenceId: string | null;
  updatedAt: string | null;
  addresses: Array<
    {
      stopAddressId: string;
      companyName: string | null;
      streetAddress: string | null;
      postalCode: string | null;
      city: string | null;
      state: string | null;
      country: string | null;
    } & { __typename: 'CompanyStopAddress' }
  >;
} & { __typename: 'CompanyPlace' };

export type TourDataFragment = {
  tour_id: number;
  shipper_transport_number: string | null;
  working_stop_id: number | null;
  carrier: ({ company_id: string; company_name: string | null } & { __typename: 'CompanyProfile' }) | null;
  activeVehicleAllocation:
    | ({ vehicleLicensePlateNumber: string | null } & { __typename: 'TourVehicleAllocation' })
    | null;
  stops: Array<
    {
      stop_id: number;
      estimated_arrival: string | null;
      estimated_arrival_status: string | null;
      estimated_arrival_distance_in_meters: number | null;
      arrival_time: string | null;
      timeslot:
        | ({ begin: string | null; end: string | null; timezone: string | null } & { __typename: 'Timeslot' })
        | null;
    } & { __typename: 'TourStop' }
  >;
} & { __typename: 'Tour' };

export type PlacesQueryVariables = Exact<{
  companyId: Scalars['String']['input'];
  textSearch?: InputMaybe<PlaceTextSearch>;
  includeSixfoldGenerated?: InputMaybe<Scalars['Boolean']['input']>;
  first: Scalars['Int']['input'];
  cursor?: InputMaybe<Scalars['String']['input']>;
}>;

export type PlacesQuery = {
  viewer:
    | ({
        user_id: string;
        company:
          | ({
              company_id: string;
              placesConnection: {
                mapTilesTemplateURI: string | null;
                count: number;
                mapTilesBounds:
                  | ({
                      ne: { lat: number; lng: number } & { __typename: 'PointLocation' };
                      sw: { lat: number; lng: number } & { __typename: 'PointLocation' };
                    } & { __typename: 'Bounds' })
                  | null;
                places: {
                  edges: Array<
                    | ({ node: (PlaceDetailsFragment & { __typename: 'CompanyPlace' }) | null } & {
                        __typename: 'CompanyPlaceEdge';
                      })
                    | null
                  > | null;
                  pageInfo: { hasNextPage: boolean; endCursor: string | null } & { __typename: 'PageInfo' };
                } & { __typename: 'CompanyPlaceConnection' };
              } & { __typename: 'CountedCompanyPlaceConnection' };
            } & { __typename: 'Company' })
          | null;
      } & { __typename: 'User' })
    | null;
} & { __typename: 'Query' };

export type PlaceQueryVariables = Exact<{
  companyId: Scalars['String']['input'];
  placeId: Scalars['String']['input'];
  includeStopAddresses: Scalars['Boolean']['input'];
}>;

export type PlaceQuery = {
  viewer:
    | ({
        user_id: string;
        company:
          | ({
              company_id: string;
              place:
                | ({
                    name: string;
                    place_id: string;
                    referenceId: string | null;
                    isSixfoldGenerated: boolean;
                    updatedAt: string | null;
                    updatedByUser:
                      | ({
                          user_id: string;
                          email: string | null;
                          first_name: string | null;
                          last_name: string | null;
                        } & { __typename: 'UserProfile' })
                      | null;
                    geofences: Array<
                      {
                        zone: PlaceGeofenceZoneType;
                        geofence:
                          | ({
                              radius_meters: number;
                              origin: { lat: number; lng: number } & { __typename: 'PointLocation' };
                            } & { __typename: 'CircleGeofence' })
                          | ({ points: Array<{ lat: number; lng: number } & { __typename: 'PointLocation' }> } & {
                              __typename: 'PolygonGeofence';
                            });
                      } & { __typename: 'PlaceGeofenceWithZone' }
                    >;
                    addresses: Array<
                      {
                        location: ({ lat: number; lng: number } & { __typename: 'PointLocation' }) | null;
                      } & AddressDetailsFragment & { __typename: 'CompanyStopAddress' }
                    >;
                    location: { lat: number; lng: number } & { __typename: 'PointLocation' };
                    possibleAddresses?: {
                      edges: Array<
                        | ({
                            node:
                              | ({
                                  location: ({ lat: number; lng: number } & { __typename: 'PointLocation' }) | null;
                                } & AddressDetailsFragment & { __typename: 'CompanyStopAddress' })
                              | null;
                          } & { __typename: 'CompanyStopAddressEdge' })
                        | null
                      > | null;
                    } & { __typename: 'CompanyStopAddressConnection' };
                  } & { __typename: 'CompanyPlace' })
                | null;
            } & { __typename: 'Company' })
          | null;
      } & { __typename: 'User' })
    | null;
} & { __typename: 'Query' };

export type CreatePlaceMutationVariables = Exact<{
  input: CreateCompanyPlaceInput;
}>;

export type CreatePlaceMutation = {
  createCompanyPlace: (PlaceDetailsFragment & { __typename: 'CompanyPlace' }) | null;
} & { __typename: 'Mutation' };

export type UpdatePlaceMutationVariables = Exact<{
  input: UpdateCompanyPlaceInput;
}>;

export type UpdatePlaceMutation = {
  updateCompanyPlace: (PlaceDetailsFragment & { __typename: 'CompanyPlace' }) | null;
} & { __typename: 'Mutation' };

export type ExposeSixfoldGeneratedPlaceMutationVariables = Exact<{
  input: ExposeSixfoldGeneratedPlaceInput;
}>;

export type ExposeSixfoldGeneratedPlaceMutation = {
  exposeSixfoldGeneratedPlace: (PlaceDetailsFragment & { __typename: 'CompanyPlace' }) | null;
} & { __typename: 'Mutation' };

export type DeletePlaceMutationVariables = Exact<{
  placeId: Scalars['String']['input'];
}>;

export type DeletePlaceMutation = { deleteCompanyPlace: boolean | null } & { __typename: 'Mutation' };

export type AddressesQueryVariables = Exact<{
  companyId: Scalars['String']['input'];
  textSearch?: InputMaybe<Scalars['String']['input']>;
  first: Scalars['Int']['input'];
  cursor?: InputMaybe<Scalars['String']['input']>;
}>;

export type AddressesQuery = {
  viewer:
    | ({
        user_id: string;
        company:
          | ({
              company_id: string;
              stopAddressesConnection: {
                mapTilesTemplateURI: string | null;
                count: number;
                mapTilesBounds:
                  | ({
                      ne: { lat: number; lng: number } & { __typename: 'PointLocation' };
                      sw: { lat: number; lng: number } & { __typename: 'PointLocation' };
                    } & { __typename: 'Bounds' })
                  | null;
                addresses: {
                  edges: Array<
                    | ({ node: (AddressDetailsFragment & { __typename: 'CompanyStopAddress' }) | null } & {
                        __typename: 'CompanyStopAddressEdge';
                      })
                    | null
                  > | null;
                  pageInfo: { hasNextPage: boolean; endCursor: string | null } & { __typename: 'PageInfo' };
                } & { __typename: 'CompanyStopAddressConnection' };
              } & { __typename: 'CountedCompanyStopAddressConnection' };
            } & { __typename: 'Company' })
          | null;
      } & { __typename: 'User' })
    | null;
} & { __typename: 'Query' };

export type AddressQueryVariables = Exact<{
  companyId: Scalars['String']['input'];
  addressId: Scalars['String']['input'];
}>;

export type AddressQuery = {
  viewer:
    | ({
        user_id: string;
        company:
          | ({
              company_id: string;
              stopAddress:
                | ({
                    location: ({ lat: number; lng: number } & { __typename: 'PointLocation' }) | null;
                    closeByAddresses: {
                      edges: Array<
                        | ({
                            node:
                              | ({
                                  location: ({ lat: number; lng: number } & { __typename: 'PointLocation' }) | null;
                                } & AddressDetailsFragment & { __typename: 'CompanyStopAddress' })
                              | null;
                          } & { __typename: 'CompanyStopAddressEdge' })
                        | null
                      > | null;
                    } & { __typename: 'CompanyStopAddressConnection' };
                  } & AddressDetailsFragment & { __typename: 'CompanyStopAddress' })
                | null;
            } & { __typename: 'Company' })
          | null;
      } & { __typename: 'User' })
    | null;
} & { __typename: 'Query' };

export type PlaceShipmentsQueryVariables = Exact<{
  companyId: Scalars['String']['input'];
  placeId: Scalars['String']['input'];
  arrivalTimeBefore?: InputMaybe<Scalars['DateTime']['input']>;
}>;

export type PlaceShipmentsQuery = {
  viewer:
    | ({
        user_id: string;
        company:
          | ({
              company_id: string;
              place:
                | ({
                    place_id: string;
                    approaching: {
                      count: number;
                      tours: {
                        edges: Array<
                          | ({ node: (TourDataFragment & { __typename: 'Tour' }) | null } & { __typename: 'TourEdge' })
                          | null
                        > | null;
                      } & { __typename: 'TourConnection' };
                    } & { __typename: 'CountedPlaceTourConnection' };
                    atSite: {
                      count: number;
                      tours: {
                        edges: Array<
                          | ({ node: (TourDataFragment & { __typename: 'Tour' }) | null } & { __typename: 'TourEdge' })
                          | null
                        > | null;
                      } & { __typename: 'TourConnection' };
                    } & { __typename: 'CountedPlaceTourConnection' };
                  } & { __typename: 'CompanyPlace' })
                | null;
            } & { __typename: 'Company' })
          | null;
      } & { __typename: 'User' })
    | null;
} & { __typename: 'Query' };

export type SharedViewViewerQueryVariables = Exact<{
  sharedViewId: Scalars['String']['input'];
  skipActiveSharedView: Scalars['Boolean']['input'];
}>;

export type SharedViewViewerQuery = {
  sharedViewViewer:
    | ({
        viewerId: string;
        email: string | null;
        sharedViews: Array<
          {
            sharedViewId: string;
            name: string;
            isActive: boolean;
            transportType: TransportType;
            canShowVehiclePositions: boolean;
            owner: ({ company_id: string; company_name: string | null } & { __typename: 'CompanyProfile' }) | null;
          } & { __typename: 'SharedViewContent' }
        >;
        sharedView?:
          | ({
              sharedViewId: string;
              isActive: boolean;
              name: string;
              transportType: TransportType;
              canShowVehiclePositions: boolean;
              accessStatus: SharedViewEmailAccessStatus | null;
              owner: ({ company_id: string; company_name: string | null } & { __typename: 'CompanyProfile' }) | null;
              filterV1: ({ statuses: Array<TourStatusFilter> | null } & { __typename: 'TourFilter' }) | null;
              branding:
                | ({ logo: ({ url: string } & { __typename: 'SharedViewBrandingAsset' }) | null } & {
                    __typename: 'SharedViewBrandingAssets';
                  })
                | null;
            } & { __typename: 'SharedViewContent' })
          | null;
      } & { __typename: 'SharedViewViewer' })
    | null;
} & { __typename: 'Query' };

export type SharedViewTripListNodeFragment = {
  tour_id: number;
  shipper_transport_number: string | null;
  billOfLading: string | null;
  bookingNumber: string | null;
  containerNumber: string | null;
  carrierName: string | null;
  carrierCode: string | null;
  shipperContactName: string | null;
  consigneeContactName: string | null;
  customerContactName: string | null;
  shipperLocationName: string | null;
  consigneeLocationName: string | null;
  customerLocationName: string | null;
  transportGroupId: string | null;
  containerType: string | null;
  transitTime: number | null;
  endToEndTransitTime: number | null;
  impactDays: number | null;
  endToEndImpactDays: number | null;
  status: string | null;
  airWayBill: string | null;
  shipmentType: ShipmentType | null;
  customerPackageCount: number | null;
  customerPackageWeight: number | null;
  carrierPackageCount: number | null;
  carrierPackageWeight: number | null;
  transportAlertsCount: number;
  transportAlertsHighestSeverity: TransportAlertSeverity | null;
  customFields: Array<
    { fieldName: string; values: Array<{ value: string } & { __typename: 'CustomFieldValue' }> } & {
      __typename: 'CustomField';
    }
  >;
  vesselNames:
    | ({ pol: string | null; pod: string | null; polVoyageId: string | null; podVoyageId: string | null } & {
        __typename: 'TripVesselNames';
      })
    | null;
  stops: Array<
    {
      stop_id: number;
      deliveries: Array<
        {
          deliveryId: string;
          deliveryNumber: string | null;
          orderNumber: string | null;
          purchaseOrderNumber: string | null;
          incoterms: ({ term: string | null } & { __typename: 'TourIncoterms' }) | null;
        } & { __typename: 'TourDelivery' }
      >;
    } & { __typename: 'TourStop' }
  >;
  carrier: ({ company_id: string; company_name: string | null } & { __typename: 'CompanyProfile' }) | null;
  milestones:
    | ({
        locations: Array<
          {
            name: string;
            locationCode: string | null;
            iataCode: string | null;
            voyageId: string | null;
            type: LocationType | null;
            country: string | null;
            milestones: Array<
              {
                milestone: string;
                qualifier: MilestoneQualifier | null;
                scheduledTimeOfArrivalSource: string | null;
                estimatedTimeOfArrivalSource: string | null;
                actualTimeOfArrivalSource: string | null;
                vehicleId: string | null;
                packageCount: string | null;
                scheduledTimeOfArrival:
                  | ({ dateTime: string; timezone: string } & { __typename: 'DateTimeWithTimezone' })
                  | null;
                estimatedTimeOfArrival:
                  | ({ dateTime: string; timezone: string } & { __typename: 'DateTimeWithTimezone' })
                  | null;
                actualTimeOfArrival:
                  | ({ dateTime: string; timezone: string } & { __typename: 'DateTimeWithTimezone' })
                  | null;
                actualTimeOfArrivalOverrides:
                  | ({
                      actualTimeOfArrivalSource: string | null;
                      actualTimeOfArrival:
                        | ({ dateTime: string; timezone: string } & { __typename: 'DateTimeWithTimezone' })
                        | null;
                    } & { __typename: 'ActualTimeOverrides' })
                  | null;
              } & { __typename: 'MilestoneWithLocation' }
            >;
          } & { __typename: 'MilestoneLocation' }
        >;
        vehicles: Array<
          { vehicleId: string; name: string | null; voyageId: string | null } & { __typename: 'VehicleData' }
        >;
      } & { __typename: 'LocationsAndMilestones' })
    | null;
  incoterm: ({ term: string | null } & { __typename: 'TourIncoterms' }) | null;
  oceanDemurragePOD: (DemurrageFragment & { __typename: 'OceanDemurrage' }) | null;
  oceanDemurragePOL: (DemurrageFragment & { __typename: 'OceanDemurrage' }) | null;
  relatedTransportsForListView: Array<
    { tour_id: number; shipper_transport_number: string | null } & { __typename: 'RelatedTransportForListView' }
  >;
  documents: Array<{ documentId: string } & { __typename: 'Document' }>;
} & { __typename: 'Tour' };

export type SharedViewTripsTransportsQueryVariables = Exact<{
  sharedViewId: Scalars['String']['input'];
  sortOrder?: InputMaybe<TourSortOrder>;
  tripsSearch?: InputMaybe<TripsTextSearch>;
  statuses?: InputMaybe<Array<TourStatusFilter> | TourStatusFilter>;
  delayStatus?: InputMaybe<TourDelayStatusFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
}>;

export type SharedViewTripsTransportsQuery = {
  sharedViewViewer:
    | ({
        viewerId: string;
        sharedView:
          | ({
              sharedViewId: string;
              name: string;
              isActive: boolean;
              transportType: TransportType;
              owner: ({ company_id: string; company_name: string | null } & { __typename: 'CompanyProfile' }) | null;
              tripsTours:
                | ({
                    count: number;
                    boundedCount: number | null;
                    tours: {
                      edges: Array<
                        | ({
                            cursor: string | null;
                            node: (SharedViewTripListNodeFragment & { __typename: 'Tour' }) | null;
                          } & { __typename: 'TourEdge' })
                        | null
                      > | null;
                      pageInfo: { hasNextPage: boolean; endCursor: string | null } & { __typename: 'PageInfo' };
                    } & { __typename: 'TourConnection' };
                    mapTilesBounds:
                      | ({
                          ne: { lat: number; lng: number } & { __typename: 'PointLocation' };
                          sw: { lat: number; lng: number } & { __typename: 'PointLocation' };
                        } & { __typename: 'Bounds' })
                      | null;
                    tripsPositionsGeoJSON:
                      | ({
                          type: string;
                          features: Array<
                            {
                              type: string;
                              geometry: { type: string; coordinates: Array<number> } & {
                                __typename: 'GeoJSONGeometry';
                              };
                              properties: {
                                position_id: string;
                                total_containers: number;
                                tour_ids: Array<string>;
                                delay_status: string | null;
                              } & { __typename: 'PositionGeoJSONProperties' };
                            } & { __typename: 'PositionGeoJSONFeature' }
                          >;
                        } & { __typename: 'PositionGeoJSONFeatureCollection' })
                      | null;
                  } & { __typename: 'CountedTripsTourConnection' })
                | null;
            } & { __typename: 'SharedViewContent' })
          | null;
      } & { __typename: 'SharedViewViewer' })
    | null;
} & { __typename: 'Query' };

export type SharedViewTripsTransportsSearchQueryVariables = Exact<{
  sharedViewId: Scalars['String']['input'];
  tripsSearch?: InputMaybe<TripsTextSearch>;
  first?: InputMaybe<Scalars['Int']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
}>;

export type SharedViewTripsTransportsSearchQuery = {
  sharedViewViewer:
    | ({
        viewerId: string;
        sharedView:
          | ({
              sharedViewId: string;
              tripsTours:
                | ({
                    count: number;
                    tours: {
                      edges: Array<
                        | ({
                            cursor: string | null;
                            node: (SharedViewTripListNodeFragment & { __typename: 'Tour' }) | null;
                          } & { __typename: 'TourEdge' })
                        | null
                      > | null;
                      pageInfo: { hasNextPage: boolean; endCursor: string | null } & { __typename: 'PageInfo' };
                    } & { __typename: 'TourConnection' };
                  } & { __typename: 'CountedTripsTourConnection' })
                | null;
            } & { __typename: 'SharedViewContent' })
          | null;
      } & { __typename: 'SharedViewViewer' })
    | null;
} & { __typename: 'Query' };

export type SharedViewTransportsQueryVariables = Exact<{
  sharedViewId: Scalars['String']['input'];
  sortOrder?: InputMaybe<TourSortOrder>;
  textSearch?: InputMaybe<TourTextSearch>;
  statuses?: InputMaybe<Array<TourStatusFilter> | TourStatusFilter>;
  delayStatus?: InputMaybe<TourDelayStatusFilter>;
  stopFilters?: InputMaybe<Array<StopFilterInput> | StopFilterInput>;
  startTimeAfter?: InputMaybe<Scalars['DateTime']['input']>;
  startTimeBefore?: InputMaybe<Scalars['DateTime']['input']>;
  startTimeSugarTimezone?: InputMaybe<Scalars['IANATimezone']['input']>;
  endTimeAfter?: InputMaybe<Scalars['DateTime']['input']>;
  endTimeBefore?: InputMaybe<Scalars['DateTime']['input']>;
  endTimeSugarTimezone?: InputMaybe<Scalars['IANATimezone']['input']>;
  delayTime?: InputMaybe<TimeRangeInput>;
  hasNotes?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
}>;

export type SharedViewTransportsQuery = {
  sharedViewViewer:
    | ({
        viewerId: string;
        sharedView:
          | ({
              sharedViewId: string;
              name: string;
              isActive: boolean;
              canShowVehiclePositions: boolean;
              owner: ({ company_id: string; company_name: string | null } & { __typename: 'CompanyProfile' }) | null;
              unallocated: ({ count: number } & { __typename: 'CountedTourConnection' }) | null;
              upcoming: ({ count: number } & { __typename: 'CountedTourConnection' }) | null;
              working: ({ count: number } & { __typename: 'CountedTourConnection' }) | null;
              on_time: ({ count: number } & { __typename: 'CountedTourConnection' }) | null;
              delayed: ({ count: number } & { __typename: 'CountedTourConnection' }) | null;
              unknown: ({ count: number } & { __typename: 'CountedTourConnection' }) | null;
              tours:
                | ({
                    count: number;
                    mapTilesTemplateURI: string | null;
                    tours: {
                      edges: Array<
                        | ({ node: (ShipmentFragment & { __typename: 'Tour' }) | null } & { __typename: 'TourEdge' })
                        | null
                      > | null;
                      pageInfo: { hasNextPage: boolean; endCursor: string | null } & { __typename: 'PageInfo' };
                    } & { __typename: 'TourConnection' };
                    mapTilesBounds:
                      | ({
                          ne: { lat: number; lng: number } & { __typename: 'PointLocation' };
                          sw: { lat: number; lng: number } & { __typename: 'PointLocation' };
                        } & { __typename: 'Bounds' })
                      | null;
                  } & { __typename: 'CountedTourConnection' })
                | null;
            } & { __typename: 'SharedViewContent' })
          | null;
      } & { __typename: 'SharedViewViewer' })
    | null;
} & { __typename: 'Query' };

export type SharedViewTransportsSearchQueryVariables = Exact<{
  sharedViewId: Scalars['String']['input'];
  textSearch?: InputMaybe<TourTextSearch>;
  first?: InputMaybe<Scalars['Int']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
}>;

export type SharedViewTransportsSearchQuery = {
  sharedViewViewer:
    | ({
        viewerId: string;
        sharedView:
          | ({
              sharedViewId: string;
              tours:
                | ({
                    count: number;
                    tours: {
                      edges: Array<
                        | ({ node: (ShipmentFragment & { __typename: 'Tour' }) | null } & { __typename: 'TourEdge' })
                        | null
                      > | null;
                      pageInfo: { hasNextPage: boolean; endCursor: string | null } & { __typename: 'PageInfo' };
                    } & { __typename: 'TourConnection' };
                  } & { __typename: 'CountedTourConnection' })
                | null;
            } & { __typename: 'SharedViewContent' })
          | null;
      } & { __typename: 'SharedViewViewer' })
    | null;
} & { __typename: 'Query' };

export type SharedViewFocusedShipmentQueryVariables = Exact<{
  sharedViewId: Scalars['String']['input'];
  tourId: Scalars['Int']['input'];
  skipVehiclePositions?: InputMaybe<Scalars['Boolean']['input']>;
  skipVehicleChangePositions?: InputMaybe<Scalars['Boolean']['input']>;
  includeExtended?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type SharedViewFocusedShipmentQuery = {
  sharedViewViewer:
    | ({
        viewerId: string;
        sharedView:
          | ({
              sharedViewId: string;
              canShowVehiclePositions: boolean;
              tour: (FocusedMapShipmentFieldsFragment & { __typename: 'Tour' }) | null;
            } & { __typename: 'SharedViewContent' })
          | null;
      } & { __typename: 'SharedViewViewer' })
    | null;
} & { __typename: 'Query' };

export type SharedViewTourDetailsQueryVariables = Exact<{
  sharedViewId: Scalars['String']['input'];
  tourId: Scalars['Int']['input'];
  companyId?: InputMaybe<Scalars['String']['input']>;
  skipSharingToken?: InputMaybe<Scalars['Boolean']['input']>;
  skipMobileTrackingToken?: InputMaybe<Scalars['Boolean']['input']>;
  skipPlace?: InputMaybe<Scalars['Boolean']['input']>;
  skipExternalEvents: Scalars['Boolean']['input'];
  skipTemperature: Scalars['Boolean']['input'];
  skipShortAreaCodes?: InputMaybe<Scalars['Boolean']['input']>;
  skipNotifications?: InputMaybe<Scalars['Boolean']['input']>;
  skipHasNotifications?: InputMaybe<Scalars['Boolean']['input']>;
  includeDeliveriesCustomFieldsInTourCustomFields?: InputMaybe<Scalars['Boolean']['input']>;
  skipDeliveriesCustomFields?: InputMaybe<Scalars['Boolean']['input']>;
  skipDocuments?: InputMaybe<Scalars['Boolean']['input']>;
  skipNotes?: InputMaybe<Scalars['Boolean']['input']>;
  skipExceptions?: InputMaybe<Scalars['Boolean']['input']>;
  skipGeofenceZones?: InputMaybe<Scalars['Boolean']['input']>;
  skipVehiclePositions?: InputMaybe<Scalars['Boolean']['input']>;
  skipVehicleChangePositions?: InputMaybe<Scalars['Boolean']['input']>;
  includeExtended?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type SharedViewTourDetailsQuery = {
  sharedViewViewer:
    | ({
        viewerId: string;
        sharedView:
          | ({
              sharedViewId: string;
              canShowVehiclePositions: boolean;
              tour: (TourContainerDetailsFragment & { __typename: 'Tour' }) | null;
            } & { __typename: 'SharedViewContent' })
          | null;
      } & { __typename: 'SharedViewViewer' })
    | null;
} & { __typename: 'Query' };

export type AcceptSharedViewInvitationMutationVariables = Exact<{
  sharedViewId: Scalars['String']['input'];
}>;

export type AcceptSharedViewInvitationMutation = { acceptSharedViewInvitation: boolean } & { __typename: 'Mutation' };

export type NotificationReportDownloadQueryVariables = Exact<{ [key: string]: never }>;

export type NotificationReportDownloadQuery = {
  token:
    | ({
        resourceType: TokenResourceType;
        notificationReport:
          | ({ reportId: string; downloadUrl: string } & { __typename: 'SharedNotificationReport' })
          | null;
      } & { __typename: 'TokenResources' })
    | null;
} & { __typename: 'Query' };

export type CompanyProfileQueryVariables = Exact<{
  companyId: Scalars['String']['input'];
}>;

export type CompanyProfileQuery = {
  viewer:
    | ({
        user_id: string;
        company:
          | ({
              company_id: string;
              company_name: string | null;
              transporeonId: string | null;
              vatNumbers: Array<{ vatNumber: string } & { __typename: 'CompanyVatNumber' }>;
              sharedViewBranding: { logo: ({ url: string } & { __typename: 'CompanyAsset' }) | null } & {
                __typename: 'CompanySharedViewBranding';
              };
              settings: {
                transportContactDetails: Array<
                  {
                    firstName: string | null;
                    lastName: string | null;
                    emails: Array<string | null>;
                    phones: Array<string | null>;
                    customText: string | null;
                  } & { __typename: 'CompanyTransportContactDetails' }
                >;
              } & { __typename: 'CompanySettings' };
            } & { __typename: 'Company' })
          | null;
      } & { __typename: 'User' })
    | null;
} & { __typename: 'Query' };

export type UploadSharedViewLogoMutationVariables = Exact<{
  companyId: Scalars['String']['input'];
  logo: Scalars['Upload']['input'];
}>;

export type UploadSharedViewLogoMutation = {
  uploadSharedViewLogo:
    | ({ code: UploadFileErrorCode; message: string } & { __typename: 'UploadFileError' })
    | ({ assetId: string; url: string } & { __typename: 'UploadedCompanyAsset' });
} & { __typename: 'Mutation' };

export type UpdateCompanySharedViewBrandingMutationVariables = Exact<{
  companyId: Scalars['String']['input'];
  input: UpdateCompanySharedViewBrandingInput;
}>;

export type UpdateCompanySharedViewBrandingMutation = {
  updateCompanySharedViewBranding: ({ company_id: string } & { __typename: 'Company' }) | null;
} & { __typename: 'Mutation' };

export type CompanySettingsQueryVariables = Exact<{
  companyId: Scalars['String']['input'];
}>;

export type CompanySettingsQuery = {
  viewer:
    | ({
        user_id: string;
        company:
          | ({
              company_id: string;
              settings: {
                shareOwnVehiclesInGlobalPool: boolean;
                allowAllocatingFromGlobalPool: boolean;
                enableAutoAllocation: boolean;
                enableAutoAllocationFullVisibility: boolean;
                enableTourEmissionsCalculation: boolean;
                transportContactDetails: Array<
                  {
                    firstName: string | null;
                    lastName: string | null;
                    emails: Array<string | null>;
                    phones: Array<string | null>;
                    customText: string | null;
                  } & { __typename: 'CompanyTransportContactDetails' }
                >;
              } & { __typename: 'CompanySettings' };
            } & { __typename: 'Company' })
          | null;
      } & { __typename: 'User' })
    | null;
} & { __typename: 'Query' };

export type UpdateCompanySettingsMutationVariables = Exact<{
  input: UpdateCompanySettingsInput;
}>;

export type UpdateCompanySettingsMutation = {
  updateCompanySettings: ({ company_id: string } & { __typename: 'Company' }) | null;
} & { __typename: 'Mutation' };

export type SetCompanyVatNumbersMutationVariables = Exact<{
  companyId: Scalars['String']['input'];
  input: Array<CompanyVatNumberInput> | CompanyVatNumberInput;
  retainMissingCountryCodes: Scalars['Boolean']['input'];
}>;

export type SetCompanyVatNumbersMutation = {
  setCompanyVATNumbers: ({ success: boolean } & { __typename: 'CompanyVatNumberChangeResult' }) | null;
} & { __typename: 'Mutation' };

export type SetCompanyTransportContactDetailsMutationVariables = Exact<{
  input: UpdateCompanyTransportContactsInput;
}>;

export type SetCompanyTransportContactDetailsMutation = {
  updateCompanyTransportContacts: ({ company_id: string } & { __typename: 'Company' }) | null;
} & { __typename: 'Mutation' };

export type UserNotificationConfigQueryVariables = Exact<{
  userId: Scalars['String']['input'];
  companyId: Scalars['String']['input'];
}>;

export type UserNotificationConfigQuery = {
  userNotificationConfig:
    | ({
        user_notification_config_id: string;
        user_id: string;
        company_id: string;
        disabled_types: Array<EmailType>;
      } & { __typename: 'UserNotificationConfig' })
    | null;
} & { __typename: 'Query' };

export type UpdateUserNotificationConfigMutationVariables = Exact<{
  input: UpdateUserNotificationConfigInput;
}>;

export type UpdateUserNotificationConfigMutation = {
  updateUserNotificationConfig: ({ success: boolean } & { __typename: 'UpdateUserNotificationConfigResponse' }) | null;
} & { __typename: 'Mutation' };

export type CompanyCustomFieldSettingsQueryVariables = Exact<{
  companyId: Scalars['String']['input'];
}>;

export type CompanyCustomFieldSettingsQuery = {
  viewer:
    | ({
        user_id: string;
        company:
          | ({
              company_id: string;
              roadCustomFields: Array<
                { displayName: string | null; name: string } & { __typename: 'ConnectedCustomField' }
              >;
              oceanCustomFields: Array<
                { displayName: string | null; name: string } & { __typename: 'ConnectedCustomField' }
              >;
              airCustomFields: Array<
                { displayName: string | null; name: string } & { __typename: 'ConnectedCustomField' }
              >;
              inlandCustomFields: Array<
                { displayName: string | null; name: string } & { __typename: 'ConnectedCustomField' }
              >;
            } & { __typename: 'Company' })
          | null;
      } & { __typename: 'User' })
    | null;
} & { __typename: 'Query' };

export type UpdateCustomFieldDisplayNamesMutationVariables = Exact<{
  input: UpdateCustomFieldDisplayNamesInput;
}>;

export type UpdateCustomFieldDisplayNamesMutation = {
  updateCustomFieldDisplayNames: ({ company_id: string } & { __typename: 'Company' }) | null;
} & { __typename: 'Mutation' };

export type SharedViewUserProfileFragment = {
  userId: string;
  isSupport: boolean;
  isDeleted: boolean;
  firstName: string | null;
  lastName: string | null;
} & { __typename: 'SharedViewUserProfile' };

export type SharedViewEmailAccessFragment = {
  sharedViewAccessId: string;
  email: string;
  locale: string;
  status: SharedViewEmailAccessStatus;
  createdAt: string;
  updatedAt: string;
  acceptedAt: string | null;
  expiredAt: string | null;
  token:
    | ({ tokenId: string; createdAt: string; expiresAt: string | null } & { __typename: 'SharedViewEmailAccessToken' })
    | null;
} & { __typename: 'SharedViewEmailAccess' };

export type FilteredSharedViewsListQueryVariables = Exact<{
  companyId: Scalars['String']['input'];
  filter: SharedViewsFilterInput;
  sort: SharedViewsSortOrder;
  first?: InputMaybe<Scalars['Int']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
}>;

export type FilteredSharedViewsListQuery = {
  viewer:
    | ({
        user_id: string;
        company:
          | ({
              company_id: string;
              notFiltered: { count: number } & { __typename: 'CountedSharedViewConnection' };
              sharedViewsConnection: {
                count: number;
                sharedViews: {
                  edges: Array<
                    | ({
                        node:
                          | ({
                              sharedViewId: string;
                              isActive: boolean;
                              name: string;
                              transportType: TransportType;
                              viewerHasAccessToAllUserGroups: boolean;
                              createdByUser:
                                | (SharedViewUserProfileFragment & { __typename: 'SharedViewUserProfile' })
                                | null;
                              sharingLinks: Array<
                                { name: string | null; token: string | null } & { __typename: 'SharedViewLink' }
                              > | null;
                              emailAccesses: Array<
                                SharedViewEmailAccessFragment & { __typename: 'SharedViewEmailAccess' }
                              > | null;
                              filter: (FilterFragment & { __typename: 'TourFilter' }) | null;
                            } & { __typename: 'SharedView' })
                          | null;
                      } & { __typename: 'SharedViewEdge' })
                    | null
                  > | null;
                  pageInfo: { hasNextPage: boolean; endCursor: string | null } & { __typename: 'PageInfo' };
                } & { __typename: 'SharedViewConnection' };
              } & { __typename: 'CountedSharedViewConnection' };
            } & { __typename: 'Company' })
          | null;
      } & { __typename: 'User' })
    | null;
} & { __typename: 'Query' };

export type SharedViewCreatorsQueryVariables = Exact<{
  companyId: Scalars['String']['input'];
}>;

export type SharedViewCreatorsQuery = {
  viewer:
    | ({
        user_id: string;
        company:
          | ({
              company_id: string;
              sharedViewsCreatedBy: Array<SharedViewUserProfileFragment & { __typename: 'SharedViewUserProfile' }>;
            } & { __typename: 'Company' })
          | null;
      } & { __typename: 'User' })
    | null;
} & { __typename: 'Query' };

export type SharedViewQueryVariables = Exact<{
  companyId: Scalars['String']['input'];
  sharedViewId: Scalars['String']['input'];
}>;

export type SharedViewQuery = {
  viewer:
    | ({
        user_id: string;
        company:
          | ({
              company_id: string;
              sharedView:
                | ({
                    sharedViewId: string;
                    isActive: boolean;
                    name: string;
                    transportType: TransportType;
                    viewerHasAccessToAllUserGroups: boolean;
                    createdAt: string;
                    updatedAt: string;
                    createdByUser: (SharedViewUserProfileFragment & { __typename: 'SharedViewUserProfile' }) | null;
                    updatedByUser: (SharedViewUserProfileFragment & { __typename: 'SharedViewUserProfile' }) | null;
                    filter: (FilterFragment & { __typename: 'TourFilter' }) | null;
                    sharingLinks: Array<
                      { publicLinkId: string | null; name: string | null; token: string | null } & {
                        __typename: 'SharedViewLink';
                      }
                    > | null;
                    emailAccesses: Array<
                      SharedViewEmailAccessFragment & { __typename: 'SharedViewEmailAccess' }
                    > | null;
                  } & { __typename: 'SharedView' })
                | null;
            } & { __typename: 'Company' })
          | null;
      } & { __typename: 'User' })
    | null;
} & { __typename: 'Query' };

export type DeleteSharedViewMutationVariables = Exact<{
  input: DeleteSharedViewInput;
}>;

export type DeleteSharedViewMutation = { deleteSharedView: boolean | null } & { __typename: 'Mutation' };

export type CreateSharedViewMutationVariables = Exact<{
  input: CreateSharedViewInput;
}>;

export type CreateSharedViewMutation = { createSharedView: boolean | null } & { __typename: 'Mutation' };

export type UpdateSharedViewMutationVariables = Exact<{
  input: UpdateSharedViewInput;
}>;

export type UpdateSharedViewMutation = { updateSharedView: boolean | null } & { __typename: 'Mutation' };

export type ResendSharedViewEmailInvitationMutationVariables = Exact<{
  input: ResendSharedViewEmailInvitationInput;
}>;

export type ResendSharedViewEmailInvitationMutation = {
  resendSharedViewEmailInvitation:
    | ({ success: boolean; emailAccess: SharedViewEmailAccessFragment & { __typename: 'SharedViewEmailAccess' } } & {
        __typename: 'ResendSharedViewEmailInvitationResult';
      })
    | null;
} & { __typename: 'Mutation' };

export type CreateUserFilterMutationVariables = Exact<{
  input: CreateUserFilterInput;
}>;

export type CreateUserFilterMutation = {
  createUserFilter: ({ userFilterId: string } & { __typename: 'UserFilter' }) | null;
} & { __typename: 'Mutation' };

export type CompanyAndPersonalFilterTotalCountsQueryVariables = Exact<{
  companyId: Scalars['String']['input'];
}>;

export type CompanyAndPersonalFilterTotalCountsQuery = {
  viewer:
    | ({
        user_id: string;
        company:
          | ({
              company_id: string;
              me:
                | ({
                    role: UserRoleInCompany;
                    userFiltersConnection: { count: number } & { __typename: 'CountedUserFilterConnection' };
                  } & { __typename: 'UserInCompany' })
                | null;
              companyTourFiltersConnection: { count: number } & { __typename: 'CountedCompanyTourFilterConnection' };
            } & { __typename: 'Company' })
          | null;
      } & { __typename: 'User' })
    | null;
} & { __typename: 'Query' };

export type RemoveUserFilterMutationVariables = Exact<{
  userFilterId: Scalars['String']['input'];
}>;

export type RemoveUserFilterMutation = { removeUserFilter: boolean | null } & { __typename: 'Mutation' };

export type RemoveCompanyFilterMutationVariables = Exact<{
  companyFilterId: Scalars['String']['input'];
}>;

export type RemoveCompanyFilterMutation = { deleteCompanyTourFilter: boolean | null } & { __typename: 'Mutation' };

export type CreateCompanyFilterMutationVariables = Exact<{
  companyFilterInput: CreateCompanyTourFilterInput;
}>;

export type CreateCompanyFilterMutation = {
  createCompanyTourFilter: ({ companyTourFilterId: string; name: string } & { __typename: 'CompanyTourFilter' }) | null;
} & { __typename: 'Mutation' };

export type ShipmentCountsQueryVariables = Exact<{
  companyId: Scalars['String']['input'];
  role: TourCompanyRole;
}>;

export type ShipmentCountsQuery = {
  viewer:
    | ({
        user_id: string;
        company:
          | ({
              company_id: string;
              unallocated: { count: number } & { __typename: 'CountedTourConnection' };
              upcoming: { count: number } & { __typename: 'CountedTourConnection' };
              on_time: { count: number } & { __typename: 'CountedTourConnection' };
              delayed: { count: number } & { __typename: 'CountedTourConnection' };
              unknown: { count: number } & { __typename: 'CountedTourConnection' };
              working: { count: number } & { __typename: 'CountedTourConnection' };
            } & { __typename: 'Company' })
          | null;
      } & { __typename: 'User' })
    | null;
} & { __typename: 'Query' };

export type ShipmentFragment = {
  tour_id: number;
  status: string | null;
  working_stop_id: number | null;
  shipper_transport_number: string | null;
  transportIdentifiers: Array<string> | null;
  start_time: string | null;
  end_time: string | null;
  isGlobalAllocation: boolean;
  isGloballyAllocatedToViewerCompany: boolean;
  currentVehicle:
    | ({ vehicleLicensePlateNumber: string | null; vehicleId: string | null } & { __typename: 'VehicleAllocation' })
    | null;
  activeVehicleAllocation:
    | ({ vehicleLicensePlateNumber: string | null; allocationDeviceType: TourAllocationDeviceType | null } & {
        __typename: 'TourVehicleAllocation';
      })
    | null;
  trackedVehicles: Array<
    { vehicleId: string; vehicleLicensePlateNumber: string | null } & { __typename: 'TrackedVehicle' }
  >;
  warnings: Array<{ type: TourWarningType; severity: TourWarningSeverity | null } & { __typename: 'TourWarning' }>;
  failureReason: ({ type: TourFailureReasonType } & { __typename: 'TourFailureReason' }) | null;
  exceptions: Array<
    | ({
        exceptionId: string;
        type: string;
        description: string;
        stopId: string | null;
        deliveryIds: Array<string>;
        createdAt: string;
        source: ExceptionSource;
      } & { __typename: 'DeliveryException' })
    | ({ exceptionId: string; code: string; description: string; time: string; source: ExceptionSource } & {
        __typename: 'ServiceException';
      })
  >;
  carrier: ({ company_id: string; company_name: string | null } & { __typename: 'CompanyProfile' }) | null;
  shipper: ({ company_id: string; company_name: string | null } & { __typename: 'CompanyProfile' }) | null;
  subcontractor: ({ company_id: string; company_name: string | null } & { __typename: 'CompanyProfile' }) | null;
  stops: Array<
    {
      stop_id: number;
      type: string | null;
      status: string | null;
      estimated_arrival_accuracy: string | null;
      estimated_arrival_status: string | null;
      estimated_arrival_delay_in_seconds: number | null;
      estimated_arrival: string | null;
      arrival_delay_in_seconds: number | null;
      arrival_time: string | null;
      departure_time: string | null;
      deadline: string | null;
      sequence_number: number | null;
      display_sequence_number: number;
      display_actual_sequence_number: number;
      actual_sequence_number: number | null;
      timeslot:
        | ({ begin: string | null; end: string | null; timezone: string | null } & { __typename: 'Timeslot' })
        | null;
      location:
        | ({
            name: string | null;
            address: ({ country: string | null; city: string | null } & { __typename: 'Address' }) | null;
            position: ({ lat: number | null; lng: number | null } & { __typename: 'GeoPosition' }) | null;
          } & { __typename: 'TourLocation' })
        | null;
    } & { __typename: 'TourStop' }
  >;
  assignedUser:
    | ({ user_id: string; first_name: string | null; last_name: string | null; email: string | null } & {
        __typename: 'UserProfile';
      })
    | null;
} & { __typename: 'Tour' };

export type RoadTransportsCustomFieldsQueryVariables = Exact<{
  companyId: Scalars['String']['input'];
  role: TourCompanyRole;
  tourIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
  first: Scalars['Int']['input'];
}>;

export type RoadTransportsCustomFieldsQuery = {
  viewer:
    | ({
        user_id: string;
        company:
          | ({
              company_id: string;
              tours: {
                tours: {
                  edges: Array<
                    | ({
                        node:
                          | ({
                              tour_id: number;
                              customFields: Array<
                                {
                                  fieldName: string;
                                  values: Array<{ value: string } & { __typename: 'CustomFieldValue' }>;
                                } & { __typename: 'CustomField' }
                              >;
                            } & { __typename: 'Tour' })
                          | null;
                      } & { __typename: 'TourEdge' })
                    | null
                  > | null;
                } & { __typename: 'TourConnection' };
              } & { __typename: 'CountedTourConnection' };
            } & { __typename: 'Company' })
          | null;
      } & { __typename: 'User' })
    | null;
} & { __typename: 'Query' };

export type FocusedMapShipmentFieldsFragment = {
  isExtendedTrailAvailable: boolean;
  vehicleHistory: Array<
    {
      polyline: { points: string } & { __typename: 'Polyline' };
      metadata: {
        isExtendedTrail: boolean;
        type: VehicleHistoryPolylineType;
        startTime: string;
        endTime: string;
        vehicleId: string;
      } & { __typename: 'VehicleHistoryPolylineMetadata' };
    } & { __typename: 'VehicleHistoryPolyline' }
  > | null;
  vehicle_status:
    | ({
        timestamp: string | null;
        latitude: number | null;
        longitude: number | null;
        heading: number | null;
        accuracyInMeters: number | null;
      } & { __typename: 'VehicleStatus' })
    | null;
  tourPositionHistory?: Array<
    { vehicleId: string; lat: number; lng: number; receivedAt: string | null } & { __typename: 'VehiclePosition' }
  > | null;
  vehicleChangePositions?: Array<
    {
      vehicleId: string;
      lat: number;
      lng: number;
      receivedAt: string | null;
      previousLicensePlate: string | null;
      currentLicensePlate: string | null;
    } & { __typename: 'VehicleChangePosition' }
  > | null;
  vehicleAllocations: Array<
    { vehicleId: string | null; vehicleLicensePlateNumber: string | null } & { __typename: 'TourVehicleAllocation' }
  >;
  trackedVehicles: Array<
    { vehicleId: string; vehicleLicensePlateNumber: string | null } & { __typename: 'TrackedVehicle' }
  >;
  route:
    | ({
        legs: Array<
          {
            polyline: { points: string } & { __typename: 'Polyline' };
            metadata: { isExtendedRoute: boolean } & { __typename: 'RouteLegMetadata' };
          } & { __typename: 'RouteLeg' }
        >;
      } & { __typename: 'Route' })
    | null;
  visibleVehicleBreakHistory: Array<
    {
      vehicle_id: string;
      breaks: Array<
        {
          breakId: string;
          from: string;
          to: string | null;
          center: { lat: number; lng: number } & { __typename: 'BreakCenterPosition' };
        } & { __typename: 'VehicleBreakHistory' }
      >;
    } & { __typename: 'VehicleBreakHistoryEntry' }
  > | null;
} & ShipmentFragment & { __typename: 'Tour' };

export type ShipmentsQueryVariables = Exact<{
  companyId: Scalars['String']['input'];
  role: TourCompanyRole;
  first?: InputMaybe<Scalars['Int']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Array<TourStatusFilter> | TourStatusFilter>;
  endTimeAfter?: InputMaybe<Scalars['DateTime']['input']>;
  endTimeBefore?: InputMaybe<Scalars['DateTime']['input']>;
  endTimeSugarTimezone?: InputMaybe<Scalars['IANATimezone']['input']>;
  startTimeAfter?: InputMaybe<Scalars['DateTime']['input']>;
  startTimeBefore?: InputMaybe<Scalars['DateTime']['input']>;
  startTimeSugarTimezone?: InputMaybe<Scalars['IANATimezone']['input']>;
  delayStatus?: InputMaybe<TourDelayStatusFilter>;
  textSearch?: InputMaybe<TourTextSearch>;
  sortOrder?: InputMaybe<TourSortOrder>;
  siteIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  carrierIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  customerIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  customFields?: InputMaybe<Array<TourCustomFieldSearch> | TourCustomFieldSearch>;
  failureReasons?: InputMaybe<Array<TourFailureReasonType> | TourFailureReasonType>;
  warnings?: InputMaybe<Array<TourWarningType> | TourWarningType>;
  workingStopTimeslotBeginEnd?: InputMaybe<Scalars['DateTime']['input']>;
  timezone?: InputMaybe<Scalars['IANATimezone']['input']>;
  delayTime?: InputMaybe<TimeRangeInput>;
  timeAtStop?: InputMaybe<TimeRangeInput>;
  lastSignalTimestamp?: InputMaybe<LastSignalTimestampFilterInput>;
  workingStopStatus?: InputMaybe<WorkingStopStatusFilter>;
  assignedToUserIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  allocationStatus?: InputMaybe<TourAllocationStatus>;
  tourIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  documentTypes?: InputMaybe<Array<DocumentType> | DocumentType>;
  exceptionTypes?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  serviceExceptionCodes?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  orderItemNames?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  orderItemIsHazardous?: InputMaybe<Scalars['Boolean']['input']>;
  orderItemCustomFields?: InputMaybe<OrderItemCustomFieldInput>;
  hasNotes?: InputMaybe<Scalars['Boolean']['input']>;
  stopFilters?: InputMaybe<Array<StopFilterInput> | StopFilterInput>;
  mainVisibilityIssues?: InputMaybe<Array<VisibilityIssueType> | VisibilityIssueType>;
  vehicleLicensePlates?: InputMaybe<Array<TourVehicleLicensePlateFilterInput> | TourVehicleLicensePlateFilterInput>;
  hasTemperature?: InputMaybe<Scalars['Boolean']['input']>;
  temperatureEverOutOfRange?: InputMaybe<TemperatureEverOutOfRangeFilterInput>;
}>;

export type ShipmentsQuery = {
  viewer:
    | ({
        user_id: string;
        company:
          | ({
              company_id: string;
              tours: {
                count: number;
                reportDownloadURI: string | null;
                tours: {
                  edges: Array<
                    ({ node: (ShipmentFragment & { __typename: 'Tour' }) | null } & { __typename: 'TourEdge' }) | null
                  > | null;
                  pageInfo: { hasNextPage: boolean; endCursor: string | null } & { __typename: 'PageInfo' };
                } & { __typename: 'TourConnection' };
              } & { __typename: 'CountedTourConnection' };
            } & { __typename: 'Company' })
          | null;
      } & { __typename: 'User' })
    | null;
} & { __typename: 'Query' };

export type ShipmentsReportDownloadQueryVariables = Exact<{
  companyId: Scalars['String']['input'];
  role: TourCompanyRole;
  status?: InputMaybe<Array<TourStatusFilter> | TourStatusFilter>;
  endTimeAfter?: InputMaybe<Scalars['DateTime']['input']>;
  endTimeBefore?: InputMaybe<Scalars['DateTime']['input']>;
  endTimeSugarTimezone?: InputMaybe<Scalars['IANATimezone']['input']>;
  startTimeAfter?: InputMaybe<Scalars['DateTime']['input']>;
  startTimeBefore?: InputMaybe<Scalars['DateTime']['input']>;
  startTimeSugarTimezone?: InputMaybe<Scalars['IANATimezone']['input']>;
  delayStatus?: InputMaybe<TourDelayStatusFilter>;
  textSearch?: InputMaybe<TourTextSearch>;
  sortOrder?: InputMaybe<TourSortOrder>;
  siteIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  carrierIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  customerIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  customFields?: InputMaybe<Array<TourCustomFieldSearch> | TourCustomFieldSearch>;
  failureReasons?: InputMaybe<Array<TourFailureReasonType> | TourFailureReasonType>;
  warnings?: InputMaybe<Array<TourWarningType> | TourWarningType>;
  workingStopTimeslotBeginEnd?: InputMaybe<Scalars['DateTime']['input']>;
  timezone?: InputMaybe<Scalars['IANATimezone']['input']>;
  delayTime?: InputMaybe<TimeRangeInput>;
  timeAtStop?: InputMaybe<TimeRangeInput>;
  lastSignalTimestamp?: InputMaybe<LastSignalTimestampFilterInput>;
  workingStopStatus?: InputMaybe<WorkingStopStatusFilter>;
  assignedToUserIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  allocationStatus?: InputMaybe<TourAllocationStatus>;
  documentTypes?: InputMaybe<Array<DocumentType> | DocumentType>;
  exceptionTypes?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  serviceExceptionCodes?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  hasNotes?: InputMaybe<Scalars['Boolean']['input']>;
  stopFilters?: InputMaybe<Array<StopFilterInput> | StopFilterInput>;
  mainVisibilityIssues?: InputMaybe<Array<VisibilityIssueType> | VisibilityIssueType>;
  vehicleLicensePlates?: InputMaybe<Array<TourVehicleLicensePlateFilterInput> | TourVehicleLicensePlateFilterInput>;
  hasTemperature?: InputMaybe<Scalars['Boolean']['input']>;
  temperatureEverOutOfRange?: InputMaybe<TemperatureEverOutOfRangeFilterInput>;
}>;

export type ShipmentsReportDownloadQuery = {
  viewer:
    | ({
        user_id: string;
        company:
          | ({
              company_id: string;
              tours: { reportDownloadURI: string | null } & { __typename: 'CountedTourConnection' };
            } & { __typename: 'Company' })
          | null;
      } & { __typename: 'User' })
    | null;
} & { __typename: 'Query' };

export type MapShipmentFragment = {
  tour_id: number;
  status: string | null;
  working_stop_id: number | null;
  stops: Array<
    {
      stop_id: number;
      status: string | null;
      arrival_delay_in_seconds: number | null;
      estimated_arrival_status: string | null;
      location:
        | ({ position: ({ lat: number | null; lng: number | null } & { __typename: 'GeoPosition' }) | null } & {
            __typename: 'TourLocation';
          })
        | null;
    } & { __typename: 'TourStop' }
  >;
} & { __typename: 'Tour' };

export type ShipmentsTilesQueryVariables = Exact<{
  companyId: Scalars['String']['input'];
  role: TourCompanyRole;
  status?: InputMaybe<Array<TourStatusFilter> | TourStatusFilter>;
  endTimeAfter?: InputMaybe<Scalars['DateTime']['input']>;
  endTimeBefore?: InputMaybe<Scalars['DateTime']['input']>;
  endTimeSugarTimezone?: InputMaybe<Scalars['IANATimezone']['input']>;
  startTimeAfter?: InputMaybe<Scalars['DateTime']['input']>;
  startTimeBefore?: InputMaybe<Scalars['DateTime']['input']>;
  startTimeSugarTimezone?: InputMaybe<Scalars['IANATimezone']['input']>;
  delayStatus?: InputMaybe<TourDelayStatusFilter>;
  textSearch?: InputMaybe<TourTextSearch>;
  siteIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  carrierIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  customerIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  customFields?: InputMaybe<Array<TourCustomFieldSearch> | TourCustomFieldSearch>;
  failureReasons?: InputMaybe<Array<TourFailureReasonType> | TourFailureReasonType>;
  warnings?: InputMaybe<Array<TourWarningType> | TourWarningType>;
  workingStopTimeslotBeginEnd?: InputMaybe<Scalars['DateTime']['input']>;
  delayTime?: InputMaybe<TimeRangeInput>;
  timeAtStop?: InputMaybe<TimeRangeInput>;
  lastSignalTimestamp?: InputMaybe<LastSignalTimestampFilterInput>;
  workingStopStatus?: InputMaybe<WorkingStopStatusFilter>;
  assignedToUserIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  allocationStatus?: InputMaybe<TourAllocationStatus>;
  documentTypes?: InputMaybe<Array<DocumentType> | DocumentType>;
  exceptionTypes?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  serviceExceptionCodes?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  orderItemNames?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  orderItemIsHazardous?: InputMaybe<Scalars['Boolean']['input']>;
  orderItemCustomFields?: InputMaybe<OrderItemCustomFieldInput>;
  hasNotes?: InputMaybe<Scalars['Boolean']['input']>;
  stopFilters?: InputMaybe<Array<StopFilterInput> | StopFilterInput>;
  vehicleLicensePlates?: InputMaybe<Array<TourVehicleLicensePlateFilterInput> | TourVehicleLicensePlateFilterInput>;
  hasTemperature?: InputMaybe<Scalars['Boolean']['input']>;
  temperatureEverOutOfRange?: InputMaybe<TemperatureEverOutOfRangeFilterInput>;
}>;

export type ShipmentsTilesQuery = {
  viewer:
    | ({
        user_id: string;
        company:
          | ({
              company_id: string;
              tours: {
                mapTilesTemplateURI: string | null;
                mapTilesBounds:
                  | ({
                      ne: { lat: number; lng: number } & { __typename: 'PointLocation' };
                      sw: { lat: number; lng: number } & { __typename: 'PointLocation' };
                    } & { __typename: 'Bounds' })
                  | null;
              } & { __typename: 'CountedTourConnection' };
            } & { __typename: 'Company' })
          | null;
      } & { __typename: 'User' })
    | null;
} & { __typename: 'Query' };

export type ShipmentsLocationsQueryVariables = Exact<{
  companyId: Scalars['String']['input'];
  role: TourCompanyRole;
  status?: InputMaybe<Array<TourStatusFilter> | TourStatusFilter>;
  endTimeAfter?: InputMaybe<Scalars['DateTime']['input']>;
  endTimeBefore?: InputMaybe<Scalars['DateTime']['input']>;
  endTimeSugarTimezone?: InputMaybe<Scalars['IANATimezone']['input']>;
  startTimeAfter?: InputMaybe<Scalars['DateTime']['input']>;
  startTimeBefore?: InputMaybe<Scalars['DateTime']['input']>;
  startTimeSugarTimezone?: InputMaybe<Scalars['IANATimezone']['input']>;
  delayStatus?: InputMaybe<TourDelayStatusFilter>;
  textSearch?: InputMaybe<TourTextSearch>;
  siteIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  carrierIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  customerIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  customFields?: InputMaybe<Array<TourCustomFieldSearch> | TourCustomFieldSearch>;
  failureReasons?: InputMaybe<Array<TourFailureReasonType> | TourFailureReasonType>;
  warnings?: InputMaybe<Array<TourWarningType> | TourWarningType>;
  workingStopTimeslotBeginEnd?: InputMaybe<Scalars['DateTime']['input']>;
  delayTime?: InputMaybe<TimeRangeInput>;
  timeAtStop?: InputMaybe<TimeRangeInput>;
  lastSignalTimestamp?: InputMaybe<LastSignalTimestampFilterInput>;
  workingStopStatus?: InputMaybe<WorkingStopStatusFilter>;
  assignedToUserIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  allocationStatus?: InputMaybe<TourAllocationStatus>;
  documentTypes?: InputMaybe<Array<DocumentType> | DocumentType>;
  exceptionTypes?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  serviceExceptionCodes?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  orderItemNames?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  orderItemIsHazardous?: InputMaybe<Scalars['Boolean']['input']>;
  orderItemCustomFields?: InputMaybe<OrderItemCustomFieldInput>;
  hasNotes?: InputMaybe<Scalars['Boolean']['input']>;
  stopFilters?: InputMaybe<Array<StopFilterInput> | StopFilterInput>;
  mainVisibilityIssues?: InputMaybe<Array<VisibilityIssueType> | VisibilityIssueType>;
  vehicleLicensePlates?: InputMaybe<Array<TourVehicleLicensePlateFilterInput> | TourVehicleLicensePlateFilterInput>;
  hasTemperature?: InputMaybe<Scalars['Boolean']['input']>;
  temperatureEverOutOfRange?: InputMaybe<TemperatureEverOutOfRangeFilterInput>;
}>;

export type ShipmentsLocationsQuery = {
  viewer:
    | ({
        user_id: string;
        company:
          | ({
              company_id: string;
              tours: {
                tours: {
                  edges: Array<
                    | ({ node: (MapShipmentFragment & { __typename: 'Tour' }) | null } & { __typename: 'TourEdge' })
                    | null
                  > | null;
                } & { __typename: 'TourConnection' };
              } & { __typename: 'CountedTourConnection' };
            } & { __typename: 'Company' })
          | null;
      } & { __typename: 'User' })
    | null;
} & { __typename: 'Query' };

export type FocusedMapShipmentQueryVariables = Exact<{
  companyId: Scalars['String']['input'];
  tourId: Scalars['Int']['input'];
  skipVehiclePositions?: InputMaybe<Scalars['Boolean']['input']>;
  skipVehicleChangePositions?: InputMaybe<Scalars['Boolean']['input']>;
  includeExtended?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type FocusedMapShipmentQuery = {
  viewer:
    | ({
        user_id: string;
        company:
          | ({ company_id: string; tour: (FocusedMapShipmentFieldsFragment & { __typename: 'Tour' }) | null } & {
              __typename: 'Company';
            })
          | null;
      } & { __typename: 'User' })
    | null;
} & { __typename: 'Query' };

export type TruckMapLabelQueryVariables = Exact<{
  companyId: Scalars['String']['input'];
  tourId: Scalars['Int']['input'];
}>;

export type TruckMapLabelQuery = {
  viewer:
    | ({
        user_id: string;
        company:
          | ({
              company_id: string;
              tour:
                | ({
                    tour_id: number;
                    shipper_transport_number: string | null;
                    currentVehicle:
                      | ({ vehicleLicensePlateNumber: string | null; vehicleId: string | null } & {
                          __typename: 'VehicleAllocation';
                        })
                      | null;
                    activeVehicleAllocation:
                      | ({
                          vehicleLicensePlateNumber: string | null;
                          allocationDeviceType: TourAllocationDeviceType | null;
                        } & { __typename: 'TourVehicleAllocation' })
                      | null;
                  } & { __typename: 'Tour' })
                | null;
            } & { __typename: 'Company' })
          | null;
      } & { __typename: 'User' })
    | null;
} & { __typename: 'Query' };

export type ShipmentsFilterOptionCountsQueryVariables = Exact<{
  companyId: Scalars['String']['input'];
  transportMode: TourFilteringTransportMode;
}>;

export type ShipmentsFilterOptionCountsQuery = {
  viewer:
    | ({
        user_id: string;
        company:
          | ({
              company_id: string;
              hasHadAnyDocuments: boolean;
              hasHadAnyDeliveryExceptions: boolean;
              hasHadAnyServiceExceptions: boolean;
              hasHadAnyNotes: boolean;
              hasHadAnyTemperature: boolean;
              placesConnection: { hasAny: boolean } & { __typename: 'CountedCompanyPlaceConnection' };
              sitesConnection: { hasAny: boolean } & { __typename: 'CountedSiteConnection' };
              carriersConnection: { hasAny: boolean } & { __typename: 'CountedCarrierConnection' };
              customersConnection: { hasAny: boolean } & { __typename: 'CountedCustomerConnection' };
              bookingLocations: { hasAny: boolean } & { __typename: 'CountedCompanyBookingLocation' };
              connectedCustomFields: Array<
                { displayName: string | null; name: string } & { __typename: 'ConnectedCustomField' }
              >;
              users: { hasAny: boolean } & { __typename: 'CountedUserInCompanyProfileConnection' };
              stopStatesIdentifiersConnection: { hasAny: boolean } & {
                __typename: 'CountedCompanyStopStatesConnection';
              };
              cityIdentifiersConnection: { hasAny: boolean } & { __typename: 'CountedCompanyStopCitiesConnection' };
              postalCodeIdentifiersConnection: { hasAny: boolean } & {
                __typename: 'CountedCompanyStopPostalCodesConnection';
              };
              orderItemIdentifiersConnection: { hasAny: boolean } & { __typename: 'CountedOrderItemConnection' };
              orderItemCustomFieldIdentifiersConnection: { hasAny: boolean } & {
                __typename: 'CountedOrderItemCustomFieldConnection';
              };
              stopCompanyNameIdentifiersConnection: { hasAny: boolean } & {
                __typename: 'CountedStopCompanyNameConnection';
              };
              stopGateIdentifiersConnection: { hasAny: boolean } & {
                __typename: 'CountedCompanyStopGateIdentifiersConnection';
              };
            } & { __typename: 'Company' })
          | null;
      } & { __typename: 'User' })
    | null;
} & { __typename: 'Query' };

export type TransportGatesSearchQueryVariables = Exact<{
  companyId: Scalars['String']['input'];
  textSearch?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  gateIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;

export type TransportGatesSearchQuery = {
  viewer:
    | ({
        user_id: string;
        company:
          | ({
              company_id: string;
              stopGateIdentifiersConnection: {
                stopGateIdentifiers: {
                  edges: Array<
                    | ({
                        node:
                          | ({ gateId: string; gate: string | null } & { __typename: 'CompanyStopGateIdentifier' })
                          | null;
                      } & { __typename: 'CompanyStopGateIdentifierEdge' })
                    | null
                  > | null;
                } & { __typename: 'CompanyStopGateIdentifierConnection' };
              } & { __typename: 'CountedCompanyStopGateIdentifiersConnection' };
            } & { __typename: 'Company' })
          | null;
      } & { __typename: 'User' })
    | null;
} & { __typename: 'Query' };

export type TransportPlacesSearchQueryVariables = Exact<{
  companyId: Scalars['String']['input'];
  textSearch?: InputMaybe<PlaceTextSearch>;
  first?: InputMaybe<Scalars['Int']['input']>;
  placeIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;

export type TransportPlacesSearchQuery = {
  viewer:
    | ({
        user_id: string;
        company:
          | ({
              company_id: string;
              placesConnection: {
                places: {
                  edges: Array<
                    | ({
                        node:
                          | ({ name: string; place_id: string; referenceId: string | null } & {
                              __typename: 'CompanyPlace';
                            })
                          | null;
                      } & { __typename: 'CompanyPlaceEdge' })
                    | null
                  > | null;
                } & { __typename: 'CompanyPlaceConnection' };
              } & { __typename: 'CountedCompanyPlaceConnection' };
            } & { __typename: 'Company' })
          | null;
      } & { __typename: 'User' })
    | null;
} & { __typename: 'Query' };

export type TransportSitesSearchQueryVariables = Exact<{
  companyId: Scalars['String']['input'];
  textSearch?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  siteIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;

export type TransportSitesSearchQuery = {
  viewer:
    | ({
        user_id: string;
        company:
          | ({
              company_id: string;
              sitesConnection: {
                sites: {
                  edges: Array<
                    | ({ node: ({ name: string; site_id: string } & { __typename: 'Site' }) | null } & {
                        __typename: 'SiteEdge';
                      })
                    | null
                  > | null;
                } & { __typename: 'SiteConnection' };
              } & { __typename: 'CountedSiteConnection' };
            } & { __typename: 'Company' })
          | null;
      } & { __typename: 'User' })
    | null;
} & { __typename: 'Query' };

export type TransportUsersSearchQueryVariables = Exact<{
  companyId: Scalars['String']['input'];
  textSearch?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  userIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;

export type TransportUsersSearchQuery = {
  viewer:
    | ({
        user_id: string;
        company:
          | ({
              company_id: string;
              users: {
                users: {
                  edges: Array<
                    | ({
                        node:
                          | ({
                              profile: {
                                user_id: string;
                                email: string | null;
                                first_name: string | null;
                                last_name: string | null;
                              } & { __typename: 'UserProfile' };
                            } & { __typename: 'UserInCompanyProfile' })
                          | null;
                      } & { __typename: 'UserInCompanyProfileEdge' })
                    | null
                  > | null;
                } & { __typename: 'UserInCompanyProfileConnection' };
              } & { __typename: 'CountedUserInCompanyProfileConnection' };
            } & { __typename: 'Company' })
          | null;
      } & { __typename: 'User' })
    | null;
} & { __typename: 'Query' };

export type TransportCarriersSearchQueryVariables = Exact<{
  companyId: Scalars['String']['input'];
  textSearch?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  carrierIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  sortOrder?: InputMaybe<CompanySortOrder>;
}>;

export type TransportCarriersSearchQuery = {
  viewer:
    | ({
        user_id: string;
        company:
          | ({
              company_id: string;
              carriersConnection: {
                carriers: {
                  edges: Array<
                    | ({
                        node:
                          | ({ company_id: string; company_name: string | null } & { __typename: 'CarrierOption' })
                          | null;
                      } & { __typename: 'CarrierOptionEdge' })
                    | null
                  > | null;
                } & { __typename: 'CarrierOptionConnection' };
              } & { __typename: 'CountedCarrierConnection' };
            } & { __typename: 'Company' })
          | null;
      } & { __typename: 'User' })
    | null;
} & { __typename: 'Query' };

export type TransportCustomersSearchQueryVariables = Exact<{
  companyId: Scalars['String']['input'];
  textSearch?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  customerIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  sortOrder?: InputMaybe<CompanySortOrder>;
}>;

export type TransportCustomersSearchQuery = {
  viewer:
    | ({
        user_id: string;
        company:
          | ({
              company_id: string;
              customersConnection: {
                customers: {
                  edges: Array<
                    | ({
                        node:
                          | ({ company_id: string; company_name: string | null } & { __typename: 'CompanyProfile' })
                          | null;
                      } & { __typename: 'CompanyProfileEdge' })
                    | null
                  > | null;
                } & { __typename: 'CompanyProfileConnection' };
              } & { __typename: 'CountedCustomerConnection' };
            } & { __typename: 'Company' })
          | null;
      } & { __typename: 'User' })
    | null;
} & { __typename: 'Query' };

export type TransportBookingLocationsSearchQueryVariables = Exact<{
  companyId: Scalars['String']['input'];
  textSearch?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
}>;

export type TransportBookingLocationsSearchQuery = {
  viewer:
    | ({
        user_id: string;
        company:
          | ({
              company_id: string;
              bookingLocations: {
                bookingLocations: {
                  edges: Array<
                    | ({ node: ({ bookingLocationName: string } & { __typename: 'CompanyBookingLocation' }) | null } & {
                        __typename: 'CompanyBookingLocationEdge';
                      })
                    | null
                  > | null;
                } & { __typename: 'CompanyBookingLocationConnection' };
              } & { __typename: 'CountedCompanyBookingLocation' };
            } & { __typename: 'Company' })
          | null;
      } & { __typename: 'User' })
    | null;
} & { __typename: 'Query' };

export type TransportStopCompanyNamesQueryVariables = Exact<{
  companyId: Scalars['String']['input'];
  textSearch?: InputMaybe<Scalars['String']['input']>;
  first: Scalars['Int']['input'];
}>;

export type TransportStopCompanyNamesQuery = {
  viewer:
    | ({
        user_id: string;
        company:
          | ({
              company_id: string;
              stopCompanyNameIdentifiersConnection: {
                stopCompanyNameIdentifiers: {
                  edges: Array<
                    | ({ node: ({ value: string } & { __typename: 'StopCompanyName' }) | null } & {
                        __typename: 'StopCompanyNameEdge';
                      })
                    | null
                  > | null;
                } & { __typename: 'StopCompanyNameConnection' };
              } & { __typename: 'CountedStopCompanyNameConnection' };
            } & { __typename: 'Company' })
          | null;
      } & { __typename: 'User' })
    | null;
} & { __typename: 'Query' };

export type FilterFragment = {
  carrierIds: Array<string> | null;
  customerIds: Array<string> | null;
  platformId: string | null;
  startTimeStart: string | null;
  startTimeEnd: string | null;
  startTimeSugarTimezone: string | null;
  endTimeStart: string | null;
  endTimeEnd: string | null;
  endTimeSugarTimezone: string | null;
  statuses: Array<TourStatusFilter> | null;
  delayStatus: TourDelayStatusFilter | null;
  siteIds: Array<string> | null;
  failureReasons: Array<TourFailureReasonType> | null;
  warnings: Array<TourWarningType> | null;
  workingStopTimeslotBeginEnd: string | null;
  workingStopStatus: WorkingStopStatusFilter | null;
  assignedToUserIds: Array<string> | null;
  allocationStatus: TourAllocationStatus | null;
  carrierNames: Array<string> | null;
  carrierCodes: Array<string> | null;
  shipperContactNames: Array<string> | null;
  consigneeContactNames: Array<string> | null;
  customerContactNames: Array<string> | null;
  shipperLocationNames: Array<string> | null;
  consigneeLocationNames: Array<string> | null;
  customerLocationNames: Array<string> | null;
  transportGroupIds: Array<string> | null;
  containerNumbers: Array<string> | null;
  bookingNumbers: Array<string> | null;
  orderNumbers: Array<string> | null;
  billOfLadingNumbers: Array<string> | null;
  transportMode: Array<TourFilteringTransportMode> | null;
  airWayBillNumbers: Array<string> | null;
  voyageIds: Array<string> | null;
  documentTypes: Array<DocumentType> | null;
  exceptionTypes: Array<string> | null;
  serviceExceptionCodes: Array<string> | null;
  orderItemNames: Array<string> | null;
  orderItemIsHazardous: boolean | null;
  hasNotes: boolean | null;
  mainVisibilityIssues: Array<VisibilityIssueType> | null;
  shipmentType: Array<ShipmentTypeFilter> | null;
  incoterm: Array<IncotermTerm> | null;
  hasTemperature: boolean | null;
  customFields: Array<
    {
      fieldName: string;
      value: { values: Array<string> | null } & { __typename: 'TourCustomFieldSearchValueType' };
    } & { __typename: 'TourCustomFieldSearchType' }
  > | null;
  delayTime:
    | ({ startInSeconds: number; endInSeconds: number | null; unit: TimeUnit; comparison: ComparisonOperator } & {
        __typename: 'TimeRange';
      })
    | null;
  timeSpentAtStop:
    | ({ startInSeconds: number; endInSeconds: number | null; unit: TimeUnit; comparison: ComparisonOperator } & {
        __typename: 'TimeRange';
      })
    | null;
  locations: Array<
    {
      types: Array<string | null> | null;
      countries: Array<string | null> | null;
      locodes: Array<string | null> | null;
      iatas: Array<string | null> | null;
      names: Array<string | null> | null;
      byLastActualMilestone: boolean | null;
      milestones: Array<
        | ({
            milestoneQualifier: string;
            delayTime:
              | ({
                  criteria: string;
                  anyTimerangeCriteria: boolean | null;
                  timerange:
                    | ({
                        comparison: DelayComparisonOperator;
                        startInSeconds: number;
                        delayUnit: DelayTimerangeUnit;
                      } & { __typename: 'DelayTimeRangeOutput' })
                    | null;
                } & { __typename: 'MilestoneDelayOutput' })
              | null;
            timelineEvents: Array<
              {
                criteria: string;
                timerange:
                  | ({
                      comparison: ExtendedComparisonOperator;
                      startSugarDate: string | null;
                      endSugarDate: string | null;
                    } & { __typename: 'TimeRangeSugarDateOutput' })
                  | null;
              } & { __typename: 'LocationMilestoneTimelineEventOutput' }
            > | null;
          } & { __typename: 'LocationMilestoneOutput' })
        | null
      > | null;
    } & { __typename: 'TransportLocationOutput' }
  > | null;
  demurrage:
    | ({
        names: Array<string> | null;
        states: Array<string> | null;
        cost: number | null;
        currency: string | null;
        remainingFreeDays: number | null;
        types: Array<DemurrageType> | null;
      } & { __typename: 'OceanDemurrageFilterOutput' })
    | null;
  transportAlerts:
    | ({ severities: Array<TransportAlertSeverity> | null; types: Array<TransportAlertType> | null } & {
        __typename: 'TransportAlertsFilterOutput';
      })
    | null;
  impactDays:
    | ({ comparison: ImpactDaysComparison; startInSeconds: number } & { __typename: 'ImpactDaysOutput' })
    | null;
  stopStates: Array<{ country: string; state: string } & { __typename: 'CompanyStopStates' }> | null;
  vesselName:
    | ({
        current: Array<string | null> | null;
        fromPol: Array<string | null> | null;
        toPod: Array<string | null> | null;
      } & { __typename: 'VesselNameFilterOutput' })
    | null;
  orderItemCustomFields:
    | ({ productBrandValues: Array<string> | null; productLineValues: Array<string> | null } & {
        __typename: 'OrderItemCustomFieldOutput';
      })
    | null;
  stopFilters: Array<
    {
      placeIds: Array<string> | null;
      companyNames: Array<string> | null;
      bookingLocationNames: Array<string> | null;
      gateIds: Array<string> | null;
      countries: Array<string> | null;
      stopTypes: Array<FilterRoadStopType> | null;
      states: Array<{ country: string; state: string } & { __typename: 'CompanyStopStates' }> | null;
      cities: Array<{ city: string; country: string } & { __typename: 'CompanyStopCities' }> | null;
      postalCodes: Array<{ postalCode: string; country: string } & { __typename: 'CompanyStopPostalCodes' }> | null;
    } & { __typename: 'StopFilterOutput' }
  > | null;
  lastSignalTimestamp:
    | ({
        comparison: ComparisonOperatorExtended;
        startInSeconds: number | null;
        endInSeconds: number | null;
        unit: LstfTimeUnit | null;
      } & { __typename: 'LastSignalTimestampFilter' })
    | null;
  vehicleLicensePlates: Array<{ plate: string } & { __typename: 'TourVehicleLicensePlateFilter' }> | null;
  temperatureEverOutOfRange:
    | ({
        outOfRange: boolean;
        minTemperature: number | null;
        maxTemperature: number | null;
        temperatureUnit: TemperatureUnit | null;
      } & { __typename: 'TemperatureEverOutOfRangeFilter' })
    | null;
} & { __typename: 'TourFilter' };

export type PersonalTourFiltersQueryVariables = Exact<{
  companyId: Scalars['String']['input'];
  textSearch?: InputMaybe<Scalars['String']['input']>;
  filterType?: InputMaybe<FilterType>;
  first?: InputMaybe<Scalars['Int']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
}>;

export type PersonalTourFiltersQuery = {
  viewer:
    | ({
        user_id: string;
        company:
          | ({
              company_id: string;
              me:
                | ({
                    userFiltersConnection: {
                      count: number;
                      userFilters: {
                        edges: Array<
                          | ({
                              node:
                                | ({
                                    userFilterId: string;
                                    name: string;
                                    filter: (FilterFragment & { __typename: 'TourFilter' }) | null;
                                  } & { __typename: 'UserFilter' })
                                | null;
                            } & { __typename: 'UserFilterEdge' })
                          | null
                        > | null;
                        pageInfo: { hasNextPage: boolean; endCursor: string | null } & { __typename: 'PageInfo' };
                      } & { __typename: 'UserFilterConnection' };
                    } & { __typename: 'CountedUserFilterConnection' };
                  } & { __typename: 'UserInCompany' })
                | null;
            } & { __typename: 'Company' })
          | null;
      } & { __typename: 'User' })
    | null;
} & { __typename: 'Query' };

export type CompanyTourFiltersQueryVariables = Exact<{
  companyId: Scalars['String']['input'];
  textSearch?: InputMaybe<Scalars['String']['input']>;
  filterType?: InputMaybe<FilterType>;
  first?: InputMaybe<Scalars['Int']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
}>;

export type CompanyTourFiltersQuery = {
  viewer:
    | ({
        user_id: string;
        company:
          | ({
              company_id: string;
              companyTourFiltersConnection: {
                count: number;
                companyTourFilters: {
                  edges: Array<
                    | ({
                        node:
                          | ({
                              companyTourFilterId: string;
                              sharingToken: string | null;
                              name: string;
                              filter: (FilterFragment & { __typename: 'TourFilter' }) | null;
                            } & { __typename: 'CompanyTourFilter' })
                          | null;
                      } & { __typename: 'CompanyTourFilterEdge' })
                    | null
                  > | null;
                  pageInfo: { hasNextPage: boolean; endCursor: string | null } & { __typename: 'PageInfo' };
                } & { __typename: 'CompanyTourFilterConnection' };
              } & { __typename: 'CountedCompanyTourFilterConnection' };
            } & { __typename: 'Company' })
          | null;
      } & { __typename: 'User' })
    | null;
} & { __typename: 'Query' };

export type CompanyCustomFieldsQueryVariables = Exact<{
  companyId: Scalars['String']['input'];
  transportMode: TourFilteringTransportMode;
}>;

export type CompanyCustomFieldsQuery = {
  viewer:
    | ({
        user_id: string;
        company:
          | ({
              company_id: string;
              connectedCustomFields: Array<
                { displayName: string | null; name: string } & { __typename: 'ConnectedCustomField' }
              >;
            } & { __typename: 'Company' })
          | null;
      } & { __typename: 'User' })
    | null;
} & { __typename: 'Query' };

export type CompanyCustomFieldQueryVariables = Exact<{
  companyId: Scalars['String']['input'];
  fieldName: Scalars['String']['input'];
  transportMode: TourFilteringTransportMode;
  textSearch?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
}>;

export type CompanyCustomFieldQuery = {
  viewer:
    | ({
        user_id: string;
        company:
          | ({
              company_id: string;
              customField:
                | ({
                    valuesConnection: {
                      values: {
                        edges: Array<
                          | ({ node: ({ value: string } & { __typename: 'CustomFieldValue' }) | null } & {
                              __typename: 'CustomFieldValueEdge';
                            })
                          | null
                        > | null;
                      } & { __typename: 'CustomFieldValueConnection' };
                    } & { __typename: 'CountedCustomFieldValueConnection' };
                  } & { __typename: 'ConnectedCustomField' })
                | null;
            } & { __typename: 'Company' })
          | null;
      } & { __typename: 'User' })
    | null;
} & { __typename: 'Query' };

export type TransportCountryAndStateSearchQueryVariables = Exact<{
  companyId: Scalars['String']['input'];
  textSearch?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
}>;

export type TransportCountryAndStateSearchQuery = {
  viewer:
    | ({
        user_id: string;
        company:
          | ({
              company_id: string;
              stopStatesIdentifiersConnection: {
                stopStatesIdentifiers: {
                  edges: Array<
                    | ({ node: ({ country: string; state: string } & { __typename: 'CompanyStopStates' }) | null } & {
                        __typename: 'CompanyStopStatesEdge';
                      })
                    | null
                  > | null;
                } & { __typename: 'CompanyStopStatesConnection' };
              } & { __typename: 'CountedCompanyStopStatesConnection' };
            } & { __typename: 'Company' })
          | null;
      } & { __typename: 'User' })
    | null;
} & { __typename: 'Query' };

export type TransportCitySearchQueryVariables = Exact<{
  companyId: Scalars['String']['input'];
  textSearch?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
}>;

export type TransportCitySearchQuery = {
  viewer:
    | ({
        user_id: string;
        company:
          | ({
              company_id: string;
              cityIdentifiersConnection: {
                cityIdentifiers: {
                  edges: Array<
                    | ({ node: ({ city: string; country: string } & { __typename: 'CompanyStopCities' }) | null } & {
                        __typename: 'CompanyStopCitiesEdge';
                      })
                    | null
                  > | null;
                } & { __typename: 'CompanyStopCitiesConnection' };
              } & { __typename: 'CountedCompanyStopCitiesConnection' };
            } & { __typename: 'Company' })
          | null;
      } & { __typename: 'User' })
    | null;
} & { __typename: 'Query' };

export type TransportPostalCodeSearchQueryVariables = Exact<{
  companyId: Scalars['String']['input'];
  textSearch?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
}>;

export type TransportPostalCodeSearchQuery = {
  viewer:
    | ({
        user_id: string;
        company:
          | ({
              company_id: string;
              postalCodeIdentifiersConnection: {
                postalCodeIdentifiers: {
                  edges: Array<
                    | ({
                        node:
                          | ({ country: string; postalCode: string } & { __typename: 'CompanyStopPostalCodes' })
                          | null;
                      } & { __typename: 'CompanyStopPostalCodesEdge' })
                    | null
                  > | null;
                } & { __typename: 'CompanyStopPostalCodesConnection' };
              } & { __typename: 'CountedCompanyStopPostalCodesConnection' };
            } & { __typename: 'Company' })
          | null;
      } & { __typename: 'User' })
    | null;
} & { __typename: 'Query' };

export type SharedViewTourFilterOptionsHasAnyQueryVariables = Exact<{
  sharedViewId: Scalars['String']['input'];
}>;

export type SharedViewTourFilterOptionsHasAnyQuery = {
  sharedViewViewer:
    | ({
        viewerId: string;
        sharedView:
          | ({
              sharedViewId: string;
              tourFilterOptions:
                | ({
                    notes: { hasAny: boolean } & { __typename: 'NotesFilterOptions' };
                    stopStates: { hasAny: boolean } & { __typename: 'StopStateOptions' };
                    stopCities: { hasAny: boolean } & { __typename: 'StopCityOptions' };
                    stopPostalCodes: { hasAny: boolean } & { __typename: 'StopPostalCodeOptions' };
                    stopCompanyNames: { hasAny: boolean } & { __typename: 'StopCompanyNameOptions' };
                  } & { __typename: 'TourFilterOptions' })
                | null;
            } & { __typename: 'SharedViewContent' })
          | null;
      } & { __typename: 'SharedViewViewer' })
    | null;
} & { __typename: 'Query' };

export type SharedViewStopStatesPageQueryVariables = Exact<{
  sharedViewId: Scalars['String']['input'];
  textSearch?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;

export type SharedViewStopStatesPageQuery = {
  sharedViewViewer:
    | ({
        viewerId: string;
        sharedView:
          | ({
              sharedViewId: string;
              tourFilterOptions:
                | ({
                    stopStates: {
                      page: {
                        values: Array<{ state: string; country: string } & { __typename: 'StopStateOption' }>;
                      } & { __typename: 'StopStateOptionPage' };
                    } & { __typename: 'StopStateOptions' };
                  } & { __typename: 'TourFilterOptions' })
                | null;
            } & { __typename: 'SharedViewContent' })
          | null;
      } & { __typename: 'SharedViewViewer' })
    | null;
} & { __typename: 'Query' };

export type SharedViewStopCitiesPageQueryVariables = Exact<{
  sharedViewId: Scalars['String']['input'];
  textSearch?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;

export type SharedViewStopCitiesPageQuery = {
  sharedViewViewer:
    | ({
        viewerId: string;
        sharedView:
          | ({
              sharedViewId: string;
              tourFilterOptions:
                | ({
                    stopCities: {
                      page: { values: Array<{ city: string; country: string } & { __typename: 'StopCityOption' }> } & {
                        __typename: 'StopCityOptionPage';
                      };
                    } & { __typename: 'StopCityOptions' };
                  } & { __typename: 'TourFilterOptions' })
                | null;
            } & { __typename: 'SharedViewContent' })
          | null;
      } & { __typename: 'SharedViewViewer' })
    | null;
} & { __typename: 'Query' };

export type SharedViewStopCompanyNamesPageQueryVariables = Exact<{
  sharedViewId: Scalars['String']['input'];
  textSearch?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;

export type SharedViewStopCompanyNamesPageQuery = {
  sharedViewViewer:
    | ({
        viewerId: string;
        sharedView:
          | ({
              sharedViewId: string;
              tourFilterOptions:
                | ({
                    stopCompanyNames: {
                      page: { values: Array<{ companyName: string } & { __typename: 'StopCompanyNameOption' }> } & {
                        __typename: 'StopCompanyNameOptionPage';
                      };
                    } & { __typename: 'StopCompanyNameOptions' };
                  } & { __typename: 'TourFilterOptions' })
                | null;
            } & { __typename: 'SharedViewContent' })
          | null;
      } & { __typename: 'SharedViewViewer' })
    | null;
} & { __typename: 'Query' };

export type SharedViewStopPostalCodesPageQueryVariables = Exact<{
  sharedViewId: Scalars['String']['input'];
  textSearch?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;

export type SharedViewStopPostalCodesPageQuery = {
  sharedViewViewer:
    | ({
        viewerId: string;
        sharedView:
          | ({
              sharedViewId: string;
              tourFilterOptions:
                | ({
                    stopPostalCodes: {
                      page: {
                        values: Array<{ postalCode: string; country: string } & { __typename: 'StopPostalCodeOption' }>;
                      } & { __typename: 'StopPostalCodeOptionPage' };
                    } & { __typename: 'StopPostalCodeOptions' };
                  } & { __typename: 'TourFilterOptions' })
                | null;
            } & { __typename: 'SharedViewContent' })
          | null;
      } & { __typename: 'SharedViewViewer' })
    | null;
} & { __typename: 'Query' };

export type OrderItemsSearchQueryVariables = Exact<{
  companyId: Scalars['String']['input'];
  textSearch?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
}>;

export type OrderItemsSearchQuery = {
  viewer:
    | ({
        user_id: string;
        company:
          | ({
              company_id: string;
              orderItemIdentifiersConnection: {
                orderItemIdentifiers: {
                  edges: Array<
                    | ({
                        node:
                          | ({ orderItemId: string; orderItemName: string } & { __typename: 'OrderItemIdentifier' })
                          | null;
                      } & { __typename: 'OrderItemIdentifierEdge' })
                    | null
                  > | null;
                } & { __typename: 'OrderItemIdentifierConnection' };
              } & { __typename: 'CountedOrderItemConnection' };
            } & { __typename: 'Company' })
          | null;
      } & { __typename: 'User' })
    | null;
} & { __typename: 'Query' };

export type OrderItemCustomFieldSearchQueryVariables = Exact<{
  companyId: Scalars['String']['input'];
  search?: InputMaybe<OrderItemCustomFieldSearch>;
  first?: InputMaybe<Scalars['Int']['input']>;
}>;

export type OrderItemCustomFieldSearchQuery = {
  viewer:
    | ({
        user_id: string;
        company:
          | ({
              company_id: string;
              orderItemCustomFieldIdentifiersConnection: {
                orderItemCustomFieldIdentifiers: {
                  edges: Array<
                    | ({ node: ({ name: string; value: string } & { __typename: 'OrderItemCustomField' }) | null } & {
                        __typename: 'OrderItemCustomFieldEdge';
                      })
                    | null
                  > | null;
                } & { __typename: 'OrderItemCustomFieldConnection' };
              } & { __typename: 'CountedOrderItemCustomFieldConnection' };
            } & { __typename: 'Company' })
          | null;
      } & { __typename: 'User' })
    | null;
} & { __typename: 'Query' };

export type ChangeTourStopTimeslotMutationVariables = Exact<{
  input: TourStopTimeslotInput;
}>;

export type ChangeTourStopTimeslotMutation = {
  changeTourStopTimeslot:
    | ({
        tour_id: number;
        stops: Array<
          {
            stop_id: number;
            timeslot:
              | ({ begin: string | null; end: string | null; timezone: string | null } & { __typename: 'Timeslot' })
              | null;
            originalTimeslot: ({ begin: string | null; end: string | null } & { __typename: 'SimpleTimeslot' }) | null;
            revisedTimeslot: ({ begin: string | null; end: string | null } & { __typename: 'SimpleTimeslot' }) | null;
          } & { __typename: 'TourStop' }
        >;
      } & { __typename: 'Tour' })
    | null;
} & { __typename: 'Mutation' };

export type SharingTokenFragment = {
  token: string;
  createdBy:
    | ({ user_id: string; first_name: string | null; last_name: string | null } & { __typename: 'UserProfile' })
    | null;
} & { __typename: 'SharingToken' };

export type TourContainerDetailsFragment = {
  tour_id: number;
  transport_id: string | null;
  created_at: string;
  platform_shipper_id: string | null;
  platform_carrier_id: string | null;
  visibilityServices: Array<VisibilityService>;
  shipper_transport_number: string | null;
  bill_of_lading: string | null;
  start_time: string | null;
  status: string | null;
  working_stop_id: number | null;
  visibility_start_time: string | null;
  visibility_end_time: string | null;
  visibleTrackingStartTime: string | null;
  trackingAbandonTime: string | null;
  allocationType: TourVehicleAllocationType | null;
  hasTemperatureData: boolean | null;
  isTrailRetentionExpired: boolean;
  canAbortTour: boolean;
  isGlobalAllocation: boolean;
  isGloballyAllocatedToViewerCompany: boolean;
  canBeModified: boolean;
  isTourAccessedByCreator: boolean;
  isTimeslotUpdateEnabled: boolean;
  mobileTrackingToken?: string | null;
  platformTransportURL: string | null;
  platformBranchId: string | null;
  platform_transport_number: string | null;
  isExtendedTrailAvailable: boolean;
  visibilityIndex: number | null;
  sharingToken: string | null;
  hasTransportNotifications?: boolean;
  plannedEmissions: ({ co2WellToWheelTonnes: number } & { __typename: 'TourCalculatedEmissions' }) | null;
  fuelBasedEmissions: ({ co2WellToWheelTonnes: number | null } & { __typename: 'FuelBasedEmissions' }) | null;
  externalEmissions:
    | ({
        co2WellToWheelTonnes: number | null;
        co2WellToTankTonnes: number | null;
        co2TankToWheelTonnes: number | null;
      } & { __typename: 'ExternalEmissions' })
    | null;
  failureReason:
    | ({
        type: TourFailureReasonType;
        metadata:
          | ({ nr_of_stops_visited: string | null; allocated_license_plates: string | null } & {
              __typename: 'TourFailureReasonMetadata';
            })
          | null;
      } & { __typename: 'TourFailureReason' })
    | null;
  warnings: Array<
    {
      type: TourWarningType;
      severity: TourWarningSeverity | null;
      metadata: { [key: string]: string | number | boolean } | null;
    } & { __typename: 'TourWarning' }
  >;
  vehicleAllocations: Array<
    { vehicleId: string | null; vehicleLicensePlateNumber: string | null } & { __typename: 'TourVehicleAllocation' }
  >;
  trackedVehicles: Array<
    { vehicleId: string; vehicleLicensePlateNumber: string | null } & { __typename: 'TrackedVehicle' }
  >;
  activeVehicleAllocation:
    | ({
        vehicleId: string | null;
        vehicleLicensePlateNumber: string | null;
        vehicleTrackerTypes: Array<VehicleTrackerType> | null;
        remoteTrackerId: string | null;
        allocationDeviceType: TourAllocationDeviceType | null;
        matchedAlternativeIdentifier: string | null;
      } & { __typename: 'TourVehicleAllocation' })
    | null;
  currentVehicle:
    | ({ vehicleId: string | null; vehicleLicensePlateNumber: string | null } & { __typename: 'VehicleAllocation' })
    | null;
  activeAllocations: Array<
    { allocationId: string; status: AllocationReferenceStatus } & { __typename: 'AllocationReference' }
  >;
  cleanedVehicleAllocationHistory: Array<
    {
      allocationId: string | null;
      source: TourVehicleAllocationSource;
      vehicleId: string | null;
      allocationType: TourVehicleAllocationType | null;
      allocationSwitchType: TourAllocationSwitchType | null;
      startTrackingAt: string | null;
      vehicleLicensePlateNumber: string | null;
      isAutoAllocation: boolean | null;
      isLimitedVisibilityAllocation: boolean | null;
      matchedAlternativeIdentifier: string | null;
      additionalAssets: Array<
        { identifier: string; reason: TourAdditionalAssetReason } & { __typename: 'TourAdditionalAsset' }
      >;
    } & { __typename: 'TourVehicleAllocation' }
  >;
  customFields: Array<
    { fieldName: string; values: Array<{ value: string } & { __typename: 'CustomFieldValue' }> } & {
      __typename: 'CustomField';
    }
  >;
  platform: ({ platform_id: string; platform_name: string } & { __typename: 'Platform' }) | null;
  tourPositionHistory?: Array<
    { vehicleId: string; lat: number; lng: number; receivedAt: string | null } & { __typename: 'VehiclePosition' }
  > | null;
  vehicleChangePositions?: Array<
    {
      vehicleId: string;
      lat: number;
      lng: number;
      receivedAt: string | null;
      previousLicensePlate: string | null;
      currentLicensePlate: string | null;
    } & { __typename: 'VehicleChangePosition' }
  > | null;
  externalTourEvents?: Array<
    {
      eventId: string;
      timestamp: string;
      eventSource: ExternalEventSource;
      externalEventSource: string | null;
      qualifier: ExternalTourEventQualifier;
      externalEventQualifier: string;
      licensePlateNumber: string | null;
      remoteId: string | null;
      vehicleType: VehicleType | null;
      locationName: string | null;
    } & { __typename: 'ExternalTourEvent' }
  >;
  externalDeliveryEvents?: Array<
    {
      eventId: string;
      timestamp: string;
      eventSource: ExternalEventSource;
      externalEventSource: string | null;
      externalEventQualifier: string;
      delivery: ({ deliveryId: string; deliveryNumber: string | null } & { __typename: 'TourDelivery' }) | null;
    } & { __typename: 'ExternalTourDeliveryEvent' }
  >;
  externalStopEvents?: Array<
    {
      eventId: string;
      timestamp: string;
      eventSource: ExternalEventSource;
      externalEventSource: string | null;
      externalEventQualifier: string;
      stopId: string;
    } & { __typename: 'ExternalTourStopEvent' }
  >;
  events: Array<
    | ({
        stop_id: number;
        tour_id: number;
        event_id: number;
        vehicle_id: string | null;
        vehicle_lat: number | null;
        vehicle_lng: number | null;
        vehicle_license_plate_number: string | null;
        event_index: number;
        event_time: string | null;
        created_at: string;
        stop_event_name: StopEventName;
        externalEventCreatedAt: string | null;
        visibilitySource:
          | ({
              primaryEventSource: TourVisibilitySourceType;
              streamPrecision: TourVisibilityPrecisionType | null;
              sourcePlatform:
                | ({ platform_id: string; platform_name: string } & { __typename: 'PlatformProfile' })
                | null;
            } & { __typename: 'TourVisibilitySource' })
          | null;
      } & { __typename: 'StopEvent' })
    | ({
        tour_id: number;
        event_id: number;
        vehicle_id: string | null;
        vehicle_lat: number | null;
        vehicle_lng: number | null;
        vehicle_license_plate_number: string | null;
        event_index: number;
        event_time: string | null;
        created_at: string;
        tour_event_name: TourEventName;
        warning:
          | ({ type: TourWarningType; severity: TourWarningSeverity | null } & { __typename: 'TourWarning' })
          | null;
        metadata:
          | ({ parameters: { [key: string]: string | number | boolean } | null } & { __typename: 'TourEventMetadata' })
          | null;
        visibilitySource:
          | ({
              primaryEventSource: TourVisibilitySourceType;
              streamPrecision: TourVisibilityPrecisionType | null;
              sourcePlatform:
                | ({ platform_id: string; platform_name: string } & { __typename: 'PlatformProfile' })
                | null;
            } & { __typename: 'TourVisibilitySource' })
          | null;
      } & { __typename: 'TourEvent' })
  >;
  applicationDeepLinks: Array<{ applicationName: string; url: string } & { __typename: 'ApplicationDeepLink' }> | null;
  stops: Array<
    {
      stop_id: number;
      status: string | null;
      type: string | null;
      display_sequence_number: number;
      display_actual_sequence_number: number;
      actual_sequence_number: number | null;
      sequence_number: number | null;
      externalEtaSource: ExternalEtaSource | null;
      estimated_arrival: string | null;
      estimated_arrival_status: string | null;
      estimated_arrival_accuracy: string | null;
      estimated_arrival_delay_in_seconds: number | null;
      estimated_arrival_distance_in_meters: number | null;
      arrival_delay_in_seconds: number | null;
      arrival_time: string | null;
      departure_time: string | null;
      deadline: string | null;
      sharingTokenV2?: (SharingTokenFragment & { __typename: 'SharingToken' }) | null;
      geofenceZones?: Array<
        {
          zone: GeofenceZoneType;
          geofence:
            | ({
                type: GeofenceType;
                radiusInMeters: number;
                origin: { lat: number; lng: number } & { __typename: 'Position' };
              } & { __typename: 'GeofenceCircle' })
            | ({ type: GeofenceType; points: Array<{ lat: number; lng: number } & { __typename: 'Position' }> } & {
                __typename: 'GeofencePolygon';
              });
        } & { __typename: 'GeofenceZone' }
      >;
      timeslot:
        | ({ begin: string | null; end: string | null; timezone: string | null } & { __typename: 'Timeslot' })
        | null;
      originalTimeslot: ({ begin: string | null; end: string | null } & { __typename: 'SimpleTimeslot' }) | null;
      revisedTimeslot: ({ begin: string | null; end: string | null } & { __typename: 'SimpleTimeslot' }) | null;
      deliveries: Array<
        {
          deliveryId: string;
          deliveryNumber: string | null;
          orderNumber: string | null;
          purchaseOrderNumber: string | null;
          orderDate: string | null;
          customFields?: Array<
            { fieldName: string; values: Array<{ value: string } & { __typename: 'CustomFieldValue' }> } & {
              __typename: 'CustomField';
            }
          >;
          orderItems: Array<
            {
              orderItemId: string;
              orderItemName: string | null;
              pieceCount: number | null;
              pieceDescription: string | null;
              pieceUnit: PieceUnit | null;
              volume: number | null;
              volumeUnit: VolumeUnit | null;
              weightAmount: number | null;
              weightUnit: WeightUnit | null;
              isHazardous: boolean | null;
              itemHeight: number | null;
              itemLength: number | null;
              itemWidth: number | null;
              linearUnit: LinearUnit | null;
              orderItemCustomFields: Array<
                { name: string; value: string } & { __typename: 'OrderItemCustomField' }
              > | null;
            } & { __typename: 'OrderItem' }
          > | null;
        } & { __typename: 'TourDelivery' }
      >;
      location:
        | ({
            location_id: string | null;
            name: string | null;
            bookingLocationName: string | null;
            gate_id: string | null;
            gate: string | null;
            place?: ({ place_id: string; name: string } & { __typename: 'CompanyPlace' }) | null;
            address:
              | ({
                  full_address: string | null;
                  city: string | null;
                  country: string | null;
                  street_address: string | null;
                  state: string | null;
                  zipcode: string | null;
                  stopAddressId: string | null;
                  shortAreaCode?: string | null;
                } & { __typename: 'Address' })
              | null;
            position:
              | ({ lat: number | null; lng: number | null; provider: string | null } & { __typename: 'GeoPosition' })
              | null;
          } & { __typename: 'TourLocation' })
        | null;
      stopContacts: Array<
        {
          contactNames: Array<string>;
          phoneNumbers: Array<string>;
          emailAddresses: Array<string>;
          phoneNumberExtensions: Array<string>;
        } & { __typename: 'StopContact' }
      >;
      informationalEvents: Array<
        {
          eventId: string;
          stopId: string;
          tourId: string;
          eventName: StopEventName;
          eventTime: string | null;
          externalEventCreatedAt: string | null;
          visibilitySource:
            | ({
                primaryEventSource: TourVisibilitySourceType;
                streamPrecision: TourVisibilityPrecisionType | null;
                sourcePlatform:
                  | ({ platform_id: string; platform_name: string } & { __typename: 'PlatformProfile' })
                  | null;
              } & { __typename: 'TourVisibilitySource' })
            | null;
        } & { __typename: 'StopEventV2' }
      >;
    } & { __typename: 'TourStop' }
  >;
  shipper: ({ company_id: string; company_name: string | null } & { __typename: 'CompanyProfile' }) | null;
  carrier: ({ company_id: string; company_name: string | null } & { __typename: 'CompanyProfile' }) | null;
  subcontractor: ({ company_id: string; company_name: string | null } & { __typename: 'CompanyProfile' }) | null;
  vehicleHistory: Array<
    {
      polyline: { points: string } & { __typename: 'Polyline' };
      metadata: {
        type: VehicleHistoryPolylineType;
        startTime: string;
        endTime: string;
        isExtendedTrail: boolean;
        vehicleId: string;
      } & { __typename: 'VehicleHistoryPolylineMetadata' };
    } & { __typename: 'VehicleHistoryPolyline' }
  > | null;
  temperatureAssets?: Array<
    {
      isMainAsset: boolean;
      vehicleId: string | null;
      licensePlateNumber: string | null;
      compartments: Array<
        {
          compartmentName: string;
          sensors: Array<
            {
              name: string;
              readings: Array<{ timestamp: string; value: number } & { __typename: 'TemperatureSensorReading' }>;
            } & { __typename: 'TemperatureSensor' }
          >;
        } & { __typename: 'VehicleTemperature' }
      >;
    } & { __typename: 'TourTemperatureAsset' }
  >;
  vehicle_status:
    | ({
        timestamp: string | null;
        latitude: number | null;
        longitude: number | null;
        heading: number | null;
        accuracyInMeters: number | null;
      } & { __typename: 'VehicleStatus' })
    | null;
  visibleVehicleBreakHistory: Array<
    {
      vehicle_id: string;
      breaks: Array<
        {
          breakId: string;
          from: string;
          to: string | null;
          center: { lat: number; lng: number } & { __typename: 'BreakCenterPosition' };
        } & { __typename: 'VehicleBreakHistory' }
      >;
    } & { __typename: 'VehicleBreakHistoryEntry' }
  > | null;
  route:
    | ({
        legs: Array<
          {
            polyline: { points: string } & { __typename: 'Polyline' };
            metadata: { isExtendedRoute: boolean } & { __typename: 'RouteLegMetadata' };
          } & { __typename: 'RouteLeg' }
        >;
      } & { __typename: 'Route' })
    | null;
  latestSignal: ({ source: TourSignalSource; timestamp: string } & { __typename: 'TourSignal' }) | null;
  mainVisibilityIssue: ({ type: VisibilityIssueType } & { __typename: 'VisibilityIssue' }) | null;
  transportNotifications?: Array<
    {
      notificationId: string;
      status: NotificationStatus;
      createdByUserId: string;
      createdAt: string;
      notificationTrigger:
        | ({
            failureReasons: Array<TourFailureReasonType> | null;
            warnings: Array<TourWarningType> | null;
            exceptionTypes: Array<string> | null;
            serviceExceptionCodes: Array<string> | null;
            etaComparison: Array<
              {
                comparisonTerm: ComparisonTerm;
                comparisonValueInSeconds: number;
                stopId: string | null;
                comparisonUnit: ComparisonUnit;
                remainingTimeInSeconds: number | null;
                remainingTimeUnit: ComparisonUnit | null;
              } & { __typename: 'EtaComparison' }
            > | null;
            trackingNotStarted:
              | ({
                  remainingTime: {
                    comparisonField: TrackingNotStartedRemainingTimeField;
                    comparisonValue: number;
                    comparisonUnit: ComparisonUnit;
                  } & { __typename: 'TrackingNotStartedRemainingTime' };
                } & { __typename: 'TrackingNotStarted' })
              | null;
            vehicleTemperatureOutOfRange:
              | ({
                  minTemperature: number | null;
                  maxTemperature: number | null;
                  temperatureUnit: VehicleTemperatureOutOfRangeTemperatureUnit | null;
                  duration: number;
                  durationUnit: ComparisonUnit;
                  resolutionNotificationEnabled: boolean;
                } & { __typename: 'VehicleTemperatureOutOfRange' })
              | null;
            stopVisited:
              | ({
                  stopTypes: Array<StopVisitedStopType>;
                  includeStopLevelTrackingLinkForPickupStopEvent: boolean | null;
                } & { __typename: 'StopVisited' })
              | null;
          } & { __typename: 'NotificationTrigger' })
        | null;
      recipientsV2: Array<
        | ({ email: string; locale: string } & { __typename: 'EmailRecipient' })
        | ({ phoneNumber: string; locale: string } & { __typename: 'SmsRecipient' })
        | ({ emailStopContact: boolean | null; smsStopContact: boolean | null } & {
            __typename: 'StopContactRecipient';
          })
      >;
      creator:
        | ({ userId: string; firstName: string | null; lastName: string | null } & {
            __typename: 'NotificationUserProfile';
          })
        | null;
    } & { __typename: 'FilterBasedTransportNotification' }
  >;
  transportContactDetails: Array<
    {
      firstName: string | null;
      lastName: string | null;
      emails: Array<string | null>;
      phones: Array<string | null>;
      customText: string | null;
    } & { __typename: 'CompanyTransportContactDetails' }
  >;
  documents?: Array<
    {
      documentId: string;
      stopId: string | null;
      documentType: DocumentType;
      documentUrl: string;
      internalDownloadUrl: string | null;
      storageFileId: string;
      description: string | null;
      createdAt: string;
      fileSize: number | null;
      associatedDeliveries: Array<
        { deliveryId: string; deliveryNumber: string | null } & { __typename: 'TourDelivery' }
      >;
      createdBy: ({ firstName: string | null; lastName: string | null } & { __typename: 'DocumentCreator' }) | null;
    } & { __typename: 'Document' }
  >;
  notes?: Array<
    {
      noteId: string;
      stopId: string | null;
      noteText: string;
      noteVisibility: NoteVisibility;
      isEditable: boolean | null;
      noteSentToDriver: boolean;
      creatorCompanyId: string | null;
      creatorCompanyName: string | null;
      noteOrigin: NoteOrigin;
      createdBy: NoteCreatedBy;
      createdAt: string;
      updatedAt: string;
      associatedDeliveries: Array<
        { deliveryId: string; deliveryNumber: string | null } & { __typename: 'TourDelivery' }
      >;
    } & { __typename: 'Note' }
  >;
  exceptions?: Array<
    | ({
        exceptionId: string;
        description: string;
        stopId: string | null;
        type: string;
        deliveryIds: Array<string>;
        createdAt: string;
        source: ExceptionSource;
        exceptionFiles: Array<
          { documentUrl: string; platformDocumentId: string; description: string | null } & {
            __typename: 'ExceptionFile';
          }
        >;
      } & { __typename: 'DeliveryException' })
    | ({ exceptionId: string; code: string; description: string; time: string; source: ExceptionSource } & {
        __typename: 'ServiceException';
      })
  >;
} & { __typename: 'Tour' };

export type DocumentDownloadUrlQueryVariables = Exact<{
  documentId: Scalars['String']['input'];
  sharedViewId?: InputMaybe<Scalars['String']['input']>;
}>;

export type DocumentDownloadUrlQuery = { documentDownloadUrl: string | null } & { __typename: 'Query' };

export type CompanyTourQueryVariables = Exact<{
  companyId: Scalars['String']['input'];
  tourId: Scalars['Int']['input'];
  skipSharingToken?: InputMaybe<Scalars['Boolean']['input']>;
  skipMobileTrackingToken?: InputMaybe<Scalars['Boolean']['input']>;
  skipPlace?: InputMaybe<Scalars['Boolean']['input']>;
  skipExternalEvents: Scalars['Boolean']['input'];
  skipTemperature: Scalars['Boolean']['input'];
  skipShortAreaCodes?: InputMaybe<Scalars['Boolean']['input']>;
  skipNotifications?: InputMaybe<Scalars['Boolean']['input']>;
  skipHasNotifications?: InputMaybe<Scalars['Boolean']['input']>;
  includeDeliveriesCustomFieldsInTourCustomFields?: InputMaybe<Scalars['Boolean']['input']>;
  skipDeliveriesCustomFields?: InputMaybe<Scalars['Boolean']['input']>;
  skipDocuments?: InputMaybe<Scalars['Boolean']['input']>;
  skipNotes?: InputMaybe<Scalars['Boolean']['input']>;
  skipExceptions?: InputMaybe<Scalars['Boolean']['input']>;
  skipGeofenceZones?: InputMaybe<Scalars['Boolean']['input']>;
  skipVehiclePositions?: InputMaybe<Scalars['Boolean']['input']>;
  skipVehicleChangePositions?: InputMaybe<Scalars['Boolean']['input']>;
  includeExtended?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type CompanyTourQuery = {
  viewer:
    | ({
        user_id: string;
        company:
          | ({
              company_id: string;
              hasHadAnyDeliveryExceptions: boolean;
              hasHadAnyServiceExceptions: boolean;
              tour:
                | ({
                    tourAssignment:
                      | ({
                          assignedToUser:
                            | ({
                                user_id: string;
                                first_name: string | null;
                                last_name: string | null;
                                email: string | null;
                              } & { __typename: 'UserProfile' })
                            | null;
                        } & { __typename: 'TourAssignment' })
                      | null;
                    analyses: Array<
                      | ({
                          analyzeId: string;
                          companyId: string;
                          createdAt: string;
                          finishedAt: string | null;
                          result: string | null;
                          status: AnalyzeStatus;
                        } & { __typename: 'TransportAnalysisResponse' })
                      | null
                    > | null;
                  } & TourContainerDetailsFragment & { __typename: 'Tour' })
                | null;
            } & { __typename: 'Company' })
          | null;
      } & { __typename: 'User' })
    | null;
} & { __typename: 'Query' };

export type TokenTourQueryVariables = Exact<{
  companyId?: InputMaybe<Scalars['String']['input']>;
  skipSharingToken?: InputMaybe<Scalars['Boolean']['input']>;
  skipMobileTrackingToken?: InputMaybe<Scalars['Boolean']['input']>;
  skipPlace?: InputMaybe<Scalars['Boolean']['input']>;
  skipExternalEvents: Scalars['Boolean']['input'];
  skipTemperature: Scalars['Boolean']['input'];
  skipShortAreaCodes?: InputMaybe<Scalars['Boolean']['input']>;
  skipNotifications?: InputMaybe<Scalars['Boolean']['input']>;
  skipHasNotifications?: InputMaybe<Scalars['Boolean']['input']>;
  includeDeliveriesCustomFieldsInTourCustomFields?: InputMaybe<Scalars['Boolean']['input']>;
  skipDeliveriesCustomFields?: InputMaybe<Scalars['Boolean']['input']>;
  skipDocuments?: InputMaybe<Scalars['Boolean']['input']>;
  skipNotes?: InputMaybe<Scalars['Boolean']['input']>;
  skipExceptions?: InputMaybe<Scalars['Boolean']['input']>;
  skipGeofenceZones?: InputMaybe<Scalars['Boolean']['input']>;
  skipVehiclePositions?: InputMaybe<Scalars['Boolean']['input']>;
  skipVehicleChangePositions?: InputMaybe<Scalars['Boolean']['input']>;
  includeExtended?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type TokenTourQuery = {
  token:
    | ({ tour: (TourContainerDetailsFragment & { __typename: 'Tour' }) | null } & { __typename: 'TokenResources' })
    | null;
} & { __typename: 'Query' };

export type CompanyIdAndVisibilityServicesForTourQueryVariables = Exact<{
  tourId: Scalars['String']['input'];
}>;

export type CompanyIdAndVisibilityServicesForTourQuery = {
  viewer:
    | ({
        user_id: string;
        companyIdAndVisibilityServicesForTour:
          | ({ companyId: string; visibilityServices: Array<VisibilityService> | null } & {
              __typename: 'CompanyIdAndVisibilityServices';
            })
          | null;
      } & { __typename: 'User' })
    | null;
} & { __typename: 'Query' };

export type TokenTourVisibilityServicesQueryVariables = Exact<{ [key: string]: never }>;

export type TokenTourVisibilityServicesQuery = {
  token:
    | ({ tour: ({ tour_id: number; visibilityServices: Array<VisibilityService> } & { __typename: 'Tour' }) | null } & {
        __typename: 'TokenResources';
      })
    | null;
} & { __typename: 'Query' };

export type CompanyUserQueryVariables = Exact<{
  companyId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
}>;

export type CompanyUserQuery = {
  company:
    | ({
        company_id: string;
        user:
          | ({
              profile: {
                user_id: string;
                first_name: string | null;
                last_name: string | null;
                email: string | null;
              } & { __typename: 'UserProfile' };
            } & { __typename: 'UserInCompanyProfile' })
          | null;
      } & { __typename: 'Company' })
    | null;
} & { __typename: 'Query' };

export type AssignUserToTourMutationVariables = Exact<{
  input: AssignUserToTourInput;
}>;

export type AssignUserToTourMutation = {
  assignUserToTour:
    | ({
        assignedToUser:
          | ({ user_id: string; first_name: string | null; last_name: string | null; email: string | null } & {
              __typename: 'UserProfile';
            })
          | null;
      } & { __typename: 'TourAssignment' })
    | null;
} & { __typename: 'Mutation' };

export type DeleteUserAssignmentMutationVariables = Exact<{
  tourId: Scalars['String']['input'];
  companyId: Scalars['String']['input'];
}>;

export type DeleteUserAssignmentMutation = { deleteUserAssignment: boolean | null } & { __typename: 'Mutation' };

export type BulkAssignUserToToursMutationVariables = Exact<{
  companyId: Scalars['String']['input'];
  input: BulkAssignUserToToursInput;
}>;

export type BulkAssignUserToToursMutation = {
  bulkAssignUserToTours: { success: boolean; affectedCount: number; failedCount: number } & {
    __typename: 'BulkTourUserAssignmentResult';
  };
} & { __typename: 'Mutation' };

export type BulkDeleteUserAssignmentMutationVariables = Exact<{
  companyId: Scalars['String']['input'];
  input: BulkDeleteUserAssignmentFromToursInput;
}>;

export type BulkDeleteUserAssignmentMutation = {
  bulkDeleteUserAssignment: { success: boolean; affectedCount: number; failedCount: number } & {
    __typename: 'BulkTourUserAssignmentResult';
  };
} & { __typename: 'Mutation' };

export type CreateOrUpdateTransportNotificationMutationVariables = Exact<{
  input: CreateOrUpdateTransportNotificationInput;
}>;

export type CreateOrUpdateTransportNotificationMutation = { createOrUpdateTransportNotification: string } & {
  __typename: 'Mutation';
};

export type DeleteTransportNotificationMutationVariables = Exact<{
  input: DeleteTransportNotificationInput;
}>;

export type DeleteTransportNotificationMutation = { deleteTransportNotification: boolean } & { __typename: 'Mutation' };

export type CreateNoteMutationVariables = Exact<{
  input: CreateNoteInput;
}>;

export type CreateNoteMutation = {
  createNote:
    | ({
        noteId: string;
        stopId: string | null;
        noteText: string;
        noteVisibility: NoteVisibility;
        isEditable: boolean | null;
        noteSentToDriver: boolean;
        noteOrigin: NoteOrigin;
        createdBy: NoteCreatedBy;
        createdAt: string;
        updatedAt: string;
        associatedDeliveries: Array<
          { deliveryId: string; deliveryNumber: string | null } & { __typename: 'TourDelivery' }
        >;
      } & { __typename: 'Note' })
    | null;
} & { __typename: 'Mutation' };

export type UpdateNoteMutationVariables = Exact<{
  input: UpdateNoteInput;
}>;

export type UpdateNoteMutation = {
  updateNote:
    | ({
        noteId: string;
        stopId: string | null;
        noteText: string;
        noteVisibility: NoteVisibility;
        isEditable: boolean | null;
        noteSentToDriver: boolean;
        noteOrigin: NoteOrigin;
        createdBy: NoteCreatedBy;
        creatorCompanyId: string | null;
        creatorCompanyName: string | null;
        createdAt: string;
        updatedAt: string;
        associatedDeliveries: Array<
          { deliveryId: string; deliveryNumber: string | null } & { __typename: 'TourDelivery' }
        >;
      } & { __typename: 'Note' })
    | null;
} & { __typename: 'Mutation' };

export type DeleteNoteMutationVariables = Exact<{
  input: DeleteNoteInput;
}>;

export type DeleteNoteMutation = { deleteNote: boolean } & { __typename: 'Mutation' };

export type CreateTransportAnalysisMutationVariables = Exact<{
  input: CreateTransportAnalysisInput;
}>;

export type CreateTransportAnalysisMutation = {
  createTransportAnalysis:
    | ({
        analyzeId: string;
        companyId: string;
        createdAt: string;
        finishedAt: string | null;
        result: string | null;
        status: AnalyzeStatus;
      } & { __typename: 'TransportAnalysisResponse' })
    | null;
} & { __typename: 'Mutation' };

export type CancelTransportAnalysisMutationVariables = Exact<{
  input: CancelTransportAnalysisInput;
}>;

export type CancelTransportAnalysisMutation = {
  cancelTransportAnalysis:
    | ({ analyzeId: string; companyId: string } & { __typename: 'TransportAnalysisResponse' })
    | null;
} & { __typename: 'Mutation' };

export type TourVehicleHistoryDownloadQueryVariables = Exact<{
  companyId: Scalars['String']['input'];
  tourId: Scalars['Int']['input'];
}>;

export type TourVehicleHistoryDownloadQuery = {
  viewer:
    | ({
        user_id: string;
        company:
          | ({
              company_id: string;
              tour:
                | ({
                    tour_id: number;
                    vehicleHistoryDownload: {
                      isTruncated: boolean;
                      rows: Array<
                        {
                          vehicleId: string;
                          licensePlateNumber: string | null;
                          source: HistorySource | null;
                          type: HistoryType | null;
                          companyId: string | null;
                          timestamp: string;
                          latitude: number;
                          longitude: number;
                          positionReceivedAt: string | null;
                          telematicsProviderName: string | null;
                          telematicsIntegrationId: string | null;
                          isExtendedTrail: boolean;
                        } & { __typename: 'VehicleHistoryDownloadRow' }
                      >;
                    } & { __typename: 'VehicleHistoryDownload' };
                  } & { __typename: 'Tour' })
                | null;
            } & { __typename: 'Company' })
          | null;
      } & { __typename: 'User' })
    | null;
} & { __typename: 'Query' };

export type TranslateTransportAnalysisQueryVariables = Exact<{
  companyId: Scalars['String']['input'];
  tourId: Scalars['Int']['input'];
  input: TranslateTransportAnalysisInput;
}>;

export type TranslateTransportAnalysisQuery = {
  viewer:
    | ({
        user_id: string;
        company:
          | ({
              company_id: string;
              tour: ({ tour_id: number; translateTransportAnalysis: string | null } & { __typename: 'Tour' }) | null;
            } & { __typename: 'Company' })
          | null;
      } & { __typename: 'User' })
    | null;
} & { __typename: 'Query' };

export type AbortTourMutationVariables = Exact<{
  tour_id: Scalars['Int']['input'];
}>;

export type AbortTourMutation = {
  abortTour: ({ tour_id: number; status: string | null } & { __typename: 'Tour' }) | null;
} & { __typename: 'Mutation' };

export type TourStatusFragment = { tour_id: number; status: string | null; canAbortTour: boolean } & {
  __typename: 'Tour';
};

export type CreateTourStopSharingTokenMutationVariables = Exact<{
  tour_id: Scalars['String']['input'];
  stop_id: Scalars['String']['input'];
  company_id: Scalars['String']['input'];
}>;

export type CreateTourStopSharingTokenMutation = {
  createTourStopSharingToken:
    | ({ stop_id: number; sharingTokenV2: (SharingTokenFragment & { __typename: 'SharingToken' }) | null } & {
        __typename: 'TourStop';
      })
    | null;
} & { __typename: 'Mutation' };

export type DeleteTourStopSharingTokenMutationVariables = Exact<{
  tour_id: Scalars['String']['input'];
  stop_id: Scalars['String']['input'];
  company_id: Scalars['String']['input'];
}>;

export type DeleteTourStopSharingTokenMutation = {
  deleteTourStopSharingToken:
    | ({ stop_id: number; sharingTokenV2: (SharingTokenFragment & { __typename: 'SharingToken' }) | null } & {
        __typename: 'TourStop';
      })
    | null;
} & { __typename: 'Mutation' };

export type TourStopsTokensFragment = {
  tour_id: number;
  stops: Array<
    { stop_id: number; sharingTokenV2: (SharingTokenFragment & { __typename: 'SharingToken' }) | null } & {
      __typename: 'TourStop';
    }
  >;
} & { __typename: 'Tour' };

export type TourFragment = { tour_id: number; status: string | null } & { __typename: 'Tour' };

export type FilteredCompanyVehiclesQueryVariables = Exact<{
  companyId: Scalars['String']['input'];
  licensePlateSearch: Scalars['String']['input'];
  tourId: Scalars['Int']['input'];
}>;

export type FilteredCompanyVehiclesQuery = {
  viewer:
    | ({
        user_id: string;
        company:
          | ({
              company_id: string;
              tour:
                | ({
                    tour_id: number;
                    allocatableVehicles: {
                      edges: Array<
                        | ({
                            node:
                              | ({
                                  vehicle_id: string;
                                  license_plate_number: string | null;
                                  alternativeIdentifier: string | null;
                                  alternativeIdentifierId: string | null;
                                  timeBasedStatus: TimeBasedStatus | null;
                                } & { __typename: 'VehicleProfile' })
                              | null;
                          } & { __typename: 'VehicleProfileEdge' })
                        | null
                      > | null;
                    } & { __typename: 'VehicleProfileConnection' };
                  } & { __typename: 'Tour' })
                | null;
            } & { __typename: 'Company' })
          | null;
      } & { __typename: 'User' })
    | null;
} & { __typename: 'Query' };

export type FilteredGlobalPoolVehiclesQueryVariables = Exact<{
  companyId: Scalars['String']['input'];
  licensePlateSearch: Scalars['String']['input'];
  tourId: Scalars['Int']['input'];
}>;

export type FilteredGlobalPoolVehiclesQuery = {
  viewer:
    | ({
        user_id: string;
        company:
          | ({
              company_id: string;
              tour:
                | ({
                    tour_id: number;
                    allocatableVehicles: {
                      edges: Array<
                        | ({
                            node:
                              | ({
                                  vehicle_id: string;
                                  license_plate_number: string | null;
                                  alternativeIdentifier: string | null;
                                  alternativeIdentifierId: string | null;
                                  isOutsideOfTransportPool: boolean | null;
                                  timeBasedStatus: TimeBasedStatus | null;
                                } & { __typename: 'VehicleProfile' })
                              | null;
                          } & { __typename: 'VehicleProfileEdge' })
                        | null
                      > | null;
                    } & { __typename: 'VehicleProfileConnection' };
                  } & { __typename: 'Tour' })
                | null;
            } & { __typename: 'Company' })
          | null;
      } & { __typename: 'User' })
    | null;
} & { __typename: 'Query' };

export type CompanyMobileVehicleTrackersQueryVariables = Exact<{
  companyId: Scalars['String']['input'];
  search: Scalars['String']['input'];
  first: Scalars['Int']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
}>;

export type CompanyMobileVehicleTrackersQuery = {
  viewer:
    | ({
        user_id: string;
        company:
          | ({
              company_id: string;
              vehicles:
                | ({
                    allocatable:
                      | ({
                          vehicles: {
                            edges: Array<
                              | ({
                                  node:
                                    | ({
                                        vehicle_id: string;
                                        vehicleTrackers: Array<
                                          | { __typename: 'FMSVehicleTracker' }
                                          | ({
                                              vehicleTrackerId: string;
                                              vehicleId: string;
                                              alias: string | null;
                                              phoneNumber: string | null;
                                              trackerData: { [key: string]: string | number | boolean } | null;
                                            } & { __typename: 'MobileVehicleTracker' })
                                        >;
                                      } & { __typename: 'Vehicle' })
                                    | null;
                                } & { __typename: 'VehicleEdge' })
                              | null
                            > | null;
                            pageInfo: { hasNextPage: boolean; endCursor: string | null } & { __typename: 'PageInfo' };
                          } & { __typename: 'VehicleConnection' };
                        } & { __typename: 'CountedVehicleConnection' })
                      | null;
                  } & { __typename: 'CompanyVehicles' })
                | null;
            } & { __typename: 'Company' })
          | null;
      } & { __typename: 'User' })
    | null;
} & { __typename: 'Query' };

export type CompanySubcarriersQueryVariables = Exact<{
  companyId: Scalars['String']['input'];
  first: Scalars['Int']['input'];
  textSearch: Scalars['String']['input'];
}>;

export type CompanySubcarriersQuery = {
  viewer:
    | ({
        user_id: string;
        company:
          | ({
              company_id: string;
              carriersConnection: {
                carriers: {
                  edges: Array<
                    | ({
                        node:
                          | ({ company_id: string; company_name: string | null } & { __typename: 'CarrierOption' })
                          | null;
                      } & { __typename: 'CarrierOptionEdge' })
                    | null
                  > | null;
                } & { __typename: 'CarrierOptionConnection' };
              } & { __typename: 'CountedCarrierConnection' };
            } & { __typename: 'Company' })
          | null;
      } & { __typename: 'User' })
    | null;
} & { __typename: 'Query' };

export type TourAllocationPopupQueryVariables = Exact<{
  companyId: Scalars['String']['input'];
  tourId: Scalars['Int']['input'];
}>;

export type TourAllocationPopupQuery = {
  viewer:
    | ({
        user_id: string;
        company:
          | ({
              company_id: string;
              isMobileAllocationEnabled: boolean;
              tour:
                | ({
                    tour_id: number;
                    allocationType: TourVehicleAllocationType | null;
                    isSubcontractingEnabled: boolean;
                    canAllocateToTrimbleMobileApp: boolean;
                    activeVehicleAllocation:
                      | ({
                          vehicleId: string | null;
                          vehicleLicensePlateNumber: string | null;
                          vehicleTrackerTypes: Array<VehicleTrackerType> | null;
                        } & { __typename: 'TourVehicleAllocation' })
                      | null;
                    customFields: Array<
                      { fieldName: string; values: Array<{ value: string } & { __typename: 'CustomFieldValue' }> } & {
                        __typename: 'CustomField';
                      }
                    >;
                    subcontractor:
                      | ({ company_id: string; company_name: string | null } & { __typename: 'CompanyProfile' })
                      | null;
                    vehicleAllocations: Array<
                      {
                        source: TourVehicleAllocationSource;
                        vehicleId: string | null;
                        allocationType: TourVehicleAllocationType | null;
                        vehicleLicensePlateNumber: string | null;
                      } & { __typename: 'TourVehicleAllocation' }
                    >;
                    stops: Array<
                      {
                        stop_id: number;
                        type: string | null;
                        display_sequence_number: number;
                        location:
                          | ({
                              name: string | null;
                              position:
                                | ({ lat: number | null; lng: number | null } & { __typename: 'GeoPosition' })
                                | null;
                            } & { __typename: 'TourLocation' })
                          | null;
                      } & { __typename: 'TourStop' }
                    >;
                    suggestedVehicles: Array<
                      { vehicleId: string; licensePlate: string | null } & { __typename: 'VehicleProfile' }
                    >;
                  } & { __typename: 'Tour' })
                | null;
              vehicles:
                | ({
                    allocatableVehiclesCount: ({ count: number } & { __typename: 'CountedVehicleConnection' }) | null;
                    allocatableMobileTrackers:
                      | ({
                          vehicles: {
                            edges: Array<
                              | ({
                                  node:
                                    | ({
                                        vehicle_id: string;
                                        vehicleTrackers: Array<
                                          | { __typename: 'FMSVehicleTracker' }
                                          | ({
                                              vehicleTrackerId: string;
                                              vehicleId: string;
                                              alias: string | null;
                                              phoneNumber: string | null;
                                              trackerData: { [key: string]: string | number | boolean } | null;
                                            } & { __typename: 'MobileVehicleTracker' })
                                        >;
                                      } & { __typename: 'Vehicle' })
                                    | null;
                                } & { __typename: 'VehicleEdge' })
                              | null
                            > | null;
                          } & { __typename: 'VehicleConnection' };
                        } & { __typename: 'CountedVehicleConnection' })
                      | null;
                  } & { __typename: 'CompanyVehicles' })
                | null;
            } & { __typename: 'Company' })
          | null;
      } & { __typename: 'User' })
    | null;
} & { __typename: 'Query' };

export type TourAllocationHistoryPopupQueryVariables = Exact<{
  companyId: Scalars['String']['input'];
  tourId: Scalars['Int']['input'];
}>;

export type TourAllocationHistoryPopupQuery = {
  viewer:
    | ({
        user_id: string;
        company:
          | ({
              company_id: string;
              isMobileAllocationEnabled: boolean;
              tour:
                | ({
                    tour_id: number;
                    status: string | null;
                    allocationType: TourVehicleAllocationType | null;
                    isSubcontractingEnabled: boolean;
                    canAllocateToTrimbleMobileApp: boolean;
                    activeVehicleAllocation:
                      | ({
                          vehicleId: string | null;
                          vehicleLicensePlateNumber: string | null;
                          vehicleTrackerTypes: Array<VehicleTrackerType> | null;
                        } & { __typename: 'TourVehicleAllocation' })
                      | null;
                    customFields: Array<
                      { fieldName: string; values: Array<{ value: string } & { __typename: 'CustomFieldValue' }> } & {
                        __typename: 'CustomField';
                      }
                    >;
                    subcontractor:
                      | ({ company_id: string; company_name: string | null } & { __typename: 'CompanyProfile' })
                      | null;
                    activeAllocations: Array<
                      { allocationId: string; status: AllocationReferenceStatus } & {
                        __typename: 'AllocationReference';
                      }
                    >;
                    cleanedVehicleAllocationHistory: Array<
                      {
                        allocationId: string | null;
                        source: TourVehicleAllocationSource;
                        vehicleId: string | null;
                        allocationType: TourVehicleAllocationType | null;
                        allocationSwitchType: TourAllocationSwitchType | null;
                        startTrackingAt: string | null;
                        vehicleLicensePlateNumber: string | null;
                        isAutoAllocation: boolean | null;
                        isLimitedVisibilityAllocation: boolean | null;
                        additionalAssets: Array<
                          { identifier: string; reason: TourAdditionalAssetReason; vehicleId: string | null } & {
                            __typename: 'TourAdditionalAsset';
                          }
                        >;
                      } & { __typename: 'TourVehicleAllocation' }
                    >;
                    stops: Array<
                      {
                        stop_id: number;
                        type: string | null;
                        display_sequence_number: number;
                        location:
                          | ({
                              name: string | null;
                              position:
                                | ({ lat: number | null; lng: number | null } & { __typename: 'GeoPosition' })
                                | null;
                            } & { __typename: 'TourLocation' })
                          | null;
                      } & { __typename: 'TourStop' }
                    >;
                    suggestedVehicles: Array<
                      { vehicleId: string; licensePlate: string | null } & { __typename: 'VehicleProfile' }
                    >;
                  } & { __typename: 'Tour' })
                | null;
              vehicles:
                | ({
                    allocatableVehiclesCount: ({ count: number } & { __typename: 'CountedVehicleConnection' }) | null;
                    allocatableMobileTrackers:
                      | ({
                          vehicles: {
                            edges: Array<
                              | ({
                                  node:
                                    | ({
                                        vehicle_id: string;
                                        vehicleTrackers: Array<
                                          | { __typename: 'FMSVehicleTracker' }
                                          | ({
                                              vehicleTrackerId: string;
                                              vehicleId: string;
                                              alias: string | null;
                                              phoneNumber: string | null;
                                              trackerData: { [key: string]: string | number | boolean } | null;
                                            } & { __typename: 'MobileVehicleTracker' })
                                        >;
                                      } & { __typename: 'Vehicle' })
                                    | null;
                                } & { __typename: 'VehicleEdge' })
                              | null
                            > | null;
                          } & { __typename: 'VehicleConnection' };
                        } & { __typename: 'CountedVehicleConnection' })
                      | null;
                  } & { __typename: 'CompanyVehicles' })
                | null;
            } & { __typename: 'Company' })
          | null;
      } & { __typename: 'User' })
    | null;
} & { __typename: 'Query' };

export type TourAllocationDetailsFragment = {
  tour_id: number;
  status: string | null;
  allocationType: TourVehicleAllocationType | null;
  isSubcontractingEnabled: boolean;
  activeVehicleAllocation:
    | ({
        vehicleId: string | null;
        vehicleLicensePlateNumber: string | null;
        vehicleTrackerTypes: Array<VehicleTrackerType> | null;
      } & { __typename: 'TourVehicleAllocation' })
    | null;
  vehicleAllocations: Array<
    {
      source: TourVehicleAllocationSource;
      vehicleId: string | null;
      allocationType: TourVehicleAllocationType | null;
      vehicleLicensePlateNumber: string | null;
    } & { __typename: 'TourVehicleAllocation' }
  >;
  stops: Array<{ type: string | null; stop_id: number } & { __typename: 'TourStop' }>;
  subcontractor: ({ company_id: string; company_name: string | null } & { __typename: 'CompanyProfile' }) | null;
} & { __typename: 'Tour' };

export type AllocateVehiclesMutationVariables = Exact<{
  input: TourAllocationInput;
}>;

export type AllocateVehiclesMutation = {
  allocateVehiclesToTour: (TourAllocationDetailsFragment & { __typename: 'Tour' }) | null;
} & { __typename: 'Mutation' };

export type ChangeTourVehicleAllocationsMutationVariables = Exact<{
  input: TourVehicleAllocationsInput;
}>;

export type ChangeTourVehicleAllocationsMutation = {
  changeTourVehicleAllocations: Array<
    {
      allocationId: string | null;
      source: TourVehicleAllocationSource;
      vehicleId: string | null;
      allocationType: TourVehicleAllocationType | null;
      allocationSwitchType: TourAllocationSwitchType | null;
      startTrackingAt: string | null;
      vehicleLicensePlateNumber: string | null;
      additionalAssets: Array<
        { identifier: string; reason: TourAdditionalAssetReason; vehicleId: string | null } & {
          __typename: 'TourAdditionalAsset';
        }
      >;
    } & { __typename: 'TourVehicleAllocation' }
  >;
} & { __typename: 'Mutation' };

export type AllocateDummyMobileToTourMutationVariables = Exact<{
  input: DummyMobileTourAllocationInput;
}>;

export type AllocateDummyMobileToTourMutation = {
  allocateDummyMobileToTour: (TourAllocationDetailsFragment & { __typename: 'Tour' }) | null;
} & { __typename: 'Mutation' };

export type CreateVehicleMobileAppTrackerMutationVariables = Exact<{
  input: CreateVehicleMobileAppTrackerInput;
}>;

export type CreateVehicleMobileAppTrackerMutation = {
  createVehicleMobileAppTracker: { vehicleTrackerId: string } & { __typename: 'MobileVehicleTracker' };
} & { __typename: 'Mutation' };

export type ForwardTourMutationVariables = Exact<{
  input: ForwardTourInput;
}>;

export type ForwardTourMutation = { forwardTour: (TourAllocationDetailsFragment & { __typename: 'Tour' }) | null } & {
  __typename: 'Mutation';
};

export type UnforwardTourMutationVariables = Exact<{
  input: UnforwardTourInput;
}>;

export type UnforwardTourMutation = {
  unforwardTour: (TourAllocationDetailsFragment & { __typename: 'Tour' }) | null;
} & { __typename: 'Mutation' };

export type FinalizeTransportUploadMutationVariables = Exact<{
  input: FinalizeTransportUploadInput;
}>;

export type FinalizeTransportUploadMutation = {
  finalizeTransportUpload: { transportUploadId: string; mode: TransportUploadMode; status: TransportUploadStatus } & {
    __typename: 'FinalizeTransportUploadResult';
  };
} & { __typename: 'Mutation' };

export type InitiateTransportUploadMutationVariables = Exact<{
  input: InitiateTransportUploadInput;
}>;

export type InitiateTransportUploadMutation = {
  initiateTransportUpload: { storageFileId: string; uploadUrl: string; uploadId: string; expiresAt: string | null } & {
    __typename: 'InitiateTransportUploadResult';
  };
} & { __typename: 'Mutation' };

export type TransportUploadsQueryVariables = Exact<{
  companyId: Scalars['String']['input'];
  mode?: InputMaybe<TransportUploadMode>;
}>;

export type TransportUploadsQuery = {
  transportUploads: Array<
    {
      documentId: string;
      mode: TransportUploadMode;
      description: string;
      fileSize: number;
      status: TransportUploadStatus;
      totalRows: number | null;
      validRows: number | null;
      invalidRows: number | null;
      internalDownloadUrl: string | null;
      validationErrorMessage: string | null;
      uploadedAt: string;
      uploadedBy:
        | ({ userId: string; firstName: string | null; lastName: string | null } & {
            __typename: 'TransportUploadUploader';
          })
        | null;
    } & { __typename: 'TransportUpload' }
  >;
} & { __typename: 'Query' };

export type TripsLocationOptionsQueryVariables = Exact<{
  companyId: Scalars['String']['input'];
  type?: InputMaybe<Scalars['String']['input']>;
  types?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  subType: Scalars['String']['input'];
  textSearch?: InputMaybe<Scalars['String']['input']>;
  transportMode: TripsTransportMode;
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
}>;

export type TripsLocationOptionsQuery = {
  viewer:
    | ({
        user_id: string;
        company:
          | ({
              company_id: string;
              tripsOptionsConnection: {
                options:
                  | ({
                      edges: Array<
                        | ({ node: ({ value: string } & { __typename: 'TripsOption' }) | null } & {
                            __typename: 'TripsOptionEdge';
                          })
                        | null
                      > | null;
                    } & { __typename: 'TripsOptionConnection' })
                  | null;
              } & { __typename: 'CountedTripsOptionConnection' };
            } & { __typename: 'Company' })
          | null;
      } & { __typename: 'User' })
    | null;
} & { __typename: 'Query' };

export type MaritimeIntelligenceEventsQueryVariables = Exact<{
  companyId: Scalars['String']['input'];
  onlyActive?: InputMaybe<Scalars['Boolean']['input']>;
  eventId?: InputMaybe<Scalars['ID']['input']>;
  statuses?: InputMaybe<Array<MaritimeEventStatus> | MaritimeEventStatus>;
  titleQuery?: InputMaybe<Scalars['String']['input']>;
}>;

export type MaritimeIntelligenceEventsQuery = {
  viewer:
    | ({
        user_id: string;
        company:
          | ({
              company_id: string;
              maritimeIntelligenceEvents: Array<
                {
                  eventId: string;
                  title: string;
                  status: MaritimeEventStatus;
                  severity: MaritimeSeverity;
                  eventType: MaritimeEventType;
                  overview: string | null;
                  lastUpdatedAt: string;
                  representativeLat: number | null;
                  representativeLng: number | null;
                  affectedLocodes: Array<string>;
                  affectedPorts: Array<
                    { unlocode: string; name: string; countryCode: string | null } & {
                      __typename: 'MaritimeAffectedPort';
                    }
                  >;
                } & { __typename: 'MaritimeIntelligenceEvent' }
              >;
            } & { __typename: 'Company' })
          | null;
      } & { __typename: 'User' })
    | null;
} & { __typename: 'Query' };

export type MaritimeIncidentAffectedToursQueryVariables = Exact<{
  companyId: Scalars['String']['input'];
  eventId: Scalars['ID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  statuses?: InputMaybe<Array<MaritimeEventStatus> | MaritimeEventStatus>;
}>;

export type MaritimeIncidentAffectedToursQuery = {
  viewer:
    | ({
        user_id: string;
        company:
          | ({
              company_id: string;
              maritimeIntelligenceEvents: Array<
                {
                  eventId: string;
                  affectedTourCount: number;
                  affectedToursReportURL: string | null;
                  affectedTours: Array<
                    {
                      tour_id: number;
                      shipper_transport_number: string | null;
                      containerNumber: string | null;
                      bookingNumber: string | null;
                      carrierName: string | null;
                      containerType: string | null;
                      milestones:
                        | ({
                            locations: Array<
                              {
                                name: string;
                                locationCode: string | null;
                                type: LocationType | null;
                                milestones: Array<
                                  {
                                    qualifier: MilestoneQualifier | null;
                                    scheduledTimeOfArrival:
                                      | ({ dateTime: string; timezone: string } & {
                                          __typename: 'DateTimeWithTimezone';
                                        })
                                      | null;
                                    estimatedTimeOfArrival:
                                      | ({ dateTime: string; timezone: string } & {
                                          __typename: 'DateTimeWithTimezone';
                                        })
                                      | null;
                                    actualTimeOfArrival:
                                      | ({ dateTime: string; timezone: string } & {
                                          __typename: 'DateTimeWithTimezone';
                                        })
                                      | null;
                                  } & { __typename: 'MilestoneWithLocation' }
                                >;
                              } & { __typename: 'MilestoneLocation' }
                            >;
                          } & { __typename: 'LocationsAndMilestones' })
                        | null;
                    } & { __typename: 'Tour' }
                  >;
                } & { __typename: 'MaritimeIntelligenceEvent' }
              >;
            } & { __typename: 'Company' })
          | null;
      } & { __typename: 'User' })
    | null;
} & { __typename: 'Query' };

export type MaritimeContainerDisruptionsQueryVariables = Exact<{
  companyId: Scalars['String']['input'];
  statuses?: InputMaybe<Array<MaritimeEventStatus> | MaritimeEventStatus>;
}>;

export type MaritimeContainerDisruptionsQuery = {
  viewer:
    | ({
        user_id: string;
        company:
          | ({
              company_id: string;
              maritimeIntelligenceEvents: Array<
                {
                  eventId: string;
                  title: string;
                  status: MaritimeEventStatus;
                  severity: MaritimeSeverity;
                  eventType: MaritimeEventType;
                  affectedLocodes: Array<string>;
                  affectedPorts: Array<
                    { unlocode: string; name: string; countryCode: string | null } & {
                      __typename: 'MaritimeAffectedPort';
                    }
                  >;
                  affectedTours: Array<{ tour_id: number } & { __typename: 'Tour' }>;
                } & { __typename: 'MaritimeIntelligenceEvent' }
              >;
            } & { __typename: 'Company' })
          | null;
      } & { __typename: 'User' })
    | null;
} & { __typename: 'Query' };

export type DemurrageFragmentDetailsFragment = {
  minRemainingFreeDays: number | null;
  totalCost: number | null;
  overallState: string | null;
  currency: string;
  costs: Array<
    {
      name: string | null;
      contractReference: string | null;
      state: string | null;
      startDate: string | null;
      endDate: string | null;
      remainingFreeDays: number | null;
      overdueDays: number | null;
      runningCost: number | null;
      actualCost: number | null;
      currency: string;
      freeTimeType: string | null;
      contractType: string | null;
      comments: string | null;
      costDetails: Array<
        { daysBracket: string | null; costPerDay: number | null; calculation: string | null } & {
          __typename: 'OceanCostDetails';
        }
      >;
    } & { __typename: 'OceanDemurrageCost' }
  > | null;
} & { __typename: 'OceanDemurrage' };

export type TripsContainerDetailsBaseFragment = {
  tour_id: number;
  created_at: string;
  platformTransportURL: string | null;
  shipper_transport_number: string | null;
  status: string | null;
  sharingToken: string | null;
  billOfLading: string | null;
  bookingNumber: string | null;
  containerNumber: string | null;
  carrierName: string | null;
  carrierCode: string | null;
  containerType: string | null;
  airWayBill: string | null;
  customerPackageCount: number | null;
  customerPackageWeight: number | null;
  carrierPackageCount: number | null;
  carrierPackageWeight: number | null;
  transportAlertsHighestSeverity: TransportAlertSeverity | null;
  visibilityServices: Array<VisibilityService>;
  shipmentType: ShipmentType | null;
  platformBranchId: string | null;
  isOceanPlannedRouteHidden: boolean;
  warnings: Array<
    {
      type: TourWarningType;
      severity: TourWarningSeverity | null;
      metadata: { [key: string]: string | number | boolean } | null;
    } & { __typename: 'TourWarning' }
  >;
  carrier: ({ company_id: string; company_name: string | null } & { __typename: 'CompanyProfile' }) | null;
  tourEmissionsReceived: ({ epKgCo2: number | null } & { __typename: 'TourEmissionsReceived' }) | null;
  tripsVehicleStatus:
    | ({
        vehicle_id: string;
        latitude: number | null;
        longitude: number | null;
        heading: number | null;
        timestamp: string | null;
        accuracyInMeters: number | null;
      } & { __typename: 'VehicleStatus' })
    | null;
  tripsVehicleHistory: Array<
    {
      polyline: { points: string } & { __typename: 'Polyline' };
      metadata: { type: VehicleHistoryPolylineType } & { __typename: 'VehicleHistoryPolylineMetadata' };
    } & { __typename: 'VehicleHistoryPolyline' }
  > | null;
  tripsVesselRoute: Array<
    { type: string; startTime: string; endTime: string; polyline: { points: string } & { __typename: 'Polyline' } } & {
      __typename: 'VesselRoutePolyline';
    }
  > | null;
  tripsVesselPosition:
    | ({ latitude: number; longitude: number; heading: number | null; timestamp: string } & {
        __typename: 'VesselPosition';
      })
    | null;
  tourRoute:
    | ({ legs: Array<{ polyline: { points: string } & { __typename: 'Polyline' } } & { __typename: 'RouteLeg' }> } & {
        __typename: 'Route';
      })
    | null;
  customFields: Array<
    { fieldName: string; values: Array<{ value: string } & { __typename: 'CustomFieldValue' }> } & {
      __typename: 'CustomField';
    }
  >;
  events: Array<
    | ({
        stop_id: number;
        tour_id: number;
        event_id: number;
        vehicle_id: string | null;
        vehicle_lat: number | null;
        vehicle_lng: number | null;
        vehicle_license_plate_number: string | null;
        event_index: number;
        event_time: string | null;
        created_at: string;
        stop_event_name: StopEventName;
        externalEventCreatedAt: string | null;
        visibilitySource:
          | ({
              primaryEventSource: TourVisibilitySourceType;
              streamPrecision: TourVisibilityPrecisionType | null;
              sourcePlatform:
                | ({ platform_id: string; platform_name: string } & { __typename: 'PlatformProfile' })
                | null;
            } & { __typename: 'TourVisibilitySource' })
          | null;
      } & { __typename: 'StopEvent' })
    | ({
        event_id: number;
        tour_id: number;
        vehicle_id: string | null;
        vehicle_lat: number | null;
        vehicle_lng: number | null;
        event_index: number;
        event_time: string | null;
        created_at: string;
        tour_event_name: TourEventName;
        warning:
          | ({ type: TourWarningType; severity: TourWarningSeverity | null } & { __typename: 'TourWarning' })
          | null;
        visibilitySource:
          | ({
              primaryEventSource: TourVisibilitySourceType;
              streamPrecision: TourVisibilityPrecisionType | null;
              sourcePlatform:
                | ({ platform_id: string; platform_name: string } & { __typename: 'PlatformProfile' })
                | null;
            } & { __typename: 'TourVisibilitySource' })
          | null;
      } & { __typename: 'TourEvent' })
  >;
  stops: Array<
    {
      stop_id: number;
      display_sequence_number: number;
      location: ({ name: string | null } & { __typename: 'TourLocation' }) | null;
      deliveries: Array<
        {
          deliveryId: string;
          deliveryNumber: string | null;
          orderNumber: string | null;
          purchaseOrderNumber: string | null;
          incoterms: ({ term: string | null } & { __typename: 'TourIncoterms' }) | null;
        } & { __typename: 'TourDelivery' }
      >;
    } & { __typename: 'TourStop' }
  >;
  externalTourEvents: Array<
    {
      eventId: string;
      timestamp: string;
      eventSource: ExternalEventSource;
      externalEventSource: string | null;
      qualifier: ExternalTourEventQualifier;
      externalEventQualifier: string;
      licensePlateNumber: string | null;
      remoteId: string | null;
      vehicleType: VehicleType | null;
      locationName: string | null;
    } & { __typename: 'ExternalTourEvent' }
  >;
  incoterm: ({ term: string | null } & { __typename: 'TourIncoterms' }) | null;
  milestones:
    | ({
        vehicles: Array<
          {
            vehicleId: string;
            type: TripTransportMode;
            name: string | null;
            identificator: string | null;
            flightNumber: string | null;
            voyageId: string | null;
          } & { __typename: 'VehicleData' }
        >;
        locations: Array<
          {
            name: string;
            country: string | null;
            type: LocationType | null;
            locationCode: string | null;
            iataCode: string | null;
            locationTransportMode: MilestoneTransportModeType | null;
            position: ({ lat: number; lng: number } & { __typename: 'Position' }) | null;
            milestones: Array<
              {
                vehicleId: string | null;
                milestone: string;
                qualifier: MilestoneQualifier | null;
                estimatedTimeOfArrivalSource: string | null;
                actualTimeOfArrivalSource: string | null;
                scheduledTimeOfArrivalSource: string | null;
                packageCount: string | null;
                estimatedTimeOfArrival:
                  | ({ dateTime: string; timezone: string } & { __typename: 'DateTimeWithTimezone' })
                  | null;
                actualTimeOfArrival:
                  | ({ dateTime: string; timezone: string } & { __typename: 'DateTimeWithTimezone' })
                  | null;
                scheduledTimeOfArrival:
                  | ({ dateTime: string; timezone: string } & { __typename: 'DateTimeWithTimezone' })
                  | null;
                actualTimeOfArrivalOverrides:
                  | ({
                      actualTimeOfArrivalSource: string | null;
                      actualTimeOfArrival:
                        | ({ dateTime: string; timezone: string } & { __typename: 'DateTimeWithTimezone' })
                        | null;
                    } & { __typename: 'ActualTimeOverrides' })
                  | null;
              } & { __typename: 'MilestoneWithLocation' }
            >;
          } & { __typename: 'MilestoneLocation' }
        >;
      } & { __typename: 'LocationsAndMilestones' })
    | null;
  oceanDemurragePOD: (DemurrageFragmentDetailsFragment & { __typename: 'OceanDemurrage' }) | null;
  oceanDemurragePOL: (DemurrageFragmentDetailsFragment & { __typename: 'OceanDemurrage' }) | null;
  transportAlerts: Array<
    {
      alertId: string;
      type: TransportAlertType;
      severity: TransportAlertSeverity;
      description: string | null;
      createdAt: string;
    } & { __typename: 'TransportAlert' }
  >;
  trackingMetadata:
    | ({ carrierUpdateReceivedAt: string | null; externalStatusReceivedAt: string | null } & {
        __typename: 'TourTrackingMetadata';
      })
    | null;
  applicationDeepLinks: Array<{ applicationName: string; url: string } & { __typename: 'ApplicationDeepLink' }> | null;
} & { __typename: 'Tour' };

export type TripsContainerDetailsFragment = {
  assignedUser:
    | ({ user_id: string; first_name: string | null; last_name: string | null; email: string | null } & {
        __typename: 'UserProfile';
      })
    | null;
  relatedTransports: Array<{ sharingToken?: string | null } & ShipmentFragment & { __typename: 'Tour' }>;
  notes: Array<
    {
      noteId: string;
      stopId: string | null;
      noteText: string;
      noteVisibility: NoteVisibility;
      isEditable: boolean | null;
      noteSentToDriver: boolean;
      creatorCompanyId: string | null;
      creatorCompanyName: string | null;
      noteOrigin: NoteOrigin;
      createdBy: NoteCreatedBy;
      createdAt: string;
      updatedAt: string;
      associatedDeliveries: Array<
        { deliveryId: string; deliveryNumber: string | null } & { __typename: 'TourDelivery' }
      >;
    } & { __typename: 'Note' }
  >;
} & TripsContainerDetailsBaseFragment & { __typename: 'Tour' };

export type TripsDetailsQueryVariables = Exact<{
  companyId: Scalars['String']['input'];
  tourId: Scalars['Int']['input'];
  skipSharingToken?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type TripsDetailsQuery = {
  viewer:
    | ({
        user_id: string;
        company:
          | ({ company_id: string; tour: (TripsContainerDetailsFragment & { __typename: 'Tour' }) | null } & {
              __typename: 'Company';
            })
          | null;
      } & { __typename: 'User' })
    | null;
} & { __typename: 'Query' };

export type TripsTokenDetailsQueryVariables = Exact<{
  skipSharingToken?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type TripsTokenDetailsQuery = {
  token:
    | ({ tour: (TripsContainerDetailsFragment & { __typename: 'Tour' }) | null } & { __typename: 'TokenResources' })
    | null;
} & { __typename: 'Query' };

export type TripsSharedViewDetailsQueryVariables = Exact<{
  sharedViewId: Scalars['String']['input'];
  tourId: Scalars['Int']['input'];
}>;

export type TripsSharedViewDetailsQuery = {
  sharedViewViewer:
    | ({
        viewerId: string;
        sharedView:
          | ({ sharedViewId: string; tour: (TripsContainerDetailsBaseFragment & { __typename: 'Tour' }) | null } & {
              __typename: 'SharedViewContent';
            })
          | null;
      } & { __typename: 'SharedViewViewer' })
    | null;
} & { __typename: 'Query' };

export type ContainerCardDetailsFragment = {
  tour_id: number;
  containerNumber: string | null;
  shipmentType: ShipmentType | null;
  containerType: string | null;
  status: string | null;
  milestones:
    | ({
        locations: Array<
          { name: string; locationCode: string | null; type: LocationType | null } & { __typename: 'MilestoneLocation' }
        >;
      } & { __typename: 'LocationsAndMilestones' })
    | null;
} & { __typename: 'Tour' };

export type SharedViewBulkTripsDetailsQueryVariables = Exact<{
  sharedViewId: Scalars['String']['input'];
}>;

export type SharedViewBulkTripsDetailsQuery = {
  sharedViewViewer:
    | ({ viewerId: string; sharedView: ({ sharedViewId: string } & { __typename: 'SharedViewContent' }) | null } & {
        __typename: 'SharedViewViewer';
      })
    | null;
} & { __typename: 'Query' };

export type BulkTripsDetailsQueryVariables = Exact<{
  companyId: Scalars['String']['input'];
  tourIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
  role: TourCompanyRole;
  transportMode: Array<TourFilteringTransportMode> | TourFilteringTransportMode;
  sortOrder?: InputMaybe<TourSortOrder>;
}>;

export type BulkTripsDetailsQuery = {
  viewer:
    | ({
        user_id: string;
        company:
          | ({
              company_id: string;
              tours: {
                tours: {
                  edges: Array<
                    | ({ node: (ContainerCardDetailsFragment & { __typename: 'Tour' }) | null } & {
                        __typename: 'TourEdge';
                      })
                    | null
                  > | null;
                } & { __typename: 'TourConnection' };
              } & { __typename: 'CountedTourConnection' };
            } & { __typename: 'Company' })
          | null;
      } & { __typename: 'User' })
    | null;
} & { __typename: 'Query' };

export type TourDocumentDetailsFragment = {
  documentId: string;
  description: string | null;
  documentType: DocumentType;
  documentUrl: string;
  internalDownloadUrl: string | null;
  storageFileId: string;
  createdAt: string;
  fileSize: number | null;
  createdBy: ({ firstName: string | null; lastName: string | null } & { __typename: 'DocumentCreator' }) | null;
} & { __typename: 'Document' };

export type TourDocumentsQueryVariables = Exact<{
  companyId: Scalars['String']['input'];
  tourId: Scalars['Int']['input'];
}>;

export type TourDocumentsQuery = {
  viewer:
    | ({
        user_id: string;
        company:
          | ({
              company_id: string;
              tour:
                | ({ tour_id: number; documents: Array<TourDocumentDetailsFragment & { __typename: 'Document' }> } & {
                    __typename: 'Tour';
                  })
                | null;
            } & { __typename: 'Company' })
          | null;
      } & { __typename: 'User' })
    | null;
} & { __typename: 'Query' };

export type TourDocumentsTokenQueryVariables = Exact<{ [key: string]: never }>;

export type TourDocumentsTokenQuery = {
  token:
    | ({
        tour:
          | ({ tour_id: number; documents: Array<TourDocumentDetailsFragment & { __typename: 'Document' }> } & {
              __typename: 'Tour';
            })
          | null;
      } & { __typename: 'TokenResources' })
    | null;
} & { __typename: 'Query' };

export type TourDocumentsSharedViewQueryVariables = Exact<{
  sharedViewId: Scalars['String']['input'];
  tourId: Scalars['Int']['input'];
}>;

export type TourDocumentsSharedViewQuery = {
  sharedViewViewer:
    | ({
        viewerId: string;
        sharedView:
          | ({
              sharedViewId: string;
              tour:
                | ({ tour_id: number; documents: Array<TourDocumentDetailsFragment & { __typename: 'Document' }> } & {
                    __typename: 'Tour';
                  })
                | null;
            } & { __typename: 'SharedViewContent' })
          | null;
      } & { __typename: 'SharedViewViewer' })
    | null;
} & { __typename: 'Query' };

export type DeleteTourDocumentMutationVariables = Exact<{
  documentId: Scalars['String']['input'];
}>;

export type DeleteTourDocumentMutation = { deleteTourDocument: boolean } & { __typename: 'Mutation' };

export type InitiateDocumentUploadMutationVariables = Exact<{
  input: InitiateUploadInput;
}>;

export type InitiateDocumentUploadMutation = {
  initiateDocumentUpload: { storageFileId: string; uploadUrl: string; uploadId: string; expiresAt: string | null } & {
    __typename: 'InitiateUploadResult';
  };
} & { __typename: 'Mutation' };

export type TripsIdentifiersSearchQueryVariables = Exact<{
  company_id: Scalars['String']['input'];
  types: Array<TripsIdentifierType> | TripsIdentifierType;
  textSearch?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  identifierValues?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  transportMode: TripsTransportMode;
}>;

export type TripsIdentifiersSearchQuery = {
  viewer:
    | ({
        user_id: string;
        company:
          | ({
              company_id: string;
              tripsIdentifiersConnection: {
                tourIdentifiers: {
                  edges: Array<
                    | ({
                        node:
                          | ({ identifierType: TripsIdentifierType; identifierValue: string } & {
                              __typename: 'TripsTourIdentifier';
                            })
                          | null;
                      } & { __typename: 'TripsTourIdentifierEdge' })
                    | null
                  > | null;
                } & { __typename: 'TripsTourIdentifierConnection' };
              } & { __typename: 'CountedTripsIdentifiersConnection' };
            } & { __typename: 'Company' })
          | null;
      } & { __typename: 'User' })
    | null;
} & { __typename: 'Query' };

export type TransportGroupIdsSearchQueryVariables = Exact<{
  company_id: Scalars['String']['input'];
  textSearch?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  transportGroupIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;

export type TransportGroupIdsSearchQuery = {
  viewer:
    | ({
        user_id: string;
        company:
          | ({
              company_id: string;
              companyTransportGroupsConnection: {
                companyTransportGroups: {
                  edges: Array<
                    | ({ node: ({ transportGroupId: string } & { __typename: 'CompanyTransportGroup' }) | null } & {
                        __typename: 'CompanyTransportGroupEdge';
                      })
                    | null
                  > | null;
                } & { __typename: 'CompanyTransportGroupConnection' };
              } & { __typename: 'CountedCompanyTransportGroupConnection' };
            } & { __typename: 'Company' })
          | null;
      } & { __typename: 'User' })
    | null;
} & { __typename: 'Query' };

export type CompanyExceptionsSearchQueryVariables = Exact<{
  company_id: Scalars['String']['input'];
}>;

export type CompanyExceptionsSearchQuery = {
  viewer:
    | ({
        user_id: string;
        company:
          | ({ company_id: string; customExceptionTypes: Array<string>; serviceExceptionCodes: Array<string> } & {
              __typename: 'Company';
            })
          | null;
      } & { __typename: 'User' })
    | null;
} & { __typename: 'Query' };

export type DemurrageFragment = {
  minRemainingFreeDays: number | null;
  totalCost: number | null;
  currency: string;
  overallState: string | null;
} & { __typename: 'OceanDemurrage' };

export type TripsQueryVariables = Exact<{
  companyId: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  textSearch?: InputMaybe<TripsTextSearch>;
  siteIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  carrierIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  customerIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  assignedToUserIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  status?: InputMaybe<Array<TourStatusFilter> | TourStatusFilter>;
  customFields?: InputMaybe<Array<TourCustomFieldSearch> | TourCustomFieldSearch>;
  locations?: InputMaybe<Array<TransportLocation> | TransportLocation>;
  demurrage?: InputMaybe<OceanDemurrageFilter>;
  transportAlerts?: InputMaybe<TransportAlertsFilterInput>;
  carrierNames?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  carrierCodes?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  shipperContactNames?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  consigneeContactNames?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  customerContactNames?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  shipperLocationNames?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  consigneeLocationNames?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  customerLocationNames?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  transportGroupIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  containerNumbers?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  bookingNumbers?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  orderNumbers?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  billOfLadingNumbers?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  hasDocuments?: InputMaybe<Scalars['Boolean']['input']>;
  timezone?: InputMaybe<Scalars['IANATimezone']['input']>;
  impactDays?: InputMaybe<ImpactDaysFilter>;
  transportMode: Array<TourFilteringTransportMode> | TourFilteringTransportMode;
  airWayBillNumbers?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  flightNumbers?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  vesselName?: InputMaybe<VesselNameFilterInput>;
  voyageIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  shipmentType?: InputMaybe<Array<ShipmentTypeFilter> | ShipmentTypeFilter>;
  sortOrder?: InputMaybe<TourSortOrder>;
  boundingBox?: InputMaybe<BoundingBoxInput>;
  incoterm?: InputMaybe<Array<IncotermTerm> | IncotermTerm>;
}>;

export type TripsQuery = {
  viewer:
    | ({
        user_id: string;
        company:
          | ({
              company_id: string;
              tripsTours: {
                count: number;
                boundedCount: number | null;
                reportDownloadURI: string | null;
                tours: {
                  edges: Array<
                    | ({
                        cursor: string | null;
                        node:
                          | ({
                              tour_id: number;
                              shipper_transport_number: string | null;
                              billOfLading: string | null;
                              bookingNumber: string | null;
                              containerNumber: string | null;
                              carrierName: string | null;
                              carrierCode: string | null;
                              shipperContactName: string | null;
                              consigneeContactName: string | null;
                              customerContactName: string | null;
                              shipperLocationName: string | null;
                              consigneeLocationName: string | null;
                              customerLocationName: string | null;
                              transportGroupId: string | null;
                              containerType: string | null;
                              transitTime: number | null;
                              endToEndTransitTime: number | null;
                              impactDays: number | null;
                              endToEndImpactDays: number | null;
                              status: string | null;
                              airWayBill: string | null;
                              shipmentType: ShipmentType | null;
                              customerPackageCount: number | null;
                              customerPackageWeight: number | null;
                              carrierPackageCount: number | null;
                              carrierPackageWeight: number | null;
                              transportAlertsCount: number;
                              transportAlertsHighestSeverity: TransportAlertSeverity | null;
                              site: ({ site_id: string; name: string } & { __typename: 'SiteProfile' }) | null;
                              customFields: Array<
                                {
                                  fieldName: string;
                                  values: Array<{ value: string } & { __typename: 'CustomFieldValue' }>;
                                } & { __typename: 'CustomField' }
                              >;
                              vesselNames:
                                | ({
                                    pol: string | null;
                                    pod: string | null;
                                    polVoyageId: string | null;
                                    podVoyageId: string | null;
                                  } & { __typename: 'TripVesselNames' })
                                | null;
                              stops: Array<
                                {
                                  stop_id: number;
                                  deliveries: Array<
                                    {
                                      deliveryId: string;
                                      deliveryNumber: string | null;
                                      orderNumber: string | null;
                                      purchaseOrderNumber: string | null;
                                      incoterms: ({ term: string | null } & { __typename: 'TourIncoterms' }) | null;
                                    } & { __typename: 'TourDelivery' }
                                  >;
                                } & { __typename: 'TourStop' }
                              >;
                              carrier:
                                | ({ company_id: string; company_name: string | null } & {
                                    __typename: 'CompanyProfile';
                                  })
                                | null;
                              milestones:
                                | ({
                                    locations: Array<
                                      {
                                        name: string;
                                        locationCode: string | null;
                                        iataCode: string | null;
                                        voyageId: string | null;
                                        type: LocationType | null;
                                        country: string | null;
                                        locationTransportMode: MilestoneTransportModeType | null;
                                        milestones: Array<
                                          {
                                            milestone: string;
                                            qualifier: MilestoneQualifier | null;
                                            scheduledTimeOfArrivalSource: string | null;
                                            estimatedTimeOfArrivalSource: string | null;
                                            actualTimeOfArrivalSource: string | null;
                                            vehicleId: string | null;
                                            packageCount: string | null;
                                            scheduledTimeOfArrival:
                                              | ({ dateTime: string; timezone: string } & {
                                                  __typename: 'DateTimeWithTimezone';
                                                })
                                              | null;
                                            estimatedTimeOfArrival:
                                              | ({ dateTime: string; timezone: string } & {
                                                  __typename: 'DateTimeWithTimezone';
                                                })
                                              | null;
                                            actualTimeOfArrival:
                                              | ({ dateTime: string; timezone: string } & {
                                                  __typename: 'DateTimeWithTimezone';
                                                })
                                              | null;
                                            actualTimeOfArrivalOverrides:
                                              | ({
                                                  actualTimeOfArrivalSource: string | null;
                                                  actualTimeOfArrival:
                                                    | ({ dateTime: string; timezone: string } & {
                                                        __typename: 'DateTimeWithTimezone';
                                                      })
                                                    | null;
                                                } & { __typename: 'ActualTimeOverrides' })
                                              | null;
                                          } & { __typename: 'MilestoneWithLocation' }
                                        >;
                                      } & { __typename: 'MilestoneLocation' }
                                    >;
                                    vehicles: Array<
                                      { vehicleId: string; name: string | null; voyageId: string | null } & {
                                        __typename: 'VehicleData';
                                      }
                                    >;
                                  } & { __typename: 'LocationsAndMilestones' })
                                | null;
                              incoterm: ({ term: string | null } & { __typename: 'TourIncoterms' }) | null;
                              oceanDemurragePOD: (DemurrageFragment & { __typename: 'OceanDemurrage' }) | null;
                              oceanDemurragePOL: (DemurrageFragment & { __typename: 'OceanDemurrage' }) | null;
                              assignedUser:
                                | ({
                                    user_id: string;
                                    first_name: string | null;
                                    last_name: string | null;
                                    email: string | null;
                                  } & { __typename: 'UserProfile' })
                                | null;
                              relatedTransportsForListView: Array<
                                { tour_id: number; shipper_transport_number: string | null } & {
                                  __typename: 'RelatedTransportForListView';
                                }
                              >;
                              documents: Array<{ documentId: string } & { __typename: 'Document' }>;
                            } & { __typename: 'Tour' })
                          | null;
                      } & { __typename: 'TourEdge' })
                    | null
                  > | null;
                  pageInfo: { hasNextPage: boolean; endCursor: string | null } & { __typename: 'PageInfo' };
                } & { __typename: 'TourConnection' };
              } & { __typename: 'CountedTripsTourConnection' };
            } & { __typename: 'Company' })
          | null;
      } & { __typename: 'User' })
    | null;
} & { __typename: 'Query' };

export type TripsToursReportDownloadQueryVariables = Exact<{
  companyId: Scalars['String']['input'];
  textSearch?: InputMaybe<TripsTextSearch>;
  siteIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  carrierIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  customerIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  assignedToUserIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  status?: InputMaybe<Array<TourStatusFilter> | TourStatusFilter>;
  customFields?: InputMaybe<Array<TourCustomFieldSearch> | TourCustomFieldSearch>;
  locations?: InputMaybe<Array<TransportLocation> | TransportLocation>;
  demurrage?: InputMaybe<OceanDemurrageFilter>;
  carrierNames?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  carrierCodes?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  shipperContactNames?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  consigneeContactNames?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  customerContactNames?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  shipperLocationNames?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  consigneeLocationNames?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  customerLocationNames?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  transportAlerts?: InputMaybe<TransportAlertsFilterInput>;
  transportGroupIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  containerNumbers?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  bookingNumbers?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  orderNumbers?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  billOfLadingNumbers?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  hasDocuments?: InputMaybe<Scalars['Boolean']['input']>;
  timezone?: InputMaybe<Scalars['IANATimezone']['input']>;
  impactDays?: InputMaybe<ImpactDaysFilter>;
  airWayBillNumbers?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  flightNumbers?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  transportMode?: InputMaybe<Array<TourFilteringTransportMode> | TourFilteringTransportMode>;
  vesselName?: InputMaybe<VesselNameFilterInput>;
  voyageIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  shipmentType?: InputMaybe<Array<ShipmentTypeFilter> | ShipmentTypeFilter>;
  incoterm?: InputMaybe<Array<IncotermTerm> | IncotermTerm>;
}>;

export type TripsToursReportDownloadQuery = {
  viewer:
    | ({
        user_id: string;
        company:
          | ({
              company_id: string;
              tripsTours: { reportDownloadURI: string | null } & { __typename: 'CountedTripsTourConnection' };
            } & { __typename: 'Company' })
          | null;
      } & { __typename: 'User' })
    | null;
} & { __typename: 'Query' };

export type CompanyFilterOptionsQueryVariables = Exact<{
  companyId: Scalars['String']['input'];
  transportMode: TripsTransportMode;
  customFieldsTransportMode: TourFilteringTransportMode;
}>;

export type CompanyFilterOptionsQuery = {
  viewer:
    | ({
        user_id: string;
        company:
          | ({
              company_id: string;
              hasHadAnyDocuments: boolean;
              sitesConnection: { hasAny: boolean } & { __typename: 'CountedSiteConnection' };
              carriersConnection: { hasAny: boolean } & { __typename: 'CountedCarrierConnection' };
              customersConnection: { hasAny: boolean } & { __typename: 'CountedCustomerConnection' };
              users: { hasAny: boolean } & { __typename: 'CountedUserInCompanyProfileConnection' };
              billOfLadingNumbers: { hasAny: boolean } & { __typename: 'CountedTripsIdentifiersConnection' };
              bookingNumbers: { hasAny: boolean } & { __typename: 'CountedTripsIdentifiersConnection' };
              orderNumbers: { hasAny: boolean } & { __typename: 'CountedTripsIdentifiersConnection' };
              containerNumbers: { hasAny: boolean } & { __typename: 'CountedTripsIdentifiersConnection' };
              carrierIdentifiers: { hasAny: boolean } & { __typename: 'CountedTripsIdentifiersConnection' };
              airWayBillNumbers: { hasAny: boolean } & { __typename: 'CountedTripsIdentifiersConnection' };
              flightNumber: { hasAny: boolean } & { __typename: 'CountedTripsIdentifiersConnection' };
              vesselName: { hasAny: boolean } & { __typename: 'CountedTripsIdentifiersConnection' };
              voyageIds: { hasAny: boolean } & { __typename: 'CountedTripsIdentifiersConnection' };
              shipperContactNames: { hasAny: boolean } & { __typename: 'CountedTripsIdentifiersConnection' };
              consigneeContactNames: { hasAny: boolean } & { __typename: 'CountedTripsIdentifiersConnection' };
              customerContactNames: { hasAny: boolean } & { __typename: 'CountedTripsIdentifiersConnection' };
              shipperLocationNames: { hasAny: boolean } & { __typename: 'CountedTripsIdentifiersConnection' };
              consigneeLocationNames: { hasAny: boolean } & { __typename: 'CountedTripsIdentifiersConnection' };
              customerLocationNames: { hasAny: boolean } & { __typename: 'CountedTripsIdentifiersConnection' };
              companyTransportGroupsConnection: { hasAny: boolean } & {
                __typename: 'CountedCompanyTransportGroupConnection';
              };
              incotermConnection: { hasAny: boolean } & { __typename: 'CountedIncotermConnection' };
              connectedCustomFields: Array<
                { displayName: string | null; name: string } & { __typename: 'ConnectedCustomField' }
              >;
            } & { __typename: 'Company' })
          | null;
      } & { __typename: 'User' })
    | null;
} & { __typename: 'Query' };

export type TripsMapPositionsGeoJsonQueryVariables = Exact<{
  companyId: Scalars['String']['input'];
  textSearch?: InputMaybe<TripsTextSearch>;
  siteIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  carrierIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  customerIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  assignedToUserIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  status?: InputMaybe<Array<TourStatusFilter> | TourStatusFilter>;
  customFields?: InputMaybe<Array<TourCustomFieldSearch> | TourCustomFieldSearch>;
  locations?: InputMaybe<Array<TransportLocation> | TransportLocation>;
  demurrage?: InputMaybe<OceanDemurrageFilter>;
  transportAlerts?: InputMaybe<TransportAlertsFilterInput>;
  carrierNames?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  carrierCodes?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  shipperContactNames?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  consigneeContactNames?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  customerContactNames?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  shipperLocationNames?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  consigneeLocationNames?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  customerLocationNames?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  transportGroupIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  containerNumbers?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  bookingNumbers?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  orderNumbers?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  billOfLadingNumbers?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  hasDocuments?: InputMaybe<Scalars['Boolean']['input']>;
  impactDays?: InputMaybe<ImpactDaysFilter>;
  transportMode: Array<TourFilteringTransportMode> | TourFilteringTransportMode;
  airWayBillNumbers?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  flightNumbers?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  vesselName?: InputMaybe<VesselNameFilterInput>;
  voyageIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  shipmentType?: InputMaybe<Array<ShipmentTypeFilter> | ShipmentTypeFilter>;
  incoterm?: InputMaybe<Array<IncotermTerm> | IncotermTerm>;
}>;

export type TripsMapPositionsGeoJsonQuery = {
  viewer:
    | ({
        user_id: string;
        company:
          | ({
              company_id: string;
              tripsTours: {
                tripsPositionsGeoJSON:
                  | ({
                      type: string;
                      features: Array<
                        {
                          type: string;
                          geometry: { type: string; coordinates: Array<number> } & { __typename: 'GeoJSONGeometry' };
                          properties: {
                            position_id: string;
                            total_containers: number;
                            tour_ids: Array<string>;
                            delay_status: string | null;
                          } & { __typename: 'PositionGeoJSONProperties' };
                        } & { __typename: 'PositionGeoJSONFeature' }
                      >;
                    } & { __typename: 'PositionGeoJSONFeatureCollection' })
                  | null;
              } & { __typename: 'CountedTripsTourConnection' };
            } & { __typename: 'Company' })
          | null;
      } & { __typename: 'User' })
    | null;
} & { __typename: 'Query' };

export type MapInitialBoundsQueryVariables = Exact<{
  companyId: Scalars['String']['input'];
  textSearch?: InputMaybe<TripsTextSearch>;
  siteIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  carrierIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  customerIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  assignedToUserIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  status?: InputMaybe<Array<TourStatusFilter> | TourStatusFilter>;
  customFields?: InputMaybe<Array<TourCustomFieldSearch> | TourCustomFieldSearch>;
  locations?: InputMaybe<Array<TransportLocation> | TransportLocation>;
  demurrage?: InputMaybe<OceanDemurrageFilter>;
  transportAlerts?: InputMaybe<TransportAlertsFilterInput>;
  carrierNames?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  carrierCodes?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  shipperContactNames?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  consigneeContactNames?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  customerContactNames?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  shipperLocationNames?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  consigneeLocationNames?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  customerLocationNames?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  transportGroupIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  containerNumbers?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  bookingNumbers?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  orderNumbers?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  billOfLadingNumbers?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  hasDocuments?: InputMaybe<Scalars['Boolean']['input']>;
  impactDays?: InputMaybe<ImpactDaysFilter>;
  transportMode: Array<TourFilteringTransportMode> | TourFilteringTransportMode;
  airWayBillNumbers?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  flightNumbers?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  vesselName?: InputMaybe<VesselNameFilterInput>;
  voyageIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  shipmentType?: InputMaybe<Array<ShipmentTypeFilter> | ShipmentTypeFilter>;
  incoterm?: InputMaybe<Array<IncotermTerm> | IncotermTerm>;
}>;

export type MapInitialBoundsQuery = {
  viewer:
    | ({
        user_id: string;
        company:
          | ({
              company_id: string;
              tripsTours: {
                mapTilesBounds:
                  | ({
                      ne: { lat: number; lng: number } & { __typename: 'PointLocation' };
                      sw: { lat: number; lng: number } & { __typename: 'PointLocation' };
                    } & { __typename: 'Bounds' })
                  | null;
              } & { __typename: 'CountedTripsTourConnection' };
            } & { __typename: 'Company' })
          | null;
      } & { __typename: 'User' })
    | null;
} & { __typename: 'Query' };

export type CompanyContainerCountQueryVariables = Exact<{
  companyId: Scalars['String']['input'];
  transportMode: Array<TourFilteringTransportMode> | TourFilteringTransportMode;
  statuses?: InputMaybe<Array<TourStatusFilter> | TourStatusFilter>;
}>;

export type CompanyContainerCountQuery = {
  viewer:
    | ({
        user_id: string;
        company:
          | ({ company_id: string; tripsTours: { count: number } & { __typename: 'CountedTripsTourConnection' } } & {
              __typename: 'Company';
            })
          | null;
      } & { __typename: 'User' })
    | null;
} & { __typename: 'Query' };

export type ChangeUserProfileMutationVariables = Exact<{
  input: UpdateViewerProfileInput;
}>;

export type ChangeUserProfileMutation = {
  updateViewerProfile: ({ user_id: string; locale: string | null } & { __typename: 'User' }) | null;
} & { __typename: 'Mutation' };

export type UserProfileQueryVariables = Exact<{
  companyId: Scalars['String']['input'];
  skipCompany: Scalars['Boolean']['input'];
}>;

export type UserProfileQuery = {
  viewer:
    | ({
        user_id: string;
        email: string | null;
        first_name: string | null;
        last_name: string | null;
        locale: string | null;
        backoffice_access_enabled: boolean | null;
        is_internal: boolean | null;
        company?:
          | ({ company_id: string; me: ({ role: UserRoleInCompany } & { __typename: 'UserInCompany' }) | null } & {
              __typename: 'Company';
            })
          | null;
      } & { __typename: 'User' })
    | null;
} & { __typename: 'Query' };

export type VisibilityAgentEnabledQueryVariables = Exact<{
  companyId?: InputMaybe<Scalars['String']['input']>;
}>;

export type VisibilityAgentEnabledQuery = {
  viewer: ({ user_id: string; isVisibilityAgentEnabled: boolean } & { __typename: 'User' }) | null;
} & { __typename: 'Query' };

export type PingUserUiActivityMutationVariables = Exact<{
  companyId: Scalars['String']['input'];
}>;

export type PingUserUiActivityMutation = { pingUserUiActivity: boolean } & { __typename: 'Mutation' };

export type TriggerAuthenticationCheckQueryVariables = Exact<{ [key: string]: never }>;

export type TriggerAuthenticationCheckQuery = { viewer: ({ user_id: string } & { __typename: 'User' }) | null } & {
  __typename: 'Query';
};

export type VehicleManagementMapVehicleDetailsQueryVariables = Exact<{
  companyId: Scalars['String']['input'];
  vehicleId: Scalars['String']['input'];
}>;

export type VehicleManagementMapVehicleDetailsQuery = {
  viewer:
    | ({
        user_id: string;
        company:
          | ({
              company_id: string;
              vehicle:
                | ({
                    vehicle_id: string;
                    license_plate_number: string | null;
                    status:
                      | ({ timestamp: string; timeBasedStatus: TimeBasedStatus } & {
                          __typename: 'RestrictedVehicleStatus';
                        })
                      | null;
                    sharedBy:
                      | ({ company_id: string; company_name: string | null } & { __typename: 'CompanyProfile' })
                      | null;
                    boundingBox: Array<{ lat: number; lng: number } & { __typename: 'PointLocation' }> | null;
                  } & { __typename: 'Vehicle' })
                | null;
            } & { __typename: 'Company' })
          | null;
      } & { __typename: 'User' })
    | null;
} & { __typename: 'Query' };

export type VehicleManagementVehicleSharedByQueryVariables = Exact<{
  companyId: Scalars['String']['input'];
  vehicleId: Scalars['String']['input'];
}>;

export type VehicleManagementVehicleSharedByQuery = {
  viewer:
    | ({
        user_id: string;
        company:
          | ({
              company_id: string;
              vehicle:
                | ({
                    vehicle_id: string;
                    sharedBy:
                      | ({ company_id: string; company_name: string | null } & { __typename: 'CompanyProfile' })
                      | null;
                  } & { __typename: 'Vehicle' })
                | null;
            } & { __typename: 'Company' })
          | null;
      } & { __typename: 'User' })
    | null;
} & { __typename: 'Query' };

export type VehicleManagementMapVehicleHistoryQueryVariables = Exact<{
  companyId: Scalars['String']['input'];
  vehicleId: Scalars['String']['input'];
  startTime: Scalars['DateTime']['input'];
  endTime: Scalars['DateTime']['input'];
}>;

export type VehicleManagementMapVehicleHistoryQuery = {
  viewer:
    | ({
        user_id: string;
        company:
          | ({
              company_id: string;
              vehicle:
                | ({
                    vehicle_id: string;
                    historyCustomer: Array<
                      {
                        timestamp: string;
                        latitude: number;
                        longitude: number;
                        heading: number | null;
                        speed: number | null;
                        metainfo: { fuelLevelLiters: number | null } & { __typename: 'VehicleStatusMetainfo' };
                      } & { __typename: 'VehicleHistoryCustomer' }
                    >;
                  } & { __typename: 'Vehicle' })
                | null;
            } & { __typename: 'Company' })
          | null;
      } & { __typename: 'User' })
    | null;
} & { __typename: 'Query' };

export type VehicleManagementVehicleDetailsSidepanelQueryVariables = Exact<{
  companyId: Scalars['String']['input'];
  vehicleId: Scalars['String']['input'];
}>;

export type VehicleManagementVehicleDetailsSidepanelQuery = {
  viewer:
    | ({
        user_id: string;
        company:
          | ({
              company_id: string;
              vehicle:
                | ({
                    vehicle_id: string;
                    license_plate_number: string | null;
                    isConstantPositionAccessAllowed: boolean;
                    mapTilesTemplateURI: string | null;
                    created_at: string | null;
                    boundingBox: Array<{ lat: number; lng: number } & { __typename: 'PointLocation' }> | null;
                    status:
                      | ({ timestamp: string; timeBasedStatus: TimeBasedStatus } & {
                          __typename: 'RestrictedVehicleStatus';
                        })
                      | null;
                    alternativeIdentifiers: Array<
                      { vehicleAlternativeIdentifierId: string; alternativeIdentifier: string } & {
                        __typename: 'VehicleAlternativeIdentifier';
                      }
                    >;
                    sharedTo: Array<
                      { company_id: string; company_name: string | null } & { __typename: 'CompanyProfile' }
                    >;
                    sharedBy:
                      | ({ company_id: string; company_name: string | null } & { __typename: 'CompanyProfile' })
                      | null;
                    vehicleTrackers: Array<
                      | ({
                          vehicleTrackerId: string;
                          trackerType: VehicleTrackerType;
                          telematicsIntegration:
                            | ({
                                telematicsIntegrationId: string;
                                isAllowedToUpdateCredentials: boolean;
                                enabled: boolean;
                                diagnosticStatus: TelematicsIntegrationDiagnosticStatus | null;
                                telematicsProvider: { telematicsProviderId: string; telematicsProviderName: string } & {
                                  __typename: 'TelematicsProvider';
                                };
                              } & { __typename: 'CompanyTelematicsIntegration' })
                            | null;
                        } & { __typename: 'FMSVehicleTracker' })
                      | ({
                          vehicleTrackerId: string;
                          trackerType: VehicleTrackerType;
                          phoneNumber: string | null;
                          alias: string | null;
                        } & { __typename: 'MobileVehicleTracker' })
                    >;
                  } & { __typename: 'Vehicle' })
                | null;
            } & { __typename: 'Company' })
          | null;
      } & { __typename: 'User' })
    | null;
} & { __typename: 'Query' };

export type VehicleManagementVehicleDetailsSidepanelDedicatedByQueryVariables = Exact<{
  companyId: Scalars['String']['input'];
  vehicleId: Scalars['String']['input'];
}>;

export type VehicleManagementVehicleDetailsSidepanelDedicatedByQuery = {
  viewer:
    | ({
        user_id: string;
        company:
          | ({
              company_id: string;
              vehicle:
                | ({
                    vehicle_id: string;
                    license_plate_number: string | null;
                    isConstantPositionAccessAllowed: boolean;
                    mapTilesTemplateURI: string | null;
                    boundingBox: Array<{ lat: number; lng: number } & { __typename: 'PointLocation' }> | null;
                    status:
                      | ({ timestamp: string; timeBasedStatus: TimeBasedStatus } & {
                          __typename: 'RestrictedVehicleStatus';
                        })
                      | null;
                    sharedBy:
                      | ({ company_id: string; company_name: string | null } & { __typename: 'CompanyProfile' })
                      | null;
                  } & { __typename: 'Vehicle' })
                | null;
            } & { __typename: 'Company' })
          | null;
      } & { __typename: 'User' })
    | null;
} & { __typename: 'Query' };

export type VehicleManagementDedicatedVehiclesQueryVariables = Exact<{
  companyId: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  licensePlateSearch?: InputMaybe<Scalars['String']['input']>;
  sorting: VehicleFilterSortOrderInput;
  timeBasedStatus?: InputMaybe<TimeBasedStatus>;
  grantedByPartnersFilter?: InputMaybe<Scalars['Boolean']['input']>;
  ownVehiclesOnly?: InputMaybe<Scalars['Boolean']['input']>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  summaryArchived: Scalars['Boolean']['input'];
}>;

export type VehicleManagementDedicatedVehiclesQuery = {
  viewer:
    | ({
        user_id: string;
        company:
          | ({
              company_id: string;
              vehicles:
                | ({
                    dedicatedVehicles:
                      | ({
                          count: number;
                          mapTilesTemplateURI: string | null;
                          vehiclesReportDownloadURI: string | null;
                          vehicleAltIdImportTemplateURI: string | null;
                          boundingBox: Array<{ lat: number; lng: number } & { __typename: 'PointLocation' }> | null;
                          vehicles: {
                            edges: Array<
                              | ({
                                  node:
                                    | ({
                                        vehicle_id: string;
                                        archived: boolean;
                                        license_plate_number: string | null;
                                        sharedTo: Array<
                                          { company_id: string; company_name: string | null } & {
                                            __typename: 'CompanyProfile';
                                          }
                                        >;
                                        sharedBy:
                                          | ({ company_id: string; company_name: string | null } & {
                                              __typename: 'CompanyProfile';
                                            })
                                          | null;
                                        status:
                                          | ({ timestamp: string; timeBasedStatus: TimeBasedStatus } & {
                                              __typename: 'RestrictedVehicleStatus';
                                            })
                                          | null;
                                        alternativeIdentifiers: Array<
                                          { vehicleAlternativeIdentifierId: string; alternativeIdentifier: string } & {
                                            __typename: 'VehicleAlternativeIdentifier';
                                          }
                                        >;
                                        vehicleTrackers: Array<
                                          | ({
                                              vehicleTrackerId: string;
                                              trackerType: VehicleTrackerType;
                                              telematicsIntegration:
                                                | ({
                                                    telematicsIntegrationId: string;
                                                    telematicsProvider: {
                                                      telematicsProviderId: string;
                                                      telematicsProviderName: string;
                                                    } & { __typename: 'TelematicsProvider' };
                                                  } & { __typename: 'CompanyTelematicsIntegration' })
                                                | null;
                                            } & { __typename: 'FMSVehicleTracker' })
                                          | ({
                                              vehicleTrackerId: string;
                                              trackerType: VehicleTrackerType;
                                              phoneNumber: string | null;
                                              alias: string | null;
                                            } & { __typename: 'MobileVehicleTracker' })
                                        >;
                                      } & { __typename: 'Vehicle' })
                                    | null;
                                } & { __typename: 'VehicleEdge' })
                              | null
                            > | null;
                            pageInfo: { hasNextPage: boolean; endCursor: string | null } & { __typename: 'PageInfo' };
                          } & { __typename: 'VehicleConnection' };
                        } & { __typename: 'CountedVehicleConnection' })
                      | null;
                    summaryCounts: { total: number; active: number; inactive: number } & {
                      __typename: 'DedicatedVehiclesSummaryCounts';
                    };
                    archivedSummaryCounts: { total: number } & { __typename: 'DedicatedVehiclesSummaryCounts' };
                  } & { __typename: 'CompanyVehicles' })
                | null;
            } & { __typename: 'Company' })
          | null;
      } & { __typename: 'User' })
    | null;
} & { __typename: 'Query' };

export type ArchiveVehiclesMutationVariables = Exact<{
  input: ArchiveVehiclesInput;
}>;

export type ArchiveVehiclesMutation = {
  archiveVehicles: { success: boolean; affectedCount: number } & { __typename: 'ArchiveVehiclesResult' };
} & { __typename: 'Mutation' };

export type UnarchiveVehiclesMutationVariables = Exact<{
  input: ArchiveVehiclesInput;
}>;

export type UnarchiveVehiclesMutation = {
  unarchiveVehicles: { success: boolean; affectedCount: number } & { __typename: 'ArchiveVehiclesResult' };
} & { __typename: 'Mutation' };

export type VehicleArchiveStatusByPlateQueryVariables = Exact<{
  companyId: Scalars['String']['input'];
  plate: Scalars['String']['input'];
}>;

export type VehicleArchiveStatusByPlateQuery = {
  viewer:
    | ({
        user_id: string;
        company:
          | ({
              company_id: string;
              currentVehicles:
                | ({ all: ({ count: number } & { __typename: 'CountedVehicleConnection' }) | null } & {
                    __typename: 'CompanyVehicles';
                  })
                | null;
              archivedVehicles:
                | ({ all: ({ count: number } & { __typename: 'CountedVehicleConnection' }) | null } & {
                    __typename: 'CompanyVehicles';
                  })
                | null;
            } & { __typename: 'Company' })
          | null;
      } & { __typename: 'User' })
    | null;
} & { __typename: 'Query' };

export type VehicleManagementDedicatedToPartnerVehiclesQueryVariables = Exact<{
  companyId: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  licensePlateSearch?: InputMaybe<Scalars['String']['input']>;
  partnerId: Scalars['String']['input'];
  partnerIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  sorting: VehicleFilterSortOrderInput;
  timeBasedStatus?: InputMaybe<TimeBasedStatus>;
  permissions?: InputMaybe<VehiclePermissionsInput>;
}>;

export type VehicleManagementDedicatedToPartnerVehiclesQuery = {
  viewer:
    | ({
        user_id: string;
        company:
          | ({
              company_id: string;
              partner:
                | ({
                    company: { company_id: string; company_name: string | null } & { __typename: 'CompanyProfile' };
                  } & { __typename: 'VehicleGrantPartner' })
                | null;
              vehicles:
                | ({
                    dedicatedToPartners:
                      | ({
                          mapTilesTemplateURI: string | null;
                          count: number;
                          boundingBox: Array<{ lat: number; lng: number } & { __typename: 'PointLocation' }> | null;
                          vehicles: {
                            edges: Array<
                              | ({
                                  node:
                                    | ({
                                        vehicle_id: string;
                                        license_plate_number: string | null;
                                        sharedTo: Array<
                                          { company_id: string; company_name: string | null } & {
                                            __typename: 'CompanyProfile';
                                          }
                                        >;
                                        status:
                                          | ({ timestamp: string; timeBasedStatus: TimeBasedStatus } & {
                                              __typename: 'RestrictedVehicleStatus';
                                            })
                                          | null;
                                        alternativeIdentifiers: Array<
                                          { vehicleAlternativeIdentifierId: string; alternativeIdentifier: string } & {
                                            __typename: 'VehicleAlternativeIdentifier';
                                          }
                                        >;
                                        sentGrants: Array<
                                          {
                                            grantId: string;
                                            permissions: { withConstantPositionAccess: boolean } & {
                                              __typename: 'VehiclePermissions';
                                            };
                                          } & { __typename: 'VehicleGrant' }
                                        >;
                                      } & { __typename: 'Vehicle' })
                                    | null;
                                } & { __typename: 'VehicleEdge' })
                              | null
                            > | null;
                            pageInfo: { hasNextPage: boolean; endCursor: string | null } & { __typename: 'PageInfo' };
                          } & { __typename: 'VehicleConnection' };
                        } & { __typename: 'CountedVehicleConnection' })
                      | null;
                    totalCount: ({ count: number } & { __typename: 'CountedVehicleConnection' }) | null;
                    activeCount: ({ count: number } & { __typename: 'CountedVehicleConnection' }) | null;
                    inactiveCount: ({ count: number } & { __typename: 'CountedVehicleConnection' }) | null;
                  } & { __typename: 'CompanyVehicles' })
                | null;
            } & { __typename: 'Company' })
          | null;
      } & { __typename: 'User' })
    | null;
} & { __typename: 'Query' };

export type SetVehicleConstantPositionAccessMutationVariables = Exact<{
  input: VehicleGrantVisibilityInput;
}>;

export type SetVehicleConstantPositionAccessMutation = { setVehicleGrantVisibility: boolean | null } & {
  __typename: 'Mutation';
};

export type VehicleManagementDedicatedToPartnersListQueryVariables = Exact<{
  companyId: Scalars['String']['input'];
  partnerNameSearch?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
}>;

export type VehicleManagementDedicatedToPartnersListQuery = {
  viewer:
    | ({
        user_id: string;
        company:
          | ({
              company_id: string;
              vehicleGrantPartners: {
                partners: {
                  edges: Array<
                    | ({
                        node:
                          | ({
                              grantCountWithoutVisibility: number;
                              grantCountWithVisibility: number;
                              company: { company_id: string; company_name: string | null } & {
                                __typename: 'CompanyProfile';
                              };
                            } & { __typename: 'VehicleGrantPartner' })
                          | null;
                      } & { __typename: 'VehicleGrantPartnerEdge' })
                    | null
                  > | null;
                  pageInfo: { endCursor: string | null; hasNextPage: boolean } & { __typename: 'PageInfo' };
                } & { __typename: 'VehicleGrantPartnerConnection' };
              } & { __typename: 'CountedVehicleGrantPartnerConnection' };
              vehicles:
                | ({
                    dedicatedToPartnersAllCountByStatus: { active: number; inActive: number } & {
                      __typename: 'VehicleCountByStatus';
                    };
                  } & { __typename: 'CompanyVehicles' })
                | null;
            } & { __typename: 'Company' })
          | null;
      } & { __typename: 'User' })
    | null;
} & { __typename: 'Query' };

export type VehicleManagementDedicatedByPartnersListQueryVariables = Exact<{
  companyId: Scalars['String']['input'];
  partnerNameSearch?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
}>;

export type VehicleManagementDedicatedByPartnersListQuery = {
  viewer:
    | ({
        user_id: string;
        company:
          | ({
              company_id: string;
              vehicleGrantPartners: {
                partners: {
                  edges: Array<
                    | ({
                        node:
                          | ({
                              grantCountWithVisibility: number;
                              company: { company_id: string; company_name: string | null } & {
                                __typename: 'CompanyProfile';
                              };
                            } & { __typename: 'VehicleGrantPartner' })
                          | null;
                      } & { __typename: 'VehicleGrantPartnerEdge' })
                    | null
                  > | null;
                  pageInfo: { endCursor: string | null; hasNextPage: boolean } & { __typename: 'PageInfo' };
                } & { __typename: 'VehicleGrantPartnerConnection' };
              } & { __typename: 'CountedVehicleGrantPartnerConnection' };
              vehicles:
                | ({
                    dedicatedByPartnersAllCount:
                      | ({ count: number } & { __typename: 'CountedVehicleConnection' })
                      | null;
                    dedicatedByPartnersActiveCount:
                      | ({ count: number } & { __typename: 'CountedVehicleConnection' })
                      | null;
                    dedicatedByPartnersInactiveCount:
                      | ({ count: number } & { __typename: 'CountedVehicleConnection' })
                      | null;
                  } & { __typename: 'CompanyVehicles' })
                | null;
            } & { __typename: 'Company' })
          | null;
      } & { __typename: 'User' })
    | null;
} & { __typename: 'Query' };

export type VehicleManagementDedicatedByPartnerVehiclesQueryVariables = Exact<{
  companyId: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  licensePlateSearch?: InputMaybe<Scalars['String']['input']>;
  sorting: VehicleFilterSortOrderInput;
  partnerId: Scalars['String']['input'];
  partnerIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  timeBasedStatus?: InputMaybe<TimeBasedStatus>;
}>;

export type VehicleManagementDedicatedByPartnerVehiclesQuery = {
  viewer:
    | ({
        user_id: string;
        company:
          | ({
              company_id: string;
              partner:
                | ({
                    company: { company_id: string; company_name: string | null } & { __typename: 'CompanyProfile' };
                  } & { __typename: 'VehicleGrantPartner' })
                | null;
              vehicles:
                | ({
                    dedicatedByPartners:
                      | ({
                          mapTilesTemplateURI: string | null;
                          count: number;
                          boundingBox: Array<{ lat: number; lng: number } & { __typename: 'PointLocation' }> | null;
                          vehicles: {
                            edges: Array<
                              | ({
                                  node:
                                    | ({
                                        vehicle_id: string;
                                        license_plate_number: string | null;
                                        status:
                                          | ({ timestamp: string; timeBasedStatus: TimeBasedStatus } & {
                                              __typename: 'RestrictedVehicleStatus';
                                            })
                                          | null;
                                        alternativeIdentifiers: Array<
                                          { vehicleAlternativeIdentifierId: string; alternativeIdentifier: string } & {
                                            __typename: 'VehicleAlternativeIdentifier';
                                          }
                                        >;
                                      } & { __typename: 'Vehicle' })
                                    | null;
                                } & { __typename: 'VehicleEdge' })
                              | null
                            > | null;
                            pageInfo: { hasNextPage: boolean; endCursor: string | null } & { __typename: 'PageInfo' };
                          } & { __typename: 'VehicleConnection' };
                        } & { __typename: 'CountedVehicleConnection' })
                      | null;
                    totalCount: ({ count: number } & { __typename: 'CountedVehicleConnection' }) | null;
                    activeCount: ({ count: number } & { __typename: 'CountedVehicleConnection' }) | null;
                    inactiveCount: ({ count: number } & { __typename: 'CountedVehicleConnection' }) | null;
                  } & { __typename: 'CompanyVehicles' })
                | null;
            } & { __typename: 'Company' })
          | null;
      } & { __typename: 'User' })
    | null;
} & { __typename: 'Query' };

export type SetVehicleAlternativeIdentifiersMutationVariables = Exact<{
  input: SetVehicleAlternativeIdentifiersInput;
}>;

export type SetVehicleAlternativeIdentifiersMutation = {
  setVehicleAlternativeIdentifiers: {
    success: boolean;
    conflicts: Array<
      {
        submittedAlternativeIdentifier: string;
        licensePlate: string | null;
        alternativeIdentifier: string | null;
        conflictedBy: VehicleAlternativeIdentifierConflictedBy;
      } & { __typename: 'VehicleAlternativeIdentifierConflict' }
    >;
    alternativeIdentifiers: Array<
      { vehicleAlternativeIdentifierId: string; alternativeIdentifier: string } & {
        __typename: 'VehicleAlternativeIdentifier';
      }
    >;
  } & { __typename: 'SetVehicleAlternativeIdentifiersResult' };
} & { __typename: 'Mutation' };

export type VehicleManagementOwnVehiclesAltIdsQueryVariables = Exact<{
  companyId: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
}>;

export type VehicleManagementOwnVehiclesAltIdsQuery = {
  viewer:
    | ({
        user_id: string;
        company:
          | ({
              company_id: string;
              vehicles:
                | ({
                    ownVehicles:
                      | ({
                          count: number;
                          vehicles: {
                            edges: Array<
                              | ({
                                  node:
                                    | ({
                                        vehicle_id: string;
                                        license_plate_number: string | null;
                                        alternativeIdentifiers: Array<
                                          { vehicleAlternativeIdentifierId: string; alternativeIdentifier: string } & {
                                            __typename: 'VehicleAlternativeIdentifier';
                                          }
                                        >;
                                        vehicleTrackers: Array<
                                          { vehicleTrackerId: string; trackerType: VehicleTrackerType } & {
                                            __typename: 'FMSVehicleTracker' | 'MobileVehicleTracker';
                                          }
                                        >;
                                      } & { __typename: 'Vehicle' })
                                    | null;
                                } & { __typename: 'VehicleEdge' })
                              | null
                            > | null;
                            pageInfo: { hasNextPage: boolean; endCursor: string | null } & { __typename: 'PageInfo' };
                          } & { __typename: 'VehicleConnection' };
                        } & { __typename: 'CountedVehicleConnection' })
                      | null;
                  } & { __typename: 'CompanyVehicles' })
                | null;
            } & { __typename: 'Company' })
          | null;
      } & { __typename: 'User' })
    | null;
} & { __typename: 'Query' };

export type SetBulkVehicleAlternativeIdentifiersMutationVariables = Exact<{
  input: SetBulkVehicleAlternativeIdentifiersInput;
  dryRun: Scalars['Boolean']['input'];
}>;

export type SetBulkVehicleAlternativeIdentifiersMutation = {
  setBulkVehicleAlternativeIdentifiers: {
    success: boolean;
    items: Array<
      {
        vehicleId: string;
        success: boolean;
        errorType: BulkVehicleAlternativeIdentifiersErrorType | null;
        conflicts: Array<
          {
            submittedAlternativeIdentifier: string;
            licensePlate: string | null;
            alternativeIdentifier: string | null;
            conflictedBy: VehicleAlternativeIdentifierConflictedBy;
          } & { __typename: 'VehicleAlternativeIdentifierConflict' }
        >;
      } & { __typename: 'BulkVehicleAlternativeIdentifiersItemResult' }
    >;
  } & { __typename: 'SetBulkVehicleAlternativeIdentifiersResult' };
} & { __typename: 'Mutation' };

export type VehicleManagementIntegrationVehiclesQueryVariables = Exact<{
  companyId: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  licensePlateSearch?: InputMaybe<Scalars['String']['input']>;
  sorting: VehicleFilterSortOrderInput;
  integrationIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;

export type VehicleManagementIntegrationVehiclesQuery = {
  viewer:
    | ({
        user_id: string;
        company:
          | ({
              company_id: string;
              vehicles:
                | ({
                    integrationVehicles:
                      | ({
                          count: number;
                          vehicles: {
                            edges: Array<
                              | ({
                                  node:
                                    | ({
                                        vehicle_id: string;
                                        license_plate_number: string | null;
                                        vehicleTrackers: Array<
                                          | ({
                                              vehicleTrackerId: string;
                                              trackerType: VehicleTrackerType;
                                              telematicsIntegration:
                                                | ({
                                                    telematicsIntegrationId: string;
                                                    telematicsProvider: {
                                                      telematicsProviderId: string;
                                                      telematicsProviderName: string;
                                                    } & { __typename: 'TelematicsProvider' };
                                                  } & { __typename: 'CompanyTelematicsIntegration' })
                                                | null;
                                            } & { __typename: 'FMSVehicleTracker' })
                                          | ({
                                              vehicleTrackerId: string;
                                              trackerType: VehicleTrackerType;
                                              phoneNumber: string | null;
                                              alias: string | null;
                                            } & { __typename: 'MobileVehicleTracker' })
                                        >;
                                      } & { __typename: 'Vehicle' })
                                    | null;
                                } & { __typename: 'VehicleEdge' })
                              | null
                            > | null;
                            pageInfo: { hasNextPage: boolean; endCursor: string | null } & { __typename: 'PageInfo' };
                          } & { __typename: 'VehicleConnection' };
                        } & { __typename: 'CountedVehicleConnection' })
                      | null;
                  } & { __typename: 'CompanyVehicles' })
                | null;
            } & { __typename: 'Company' })
          | null;
      } & { __typename: 'User' })
    | null;
} & { __typename: 'Query' };

export type VisibilityAgentConversationsQueryVariables = Exact<{
  cursor?: InputMaybe<Scalars['String']['input']>;
}>;

export type VisibilityAgentConversationsQuery = {
  visibilityAgentConversations: {
    conversations: Array<
      { conversationId: string; updatedAt: string; title: string | null } & {
        __typename: 'VisibilityAgentConversation';
      }
    >;
    pageInfo: { cursor: string | null } & { __typename: 'VisibilityAgentPageInfo' };
  } & { __typename: 'VisibilityAgentConversationsResponse' };
} & { __typename: 'Query' };

export type VisibilityAgentConversationQueryVariables = Exact<{
  conversationId: Scalars['String']['input'];
  cursor?: InputMaybe<Scalars['String']['input']>;
}>;

export type VisibilityAgentConversationQuery = {
  visibilityAgentConversation:
    | ({
        conversationId: string;
        userId: string;
        createdAt: string;
        updatedAt: string;
        title: string | null;
        messages: Array<
          {
            messageId: string;
            conversationId: string;
            role: string;
            content: string;
            timestamp: string;
            metadata:
              | ({ tokensUsed: number | null; toolsUsed: Array<string> | null; intent: string | null } & {
                  __typename: 'VisibilityAgentMessageMetadata';
                })
              | null;
          } & { __typename: 'VisibilityAgentMessage' }
        >;
        pageInfo: { cursor: string | null } & { __typename: 'VisibilityAgentPageInfo' };
      } & { __typename: 'VisibilityAgentConversationMessages' })
    | null;
} & { __typename: 'Query' };

export type CreateVisibilityAgentConversationMutationVariables = Exact<{
  input: CreateVisibilityAgentConversationInput;
}>;

export type CreateVisibilityAgentConversationMutation = {
  createVisibilityAgentConversation:
    | ({
        response: string;
        conversationId: string;
        messageId: string | null;
        metadata: {
          responseTime: number;
          tokensUsed: number;
          toolsUsed: Array<string>;
          intent: string | null;
          route: string | null;
          reasoning: string | null;
        } & { __typename: 'VisibilityAgentResponseMetadata' };
        error:
          | ({ code: string; message: string; recoverable: boolean; suggestions: Array<string> | null } & {
              __typename: 'VisibilityAgentResponseError';
            })
          | null;
      } & { __typename: 'VisibilityAgentChatResult' })
    | ({ conversationId: string } & { __typename: 'VisibilityAgentConversationCreated' })
    | ({ code: string; message: string; recoverable: boolean; suggestions: Array<string> | null } & {
        __typename: 'VisibilityAgentValidationError';
      });
} & { __typename: 'Mutation' };

export type SendVisibilityAgentMessageMutationVariables = Exact<{
  input: SendVisibilityAgentMessageInput;
}>;

export type SendVisibilityAgentMessageMutation = {
  sendVisibilityAgentMessage:
    | ({
        response: string;
        conversationId: string;
        messageId: string | null;
        metadata: {
          responseTime: number;
          tokensUsed: number;
          toolsUsed: Array<string>;
          intent: string | null;
          route: string | null;
          reasoning: string | null;
        } & { __typename: 'VisibilityAgentResponseMetadata' };
        error:
          | ({ code: string; message: string; recoverable: boolean; suggestions: Array<string> | null } & {
              __typename: 'VisibilityAgentResponseError';
            })
          | null;
      } & { __typename: 'VisibilityAgentChatResult' })
    | ({ code: string; message: string; recoverable: boolean; suggestions: Array<string> | null } & {
        __typename: 'VisibilityAgentValidationError';
      });
} & { __typename: 'Mutation' };

export type DeleteVisibilityAgentConversationMutationVariables = Exact<{
  input: DeleteVisibilityAgentConversationInput;
}>;

export type DeleteVisibilityAgentConversationMutation = { deleteVisibilityAgentConversation: boolean } & {
  __typename: 'Mutation';
};

export type SubmitVisibilityAgentFeedbackMutationVariables = Exact<{
  input: SubmitVisibilityAgentFeedbackInput;
}>;

export type SubmitVisibilityAgentFeedbackMutation = {
  submitVisibilityAgentFeedback:
    | ({
        id: string;
        messageId: string;
        feedbackType: VisibilityAgentFeedbackType;
        createdAt: string;
        feedbackText: string | null;
      } & { __typename: 'VisibilityAgentFeedbackResult' })
    | ({ code: string; message: string; recoverable: boolean; suggestions: Array<string> | null } & {
        __typename: 'VisibilityAgentValidationError';
      });
} & { __typename: 'Mutation' };
